import React, { useEffect, useState, useRef, useMemo } from "react";
import { BASE_URL } from "../../config/axios";
import axios from "axios";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import { AttachmentIcon, handleErrorToast } from "../CustomFunctions";
import "jspdf-autotable";
import { DateRangePicker, CSSForSelect } from "../CustomFunctions";
import * as XLSX from "xlsx";
import Select, { components } from "react-select";
import {
  AddwithWhiteCircle,
  DocumentIcon,
  DownloadIcon,
  Attachment,
  Eye,
  UpdatePencil,
  CrossRed,
  DOCIcon,
  AddwithBlueCircle,
  Notes,
  ArrowBulletHead,
  ArrowBullet,
  ArrowBulletReverse,
  Star,
  CancelCircle,
  DeleteDustbinbUTTON,
} from "../AllSvg";
import { useNavigate } from "react-router-dom";
import {
  formatDateDDMMYYYY,
  formattedDateLong,
  formatDateDDMMYYYYmonth,
  formatDateIndian,
  formatDateDDMMYYYYmonthNew,
} from "../Date";
import { use } from "react";
const formatISTWithOffset = (localDateStr) => {
  const date = new Date(localDateStr);
  const pad = (n) => n.toString().padStart(2, "0");
  const year = date.getFullYear();
  const month = pad(date.getMonth() + 1);
  const day = pad(date.getDate());
  const hours = pad(date.getHours());
  const minutes = pad(date.getMinutes());
  const seconds = pad(date.getSeconds());

  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}+05:30`;
};

const AddBidDetails = ({ getBidData, handleGetStats, filters }) => {
  const [show, setShow] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
  const uniqueStreamTypes = new Set();
  const [JvPartnerData, setJvPartnerData] = useState([]);
  const fileInputRefs = useRef([]);
  const [rfpFiles, setRfpFiles] = useState([]);
  const [rfpFilesother, setRfpFilesOther] = useState([]);
  const handleRfpFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setRfpFiles((prev) => [...prev, ...newFiles]);
    }
  };

  const handleRfpFileOtherChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setRfpFilesOther((prev) => [...prev, ...newFiles]);
    }
  };

  const handleRemove = (index) => {
    setRfpFiles((prev) => prev.filter((_, i) => i !== index));
  };
  const handleRemoveOther = (index) => {
    setRfpFilesOther((prev) => prev.filter((_, i) => i !== index));
  };

  const getJvPartner = async () => {
    setBuffering(true);
    let url;
    try {
      url = `${BASE_URL}/siteproject/JVPartner/`;

      const sub = await axios.get(url);

      setJvPartnerData(sub.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  const handleClose = () => {
    setFormData({
      sector: "",
      tender_type: "",

      tender_name: "",
      submission_date: "",
      lane: "",
      state: "",
      cost_of_consult: "",
      length: "",
      cost_of_construction: "",
      duration: {
        construction: "",
        dlp: "",
        onm: "",
      },
      status: "pending",
      lead_partner: "",
      jv_partner_name: "",
      associate_with_version: "",
      emd: "",
      eligibity_criteria: "",
      remarks: "",
      type_of_project: "",
      km_cost: "",
      fee: "",
      bid_security: "",
      tender_id: "",
      e_published: "",
      pbg_details: "",
      pbg_requried: "",
    });
    setErrors({});
    setShow(false);
    setDocNames("");
    setRfpFiles([]);
  };
  const handleShow = () => {
    setShow(true);
    getJvPartner();
    getSubCompany();
    clientList.forEach((entry) => {
      uniqueStreamTypes.add(entry.client_name);
    });
  };
  const [empList, setEmpList] = useState([]);
  const [buffer, setBuffering] = useState(false);

  const [formData, setFormData] = useState({
    sector: "",
    tender_type: "",
    client: "",
    tender_name: "",
    submission_date: "",
    lane: "",
    state: "",
    cost_of_consult: "",
    length: "",
    cost_of_construction: "",
    duration: {
      construction: "",
      dlp: "",
      onm: "",
    },
    status: "pending",
    lead_partner: "",
    is_special_tender: false,
    jv_partner_name: "",
    associate_with_version: "",
    emd: "",
    eligibity_criteria: "",
    remarks: "",
    type_of_project: "",
    km_cost: "",
    fee: "",
    bid_security: "",
    tender_id: "",
    e_published: "",
    consultancy_fees: "",
    GST_consultancy: "",
    construction_fees: "",
    special_structure_type: "",
    other_sector_type: "",
    other_tender_type: "",
    publish_date: "",
    ro: "",
    pbg_requried: "",
    pbg_details: "",
    consultancy_fees: "",
  });

  const getSubCompany = async () => {
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSiteSubCompanyList(sub.data);
    } catch (error) {}
  };

  const updateStatusAndRemarks = () => {
    let newStatus = "";
    let newRemark = "";

    if (formData.actual_completion_date) {
      newStatus = "Completed";
      newRemark = "The project is successfully completed.";
    } else if (formData.actual_construction_completion_date) {
      newStatus = "Yet to Complete including O&M";
      newRemark = "Construction phase completed; O&M is pending.";
    } else if (formData.schedule_completion_date) {
      newStatus = "In Progress";
      newRemark = "Project is currently in progress.";
    } else if (formData.schedule_construction_completion_date) {
      newStatus = "In Progress including O&M";
      newRemark = "Construction is in progress along with O&M.";
    } else if (formData.commencement_date) {
      newStatus = "Yet to Commence";
      newRemark = "Project commencement is yet to start.";
    } else if (formData.agreement_date) {
      newStatus = "Yet to Sign Agreement";
      newRemark = "Agreement signing is pending.";
    } else if (formData.bgid_submission_date) {
      newStatus = "Yet to Submit BG";
      newRemark = "Bank Guarantee submission is pending.";
    } else if (formData.loa_award_date) {
      newStatus = "Yet to Award";
      newRemark = "Letter of Award is pending.";
    } else if (formData.bid_due_date) {
      newStatus = "Yet to Bid";
      newRemark = "Bid submission is pending.";
    }

    setFormData((prevFormData) => ({
      ...prevFormData,
      status: newStatus,
    }));
  };

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});
  const [docNames, setDocNames] = useState();

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = [
      "tender_id",
      "submission_date",
      "length",
      "tender_name",
      "sector",
      "tender_type",
      "client",
      "state",
      "publish_date",
      formData.sector === "Highway" ? "lane" : null,
      formData.pbg_requried && formData.pbg_details === ""
        ? "pbg_details"
        : null,
      formData.is_special_tender &&
      (formData.special_structure_type === null ||
        formData.special_structure_type === "null" ||
        formData.special_structure_type === "")
        ? "special_structure_type"
        : null,
    ].filter(Boolean);

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          formData,
        );
    };

    requiredFields.forEach((field) => {
      const value = getValue(field);
      if (!value) {
        newErrors[field] = `${field
          .replace(/\./g, " ")
          .replace(/_/g, " ")
          .replace(/\b\w/g, (c) => c.toUpperCase())} is required!`;
      }
    });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked, options, files } = e.target;

    let newValue;
    if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files.length > 0 ? files[0] : null;
    } else {
      newValue = value;
    }

    const keys = name.split(".");
    const topKey = keys[0];

    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData };

      if (keys.length === 2) {
        updatedFormData[topKey] = {
          ...updatedFormData[topKey],
          [keys[1]]: newValue,
        };
      } else {
        updatedFormData[name] = newValue;
      }

      return updatedFormData;
    });

    setInputState((prevState) => {
      if (keys.length === 2) {
        return {
          ...prevState,
          [topKey]: {
            ...prevState[topKey],
            [keys[1]]: newValue ? "green" : "",
          },
        };
      } else {
        return {
          ...prevState,
          [name]: newValue ? "green" : "",
        };
      }
    });

    // Clear errors if value is valid
    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (keys.length === 2 && updatedErrors[topKey]) {
          updatedErrors[topKey] = {
            ...updatedErrors[topKey],
          };
          delete updatedErrors[topKey][keys[1]];
          if (Object.keys(updatedErrors[topKey]).length === 0) {
            delete updatedErrors[topKey];
          }
        } else {
          delete updatedErrors[name];
        }
        return updatedErrors;
      });
    }
  };

  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true);
      const loadingToastId = toast.loading("Loading: Please wait...");
      const formDataToSend = new FormData();

      Object.keys(formData).forEach((key) => {
        if (key === "duration") {
          formDataToSend.append("duration", JSON.stringify(formData.duration));
        } else if (key === "submission_date") {
          formDataToSend.append(
            "submission_date",
            formatISTWithOffset(formData.submission_date),
          );
        } else {
          formDataToSend.append(key, formData[key]);
        }
      });

      try {
        let res = await axios.post(
          `${BASE_URL}/siteproject/BidTenders/`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          await getBidData(filters);
          await handleGetStats();
        }

        if (res.status === 200 && rfpFiles.length) {
          try {
            const formData = new FormData();

            rfpFiles.forEach((file) => {
              formData.append("rfp_tender", res?.data?.id);
              formData.append("document_name", file?.name);
              formData.append("document", file);
            });

            const uploadRes = await axios.post(
              `${BASE_URL}/siteproject/bulkrfp/`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              },
            );
          } catch (uploadErr) {
            setRfpFiles([]);
          } finally {
            setRfpFiles([]);
            getBidData(filters);
          }
        }
        if (res.status === 200 && rfpFilesother.length) {
          try {
            const formData = new FormData();

            rfpFilesother.forEach((file) => {
              formData.append("Rfpother_tender", res?.data?.id);
              formData.append("document_name", file?.name);
              formData.append("document", file);
            });

            const uploadRes = await axios.post(
              `${BASE_URL}/siteproject/bulkother/`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              },
            );
          } catch (uploadErr) {
            setRfpFiles([]);
          } finally {
            setRfpFiles([]);
            getBidData(filters);
          }
        }
        setShow(false);
        setLoading(false);
        toast.dismiss(loadingToastId);
        handleClose();
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const addNewDocument = () => {
    setFormData((prevFormData) => [
      ...prevFormData,
      {
        document_name: "",
        document_file: null,
      },
    ]);
    fileInputRefs.current.push(null);
  };

  const handleRemoveDocument = (index) => {
    setFormData((prevFormData) => prevFormData.filter((_, i) => i !== index));
    fileInputRefs.current.splice(index, 1);
  };

  const handleClear = (index) => {
    setFormData((prevFormData) => {
      const newDocuments = [...prevFormData];
      newDocuments[index] = {
        ...newDocuments[index],
        document_file: null,
      };
      return newDocuments;
    });

    if (fileInputRefs.current[index]) {
      fileInputRefs.current[index].value = "";
    }
    setErrors((prevErrors) => {
      const newErrors = { ...prevErrors };
      delete newErrors[`${index}-document_file`];
      return newErrors;
    });
  };

  const handleFileChange = (e, index) => {
    const file = e.target.files[0];

    if (file) {
      const allowedTypes = [
        "application/pdf", // PDF
        "application/zip",
        "application/x-zip-compressed", // ZIP
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // XLSX
        "application/vnd.ms-excel", // XLS
      ];

      if (
        !allowedTypes.includes(file.type) &&
        !file.name.match(/\.(zip|pdf|xls|xlsx)$/)
      ) {
        toast.error("Only ZIP, PDF, and Excel files are allowed!");
        return;
      }

      setFormData((prevFormData) => {
        const newDocuments = [...prevFormData];
        newDocuments[index] = {
          ...newDocuments[index],
          document_file: file,
        };
        return newDocuments;
      });

      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[`${index}-document_file`];
        return newErrors;
      });
    }
  };

  const handleChangeAssignedTo = (selected) => {
    const com_operators = selected?.map((item) => item.value) || [];
    setFormData((prevState) => ({
      ...prevState,
      com_operators,
    }));
  };

  const options = empList
    ?.sort((a, b) => parseInt(a.emp_code) - parseInt(b.emp_code))
    ?.map((e) => ({
      value: e.id,
      label: `${e.emp_code} - ${e.name}`,
    }));

  const states = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  return (
    <>
      <button
        title="Add Tender Details"
        className="upload-svg"
        onClick={handleShow}
      >
        <AddwithWhiteCircle /> Tender
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Add Tender Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-form">
            <div className="form-flex-wrap">
              {/* Tender ID */}
              <div className="flex-columns">
                <label className="form-labels">
                  Tender ID <span className="required">*</span>
                </label>
                <input
                  type="text"
                  name="tender_id"
                  placeholder="Example - NHAI2025-RJ-011"
                  value={formData.tender_id}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.tender_id ? "error" : inputState.tender_id ? "success" : ""}`}
                />
                <br />
                {errors.tender_id && (
                  <span className="error-message">{errors.tender_id}</span>
                )}
              </div>

              <div className="flex-columns">
                <div
                  className="flex-row justify-between form-labels"
                  style={{ height: "25px" }}
                >
                  <label htmlFor="tender_name" className="">
                    Tender Name
                    <span className="required">*</span>
                  </label>
                  <div className="checkbox-wrapper">
                    <label className="custom-checkbox  font-weight500 font-size-subheading">
                      <input
                        type="checkbox"
                        name="is_special_tender"
                        checked={formData.is_special_tender || false}
                        onChange={handleInputChange}
                      />
                      <span className="checkmark"></span>
                      Special Tender
                    </label>
                  </div>
                </div>
                <input
                  type="text"
                  name="tender_name"
                  placeholder="Example - NH66 Highway Project"
                  value={formData.tender_name}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.tender_name ? "error" : inputState.tender_name ? "success" : ""}`}
                />
                <br />
                {errors.tender_name && (
                  <span className="error-message">{errors.tender_name}</span>
                )}
              </div>

              {/* special_structure_type */}
              {formData.is_special_tender && (
                <div className="flex-columns">
                  <label className="form-labels">
                    Special Structure Type{" "}
                    <span className="required">*</span>{" "}
                  </label>
                  <br />
                  <select
                    name="special_structure_type"
                    placeholder="Special Structure"
                    value={formData.special_structure_type}
                    onChange={handleInputChange}
                    className={`form-input input-form ${errors.special_structure_type ? "error" : inputState.special_structure_type ? "success" : ""}`}
                  >
                    <option value="">Select structure type</option>
                    <option value="tunnel">Tunnel</option>
                    <option value="major_bridge">Major Bridge</option>
                    <option value="cable_stayed">Cable Stayed</option>
                    <option value="elevated">Elevated</option>
                  </select>
                  {errors.special_structure_type && (
                    <span className="error-message">
                      {errors.special_structure_type}
                    </span>
                  )}
                </div>
              )}

              <div className="flex-columns">
                <label className="form-labels">
                  Sector <span className="required">*</span>
                </label>
                <br />
                <select
                  name="sector"
                  value={formData.sector}
                  onChange={handleInputChange}
                  placeholder="Select Sector"
                  className={`form-input input-form ${errors.sector ? "error" : inputState.sector ? "success" : ""}`}
                >
                  <option value="">Select sector</option>
                  <option value="Highway">Highway</option>
                  <option value="Railway">Railway</option>
                  <option value="Metro">Metro</option>
                  <option value="Water">Water</option>
                  <option value="Ropeway">Ropeway</option>
                  <option value="Building">Building</option>
                  <option value="Other">Other</option>
                </select>
                <br />
                {errors.sector && (
                  <span className="error-message">{errors.sector}</span>
                )}
              </div>

              {formData.sector === "Other" && (
                <div className="flex-columns">
                  <label className="form-labels">Other Sector Type </label>
                  <input
                    type="text"
                    name="other_sector_type"
                    placeholder="Other Sector Type Name"
                    value={formData.other_sector_type}
                    onChange={handleInputChange}
                    className={`form-input input-form ${errors.other_sector_type ? "error" : inputState.other_sector_type ? "success" : ""}`}
                  />
                  {errors.other_sector_type && (
                    <span className="error-message">
                      {errors.other_sector_type}
                    </span>
                  )}
                </div>
              )}

              {/* Tender Type */}
              <div className="flex-columns">
                <label className="form-labels">
                  Tender Type <span className="required">*</span>
                </label>
                <select
                  name="tender_type"
                  value={formData.tender_type}
                  onChange={handleInputChange}
                  placeholder="Select Tender Type"
                  className={`form-input input-form ${
                    errors.tender_type
                      ? "error"
                      : inputState.tender_type
                        ? "success"
                        : ""
                  }`}
                >
                  <option value="">Select Tender Type</option>

                  {/* Always visible */}
                  <option value="Feasibility">Feasibility</option>
                  <option value="DPR">DPR</option>
                  <option value="FesibilityCumDPR">Feasibility Cum DPR</option>
                  <option value="Authority_Engineer">Authority Engineer</option>
                  <option value="Independent_Engineer">
                    Independent Engineer
                  </option>
                  <option value="PMC">PMC</option>
                  <option value="Supervision">Supervision</option>
                  <option value="eoi">EOI</option>
                  <option value="Empanelment">Empanelment</option>
                  <option value="O&M">O&amp;M</option>
                  <option value="IEO&M">IE O&amp;M</option>
                  <option value="AE_O&M">AE O&amp;M</option>
                  <option value="Supervision_O&M">Supervision O&amp;M</option>
                  <option value="Survey">Survey</option>
                  <option value="Technology">Technology</option>
                  <option value="machinery">Machinery</option>
                  <option value="slope_stability">Slope Stability</option>
                  <option value="slope_protection">Slope Protection</option>
                  <option value="Detailed_Design">Detailed Design</option>
                  <option value="Architecture">Architecture</option>
                  <option value="safety_consultant">SAFETY CONSULTANT</option>
                  <option value="pms">PMS</option>

                  <option value="Other">Other</option>

                  {/* 👇 Show only if sector === "Railway" */}
                  {formData.sector === "Railway" && (
                    <>
                      <option value="PSSA">PSSA</option>
                      <option value="GC">GC</option>
                      <option value="Temping">Temping</option>
                      <option value="FLS">FLS</option>
                      <option value="Station_Redevelopment">
                        Station Redevelopment
                      </option>
                    </>
                  )}
                </select>
                <br />
                {errors.tender_type && (
                  <span className="error-message">{errors.tender_type}</span>
                )}
              </div>

              {formData.tender_type === "Other" && (
                <div className="flex-columns">
                  <label className="form-labels">Other Sector Type</label>
                  <input
                    type="text"
                    name="other_tender_type"
                    placeholder="Other Tender Type Name"
                    value={formData.other_tender_type}
                    onChange={handleInputChange}
                    className={`form-input input-form ${errors.other_tender_type ? "error" : inputState.other_tender_type ? "success" : ""}`}
                  />
                  {errors.other_tender_type && (
                    <span className="error-message">
                      {errors.other_tender_type}
                    </span>
                  )}
                </div>
              )}

              <div className="flex-columns">
                <label className="form-labels">
                  Client <span className="required">*</span>{" "}
                </label>
                <br />
                <select
                  name="client"
                  value={formData.client}
                  onChange={handleInputChange}
                  placeholder="Select Client"
                  className={`form-input input-form ${errors.client ? "error" : inputState.client ? "success" : ""}`}
                >
                  <option value="">Select Client</option>
                  {formData.sector === "Railway" ? (
                    <>
                      <option value="CENTRAL_RAILWAY">Central Railway</option>
                      <option value="EAST_CENTRAL_RAILWAY">
                        East Central Railway
                      </option>
                      <option value="EASTERN_RAILWAY">Eastern Railway</option>
                      <option value="MINISTRY_OF_RAILWAYS">
                        Ministry of Railways
                      </option>
                      <option value="MUMBAI_RAILWAY_VIKAS_CORPORATION">
                        Mumbai Railway Vikas Corporation
                      </option>
                      <option value="NORTH_CENTRAL_RAILWAY">
                        North Central Railway
                      </option>
                      <option value="NORTH_EASTERN_RAILWAYS">
                        North Eastern Railways
                      </option>
                      <option value="NORTHEST_FRONTIER_RAILWAYA">
                        Northest Frontier Railwaya
                      </option>
                      <option value="NORTHERN_RAILWAY">Northern Railway</option>
                      <option value="RAILWAY_ENERGY_MANAGEMENT_COMPANY_LIMITED">
                        Railway Energy Management Company Limited
                      </option>
                      <option value="SOUTH_CENTRAL_RAILWAY">
                        South Central Railway
                      </option>
                      <option value="SOUTH_EASTERN_RAILWAYS">
                        South Eastern Railways
                      </option>
                      <option value="SOUTHEST_FRONTIER_RAILWAY">
                        Southest Frontier Railway
                      </option>
                      <option value="SOUTHERN_RAILWAY">Southern Railway</option>
                      <option value="EAST_COAST_RAILWAY">
                        EAST COAST RAILWAY
                      </option>
                      <option value="South_West_Central_Railway">
                        South West Central Railway
                      </option>
                      <option value="West_Central_Railway ">
                        West Central Railway{" "}
                      </option>
                      <option value="South_Western_Railway">
                        {" "}
                        South Western Railway
                      </option>
                      <option value="Western_Railway">Western Railway</option>
                      <option value="North_Western_Railway">
                        {" "}
                        North Western Railway{" "}
                      </option>
                      <option value="South_East_Railway">
                        South East Railway
                      </option>
                    </>
                  ) : (
                    <>
                      <option value="NHAI">NHAI</option>
                      <option value="MORTH">MoRTH</option>
                      <option value="NHIDCL">NHIDCL</option>
                      <option value="BRO">BRO</option>
                      <option value="PWDS">PWDs</option>
                      <option value="MPRDCL">MPRDCL</option>
                      <option value="MHRDCL">MHRDCL</option>
                      <option value="GJRDCL">GJRDCL</option>
                      <option value="SHAJ">SHAJ</option>
                      <option value="HSIIDC">HSIIDC</option>
                      <option value="BHRDCL">BHRDCL</option>
                      <option value="UPEIDA">UPEIDA</option>
                      <option value="UPHA&SP">UPHA&SP</option>
                      <option value="RITES">RITES</option>
                      <option value="HRBG">HRBG</option>
                      <option value="APCRDA">APCRDA</option>
                      <option value="RCDB">RCDB</option>
                      <option value="BSIL">BSIL</option>
                      <option value="BUIDCL">BUIDCL</option>
                      <option value="CMRL">CMRL</option>
                      <option value="DMRCL">DMRCL</option>
                      <option value="EPIL">EPIL</option>
                      <option value="HRSI&IDCL">HRSI&IDCL</option>
                      <option value="H&UDCL">H&UDCL</option>
                      <option value="J&KRRDA">J&KRRDA</option>
                      <option value="MHSIDC">MHSIDC</option>
                      <option value="MHMRCL">MHMRCL</option>
                      <option value="RJSRD&CCL">RJSRD&CCL</option>
                      <option value="KARDCL">KARDCL</option>
                      <option value="TNRDL">TNRDL</option>
                      <option value="APRDC">APRDC</option>
                      <option value="PBIDB">PBIDB</option>
                      <option value="R&BDT">R&BDT</option>
                      <option value="RCDJ">RCDJ</option>
                      <option value="JHSRDC">JHSRDC</option>
                      <option value="HPPWD">HPPWD</option>
                      <option value="UKPWD">UKPWD</option>
                      <option value="DSI&IDC">DSI&IDC</option>
                      <option value="GOAPWD">GOAPWD</option>
                      <option value="HRRIDC">HRRIDC</option>
                      <option value="RIDFOD">RIDFOD</option>
                      <option value="RJSID&IC">RJSID&IC</option>
                      <option value="KLRFB">KLRFB</option>
                      <option value="RSHA">RSHA</option>
                      <option value="BIDA">BIDA</option>
                      <option value="MIDFC">MIDFC</option>
                      <option value="SOI">SOI</option>
                      <option value="JNPT">JNPT</option>
                      <option value="BMRCL">BMRCL</option>
                      <option value="OBCCL">OBCCL</option>
                      <option value="OTHER">Other</option>
                    </>
                  )}
                </select>
                <br />
                {errors.client && (
                  <span className="error-message">{errors.client}</span>
                )}
              </div>

              <div className="flex-columns">
                <label className="form-labels">Client Ro </label>
                <input
                  type="text"
                  name="ro"
                  value={formData?.ro}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors?.ro ? "error" : inputState?.ro ? "success" : ""}`}
                />
                {errors?.ro && (
                  <span className="error-message">{errors.ro}</span>
                )}
              </div>

              <div className="flex-columns">
                <label className="form-labels">
                  Publish Date <span className="required">*</span>{" "}
                </label>
                <input
                  type="date"
                  name="publish_date"
                  value={formData?.publish_date}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors?.publish_date ? "error" : inputState?.publish_date ? "success" : ""}`}
                />
                <br />
                {errors?.publish_date && (
                  <span className="error-message">{errors?.publish_date}</span>
                )}
              </div>

              <div className="flex-columns">
                <label className="form-labels">
                  Submission Date <span className="required">*</span>
                </label>
                <input
                  type="datetime-local"
                  name="submission_date"
                  value={formData?.submission_date}
                  onChange={handleInputChange}
                  min={new Date().toISOString().slice(0, 16)}
                  className={`form-input input-form ${errors?.submission_date ? "error" : inputState?.submission_date ? "success" : ""}`}
                />
                {errors?.submission_date && (
                  <span className="error-message">
                    {errors?.submission_date}
                  </span>
                )}
              </div>

              {formData.sector != "Railway" && (
                <div className="flex-columns">
                  <label className="form-labels">Lane</label>
                  <br />
                  <select
                    name="lane"
                    value={formData.lane}
                    onChange={handleInputChange}
                    placeholder="Select Lane"
                    className={`form-input input-form ${
                      errors.lane ? "error" : inputState.lane ? "success" : ""
                    }`}
                  >
                    <option value="">Select Lane</option>
                    <option value="2">2 Lane</option>
                    <option value="4">4 Lane</option>
                    <option value="6">6 Lane</option>
                    <option value="8">8 Lane</option>
                    <option value="nhsl">NHSL</option>
                    <option value="rfp_not_uploaded">Not Available</option>
                    <option value="not_required">Not Required</option>
                  </select>

                  {errors.lane && (
                    <span className="error-message">{errors.lane}</span>
                  )}
                </div>
              )}

              <div className="flex-columns">
                <label className="form-labels">
                  State <span className="required">*</span>{" "}
                </label>
                <br />
                <select
                  name="state"
                  value={formData.state}
                  onChange={handleInputChange}
                  placeholder="Select State"
                  className={`form-input input-form ${errors.state ? "error" : inputState.state ? "success" : ""}`}
                >
                  <option value="">Select State</option>
                  {states.map((state) => (
                    <option key={state} value={state}>
                      {state}
                    </option>
                  ))}
                </select>
                <br />
                {errors.state && (
                  <span className="error-message">{errors.state}</span>
                )}
              </div>
              <div className="flex-columns">
                <label htmlFor="pbg_requried" className="form-labels">
                  PBG Required
                </label>
                <select
                  id="pbg_requried"
                  name="pbg_requried"
                  value={formData.pbg_requried}
                  onChange={(e) =>
                    setFormData((prev) => ({
                      ...prev,
                      pbg_requried:
                        e.target.value === "true"
                          ? true
                          : e.target.value === "false"
                            ? false
                            : null,
                    }))
                  }
                  className="form-input input-form"
                >
                  <option value="">PBG Required</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
                {errors.pbg_requried && (
                  <span className="error-message">{errors.pbg_requried}</span>
                )}
              </div>
              {formData.pbg_requried && (
                <div className="flex-columns">
                  <label className="form-labels">
                    Pbg Details <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="pbg_details"
                    placeholder="Pbg Details"
                    value={formData.pbg_details}
                    onChange={handleInputChange}
                    className={`form-input input-form ${errors.pbg_details ? "error" : inputState.pbg_details ? "success" : ""}`}
                  />
                  <br />
                  {errors.pbg_details && (
                    <span className="error-message">{errors.pbg_details}</span>
                  )}
                </div>
              )}

              <div className="flex-columns">
                <label className="form-labels">
                  Consultancy Cost (in crores)
                </label>
                <input
                  type="number"
                  name="consultancy_fees"
                  placeholder="e.g. 2.5 (in crores)"
                  value={formData.consultancy_fees}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.consultancy_fees ? "error" : inputState.consultancy_fees ? "success" : ""}`}
                />
                {errors.consultancy_fees && (
                  <span className="error-message">
                    {errors.consultancy_fees}
                  </span>
                )}
              </div>
              <div className="flex-columns">
                <label className="form-labels">
                  Construction Fees (in crores)
                </label>
                <input
                  type="number"
                  name="construction_fees"
                  placeholder="e.g. 2.5 (in crores)"
                  value={formData.construction_fees}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.construction_fees ? "error" : inputState.construction_fees ? "success" : ""}`}
                />
                {errors.construction_fees && (
                  <span className="error-message">
                    {errors.construction_fees}
                  </span>
                )}
              </div>

              <div className="flex-columns">
                <label className="form-labels">GST</label>
                <br />
                <select
                  name="GST_construction"
                  value={formData.GST_construction}
                  onChange={handleInputChange}
                  placeholder="Select GST Consultancy"
                  className={`form-input input-form ${errors.GST_construction ? "error" : inputState.GST_construction ? "success" : ""}`}
                >
                  <option value="">Select GST</option>
                  <option value="Including">Including</option>
                  <option value="Excluding">Excluding</option>
                </select>
                {errors.GST_construction && (
                  <span className="error-message">
                    {errors.GST_construction}
                  </span>
                )}
              </div>

              <div className="flex-columns">
                <label className="form-labels">Length</label>{" "}
                <span className="required">*</span>
                <br />
                <input
                  type="number"
                  name="length"
                  placeholder="Example - 125"
                  value={formData.length}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.length ? "error" : inputState.length ? "success" : ""}`}
                />
                <br />
                {errors.length && (
                  <span className="error-message">{errors.length}</span>
                )}
              </div>

              <div className="flex-columns">
                <label className="form-labels">
                  {formData.tender_type === "DPR"
                    ? "Construction Duration"
                    : "Project Duration"}
                </label>
                <input
                  type="number"
                  name="duration.construction"
                  placeholder="Example - 24 months"
                  value={formData.duration.construction}
                  onChange={handleInputChange}
                  className={`form-input input-form ${
                    errors["duration.construction"]
                      ? "error"
                      : inputState?.duration?.construction
                        ? "success"
                        : ""
                  }`}
                />
                {errors["duration.construction"] && (
                  <span className="error-message">
                    {errors["duration.construction"]}
                  </span>
                )}
              </div>

              <div className="flex-columns">
                <label className="form-labels">DLP Duration</label>
                <input
                  type="number"
                  name="duration.dlp"
                  placeholder="Example - 24 months"
                  value={formData.duration.dlp}
                  onChange={handleInputChange}
                  className={`form-input input-form ${
                    errors["duration.dlp"]
                      ? "error"
                      : inputState?.duration?.dlp
                        ? "success"
                        : ""
                  }`}
                />
                {errors["duration.dlp"] && (
                  <span className="error-message">
                    {errors["duration.dlp"]}
                  </span>
                )}
              </div>

              <div className="flex-columns">
                <label className="form-labels">OnM Duration</label>
                <input
                  type="number"
                  name="duration.onm"
                  placeholder="Example - 24 months"
                  value={formData.duration.onm}
                  onChange={handleInputChange}
                  className={`form-input input-form ${
                    errors["duration.onm"]
                      ? "error"
                      : inputState?.duration?.onm
                        ? "success"
                        : ""
                  }`}
                />
                {errors["duration.onm"] && (
                  <span className="error-message">
                    {errors["duration.onm"]}
                  </span>
                )}
              </div>

              {/* <div className="flex-columns">
                                <label className="form-labels">KM Cost</label>
                                <br />
                                <input
                                    type="number"
                                    name="km_cost"
                                    placeholder="Example - 150000"
                                    value={formData.km_cost}
                                    onChange={handleInputChange}
                                    className={`form-input input-form ${errors.km_cost ? 'error' : inputState.km_cost ? 'success' : ''}`}
                                />
                                {errors.km_cost && <span className="error-message">{errors.km_cost}</span>}
                            </div> */}

              <div className="flex-columns">
                <label className="form-labels">Remarks</label>
                <br />
                <textarea
                  name="remarks"
                  placeholder="Example - Project site visit completed and documents verified."
                  value={formData.remarks}
                  onChange={handleInputChange}
                  className={`form-input input-form ${errors.remarks ? "error" : inputState.remarks ? "success" : ""}`}
                />
                {errors.remarks && (
                  <span className="error-message">{errors.remarks}</span>
                )}
              </div>
              <div style={{ width: "100%" }}>
                {" "}
                <div
                  style={{
                    width: "100%",
                    maxWidth: 480,
                    margin: "0",
                    background: "#fff",
                    borderRadius: 8,
                    boxShadow: "0 2px 12px #eee",
                    padding: 32,
                  }}
                >
                  <label
                    className="form-labels font-weight500 font-size-subheading"
                    style={{
                      marginBottom: 12,
                      display: "block",
                      fontSize: 18,
                      fontWeight: 600,
                    }}
                  >
                    Upload Tender Document
                  </label>
                  <input
                    type="file"
                    multiple
                    onChange={handleRfpFileChange}
                    style={{ marginBottom: 24, width: "100%" }}
                    className="form-control"
                  />

                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      width: "100%",
                      maxHeight: 180,
                      overflowY: "auto",
                      border: rfpFiles.length ? "1px solid #ececec" : "none",
                      borderRadius: 6,
                      background: rfpFiles.length ? "#fafafd" : "none",
                    }}
                  >
                    {rfpFiles.map((file, index) => (
                      <li
                        key={file.name}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 8px",
                          borderBottom:
                            index !== rfpFiles.length - 1
                              ? "1px solid #ececec"
                              : "none",
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            fill="#6c63ff"
                            style={{ marginRight: 8, verticalAlign: "middle" }}
                          >
                            <rect width="18" height="18" rx="3" />
                          </svg>
                          {file.name}
                        </span>
                        <button
                          onClick={() => handleRemove(index)}
                          style={{
                            marginLeft: 16,
                            padding: "4px 12px",
                            backgroundColor: "#ff4e4e",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            fontWeight: 500,
                            cursor: "pointer",
                            fontSize: 14,
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                    {!rfpFiles.length && (
                      <li
                        style={{
                          color: "#999",
                          textAlign: "center",
                          padding: 20,
                        }}
                      >
                        No files uploaded
                      </li>
                    )}
                  </ul>
                </div>
                <div
                  style={{
                    width: "100%",
                    maxWidth: 480,
                    margin: "0",
                    background: "#fff",
                    borderRadius: 8,
                    boxShadow: "0 2px 12px #eee",
                    padding: 32,
                  }}
                >
                  <label
                    className="form-labels font-weight500 font-size-subheading"
                    style={{
                      marginBottom: 12,
                      display: "block",
                      fontSize: 18,
                      fontWeight: 600,
                    }}
                  >
                    Upload Tender Other Document
                  </label>
                  <input
                    type="file"
                    multiple
                    onChange={handleRfpFileOtherChange}
                    style={{ marginBottom: 24, width: "100%" }}
                    className="form-control"
                  />

                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      width: "100%",
                      maxHeight: 180,
                      overflowY: "auto",
                      border: rfpFilesother.length
                        ? "1px solid #ececec"
                        : "none",
                      borderRadius: 6,
                      background: rfpFilesother.length ? "#fafafd" : "none",
                    }}
                  >
                    {rfpFilesother.map((file, index) => (
                      <li
                        key={file.name}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 8px",
                          borderBottom:
                            index !== rfpFilesother.length - 1
                              ? "1px solid #ececec"
                              : "none",
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            fill="#6c63ff"
                            style={{ marginRight: 8, verticalAlign: "middle" }}
                          >
                            <rect width="18" height="18" rx="3" />
                          </svg>
                          {file.name}
                        </span>
                        <button
                          onClick={() => handleRemoveOther(index)}
                          style={{
                            marginLeft: 16,
                            padding: "4px 12px",
                            backgroundColor: "#ff4e4e",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            fontWeight: 500,
                            cursor: "pointer",
                            fontSize: 14,
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                    {!rfpFilesother.length && (
                      <li
                        style={{
                          color: "#999",
                          textAlign: "center",
                          padding: 20,
                        }}
                      >
                        No files uploaded
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>

            <div className="button-models">
              <button
                type="submit"
                onClick={handleSubmit}
                className="model-button model-button-submit"
              >
                Submit
              </button>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted &&
                Object.keys(errors).length > 0 &&
                (Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">
                    Please fill all mandatory fields!
                  </h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors)
                      .map((field) =>
                        field
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (char) => char.toUpperCase()),
                      )
                      .join(", ") + " are required!"}
                  </h6>
                ))}
            </p>
          </form>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={100000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

const UpdateBidDetails = ({
  i,
  getBidData,
  toggleState,
  usedWhere,
  BidData,
  filters,
  onUpdateSuccess,
}) => {
  const [show, setShow] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
  const [lastUpdatedTenderId, setLastUpdatedTenderId] = useState(null);
  const uniqueStreamTypes = new Set();
  const [JvPartnerData, setJvPartnerData] = useState([]);
  const [docNames, setDocNames] = useState("");
  const fileInputRef = useRef("");

  const states = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  const getJvPartner = async () => {
    setBuffering(true);
    let url;
    try {
      url = `${BASE_URL}/siteproject/JVPartner/`;

      const sub = await axios.get(url);

      setJvPartnerData(sub.data);
    } catch (err) {
      handleErrorToast(err);
    } finally {
      setBuffering(false);
    }
  };

  const handleClose = () => {
    setFormData({
      tender_id: "",
      tender_name: "",
      sector: "",
      tender_type: "",
      client: "",
      submission_date: "",
      publish_date: "",
      lane: "",
      state: "",
      consultancy_fees: "",
      construction_fees: "",
      GST_construction: "",
      length: "",
      duration: {
        construction: "",
        dlp: "",
        onm: "",
      },
      type_of_project: "",
      km_cost: "",
      remarks: "",
      pbg_requried: "",
      pbg_details: "",
    });
    setDocNames("");
    setErrors({});
    setShow(false);

    setWishData({
      associate_allowed: false,
      jv_partner_external: false,
      qualified: false,
      technical_marking: false,
      jv_partner_name: "",
      jv_partner_qualification_criteria: "",
      tenderIDD: null,
    });

    setFinalData({
      final_jv_name: "",
      lead_partner: "",
      assosiate_partner: "",
      external_jv: "",
      emd_amount: "",
      emd_unit: "",
      team_required: "",
      team_requirements_details: "",
      recipient_details: "",
      bg_amount: "",
      bg_type: "",
      emd_type: "",
      emd_submission_type: "",
      tendersubmission: "",
      tenderIDD: "",
    });
  };
  const handleShow = () => {
    setShow(true);
    getSubCompany();
    getJvPartner();
    clientList.forEach((entry) => {
      uniqueStreamTypes.add(entry.client_name);
    });
    const filteredData = { ...i };
    const toDatetimeLocal = (isoString) => {
      if (!isoString) return "";
      const date = new Date(isoString);
      const tzOffset = date.getTimezoneOffset() * 60000; // offset in ms
      const localISOTime = new Date(date - tzOffset).toISOString().slice(0, 16);
      return localISOTime; // "2025-09-18T05:22"
    };
    const extractRequiredFields = (data) => ({
      tender_id: data.tender_id || "",
      tender_name: data.tender_name || "",
      sector: data.sector || "",
      tender_type: data.tender_type || "",
      client: data.client || "",
      submission_date: data.corrigendum_date
        ? toDatetimeLocal(data.corrigendum_date)
        : toDatetimeLocal(data?.submission_date) || "",
      publish_date: data.publish_date || "",
      lane: data.lane || "",
      state: data.state || "",
      consultancy_fees: data.consultancy_fees || "",
      construction_fees: data.construction_fees || "",
      GST_construction: data.GST_construction || "",
      length: data.length || "",
      duration: {
        construction: data.duration?.construction || "",
        dlp: data.duration?.dlp || "",
        onm: data.duration?.onm || "",
      },
      type_of_project: data.type_of_project || "",
      km_cost: data.km_cost || "",
      remarks: data.remarks || "",
      ro: data.ro || "",
    });

    const cleanedData = extractRequiredFields(filteredData);
    setFormData(cleanedData);
  };

  const [buffer, setBuffering] = useState(false); //buffering logic

  const [formData, setFormData] = useState({
    tender_id: "",
    tender_name: "",
    sector: "",
    tender_type: "",
    client: "",
    submission_date: "",
    publish_date: "",
    lane: "",
    state: "",
    consultancy_fees: "",
    construction_fees: "",
    GST_construction: "",
    length: "",
    duration: {
      construction: "",
      dlp: "",
      onm: "",
    },
    type_of_project: "",
    km_cost: "",
    ro: "",
    remarks: "",
    pbg_requried: "",
    pbg_details: "",
    is_special_tender: "",
    special_structure_type: "",
  });

  const [wishListData, setWishData] = useState({
    associate_allowed: false,
    jv_partner_external: false,
    qualified: false,
    technical_marking: false,
    jv_partner_type: "",
    jv_partner_qualification_criteria: "",
    tenderIDD: null,
  });

  const [tenderId, setTenderId] = useState("null");

  useEffect(() => {
    setTenderId(wishListData.tenderIDD);
  }, [wishListData.tenderIDD]);
  const [wishlistinputState, setwishlistInputState] = useState({});
  const handleWishListInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    setwishlistInputState((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
            ? "green"
            : ""
          : newValue
            ? "green"
            : "",
    }));

    setWishData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,
      };

      return updatedFormData;
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const [finalData, setFinalData] = useState({
    final_jv_name: "",
    lead_partner: "",
    assosiate_partner: "",
    external_jv: "",
    emd_amount: "",
    emd_unit: "",
    team_required: "",
    team_requirements_details: "",
    recipient_details: "",
    bg_amount: "",
    bg_type: "",
    emd_type: "",
    emd_submission_type: "",
    tendersubmission: "",
    tenderIDD: "",
  });
  useEffect(() => {
    setTenderId(finalData.tenderIDD);
  }, [finalData.tenderIDD]);
  const [finalinputState, setfinalInputState] = useState({});
  const handlefinalInputChange = (e) => {
    const { name, value, type, checked } = e.target;

    let newValue;
    if (type === "checkbox") {
      newValue = checked;
    } else {
      newValue = value;
    }

    setfinalInputState((prevState) => ({
      ...prevState,
      [name]:
        type === "checkbox"
          ? checked
            ? "green"
            : ""
          : newValue
            ? "green"
            : "",
    }));

    setFinalData((prevFormData) => {
      const updatedFormData = {
        ...prevFormData,
        [name]: newValue,
      };

      return updatedFormData;
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        delete updatedErrors[name];
        return updatedErrors;
      });
    }
  };

  const getSubCompany = async () => {
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSiteSubCompanyList(sub.data);
    } catch (error) {}
  };

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};

    const requiredFields = [
      "tender_id",
      "submission_date",
      "length",
      "tender_name",
      "sector",
      "tender_type",
      "client",
      "state",
      "publish_date",
      formData.sector === "Highway" ? "lane" : null,
      // formData.pbg_requried ? "pbg_details" : null,
      // formData.is_special_tender && (formData.special_structure_type === null || formData.special_structure_type === "null" || formData.special_structure_type === "") ? "special_structure_type" : null,
    ];

    const getValue = (path) => {
      return (
        path != null &&
        path
          .split(".")
          .reduce(
            (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
            formData,
          )
      );
    };

    // requiredFields.forEach((field) => {
    //     const value = getValue(field);
    //     console.log(value, field)
    //     if (!value) {
    //         newErrors[field] = `${field.replace(/\./g, ' ').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())} is required!`;
    //     }
    // });

    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked, options, files } = e.target;

    let newValue;
    if (type === "select-multiple") {
      newValue = Array.from(options)
        .filter((option) => option.selected)
        .map((option) => option.value);
    } else if (type === "checkbox") {
      newValue = checked;
    } else if (type === "file") {
      newValue = files.length > 0 ? files[0] : null;
    } else {
      newValue = value;
    }

    const keys = name.split(".");
    const topKey = keys[0];

    setFormData((prevFormData) => {
      const updatedFormData = { ...prevFormData };

      if (keys.length === 2) {
        updatedFormData[topKey] = {
          ...updatedFormData[topKey],
          [keys[1]]: newValue,
        };
      } else {
        updatedFormData[name] = newValue;
      }

      return updatedFormData;
    });

    setInputState((prevState) => {
      if (keys.length === 2) {
        return {
          ...prevState,
          [topKey]: {
            ...prevState[topKey],
            [keys[1]]: newValue ? "green" : "",
          },
        };
      } else {
        return {
          ...prevState,
          [name]: newValue ? "green" : "",
        };
      }
    });

    if (value.trim()) {
      setErrors((prevErrors) => {
        const updatedErrors = { ...prevErrors };
        if (keys.length === 2 && updatedErrors[topKey]) {
          updatedErrors[topKey] = {
            ...updatedErrors[topKey],
          };
          delete updatedErrors[topKey][keys[1]];
          if (Object.keys(updatedErrors[topKey]).length === 0) {
            delete updatedErrors[topKey];
          }
        } else {
          delete updatedErrors[name];
        }
        return updatedErrors;
      });
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    if (file) {
      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-"); // Format: YYYY-MM-DD
      const time = now
        .toLocaleTimeString("en-GB", { hour12: false })
        .replace(/:/g, "-"); // Format: HH-MM-SS
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = "";
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        randomCode += allChars[randomIndex];
      }
      const customFileName = `Aimantra ${date} ${time}_${randomCode} ${file.name}`;
      const customFile = new File([file], customFileName, { type: file.type });

      setFormData({
        ...formData,
        document: customFile,
      });
      setDocNames(customFileName);
    } else {
      setDocNames("");
    }
  };

  const handleClear = () => {
    setFormData((prevState) => ({
      ...prevState,
      document: null,
    }));
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }

    setDocNames("");
  };

  const [loading, setLoading] = useState(false); //loading logic
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validateForm()) {
      setLoading(true); //loading logic
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      const formDataToSend = new FormData();
      const symbols = "!@#$%^&*()_-+=";
      const lowercaseLetters = "abcdefghijklmnopqrstuvwxyz";
      const uppercaseLetters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      const numbers = "0123456789";
      const now = new Date();
      const date = now
        .toLocaleDateString("en-GB")
        .split("/")
        .reverse()
        .join("-");
      const time = now
        .toLocaleTimeString("en-GB", { hour12: false })
        .replace(/:/g, "-");
      const allChars = symbols + lowercaseLetters + uppercaseLetters + numbers;
      let randomCode = "";
      for (let i = 0; i < 8; i++) {
        const randomIndex = Math.floor(Math.random() * allChars.length);
        randomCode += allChars[randomIndex];
      }

      const originalFile2 = formData?.document;
      const customFileName2 = `Aimantra ${date} ${time}_${randomCode} ${originalFile2?.name}`;
      const customFile2 = new File([originalFile2], customFileName2, {
        type: originalFile2?.type,
      });
      Object.keys(formData).forEach((key) => {
        if (key !== "document") {
          if (key === "duration") {
            formDataToSend.append(
              "duration",
              JSON.stringify(formData.duration),
            );
          } else if (key === "submission_date") {
            formDataToSend.append(
              "submission_date",
              formatISTWithOffset(formData.submission_date),
            );
          } else {
            formDataToSend.append(key, formData[key]);
          }
        }
      });
      if (formData.document) {
        formDataToSend.append("document", formData.document);
      }
      try {
        let data = null;
        let id = null;

        console.log(formData.tender_id, "tender id delete");
        if (usedWhere === "downward") {
          setLastUpdatedTenderId(formData.tender_id);
          data = formData;
          id = i.id;
        } else if (usedWhere === "upward" && toggleState === 2) {
          setLastUpdatedTenderId(formData.tender_id);
          data = wishListData;
          id = tenderId;
        } else if (usedWhere === "upward" && toggleState === 4) {
          setLastUpdatedTenderId(formData.tender_id);
          data = finalData;
          id = tenderId;
        }

        let res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${id}/`,
          formDataToSend,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          console.log("fucntion started", usedWhere, lastUpdatedTenderId);

          sessionStorage.setItem("scrollTenderId", i.tender_id);
          // onUpdateSuccess(i.tender_id);

          setShow(false);
          await getBidData(filters);
        } else {
        }
      } catch (err) {
        //toast Logic
        handleErrorToast(err);
      } finally {
        setLoading(false); //loading logic
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [tenderData, settenderData] = useState({});
  const getData = async () => {
    setBuffering(true); // Start Buffering
    let url;
    try {
      url = `${BASE_URL}/siteproject/tenderBDfilterbyid/${tenderId}/`;

      const sub = await axios.get(url);

      settenderData(sub.data);
    } catch (err) {
      handleErrorToast(err); // Toast Logic
    } finally {
      setBuffering(false); // End Buffering
    }
  };

  useEffect(() => {
    if (toggleState === 4 && show === true && tenderId && tenderId !== "null") {
      getData();
    }
  }, [toggleState, show, tenderId]);

  return (
    <>
      <button
        title="Edit Tender Details"
        className={usedWhere === "downward" ? "view_button" : "upload-svg"}
        onClick={handleShow}
      >
        {usedWhere === "downward" ? (
          <>
            <UpdatePencil color={"#2576bc"} />{" "}
          </>
        ) : toggleState === 2 && usedWhere === "upward" ? (
          <>
            <AddwithWhiteCircle />
            Eligibility Cretria
          </>
        ) : toggleState === 9 && usedWhere === "upward" ? (
          <>
            <AddwithWhiteCircle />
            Final Details
          </>
        ) : (
          ""
        )}
      </button>

      <Modal
        Modal
        show={show}
        onHide={handleClose}
        dialogClassName={
          usedWhere === "downward" || toggleState === 9
            ? "ourcompany-model"
            : toggleState === 2 && usedWhere === "upward"
              ? "custom-modal"
              : ""
        }
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>
            {usedWhere === "downward" ? (
              <>Edit Tender Details</>
            ) : toggleState === 2 && usedWhere === "upward" ? (
              <>Add Eligibility Cretria</>
            ) : toggleState === 9 && usedWhere === "upward" ? (
              <>Add Final Details</>
            ) : (
              ""
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-form">
            {usedWhere === "downward" ? (
              <>
                <div className="form-flex-wrap">
                  <div className="flex-column">
                    <label className="form-labels">
                      Tender ID <span className="required">*</span>
                    </label>
                    <input
                      type="text"
                      name="tender_id"
                      placeholder="Example - NHAI2025-RJ-011"
                      value={formData.tender_id}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.tender_id ? "error" : inputState.tender_id ? "success" : ""}`}
                    />
                    {errors.tender_id && (
                      <span className="error-message">{errors.tender_id}</span>
                    )}
                  </div>
                  <div className="flex-column">
                    <div
                      className="flex-row justify-between form-labels"
                      style={{ height: "25px" }}
                    >
                      <label htmlFor="tender_name" className="">
                        Tender Name
                        <span className="required">*</span>
                      </label>
                      <div className="checkbox-wrapper">
                        <label className="custom-checkbox  font-weight500 font-size-subheading">
                          <input
                            type="checkbox"
                            name="is_special_tender"
                            checked={formData.is_special_tender || false}
                            onChange={handleInputChange}
                          />
                          <span className="checkmark"></span>
                          Special Tender
                        </label>
                      </div>
                    </div>
                    <input
                      type="text"
                      name="tender_name"
                      placeholder="Example - NH66 Highway Project"
                      value={formData.tender_name}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.tender_name ? "error" : inputState.tender_name ? "success" : ""}`}
                    />
                    {errors.tender_name && (
                      <span className="error-message">
                        {errors.tender_name}
                      </span>
                    )}
                  </div>
                  {formData.is_special_tender && (
                    <div className="flex-columns">
                      <label className="form-labels">
                        Special Structure Type{" "}
                        <span className="required">*</span>{" "}
                      </label>
                      <br />
                      <select
                        name="special_structure_type"
                        placeholder="Special Structure"
                        value={formData.special_structure_type}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.special_structure_type ? "error" : inputState.special_structure_type ? "success" : ""}`}
                      >
                        <option value="">Select structure type</option>
                        <option value="tunnel">Tunnel</option>
                        <option value="major_bridge">Major Bridge</option>
                        <option value="cable_stayed">Cable Stayed</option>
                        <option value="elevated">Elevated</option>
                      </select>
                      {errors.special_structure_type && (
                        <span className="error-message">
                          {errors.special_structure_type}
                        </span>
                      )}
                    </div>
                  )}
                  <div className="flex-column">
                    <label className="form-labels">
                      Sector <span className="required">*</span>{" "}
                    </label>
                    <select
                      name="sector"
                      value={formData.sector}
                      onChange={handleInputChange}
                      placeholder="Select Sector"
                      className={`form-input input-form ${errors.sector ? "error" : inputState.sector ? "success" : ""}`}
                    >
                      <option value="">Select sector</option>
                      <option value="Highway">Highway</option>
                      <option value="Railway">Railway</option>
                      <option value="Metro">Metro</option>
                      <option value="Water">Water</option>
                      <option value="Ropeway">Ropeway</option>
                      <option value="Building">Building</option>
                      <option value="Other">Other</option>
                    </select>
                    {errors.sector && (
                      <span className="error-message">{errors.sector}</span>
                    )}
                  </div>

                  {formData.sector === "Other" && (
                    <div className="flex-column">
                      <label className="form-labels">Other Sector Type </label>
                      <input
                        type="text"
                        name="other_sector_type"
                        placeholder="Other Sector Type Name"
                        value={formData.other_sector_type}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.other_sector_type ? "error" : inputState.other_sector_type ? "success" : ""}`}
                      />
                      {errors.other_sector_type && (
                        <span className="error-message">
                          {errors.other_sector_type}
                        </span>
                      )}
                    </div>
                  )}

                  {/* Tender Type */}
                  <div className="flex-column">
                    <label className="form-labels">
                      Tender Type <span className="required">*</span>
                    </label>
                    <select
                      name="tender_type"
                      value={formData.tender_type}
                      onChange={handleInputChange}
                      placeholder="Select Tender Type"
                      className={`form-input input-form ${
                        errors.tender_type
                          ? "error"
                          : inputState.tender_type
                            ? "success"
                            : ""
                      }`}
                    >
                      <option value="">Select Tender Type</option>

                      {/* Always visible */}
                      <option value="Feasibility">Feasibility</option>
                      <option value="DPR">DPR</option>
                      <option value="FesibilityCumDPR">
                        Feasibility Cum DPR
                      </option>
                      <option value="Authority_Engineer">
                        Authority Engineer
                      </option>
                      <option value="Independent_Engineer">
                        Independent Engineer
                      </option>
                      <option value="PMC">PMC</option>
                      <option value="Supervision">Supervision</option>
                      <option value="eoi">EOI</option>
                      <option value="Empanelment">Empanelment</option>
                      <option value="O&M">O&amp;M</option>
                      <option value="IEO&M">IE O&amp;M</option>
                      <option value="AE_O&M">AE O&amp;M</option>
                      <option value="Supervision_O&M">
                        Supervision O&amp;M
                      </option>
                      <option value="Survey">Survey</option>
                      <option value="Technology">Technology</option>
                      <option value="machinery">Machinery</option>
                      <option value="slope_stability">Slope Stability</option>
                      <option value="slope_protection">Slope Protection</option>
                      <option value="Detailed_Design">Detailed Design</option>
                      <option value="Architecture">Architecture</option>
                      <option value="safety_consultant">
                        SAFETY CONSULTANT
                      </option>
                      <option value="pms">PMS</option>
                      <option value="Other">Other</option>

                      {/* 👇 Show only if sector === "Railway" */}
                      {formData.sector === "Railway" && (
                        <>
                          <option value="PSSA">PSSA</option>
                          <option value="GC">GC</option>
                          <option value="Temping">Temping</option>
                          <option value="FLS">FLS</option>
                          <option value="Station_Redevelopment">
                            Station Redevelopment
                          </option>
                        </>
                      )}
                    </select>
                    <br />
                    {errors.tender_type && (
                      <span className="error-message">
                        {errors.tender_type}
                      </span>
                    )}
                  </div>

                  {formData.tender_type === "Other" && (
                    <div className="flex-column">
                      <label className="form-labels">Other Sector Type </label>
                      <input
                        type="text"
                        name="other_tender_type"
                        placeholder="Other Tender Type Name"
                        value={formData.other_tender_type}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.other_tender_type ? "error" : inputState.other_tender_type ? "success" : ""}`}
                      />
                      {errors.other_tender_type && (
                        <span className="error-message">
                          {errors.other_tender_type}
                        </span>
                      )}
                    </div>
                  )}

                  <div className="flex-column">
                    <label className="form-labels">
                      Client <span className="required">*</span>{" "}
                    </label>
                    <select
                      name="client"
                      value={formData.client}
                      onChange={handleInputChange}
                      placeholder="Select Client"
                      className={`form-input input-form ${errors.client ? "error" : inputState.client ? "success" : ""}`}
                    >
                      <option value="">Select Client</option>
                      {formData.sector === "Railway" ? (
                        <>
                          <option value="CENTRAL_RAILWAY">
                            Central Railway
                          </option>
                          <option value="EAST_CENTRAL_RAILWAY">
                            East Central Railway
                          </option>
                          <option value="EASTERN_RAILWAY">
                            Eastern Railway
                          </option>
                          <option value="MINISTRY_OF_RAILWAYS">
                            Ministry of Railways
                          </option>
                          <option value="MUMBAI_RAILWAY_VIKAS_CORPORATION">
                            Mumbai Railway Vikas Corporation
                          </option>
                          <option value="NORTH_CENTRAL_RAILWAY">
                            North Central Railway
                          </option>
                          <option value="NORTH_EASTERN_RAILWAYS">
                            North Eastern Railways
                          </option>
                          <option value="NORTHEST_FRONTIER_RAILWAYA">
                            Northest Frontier Railwaya
                          </option>
                          <option value="NORTHERN_RAILWAY">
                            Northern Railway
                          </option>
                          <option value="RAILWAY_ENERGY_MANAGEMENT_COMPANY_LIMITED">
                            Railway Energy Management Company Limited
                          </option>
                          <option value="SOUTH_CENTRAL_RAILWAY">
                            South Central Railway
                          </option>
                          <option value="SOUTH_EASTERN_RAILWAYS">
                            South Eastern Railways
                          </option>
                          <option value="SOUTHEST_FRONTIER_RAILWAY">
                            Southest Frontier Railway
                          </option>
                          <option value="SOUTHERN_RAILWAY">
                            Southern Railway
                          </option>
                          <option value="EAST_COAST_RAILWAY">
                            EAST COAST RAILWAY
                          </option>
                          <option value="South_West_Central_Railway">
                            South West Central Railway
                          </option>
                          <option value="West_Central_Railway ">
                            West Central Railway{" "}
                          </option>
                          <option value="South_Western_Railway">
                            {" "}
                            South Western Railway
                          </option>
                          <option value="Western_Railway">
                            Western Railway
                          </option>
                          <option value="North_Western_Railway">
                            {" "}
                            North Western Railway{" "}
                          </option>
                          <option value="South_East_Railway">
                            South East Railway
                          </option>
                        </>
                      ) : (
                        <>
                          <option value="NHAI">NHAI</option>
                          <option value="MORTH">MoRTH</option>
                          <option value="NHIDCL">NHIDCL</option>
                          <option value="BRO">BRO</option>
                          <option value="PWDS">PWDs</option>
                          <option value="MPRDCL">MPRDCL</option>
                          <option value="MHRDCL">MHRDCL</option>
                          <option value="GJRDCL">GJRDCL</option>
                          <option value="SHAJ">SHAJ</option>
                          <option value="HSIIDC">HSIIDC</option>
                          <option value="BHRDCL">BHRDCL</option>
                          <option value="UPEIDA">UPEIDA</option>
                          <option value="UPHA&SP">UPHA&SP</option>
                          <option value="RITES">RITES</option>
                          <option value="HRBG">HRBG</option>
                          <option value="APCRDA">APCRDA</option>
                          <option value="RCDB">RCDB</option>
                          <option value="BSIL">BSIL</option>
                          <option value="BUIDCL">BUIDCL</option>
                          <option value="CMRL">CMRL</option>
                          <option value="DMRCL">DMRCL</option>
                          <option value="EPIL">EPIL</option>
                          <option value="HRSI&IDCL">HRSI&IDCL</option>
                          <option value="H&UDCL">H&UDCL</option>
                          <option value="J&KRRDA">J&KRRDA</option>
                          <option value="MHSIDC">MHSIDC</option>
                          <option value="MHMRCL">MHMRCL</option>
                          <option value="RJSRD&CCL">RJSRD&CCL</option>
                          <option value="KARDCL">KARDCL</option>
                          <option value="TNRDL">TNRDL</option>
                          <option value="APRDC">APRDC</option>
                          <option value="PBIDB">PBIDB</option>
                          <option value="R&BDT">R&BDT</option>
                          <option value="RCDJ">RCDJ</option>
                          <option value="JHSRDC">JHSRDC</option>
                          <option value="HPPWD">HPPWD</option>
                          <option value="UKPWD">UKPWD</option>
                          <option value="DSI&IDC">DSI&IDC</option>
                          <option value="GOAPWD">GOAPWD</option>
                          <option value="HRRIDC">HRRIDC</option>
                          <option value="RIDFOD">RIDFOD</option>
                          <option value="RJSID&IC">RJSID&IC</option>
                          <option value="KLRFB">KLRFB</option>
                          <option value="RSHA">RSHA</option>
                          <option value="BIDA">BIDA</option>
                          <option value="MIDFC">MIDFC</option>
                          <option value="SOI">SOI</option>
                          <option value="JNPT">JNPT</option>
                          <option value="BMRCL">BMRCL</option>
                          <option value="OBCCL">OBCCL</option>
                          <option value="OTHER">Other</option>
                        </>
                      )}
                    </select>
                    {errors.client && (
                      <span className="error-message">{errors.client}</span>
                    )}
                  </div>
                  <div className="flex-column">
                    <label className="form-labels">Client Ro</label>
                    <input
                      type="text"
                      name="ro"
                      value={formData?.ro}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors?.ro ? "error" : inputState?.ro ? "success" : ""}`}
                    />
                    {errors?.ro && (
                      <span className="error-message">{errors.ro}</span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">
                      Publish Date <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      name="publish_date"
                      value={formData?.publish_date}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors?.publish_date ? "error" : inputState?.publish_date ? "success" : ""}`}
                    />
                    {errors?.publish_date && (
                      <span className="error-message">
                        {errors?.publish_date}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">
                      Submission Date <span className="required">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      name="submission_date"
                      value={formData?.submission_date}
                      onChange={handleInputChange}
                      min={new Date().toISOString().slice(0, 16)}
                      className={`form-input input-form ${errors?.submission_date ? "error" : inputState?.submission_date ? "success" : ""}`}
                    />
                    {errors?.submission_date && (
                      <span className="error-message">
                        {errors?.submission_date}
                      </span>
                    )}
                  </div>

                  {formData.sector != "Railway" && (
                    <div className="flex-column">
                      <label className="form-labels">Lane</label>

                      <select
                        name="lane"
                        value={formData.lane}
                        onChange={handleInputChange}
                        placeholder="Select Lane"
                        className={`form-input input-form ${
                          errors.lane
                            ? "error"
                            : inputState.lane
                              ? "success"
                              : ""
                        }`}
                      >
                        <option value="">Select Lane</option>
                        <option value="2">2 Lane</option>
                        <option value="4">4 Lane</option>
                        <option value="6">6 Lane</option>
                        <option value="8">8 Lane</option>
                        <option value="nhsl">NHSL</option>
                        <option value="rfp_not_uploaded">Not Available</option>
                        <option value="not_required">Not Required</option>
                      </select>

                      {errors.lane && (
                        <span className="error-message">{errors.lane}</span>
                      )}
                    </div>
                  )}

                  <div className="flex-column">
                    <label className="form-labels">
                      State <span className="required">*</span>{" "}
                    </label>
                    <select
                      name="state"
                      value={formData.state}
                      onChange={handleInputChange}
                      placeholder="Select State"
                      className={`form-input input-form ${errors.state ? "error" : inputState.state ? "success" : ""}`}
                    >
                      <option value="">Select State</option>
                      {states.map((state) => (
                        <option key={state} value={state}>
                          {state}
                        </option>
                      ))}
                    </select>
                    {errors.state && (
                      <span className="error-message">{errors.state}</span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label htmlFor="pbg_requried" className="form-labels">
                      PBG Required
                    </label>
                    <select
                      id="pbg_requried"
                      name="pbg_requried"
                      value={formData.pbg_requried}
                      onChange={(e) =>
                        setFormData((prev) => ({
                          ...prev,
                          pbg_requried:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null,
                        }))
                      }
                      className="form-input input-form"
                    >
                      <option value="">PBG Required</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                    {errors.pbg_requried && (
                      <span className="error-message">
                        {errors.pbg_requried}
                      </span>
                    )}
                  </div>
                  {formData.pbg_requried && (
                    <div className="flex-column">
                      <label className="form-labels">Pbg Details</label>
                      <input
                        type="text"
                        name="pbg_details"
                        placeholder="Pbg Details"
                        value={formData.pbg_details}
                        onChange={handleInputChange}
                        className={`form-input input-form ${errors.pbg_details ? "error" : inputState.pbg_details ? "success" : ""}`}
                      />
                      {errors.pbg_details && (
                        <span className="error-message">
                          {errors.pbg_details}
                        </span>
                      )}
                    </div>
                  )}

                  <div className="flex-column">
                    <label className="form-labels">
                      Consultancy Fees (in crores)
                    </label>
                    <input
                      type="number"
                      name="consultancy_fees"
                      placeholder="e.g. 2.5 (in crores)"
                      value={formData.consultancy_fees}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.consultancy_fees ? "error" : inputState.consultancy_fees ? "success" : ""}`}
                    />
                    {errors.consultancy_fees && (
                      <span className="error-message">
                        {errors.consultancy_fees}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">
                      Construction Fees (in crores)
                    </label>
                    <input
                      type="number"
                      name="construction_fees"
                      placeholder="e.g. 2.5 (in crores)"
                      value={formData.construction_fees}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.construction_fees ? "error" : inputState.construction_fees ? "success" : ""}`}
                    />
                    {errors.construction_fees && (
                      <span className="error-message">
                        {errors.construction_fees}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">Length </label>
                    <input
                      type="number"
                      name="length"
                      placeholder="Example - 125"
                      value={formData.length}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.length ? "error" : inputState.length ? "success" : ""}`}
                    />
                    {errors.length && (
                      <span className="error-message">{errors.length}</span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">
                      {formData.tender_type === "DPR"
                        ? "Construction Duration"
                        : "Project Duration"}{" "}
                    </label>
                    <input
                      type="number"
                      name="duration.construction"
                      placeholder="Example - 24 months"
                      value={formData.duration.construction}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors["duration.construction"] ? "error" : inputState.duration ? "success" : ""}`}
                    />
                    {errors["duration.construction"] && (
                      <span className="error-message">
                        {errors["duration.construction"]}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">DLP Duration </label>
                    <input
                      type="number"
                      name="duration.dlp"
                      placeholder="Example - 24 months"
                      value={formData.duration.dlp}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors["duration.dlp"] ? "error" : inputState.duration ? "success" : ""}`}
                    />
                    {errors["duration.dlp"] && (
                      <span className="error-message">
                        {errors["duration.dlp"]}
                      </span>
                    )}
                  </div>

                  <div className="flex-column">
                    <label className="form-labels">OnM Duration</label>
                    <input
                      type="number"
                      name="duration.onm"
                      placeholder="Example - 24 months"
                      value={formData.duration.onm}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors["duration.onm"] ? "error" : inputState.duration ? "success" : ""}`}
                    />
                    {errors["duration.onm"] && (
                      <span className="error-message">
                        {errors["duration.onm"]}
                      </span>
                    )}
                  </div>

                  {/* <div className="flex-column">
                                        <label className="form-labels">KM Cost </label>
                                        <input
                                            type="number"
                                            name="km_cost"
                                            placeholder="Example - 150000"
                                            value={formData.km_cost}
                                            onChange={handleInputChange}
                                            className={`form-input input-form ${errors.km_cost ? 'error' : inputState.km_cost ? 'success' : ''}`}
                                        />
                                        {errors.km_cost && <span className="error-message">{errors.km_cost}</span>}
                                    </div> */}

                  <div className="flex-column">
                    <label className="form-labels">Remarks</label>
                    <textarea
                      name="remarks"
                      placeholder="Example - Project site visit completed and documents verified."
                      value={formData.remarks}
                      onChange={handleInputChange}
                      className={`form-input input-form ${errors.remarks ? "error" : inputState.remarks ? "success" : ""}`}
                    />
                    {errors.remarks && (
                      <span className="error-message">{errors.remarks}</span>
                    )}
                  </div>

                  <div className="upload-button-field">
                    <div className="flex-column">
                      <label
                        htmlFor="document"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        Upload Document
                      </label>
                      <div className="flex-row justify-between">
                        <div>
                          <label htmlFor="document" className="svg-icon">
                            <div className="svg-field form-input align-center">
                              <Attachment />
                            </div>
                          </label>
                          <input
                            type="file"
                            id="document"
                            name="document_file"
                            accept=".zip, .pdf, .xls, .xlsx"
                            style={{ display: "none" }}
                            onChange={handleFileChange}
                            ref={fileInputRef}
                          />
                        </div>
                        <div style={{ width: docNames ? "6vw" : "35vw" }}>
                          {docNames ? (
                            <span className="file-name">{docNames}</span>
                          ) : i.document ? (
                            <a href={i.document} target="blank">
                              <div className="flex-row justify-center">
                                <DocumentIcon /> View
                              </div>
                            </a>
                          ) : (
                            ""
                          )}
                        </div>
                        {docNames !== "" && (
                          <div
                            className="flex-row justify-between"
                            style={{ width: "12vw" }}
                          >
                            <button
                              type="button"
                              title="Clear File"
                              onClick={handleClear}
                              className="file-clear clear-button"
                            >
                              Clear
                            </button>
                          </div>
                        )}
                      </div>
                      {errors.document && (
                        <span className="error-message font-size-text">
                          {errors.document}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
              </>
            ) : toggleState === 2 && usedWhere === "upward" ? (
              <>
                <div>
                  <div className="form-flex-wrap">
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="tenderIDD"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Select Tender<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="tenderIDD"
                        name="tenderIDD"
                        value={wishListData.tenderIDD}
                        onChange={handleWishListInputChange}
                        className={`form-input form-group-selection ${
                          errors.tenderIDD
                            ? "error"
                            : wishlistinputState.tenderIDD
                              ? "success"
                              : ""
                        }`}
                      >
                        <option value="">Select Tender</option>
                        {BidData.filter(
                          (item) => item.is_in_bidlist === true,
                        ).map((item) => (
                          <option value={item.id}>{item.tender_name}</option>
                        ))}
                      </select>
                      <div>
                        {errors.tenderIDD && (
                          <span className="error-message font-size-text ">
                            {errors.tenderIDD}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="checkbox-wrapper">
                      <label className="custom-checkbox  font-weight500 font-size-subheading">
                        <input
                          type="checkbox"
                          name="qualified"
                          checked={wishListData.qualified || false}
                          onChange={handleWishListInputChange}
                        />
                        <span className="checkmark"></span>
                        Qualified
                      </label>
                    </div>
                    <div className="checkbox-wrapper">
                      <label className="custom-checkbox  font-weight500 font-size-subheading">
                        <input
                          type="checkbox"
                          name="jv_partner_external"
                          checked={wishListData.jv_partner_external || false}
                          onChange={handleWishListInputChange}
                        />
                        <span className="checkmark"></span>
                        Is External JV Partner
                      </label>
                    </div>
                    <div className="checkbox-wrapper">
                      <label className="custom-checkbox  font-weight500 font-size-subheading">
                        <input
                          type="checkbox"
                          name="technical_marking"
                          checked={wishListData.technical_marking || false}
                          onChange={handleWishListInputChange}
                        />
                        <span className="checkmark"></span>
                        Technical Marking
                      </label>
                    </div>
                    <div className="checkbox-wrapper">
                      <label className="custom-checkbox  font-weight500 font-size-subheading">
                        <input
                          type="checkbox"
                          name="associate_allowed"
                          checked={wishListData.associate_allowed || false}
                          onChange={handleWishListInputChange}
                        />
                        <span className="checkmark"></span>
                        Associate Allowed
                      </label>
                    </div>
                  </div>
                  <div className="form-flex-wrap">
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="jv_partner_qualification_criteria"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        JV Partner Qualification Criteria
                        <span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="jv_partner_qualification_criteria"
                        name="jv_partner_qualification_criteria"
                        value={wishListData.jv_partner_qualification_criteria}
                        onChange={handleWishListInputChange}
                        className={`form-input form-input-time form-group-selection ${
                          errors.jv_partner_qualification_criteria
                            ? "error"
                            : wishlistinputState.jv_partner_qualification_criteria
                              ? "success"
                              : ""
                        }`}
                      >
                        <option value="null">
                          Select Qualification Criteria{" "}
                        </option>
                        <option value="As_Whole">As Per Whole</option>
                        <option value="As_per_technicalshare">
                          As Per Technical Share
                        </option>
                        <option value="As_per_technicalshare_financeshare">
                          Techincal and Finance Share
                        </option>
                      </select>

                      <div>
                        {errors.jv_partner_qualification_criteria && (
                          <span className="error-message font-size-text ">
                            {errors.jv_partner_qualification_criteria}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="jv_partner_type"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        JV Partner<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="jv_partner_type"
                        name="jv_partner_type"
                        value={wishListData.jv_partner_type}
                        onChange={handleWishListInputChange}
                        className={`form-input form-input-time form-group-selection ${
                          errors.jv_partner_type
                            ? "error"
                            : wishlistinputState.jv_partner_type
                              ? "success"
                              : ""
                        }`}
                      >
                        <option value="null">Select JV Partner </option>
                        <option value="sapl">SAPL</option>
                        <option value="cipl">CIPL</option>
                        <option value="joint">Joint</option>
                      </select>

                      <div>
                        {errors.jv_partner_type && (
                          <span className="error-message font-size-text ">
                            {errors.jv_partner_type}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : toggleState === 9 && usedWhere === "upward" ? (
              <>
                <div className="form-flex-wrap">
                  <div className="form-flex-wrap">
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="tenderIDD"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Select Tender<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="tenderIDD"
                        name="tenderIDD"
                        value={finalData.tenderIDD}
                        onChange={handlefinalInputChange}
                        className={`form-input form-group-selection ${
                          errors.tenderIDD
                            ? "error"
                            : finalinputState.tenderIDD
                              ? "success"
                              : ""
                        }`}
                      >
                        <option value="">Select Tender</option>
                        {BidData.filter(
                          (item) => item.is_finalize === true,
                        ).map((item) => (
                          <option value={item.id}>{item.tender_name}</option>
                        ))}
                      </select>
                      <div>
                        {errors.tenderIDD && (
                          <span className="error-message font-size-text ">
                            {errors.tenderIDD}
                          </span>
                        )}
                      </div>
                    </div>

                    <div className="flex-column">
                      <label
                        htmlFor="lead_partner"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Lead Partner Name
                      </label>
                      <input
                        maxLength={50}
                        type="text"
                        id="lead_partner"
                        name="lead_partner"
                        placeholder="Lead Partner Name"
                        onChange={handlefinalInputChange}
                        value={finalData.lead_partner}
                        className={`form-input ${
                          errors.lead_partner
                            ? "error"
                            : finalinputState.lead_partner
                              ? "success"
                              : ""
                        }`}
                      />
                      {errors.lead_partner && (
                        <span className="error-message font-size-text ">
                          {errors.lead_partner}
                        </span>
                      )}
                    </div>
                    <div className="flex-column">
                      <label
                        htmlFor="final_jv_name"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        JV Partner Name
                      </label>
                      <input
                        maxLength={50}
                        type="text"
                        id="final_jv_name"
                        name="final_jv_name"
                        placeholder="JV Partner Name"
                        onChange={handlefinalInputChange}
                        value={finalData.final_jv_name}
                        className={`form-input ${
                          errors.final_jv_name
                            ? "error"
                            : finalinputState.final_jv_name
                              ? "success"
                              : ""
                        }`}
                      />
                      {errors.final_jv_name && (
                        <span className="error-message font-size-text ">
                          {errors.final_jv_name}
                        </span>
                      )}
                    </div>
                    {tenderData.associate_allowed && (
                      <div className="flex-column">
                        <label
                          htmlFor="assosiate_partner"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Associate Partner Name
                        </label>
                        <input
                          maxLength={50}
                          type="text"
                          id="assosiate_partner"
                          name="assosiate_partner"
                          placeholder="Associate Partner Name"
                          onChange={handlefinalInputChange}
                          value={finalData.assosiate_partner}
                          className={`form-input ${
                            errors.assosiate_partner
                              ? "error"
                              : finalinputState.assosiate_partner
                                ? "success"
                                : ""
                          }`}
                        />
                        {errors.assosiate_partner && (
                          <span className="error-message font-size-text ">
                            {errors.assosiate_partner}
                          </span>
                        )}
                      </div>
                    )}
                    {tenderData.jv_partner_external && (
                      <div className="flex-column">
                        <label
                          htmlFor="external_jv"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          External JV Partner Name
                        </label>
                        <input
                          maxLength={50}
                          type="text"
                          id="external_jv"
                          name="external_jv"
                          placeholder="External JV Partner Name"
                          onChange={handlefinalInputChange}
                          value={finalData.external_jv}
                          className={`form-input ${
                            errors.external_jv
                              ? "error"
                              : finalinputState.external_jv
                                ? "success"
                                : ""
                          }`}
                        />
                        {errors.external_jv && (
                          <span className="error-message font-size-text ">
                            {errors.external_jv}
                          </span>
                        )}
                      </div>
                    )}

                    <div className="flex-column">
                      <label
                        htmlFor="emd_amount"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        EMD Amount
                      </label>
                      <input
                        maxLength={50}
                        type="number"
                        id="emd_amount"
                        name="emd_amount"
                        placeholder="Enter full amount (e.g. 1 crore = 10000000)"
                        onChange={handlefinalInputChange}
                        value={finalData.emd_amount}
                        className={`form-input ${
                          errors.emd_amount
                            ? "error"
                            : finalinputState.emd_amount
                              ? "success"
                              : ""
                        }`}
                      />
                      {errors.emd_amount && (
                        <span className="error-message font-size-text ">
                          {errors.emd_amount}
                        </span>
                      )}
                    </div>

                    <div className="dropdown-wrapper flex justify-center ">
                      <label
                        htmlFor="emd_unit"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        EMD Unit<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="emd_unit"
                        name="emd_unit"
                        value={finalData.emd_unit}
                        onChange={handlefinalInputChange}
                        className="form-input font-size-subheading"
                      >
                        <option value="">Select EMD Unit</option>
                        <option value="crore">Crore</option>
                        <option value="lakhs">Lakhs</option>
                        <option value="thousand">thousand</option>
                        <option value="hundreds">hundreds</option>
                      </select>
                    </div>

                    <div className="flex-column">
                      <label
                        htmlFor="team_requirements_details"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Team Requirements Details
                      </label>
                      <input
                        maxLength={50}
                        type="number"
                        id="team_requirements_details"
                        name="team_requirements_details"
                        placeholder="Team Requirements Details"
                        onChange={handlefinalInputChange}
                        value={finalData.team_requirements_details}
                        className={`form-input ${
                          errors.team_requirements_details
                            ? "error"
                            : finalinputState.team_requirements_details
                              ? "success"
                              : ""
                        }`}
                      />
                      {errors.team_requirements_details && (
                        <span className="error-message font-size-text ">
                          {errors.team_requirements_details}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="flex-column">
                    <label
                      htmlFor="recipient_details"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Recipient Details
                    </label>
                    <input
                      maxLength={50}
                      type="text"
                      id="recipient_details"
                      name="recipient_details"
                      placeholder="Recipient Details"
                      onChange={handlefinalInputChange}
                      value={finalData.recipient_details}
                      className={`form-input ${
                        errors.recipient_details
                          ? "error"
                          : finalinputState.recipient_details
                            ? "success"
                            : ""
                      }`}
                    />
                    {errors.recipient_details && (
                      <span className="error-message font-size-text ">
                        {errors.recipient_details}
                      </span>
                    )}
                  </div>
                  <div className="form-flex-wrap " style={{ width: "100%" }}>
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="emd_submission_type"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        EMD Submisssion Type<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="emd_submission_type"
                        name="emd_submission_type"
                        value={finalData.emd_submission_type}
                        onChange={handlefinalInputChange}
                        className={`form-input form-input-time form-group-selection ${
                          errors.emd_submission_type
                            ? "error"
                            : finalinputState.emd_submission_type
                              ? "success"
                              : ""
                        }`}
                      >
                        <option value="null">EMD Submisssion Type</option>
                        <option value="Online">Online</option>
                        <option value="HardCopy">HardCopy</option>
                        <option value="Both">Both</option>
                      </select>

                      <div>
                        {errors.emd_submission_type && (
                          <span className="error-message font-size-text ">
                            {errors.emd_submission_type}
                          </span>
                        )}
                      </div>
                    </div>
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="tendersubmission"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Tender Submission Type
                        <span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="tendersubmission"
                        name="tendersubmission"
                        value={finalData.tendersubmission}
                        onChange={handlefinalInputChange}
                        className={`form-input form-input-time form-group-selection ${
                          errors.tendersubmission
                            ? "error"
                            : finalinputState.tendersubmission
                              ? "success"
                              : ""
                        }`}
                      >
                        <option value="null">Tender Submission Type</option>
                        <option value="Online">Online</option>
                        <option value="HardCopy">HardCopy</option>
                        <option value="Both">Both</option>
                      </select>

                      <div>
                        {errors.tendersubmission && (
                          <span className="error-message font-size-text ">
                            {errors.tendersubmission}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              ""
            )}

            <div className="button-models">
              <button
                type="submit"
                onClick={handleSubmit}
                className="model-button model-button-submit"
              >
                {toggleState === 1 ? "Update" : "Submit"}
              </button>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted &&
                Object.keys(errors).length > 0 &&
                (Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">
                    Please fill all mandatory fields!
                  </h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors)
                      .map((field) =>
                        field
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (char) => char.toUpperCase()),
                      )
                      .join(", ") + " are required!"}
                  </h6>
                ))}
            </p>
          </form>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};
// const UpdateBidDetailsTab = ({ i, getBidData, toggleState, usedWhere, BidData, filters, onUpdateSuccess }) => {
//     const [show, setShow] = useState(false);
//     const [selectedToggleState, setSelectedToggleState] = useState(toggleState || 2); // Default to Eligibility Criteria
//     const [moveToStage, setMoveToStage] = useState('');
//     const getJvPartner = async () => {
//         setBuffering(true);
//         let url;
//         try {
//             url = `${BASE_URL}/siteproject/JVPartner/`;

//             const sub = await axios.get(url);

//             setJvPartnerData(sub.data);
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             setBuffering(false);
//         }
//     };
//     const [buffer, setBuffering] = useState(false); //buffering logic
//     // Add this state for the move to dropdown
//     const [targetStage, setTargetStage] = useState('');

//     // Your existing states...
//     const [wishListData, setWishData] = useState({
//         associate_allowed: false,
//         jv_partner_external: false,
//         qualified: false,
//         technical_marking: false,
//         jv_partner_type: "",
//         jv_partner_qualification_criteria: "",
//         tenderIDD: null,

//     });

//     const [tenderId, setTenderId] = useState("null");

//     useEffect(() => {

//         setTenderId(wishListData.tenderIDD)

//     }, [wishListData.tenderIDD]);
//     const [wishlistinputState, setwishlistInputState] = useState({});
//     const [isSubmitted, setIsSubmitted] = useState(false);
//     const [errors, setErrors] = useState({});
//     const [inputState, setInputState] = useState({});

//     const validateForm = () => {
//         const newErrors = {};

//         const requiredFields = [
//             'tender_id', 'submission_date', "length", "tender_name", "sector", "tender_type", "client", "state",
//             formData.sector === "Highway" ? "lane" : null,
//             // formData.pbg_requried ? "pbg_details" : null,
//             // formData.is_special_tender && (formData.special_structure_type === null || formData.special_structure_type === "null" || formData.special_structure_type === "") ? "special_structure_type" : null,
//         ];

//         const getValue = (path) => {
//             return path != null && path.split('.').reduce((obj, key) => (obj && obj[key] !== undefined) ? obj[key] : '', formData);
//         };

//         // requiredFields.forEach((field) => {
//         //     const value = getValue(field);
//         //     console.log(value, field)
//         //     if (!value) {
//         //         newErrors[field] = `${field.replace(/\./g, ' ').replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())} is required!`;
//         //     }
//         // });

//         setErrors(newErrors);
//         setIsSubmitted(true);
//         return Object.keys(newErrors).length === 0;
//     };
//     const handleWishListInputChange = (e) => {
//         const { name, value, type, checked } = e.target;

//         let newValue;
//         if (type === "checkbox") {
//             newValue = checked;
//         } else {
//             newValue = value;
//         }

//         setwishlistInputState((prevState) => ({
//             ...prevState,
//             [name]:
//                 type === "checkbox"
//                     ? checked
//                         ? "green"
//                         : ""
//                     : newValue
//                         ? "green"
//                         : "",
//         }));

//         setWishData((prevFormData) => {
//             const updatedFormData = {
//                 ...prevFormData,
//                 [name]: newValue,
//             };

//             return updatedFormData;
//         });

//         if (value.trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[name];
//                 return updatedErrors;
//             });
//         }
//     };

//     const [finalData, setFinalData] = useState({
//         final_jv_name: "",
//         lead_partner: "",
//         assosiate_partner: "",
//         external_jv: "",
//         emd_amount: "",
//         emd_unit: "",
//         team_required: "",
//         team_requirements_details: '',
//         recipient_details: '',
//         bg_amount: "",
//         bg_type: "",
//         emd_type: "",
//         emd_submission_type: "",
//         tendersubmission: "",
//         tenderIDD: "",
//     });
//     useEffect(() => {

//         setTenderId(finalData.tenderIDD)

//     }, [finalData.tenderIDD]);
//     const [finalinputState, setfinalInputState] = useState({});
//     const handlefinalInputChange = (e) => {
//         const { name, value, type, checked } = e.target;

//         let newValue;
//         if (type === "checkbox") {
//             newValue = checked;
//         } else {
//             newValue = value;
//         }

//         setfinalInputState((prevState) => ({
//             ...prevState,
//             [name]:
//                 type === "checkbox"
//                     ? checked
//                         ? "green"
//                         : ""
//                     : newValue
//                         ? "green"
//                         : "",
//         }));

//         setFinalData((prevFormData) => {
//             const updatedFormData = {
//                 ...prevFormData,
//                 [name]: newValue,
//             };

//             return updatedFormData;
//         });

//         if (value.trim()) {
//             setErrors((prevErrors) => {
//                 const updatedErrors = { ...prevErrors };
//                 delete updatedErrors[name];
//                 return updatedErrors;
//             });
//         }
//     };
//     const [clientList, setClientList] = useState([]);
//     const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
//     const [lastUpdatedTenderId, setLastUpdatedTenderId] = useState(null);
//     const uniqueStreamTypes = new Set();
//     const [JvPartnerData, setJvPartnerData] = useState([]);
//     const [docNames, setDocNames] = useState("");
//     const fileInputRef = useRef("");
//     const handleClose = () => {
//         setFormData({
//             tender_id: '',
//             tender_name: '',
//             sector: '',
//             tender_type: '',
//             client: '',
//             submission_date: '',
//             publish_date: '',
//             lane: '',
//             state: '',
//             consultancy_fees: '',
//             construction_fees: '',
//             GST_construction: '',
//             length: '',
//             duration: {
//                 construction: '',
//                 dlp: '',
//                 onm: '',
//             },
//             type_of_project: '',
//             km_cost: '',
//             remarks: '',
//             pbg_requried: '',
//             pbg_details: '',
//         });
//         setDocNames("");
//         setErrors({});
//         setShow(false);

//         setWishData({
//             associate_allowed: false,
//             jv_partner_external: false,
//             qualified: false,
//             technical_marking: false,
//             jv_partner_name: "",
//             jv_partner_qualification_criteria: "",
//             tenderIDD: null,

//         });

//         setFinalData({
//             final_jv_name: "",
//             lead_partner: "",
//             assosiate_partner: "",
//             external_jv: "",
//             emd_amount: "",
//             emd_unit: '',
//             team_required: "",
//             team_requirements_details: '',
//             recipient_details: '',
//             bg_amount: "",
//             bg_type: "",
//             emd_type: "",
//             emd_submission_type: "",
//             tendersubmission: "",
//             tenderIDD: "",
//         })
//     };

//     const [formData, setFormData] = useState({
//         tender_id: '',
//         tender_name: '',
//         sector: '',
//         tender_type: '',
//         client: '',
//         submission_date: '',
//         publish_date: '',
//         lane: '',
//         state: '',
//         consultancy_fees: '',
//         construction_fees: '',
//         GST_construction: '',
//         length: '',
//         duration: {
//             construction: '',
//             dlp: '',
//             onm: '',
//         },
//         type_of_project: '',
//         km_cost: '',
//         ro: "",
//         remarks: '',
//         pbg_requried: "",
//         pbg_details: "",
//         is_special_tender: '',
//         special_structure_type: '',
//     });
//     // Add this function to handle stage selection
//     const handleStageChange = (e) => {
//         const stage = parseInt(e.target.value);
//         setTargetStage(stage);
//         setSelectedToggleState(stage); // Update the form fields based on selected stage
//     };
//     const getSubCompany = async () => {
//         try {
//             const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
//             setSiteSubCompanyList(sub.data);
//         } catch (error) {

//         }
//     }
//     // Modify your handleShow function
//     const handleShow = () => {
//         setShow(true);
//         getSubCompany();
//         getJvPartner();
//         clientList.forEach((entry) => {
//             uniqueStreamTypes.add(entry.client_name);
//         });

//         // Set default target stage based on current toggleState
//         setTargetStage(toggleState);
//         setSelectedToggleState(toggleState);

//         const filteredData = { ...i };
//         const toDatetimeLocal = (isoString) => {
//             if (!isoString) return "";
//             const date = new Date(isoString);
//             const tzOffset = date.getTimezoneOffset() * 60000;
//             const localISOTime = new Date(date - tzOffset).toISOString().slice(0, 16);
//             return localISOTime;
//         };

//         const extractRequiredFields = (data) => ({
//             tender_id: data.tender_id || '',
//             tender_name: data.tender_name || '',
//             sector: data.sector || '',
//             tender_type: data.tender_type || '',
//             client: data.client || '',
//             submission_date: toDatetimeLocal(data?.submission_date) || '',
//             publish_date: data.publish_date || '',
//             lane: data.lane || '',
//             state: data.state || '',
//             consultancy_fees: data.consultancy_fees || '',
//             construction_fees: data.construction_fees || '',
//             GST_construction: data.GST_construction || '',
//             length: data.length || '',
//             duration: {
//                 construction: data.duration?.construction || '',
//                 dlp: data.duration?.dlp || '',
//                 onm: data.duration?.onm || '',
//             },
//             type_of_project: data.type_of_project || '',
//             km_cost: data.km_cost || '',
//             remarks: data.remarks || '',
//             ro: data.ro || "",
//         });

//         const cleanedData = extractRequiredFields(filteredData);
//         setFormData(cleanedData);
//     };

//     // Modify your modal header to show dynamic title based on selected stage
//     const getModalTitle = () => {
//         switch (selectedToggleState) {
//             case 2: return 'Eligibility Criteria';
//             case 3: return 'Finalize Partners';
//             case 4: return 'Tender Documents';
//             case 5: return 'Tender Result';
//             default: return 'Update Tender Details';
//         }
//     };
//     const [loading, setLoading] = useState(false); //loading logic
//     // Modify your submit handler to handle stage movement
//     const handleSubmit = async (e) => {
//         e.preventDefault();

//         if (validateForm()) {
//             setLoading(true);
//             const loadingToastId = toast.loading("Loading: Please wait...");
//             const formDataToSend = new FormData();

//             // Your existing form data preparation...

//             try {
//                 let data = null;
//                 let id = null;

//                 // Determine which data to send based on selected toggle state
//                 if (usedWhere === "downward") {
//                     setLastUpdatedTenderId(formData.tender_id);
//                     data = formData;
//                     id = i.id;
//                 } else {
//                     setLastUpdatedTenderId(formData.tender_id);

//                     // Use data based on selected toggle state
//                     if (selectedToggleState === 2) {
//                         data = wishListData;
//                     } else if (selectedToggleState === 3 || selectedToggleState === 4) {
//                         data = finalData;
//                     }
//                     id = tenderId;
//                 }

//                 // Add stage movement flags based on targetStage
//                 if (targetStage) {
//                     const stageFlags = {
//                         '2': { is_in_targetlist: true, date_bb: new Date().toISOString() },
//                         '3': { is_finalize: true, date_cc: new Date().toISOString() },
//                         '4': { is_submitted: true, date_ee: new Date().toISOString() },
//                         '9': { is_bid_prepare_in_progress: true, date_ff: new Date().toISOString() }
//                     };

//                     if (stageFlags[targetStage]) {
//                         Object.assign(data, stageFlags[targetStage]);
//                     }
//                 }

//                 let res = await axios.put(
//                     `${BASE_URL}/siteproject/BidTenderUpdate/${id}/`,
//                     formDataToSend, {
//                     headers: {
//                         "Content-Type": "multipart/form-data",
//                     },
//                 });

//                 if (res.status === 200 || res.status === 201) {
//                     sessionStorage.setItem('scrollTenderId', i.tender_id);
//                     setShow(false);
//                     await getBidData(filters);

//                     // Show success message based on target stage
//                     const successMessages = {
//                         '2': "Moved to Target Tenders successfully",
//                         '3': "Moved to Final Tenders successfully",
//                         '4': "Moved to Submitted Tenders successfully",
//                         '9': "Moved to Bid Prepare In Progress successfully"
//                     };

//                     if (targetStage && successMessages[targetStage]) {
//                         toast.success(successMessages[targetStage]);
//                     }
//                 }
//             } catch (err) {
//                 handleErrorToast(err);
//             } finally {
//                 setLoading(false);
//                 toast.dismiss(loadingToastId);
//             }
//         }
//     };
//     const Partners = [
//         { key: "Saptagon Asia Private Limited", value: "Saptagon Asia Private Limited" },
//         { key: "Civilmantra Infracon Limited", value: "Civilmantra Infracon Limited" },
//         { key: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED", value: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED" },
//         { key: "ISAN CORPORATION", value: "ISAN CORPORATION" },
//         { key: "MARC TECHNOCRATS LIMITED", value: "MARC TECHNOCRATS LIMITED" },
//         { key: "ALOMNDS GLOBAL INFRASTRUCTURE", value: "ALOMNDS GLOBAL INFRASTRUCTURE" },
//         { key: "VOYANTS SOLUTIONS PVT LTD", value: "VOYANTS SOLUTIONS PVT LTD" },
//         { key: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED", value: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED" },
//         { key: "MSV INTERNATIONAL", value: "MSV INTERNATIONAL" },
//         { key: "YONGMA ENGINEERING CO LTD", value: "YONGMA ENGINEERING CO LTD" },
//         { key: "TECH-4", value: "TECH-4" },
//         { key: "AECOM INDIA PRIVATE LIMITED", value: "AECOM INDIA PRIVATE LIMITED" },
//         { key: "SMEC INDIA PVT LTD", value: "SMEC INDIA PVT LTD" },
//         { key: "SPECTRUM", value: "SPECTRUM" },
//         { key: "INSTUTIUTE GIPROSTROYMOST", value: "INSTUTIUTE GIPROSTROYMOST" },
//         { key: "RODIC CONSULTANT PRIVATE LIMITED", value: "RODIC CONSULTANT PRIVATE LIMITED" },
//         { key: "CHAITANYA PROJECT CONSULTANCY LTD", value: "CHAITANYA PROJECT CONSULTANCY LTD" },
//         { key: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)", value: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)" },
//         { key: "TPF ENGINEERING PRIVATE LIMITED", value: "TPF ENGINEERING PRIVATE LIMITED" },
//         { key: "INFRAPLUS CONSULTANCY PVT LTD", value: "INFRAPLUS CONSULTANCY PVT LTD" },
//         { key: "RITES LIMITED", value: "RITES LIMITED" },
//         { key: "TPF GETINSAEUROESTUDIOS SL", value: "TPF GETINSAEUROESTUDIOS SL" },
//         { key: "SA INFRASTURCTURE CONSULTING PRIVATE", value: "SA INFRASTURCTURE CONSULTING PRIVATE" },
//         { key: "CEG LIMITED", value: "CEG LIMITED" },
//         { key: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD", value: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD" },
//         { key: "Egis", value: "Egis" },
//         { key: "sapl", value: "SAPL" },
//         { key: "cipl", value: "CIPL" },
//         { key: "joint", value: "Joint" },
//         { key: "Other", value: "Other" },
//         { key: "Not Required", value: "Not Required" }
//     ];
//     return (
//         <>
//             <button
//                 title="Move  Tender to Any Tab"
//                 className={usedWhere === "downward" ? "view_button" : "upload-svg"}
//                 onClick={handleShow}
//             >
//                 {usedWhere === "downward" ?
//                     <>
//                         <UpdatePencil color={"#2576bc"} /> {" "}
//                     </>
//                     : selectedToggleState === 2 && usedWhere === "upward" ?
//                         <>
//                             <AddwithWhiteCircle />
//                             Eligibility Criteria
//                         </> : selectedToggleState === 3 && usedWhere === "upward" ?
//                             <>
//                                 <AddwithWhiteCircle />
//                                 Finalize Partners
//                             </> : selectedToggleState === 4 && usedWhere === "upward" ?
//                                 <>
//                                     <AddwithWhiteCircle />
//                                     Tender Documents
//                                 </> : selectedToggleState === 5 && usedWhere === "upward" ?
//                                     <>
//                                         <AddwithWhiteCircle />
//                                         Tender Result
//                                     </> : ""
//                 }
//             </button>

//             <Modal show={show} onHide={handleClose}
//                 dialogClassName={usedWhere === "downward" || selectedToggleState === 4 ? "ourcompany-model" : ((selectedToggleState === 2) && usedWhere === "upward") ? "custom-modal" : ""}>

//                 <Modal.Header closeButton className="justify-center task-Tab-heading font-weight500 font-size-heading">
//                     <Modal.Title>{getModalTitle()}</Modal.Title>
//                 </Modal.Header>

//                 <Modal.Body>
//                     <form className="register-form">

//                         {/* Move To Dropdown - Only show for upward movement */}

//                         <div className="dropdown-wrapper flex-column justify-center" style={{ marginBottom: '20px' }}>
//                             <label htmlFor="move_to_stage" className="form-label font-weight500 font-size-subheading">
//                                 Move To Stage<span className="required">*</span>
//                             </label>
//                             <select
//                                 id="move_to_stage"
//                                 name="move_to_stage"
//                                 value={targetStage}
//                                 onChange={handleStageChange}
//                                 className="form-input font-size-subheading"
//                             >
//                                 <option value="">Select Stage to Move</option>
//                                 <option value="2">Target Tender</option>
//                                 <option value="9">Bid Prepare In Progress</option>
//                                 <option value="3">Final Tender</option>
//                                 <option value="4">Submit Tender</option>
//                                 <option value="5">Tender Result</option>
//                             </select>
//                         </div>

//                         <>
//                             {selectedToggleState === 2 && (
//                                 // Eligibility Criteria Fields
//                                 <div className="form-flex-wrap">
//                                     <div className="form-flex-wrap">
//                                         <div className="flex-column form-group-selectt">
//                                             <label htmlFor="tenderIDD" className="form-labels  font-weight500    font-size-subheading">
//                                                 Select Tender<span className="required">*</span>
//                                             </label>
//                                             <br />
//                                             <select
//                                                 id="tenderIDD"
//                                                 name="tenderIDD"
//                                                 value={finalData.tenderIDD}
//                                                 onChange={handlefinalInputChange}
//                                                 className={`form-input form-group-selection ${errors.tenderIDD ? "error" : finalinputState.tenderIDD ? "success" : ""
//                                                     }`}
//                                             >
//                                                 <option value="">Select Tender</option>
//                                                 {BidData.filter(item => item.is_finalize === true).map((item) => (
//                                                     <option value={item.id}>{item.tender_name}</option>
//                                                 ))}
//                                             </select>
//                                             <div>
//                                                 {errors.tenderIDD && (
//                                                     <span className="error-message font-size-text ">{errors.tenderIDD}</span>
//                                                 )}
//                                             </div>
//                                         </div>

//                                         <div className="flex-column">
//                                             <label htmlFor="lead_partner" className="form-labels  font-weight500    font-size-subheading">
//                                                 Lead Partner Name
//                                             </label>
//                                             <input
//                                                 maxLength={50}
//                                                 type="text"
//                                                 id="lead_partner"
//                                                 name="lead_partner"
//                                                 placeholder="Lead Partner Name"
//                                                 onChange={handlefinalInputChange}
//                                                 value={finalData.lead_partner}
//                                                 className={`form-input ${errors.lead_partner ? "error" : finalinputState.lead_partner ? "success" : ""
//                                                     }`}
//                                             />
//                                             {errors.lead_partner && (
//                                                 <span className="error-message font-size-text ">{errors.lead_partner}</span>
//                                             )}

//                                         </div>
//                                         <div className="flex-column">
//                                             <label htmlFor="final_jv_name" className="form-labels  font-weight500    font-size-subheading">
//                                                 JV Partner Name
//                                             </label>
//                                             <input
//                                                 maxLength={50}
//                                                 type="text"
//                                                 id="final_jv_name"
//                                                 name="final_jv_name"
//                                                 placeholder="JV Partner Name"
//                                                 onChange={handlefinalInputChange}
//                                                 value={finalData.final_jv_name}
//                                                 className={`form-input ${errors.final_jv_name ? "error" : finalinputState.final_jv_name ? "success" : ""
//                                                     }`}
//                                             />
//                                             {errors.final_jv_name && (
//                                                 <span className="error-message font-size-text ">{errors.final_jv_name}</span>
//                                             )}

//                                         </div>
//                                         {tenderData.associate_allowed &&
//                                             <div className="flex-column">
//                                                 <label htmlFor="assosiate_partner" className="form-labels  font-weight500    font-size-subheading">
//                                                     Associate Partner Name
//                                                 </label>
//                                                 <input
//                                                     maxLength={50}
//                                                     type="text"
//                                                     id="assosiate_partner"
//                                                     name="assosiate_partner"
//                                                     placeholder="Associate Partner Name"
//                                                     onChange={handlefinalInputChange}
//                                                     value={finalData.assosiate_partner}
//                                                     className={`form-input ${errors.assosiate_partner ? "error" : finalinputState.assosiate_partner ? "success" : ""
//                                                         }`}
//                                                 />
//                                                 {errors.assosiate_partner && (
//                                                     <span className="error-message font-size-text ">{errors.assosiate_partner}</span>
//                                                 )}

//                                             </div>
//                                         }
//                                         {tenderData.jv_partner_external &&
//                                             <div className="flex-column">
//                                                 <label htmlFor="external_jv" className="form-labels  font-weight500    font-size-subheading">
//                                                     External JV Partner Name
//                                                 </label>
//                                                 <input
//                                                     maxLength={50}
//                                                     type="text"
//                                                     id="external_jv"
//                                                     name="external_jv"
//                                                     placeholder="External JV Partner Name"
//                                                     onChange={handlefinalInputChange}
//                                                     value={finalData.external_jv}
//                                                     className={`form-input ${errors.external_jv ? "error" : finalinputState.external_jv ? "success" : ""
//                                                         }`}
//                                                 />
//                                                 {errors.external_jv && (
//                                                     <span className="error-message font-size-text ">{errors.external_jv}</span>
//                                                 )}

//                                             </div>
//                                         }

//                                         <div className="flex-column">
//                                             <label htmlFor="emd_amount" className="form-labels  font-weight500    font-size-subheading">
//                                                 EMD Amount
//                                             </label>
//                                             <input
//                                                 maxLength={50}
//                                                 type="number"
//                                                 id="emd_amount"
//                                                 name="emd_amount"
//                                                 placeholder="EMD Amount"
//                                                 onChange={handlefinalInputChange}
//                                                 value={finalData.emd_amount}
//                                                 className={`form-input ${errors.emd_amount ? "error" : finalinputState.emd_amount ? "success" : ""
//                                                     }`}
//                                             />
//                                             {errors.emd_amount && (
//                                                 <span className="error-message font-size-text ">{errors.emd_amount}</span>
//                                             )}

//                                         </div>

//                                         <div className="dropdown-wrapper flex justify-center ">
//                                             <label htmlFor="emd_unit" className="form-labels font-weight500 font-size-subheading">
//                                                 EMD Unit<span className="required">*</span>
//                                             </label>
//                                             <br />
//                                             <select
//                                                 id="emd_unit"
//                                                 name="emd_unit"
//                                                 value={finalData.emd_unit}
//                                                 onChange={handlefinalInputChange}
//                                                 className="form-input font-size-subheading"
//                                             >
//                                                 <option value="">Select EMD Unit</option>
//                                                 <option value="crore">Crore</option>
//                                                 <option value="lakhs">Lakhs</option>
//                                                 <option value="thousand">thousand</option>
//                                                 <option value="hundreds">hundreds</option>
//                                             </select>
//                                         </div>

//                                         <div className="flex-column">
//                                             <label htmlFor="team_requirements_details" className="form-labels  font-weight500    font-size-subheading">
//                                                 Team Requirements Details
//                                             </label>
//                                             <input
//                                                 maxLength={50}
//                                                 type="number"
//                                                 id="team_requirements_details"
//                                                 name="team_requirements_details"
//                                                 placeholder="Team Requirements Details"
//                                                 onChange={handlefinalInputChange}
//                                                 value={finalData.team_requirements_details}
//                                                 className={`form-input ${errors.team_requirements_details ? "error" : finalinputState.team_requirements_details ? "success" : ""
//                                                     }`}
//                                             />
//                                             {errors.team_requirements_details && (
//                                                 <span className="error-message font-size-text ">{errors.team_requirements_details}</span>
//                                             )}

//                                         </div>
//                                     </div>
//                                     <div className="flex-column">
//                                         <label htmlFor="recipient_details" className="form-labels  font-weight500    font-size-subheading">
//                                             Recipient Details
//                                         </label>
//                                         <input
//                                             maxLength={50}
//                                             type="text"
//                                             id="recipient_details"
//                                             name="recipient_details"
//                                             placeholder="Recipient Details"
//                                             onChange={handlefinalInputChange}
//                                             value={finalData.recipient_details}
//                                             className={`form-input ${errors.recipient_details ? "error" : finalinputState.recipient_details ? "success" : ""
//                                                 }`}
//                                         />
//                                         {errors.recipient_details && (
//                                             <span className="error-message font-size-text ">{errors.recipient_details}</span>
//                                         )}

//                                     </div>
//                                     <div className="form-flex-wrap " style={{ width: "100%" }}>

//                                         <div className="flex-column form-group-selectt">
//                                             <label htmlFor="emd_submission_type" className="form-labels  font-weight500    font-size-subheading">
//                                                 EMD Submisssion Type<span className="required">*</span>
//                                             </label>
//                                             <br />
//                                             <select
//                                                 id="emd_submission_type"
//                                                 name="emd_submission_type"
//                                                 value={finalData.emd_submission_type}
//                                                 onChange={handlefinalInputChange}
//                                                 className={`form-input form-input-time form-group-selection ${errors.emd_submission_type ? "error" : finalinputState.emd_submission_type ? "success" : ""
//                                                     }`}
//                                             >
//                                                 <option value="null">EMD Submisssion Type</option>
//                                                 <option value="Online">Online</option>
//                                                 <option value="HardCopy">HardCopy</option>
//                                                 <option value="Both">Both</option>

//                                             </select>

//                                             <div>
//                                                 {errors.emd_submission_type && (
//                                                     <span className="error-message font-size-text ">{errors.emd_submission_type}</span>
//                                                 )}
//                                             </div>
//                                         </div>
//                                         <div className="flex-column form-group-selectt">
//                                             <label htmlFor="tendersubmission" className="form-labels  font-weight500    font-size-subheading">
//                                                 Tender Submission Type<span className="required">*</span>
//                                             </label>
//                                             <br />
//                                             <select
//                                                 id="tendersubmission"
//                                                 name="tendersubmission"
//                                                 value={finalData.tendersubmission}
//                                                 onChange={handlefinalInputChange}
//                                                 className={`form-input form-input-time form-group-selection ${errors.tendersubmission ? "error" : finalinputState.tendersubmission ? "success" : ""
//                                                     }`}
//                                             >
//                                                 <option value="null">Tender Submission Type</option>
//                                                 <option value="Online">Online</option>
//                                                 <option value="HardCopy">HardCopy</option>
//                                                 <option value="Both">Both</option>

//                                             </select>

//                                             <div>
//                                                 {errors.tendersubmission && (
//                                                     <span className="error-message font-size-text ">{errors.tendersubmission}</span>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}

//                             {selectedToggleState === 3 && (
//                                 // Finalize Partners Fields
//                                 <div>
//                                     <div className="form-flex-wrap">
//                                         <div className="flex-column form-group-selectt">
//                                             <label htmlFor="tenderIDD" className="form-labels  font-weight500    font-size-subheading">
//                                                 Select Tender<span className="required">*</span>
//                                             </label>
//                                             <br />
//                                             <select
//                                                 id="tenderIDD"
//                                                 name="tenderIDD"
//                                                 value={wishListData.tenderIDD}
//                                                 onChange={handleWishListInputChange}
//                                                 className={`form-input form-group-selection ${errors.tenderIDD ? "error" : wishlistinputState.tenderIDD ? "success" : ""
//                                                     }`}
//                                             >
//                                                 <option value="">Select Tender</option>
//                                                 {BidData.filter(item => item.is_in_bidlist === true).map((item) => (
//                                                     <option value={item.id}>{item.tender_name}</option>
//                                                 ))}
//                                             </select>
//                                             <div>
//                                                 {errors.tenderIDD && (
//                                                     <span className="error-message font-size-text ">{errors.tenderIDD}</span>
//                                                 )}
//                                             </div>
//                                         </div>
//                                         <div className="checkbox-wrapper">
//                                             <label className="custom-checkbox  font-weight500 font-size-subheading">
//                                                 <input
//                                                     type="checkbox"
//                                                     name="qualified"
//                                                     checked={wishListData.qualified || false}
//                                                     onChange={handleWishListInputChange}
//                                                 />
//                                                 <span className="checkmark"></span>
//                                                 Qualified
//                                             </label>

//                                         </div>
//                                         <div className="checkbox-wrapper">
//                                             <label className="custom-checkbox  font-weight500 font-size-subheading">
//                                                 <input
//                                                     type="checkbox"
//                                                     name="jv_partner_external"
//                                                     checked={wishListData.jv_partner_external || false}
//                                                     onChange={handleWishListInputChange}
//                                                 />
//                                                 <span className="checkmark"></span>
//                                                 Is External JV Partner
//                                             </label>

//                                         </div>
//                                         <div className="checkbox-wrapper">
//                                             <label className="custom-checkbox  font-weight500 font-size-subheading">
//                                                 <input
//                                                     type="checkbox"
//                                                     name="technical_marking"
//                                                     checked={wishListData.technical_marking || false}
//                                                     onChange={handleWishListInputChange}
//                                                 />
//                                                 <span className="checkmark"></span>
//                                                 Technical Marking
//                                             </label>

//                                         </div>
//                                         <div className="checkbox-wrapper">
//                                             <label className="custom-checkbox  font-weight500 font-size-subheading">
//                                                 <input
//                                                     type="checkbox"
//                                                     name="associate_allowed"
//                                                     checked={wishListData.associate_allowed || false}
//                                                     onChange={handleWishListInputChange}
//                                                 />
//                                                 <span className="checkmark"></span>
//                                                 Associate Allowed
//                                             </label>

//                                         </div>
//                                     </div>
//                                     <div className="form-flex-wrap">
//                                         <div className="flex-column form-group-selectt">
//                                             <label htmlFor="jv_partner_qualification_criteria" className="form-labels  font-weight500    font-size-subheading">
//                                                 JV Partner Qualification Criteria<span className="required">*</span>
//                                             </label>
//                                             <br />
//                                             <select
//                                                 id="jv_partner_qualification_criteria"
//                                                 name="jv_partner_qualification_criteria"
//                                                 value={wishListData.jv_partner_qualification_criteria}
//                                                 onChange={handleWishListInputChange}
//                                                 className={`form-input form-input-time form-group-selection ${errors.jv_partner_qualification_criteria ? "error" : wishlistinputState.jv_partner_qualification_criteria ? "success" : ""
//                                                     }`}
//                                             >
//                                                 <option value="null">Select Qualification Criteria </option>
//                                                 <option value="As_Whole">As Per Whole</option>
//                                                 <option value="As_per_technicalshare">As Per Technical Share</option>
//                                                 <option value="As_per_technicalshare_financeshare">Techincal and Finance Share</option>

//                                             </select>

//                                             <div>
//                                                 {errors.jv_partner_qualification_criteria && (
//                                                     <span className="error-message font-size-text ">{errors.jv_partner_qualification_criteria}</span>
//                                                 )}
//                                             </div>
//                                         </div>
//                                         <div className="flex-column form-group-selectt">
//                                             <label htmlFor="jv_partner_type" className="form-labels  font-weight500    font-size-subheading">
//                                                 JV Partner<span className="required">*</span>
//                                             </label>
//                                             <br />
//                                             <select
//                                                 id="jv_partner_type"
//                                                 name="jv_partner_type"
//                                                 value={wishListData.jv_partner_type}
//                                                 onChange={handleWishListInputChange}
//                                                 className={`form-input form-input-time form-group-selection ${errors.jv_partner_type ? "error" : wishlistinputState.jv_partner_type ? "success" : ""
//                                                     }`}
//                                             >
//                                                 <option value="null">Select JV Partner </option>
//                                                 <option value="sapl">SAPL</option>
//                                                 <option value="cipl">CIPL</option>
//                                                 <option value="joint">Joint</option>

//                                             </select>

//                                             <div>
//                                                 {errors.jv_partner_type && (
//                                                     <span className="error-message font-size-text ">{errors.jv_partner_type}</span>
//                                                 )}
//                                             </div>
//                                         </div>
//                                     </div>
//                                 </div>
//                             )}

//                             {selectedToggleState === 4 && (
//                                 // Tender Documents Fields
//                                 <div className="form-flex-wrap">

//                                     {/* Tender Documents Specific Fields */}
//                                     <div className="dropdown-wrapper flex justify-center">
//                                         <label htmlFor="team_required" className="form-labels font-weight500 font-size-subheading">
//                                             Team Required<span className="required">*</span>
//                                         </label>
//                                         <br />
//                                         <select
//                                             name="team_required"
//                                             value={finalData.team_required}
//                                             onChange={handlefinalInputChange}
//                                             className="form-input font-size-subheading"
//                                         >
//                                             <option value="">Select Team Required</option>
//                                             <option value="true">Yes</option>
//                                             <option value="false">No</option>
//                                         </select>
//                                     </div>

//                                     <div className="dropdown-wrapper flex justify-center">
//                                         <label htmlFor="is_emd_required" className="form-labels font-weight500 font-size-subheading">
//                                             EMD Required<span className="required">*</span>
//                                         </label>
//                                         <br />
//                                         <select
//                                             name="is_emd_required"
//                                             value={finalData.is_emd_required}
//                                             onChange={handlefinalInputChange}
//                                             className="form-input font-size-subheading"
//                                         >
//                                             <option value="">Select EMD Required</option>
//                                             <option value="true">Yes</option>
//                                             <option value="false">No</option>
//                                         </select>
//                                     </div>

//                                     {/* Add more tender documents fields as needed */}
//                                 </div>
//                             )}

//                             {selectedToggleState === 5 && (
//                                 // Tender Result Fields
//                                 <div className="form-flex-wrap">
//                                     <div className="dropdown-wrapper flex justify-center">
//                                         <label htmlFor="tech_open" className="form-labels font-weight500 font-size-subheading">
//                                             Tech Open<span className="required">*</span>
//                                         </label>
//                                         <br />
//                                         <select
//                                             name="tech_open"
//                                             value={finalData.tech_open}
//                                             onChange={handlefinalInputChange}
//                                             className="form-input font-size-subheading"
//                                         >
//                                             <option value="">Tech Open</option>
//                                             <option value="true">Yes</option>
//                                             <option value="false">No</option>
//                                         </select>
//                                     </div>

//                                     <div className="dropdown-wrapper flex justify-center">
//                                         <label htmlFor="are_we_l1" className="form-labels font-weight500 font-size-subheading">
//                                             Are We L1<span className="required">*</span>
//                                         </label>
//                                         <br />
//                                         <select
//                                             name="are_we_l1"
//                                             value={finalData.are_we_l1}
//                                             onChange={handlefinalInputChange}
//                                             className="form-input font-size-subheading"
//                                         >
//                                             <option value="">Are We L1</option>
//                                             <option value="true">Yes</option>
//                                             <option value="false">No</option>
//                                         </select>
//                                     </div>

//                                     {/* Add more tender result fields as needed */}
//                                 </div>
//                             )}
//                         </>

//                         <div className="button-models">
//                             <button type="submit" onClick={handleSubmit} className="model-button model-button-submit">
//                                 {usedWhere === "downward" ? "Update" : `Move to ${getModalTitle()}`}
//                             </button>
//                         </div>

//                         <p className="error-message font-size-text">
//                             {isSubmitted && Object.keys(errors).length > 0 && (
//                                 Object.keys(errors).length > 5 ? (
//                                     <h5 className="text-center">Please fill all mandatory fields!</h5>
//                                 ) : (
//                                     <h6 className="text-center">
//                                         {Object.keys(errors)
//                                             .map((field) =>
//                                                 field
//                                                     .replace(/_/g, ' ')
//                                                     .replace(/\b\w/g, (char) => char.toUpperCase())
//                                             )
//                                             .join(', ') + ' are required!'}
//                                     </h6>
//                                 )
//                             )}
//                         </p>
//                     </form>
//                 </Modal.Body>

//                 <ToastContainer
//                     position="top-center"
//                     autoClose={1000}
//                     hideProgressBar={false}
//                     newestOnTop={true}
//                     closeOnClick
//                     rtl={false}
//                     pauseOnFocusLoss
//                     draggable
//                     pauseOnHover
//                 />
//             </Modal>
//         </>
//     );
// };
// const Addtocart = ({ i, getBid, toggleState, filters, setToggleState,getDaysLeftNumber }) => {
//     const [show, setShow] = useState(false);

//     const handleClose = () => setShow(false);
//     const handleShow = () => {
//         setShow(true);
//     };

//     const handleFormSubmit = async (e) => {
//         e.preventDefault();
//         const loadingToastId = toast.loading("Processing...");

//         // Step 1: Prepare updated data
//         const updatedData = {
//             ...i,
//             document: null,
//         };

//         if (toggleState === 1) {
//             updatedData.is_in_bidlist = true;
//             updatedData.date_aa = new Date().toISOString();
//         } else if (toggleState === 2) {
//             updatedData.is_in_targetlist = true;
//             updatedData.date_bb = new Date().toISOString();
//         } else if (toggleState === 3) {
//             updatedData.is_finalize = true;
//             updatedData.date_cc = new Date().toISOString();
//         } else if (toggleState === 9) {
//             updatedData.is_submitted = true;
//             updatedData.date_ee = new Date().toISOString();

//         } else if (toggleState === 4) {
//             updatedData.is_bid_prepare_in_progress = true;
//             updatedData.date_ff = new Date().toISOString();
//             updatedData.assigned_to = toggleEmployeeCode;
//             updatedData.assigned_by = sessionStorage.getItem('emp_code');
//         }

//         // Step 2: Build FormData
//         const formData = new FormData();

//         for (let key in updatedData) {
//             const value = updatedData[key];

//             if (value === null || value === undefined) continue;

//             if (typeof value === 'object' && !Array.isArray(value)) {
//                 // Nested objects (like duration)
//                 formData.append(key, JSON.stringify(value));
//             } else if (Array.isArray(value)) {
//                 // Optional: handle arrays if backend accepts this pattern
//                 value.forEach((item, index) => {
//                     formData.append(`${key}[${index}]`, typeof item === 'object' ? JSON.stringify(item) : item);
//                 });
//             } else {
//                 formData.append(key, value);
//             }
//         }

//         // Step 3: Make request
//         try {
//             const res = await axios.put(
//                 `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
//                 formData,
//                 {
//                     headers: {
//                         "Content-Type": "multipart/form-data",
//                     },
//                 }
//             );

//             if (res.status === 200) {
//                 await getBid(filters);
//                 setShow(false);
//                 toast.dismiss(loadingToastId);
//                 toast.success(
//                     toggleState === 1 ? "Added to WishList" :
//                         toggleState === 2 ? "Added to Target list" :
//                             toggleState === 3 ? "Marked as Final" :
//                                 toggleState === 9 ? "Added To Bid Prepare In Progress" :
//                                     "Marked as Submitted"
//                 );
//                 // setToggleState(prev => prev + 1);
//             }
//         } catch (err) {
//             handleErrorToast(err);
//         } finally {
//             toast.dismiss(loadingToastId);
//         }
//     };
//     const [employeeList, setEmployeeList] = useState([]);
//     const [toggleEmployeeCode, settoggleEmployeeCode] = useState('')

//     const getEmployeeData = async () => {
//         try {
//             const response = await axios.get('https://cipl.aimantra.info/siteproject/employeebyfilterss/null/null/null/134b633a-89b3-4173-a51e-d030c5b562f5/null/null/d11b2d36-9a36-47df-98c4-4e23923c0abb/');
//             setEmployeeList(response.data);
//         } catch (error) {
//             console.error("Error fetching employee data:", error);

//         }
//     }

//     useEffect(() => {
//         if (show) {
//             getEmployeeData()
//         }

//     }, [show])
//     return (
//         <>
//             <button title="Move To Next" onClick={handleShow} style={{ cursor: 'pointer', width: '2.7rem', height: '2.7rem', backgroundColor: '#2576bc', color: 'white', borderRadius: '50%', fontSize: '1.5rem' }}>

//                 <ArrowBullet color={'white'} />

//             </button>

//             <Modal show={show} onHide={handleClose} dialogClassName="request-leave width-40vw">
//                 <Modal.Header closeButton>
//                     <Modal.Title>Move Tender To
//                         {toggleState === 1 ? 'Wish Listed Tenders' :
//                             toggleState === 2 ? 'Target Tenders' :
//                                 toggleState === 3 ? 'Final Tenders' :
//                                     toggleState === 9 ? 'Submitted Tenders' :
//                                         toggleState === 4 ? 'Bid Prepare In Progress Tenders' :
//                                             'Rejected Tenders'}
//                     </Modal.Title>
//                 </Modal.Header>
//                 <Modal.Body>
//                     <div className="parent-div">
//                         Are You Sure You Want to Add This Tender To
//                         {toggleState === 1 ? 'Wish Listed Tenders' :
//                             toggleState === 2 ? 'Target Tenders' :
//                                 toggleState === 3 ? 'Final Tenders' :
//                                     toggleState === 9 ? 'Submitted Tenders' :
//                                         toggleState === 4 ? 'Bid Prepare In Progress Tenders' :
//                                             'Rejected Tenders'}
//                         {i.tender_name}?
//                         {toggleState === 4 &&
//                             <div title="Team Employee" className="flex-column form-group-selectt" style={{ display: 'block' }}>
//                                 <label htmlFor="Site Employees" className="form-labels font-weight500 font-size-subheading">
//                                     Assign Tender To Team <span className="required">*</span>
//                                 </label>
//                                 <br />
//                                 <Select
//                                     options={employeeList.map(emp => ({
//                                         value: emp.emp_code,                // ✅ this is what will be stored onChange
//                                         label: `${emp.emp_code} - ${emp.name}`, // ✅ what will be displayed
//                                     }))}
//                                     onChange={(selectedOption) => {
//                                         if (selectedOption) {
//                                             settoggleEmployeeCode(selectedOption.value); // ✅ set emp_code only
//                                         } else {
//                                             settoggleEmployeeCode(null);
//                                         }
//                                     }}
//                                     value={
//                                         employeeList
//                                             ? employeeList
//                                                 .map(emp => ({
//                                                     value: emp.emp_code,
//                                                     label: `${emp.emp_code} - ${emp.name}`,
//                                                 }))
//                                                 .find(option => option.value === toggleEmployeeCode) || null
//                                             : null
//                                     }
//                                     placeholder="Select an Employee"
//                                     isSearchable
//                                     isClearable
//                                     noOptionsMessage={() => "No other options"}
//                                 // styles={CSSForSelect}
//                                 />

//                                 {/* {error && <span className="error-message font-size-text">{error}</span>} */}
//                             </div>
//                         }
//                         <div className="button-models">
//                             <button className="model-button   font-weight500   model-button-cancel " onClick={handleClose}>
//                                 Cancel
//                             </button>
//                             <button
//                                 onClick={handleFormSubmit}
//                                 className="model-button   font-weight500    model-button-delete"
//                             >
//                                 Confirm
//                             </button>
//                         </div>
//                     </div>

//                 </Modal.Body>
//                 <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover />
//             </Modal>
//         </>
//     );
// };
const Addtocart = ({
  i,
  getBid,
  toggleState,
  filters,
  setToggleState,
  getDaysLeftNumber,
}) => {
  const [show, setShow] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [toggleEmployeeCode, settoggleEmployeeCode] = useState([]);

  const [errors, setErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // -------------------------
  // VALIDATE USING UPDATED DATA ONLY
  // -------------------------
  const validateUpdatedData = (data) => {
    const newErrors = {};
    let requiredFields = [];

    if (toggleState === 2) {
      requiredFields = [
        data.is_jv_allowed == null ? "is_jv_allowed" : null,
        "tech_score",
        "company_score",
        "company_name",
        "eligibity_criteria",
        data.eligibity_criteria === "Special"
          ? "eligibity_criteria_special"
          : null,
        data.soil_quality == null ? "soil_quality" : null,
        data.participating_as == null ? "participating_as" : null,
        data.is_jv_consorium_association_allowed == null
          ? "jv_consorium_association_allowed"
          : null,
        data.site_apprisate_required == null ? "site_apprisate_required" : null,
        data.site_apprisate_required != null ? "site_apprisate_marking" : null,
        data.work_methodology_required == null
          ? "work_methodology_required"
          : null,
        data.work_methodology_required != null
          ? "work_methodology_marking"
          : null,
        data.presentation_required == null ? "presentation_required" : null,
        data.presentation_required ? "presentation_required_marking" : null,
        data.presentation_required ? "presentation_type" : null,
      ].filter(Boolean);
    }

    // 🟦 FINAL TENDER (toggleState = 3)
    else if (toggleState === 3) {
      requiredFields = [
        data.tender_submission_type == null ? "tender_submission_type" : null,
        data.bid_prepare_by == null ? "bid_prepare_by" : null,
        data.bg_prepare_by == null ? "bg_prepare_by" : null,
        "lead_partner_share",
        data.jv_partner_name !== "Not Required" ? "jv_partner_share" : null,
        data.assosiate_partner !== "Not Required"
          ? "associate_partner_share"
          : null,
        data.is_emd_required == null ? "is_emd_required" : null,
        data.is_emd_required ? "emd_amount" : null,
        data.is_emd_required ? "emd_unit" : null,
        // data.is_emd_required ? "emd_review" : null,
        data.is_emd_required ? "exmpted_emd" : null,
        data.is_emd_required ? "emd_type" : null,
        data.is_emd_required ? "emd_submission_type" : null,
      ].filter(Boolean);
    }

    // 🟦 SUBMITTED (toggleState = 9)
    else if (toggleState === 9) {
      requiredFields = [
        data.checklist == null ? "checklist" : null,
        // data.team_required == null ? "team_required" : null,
        // data.team_required ? "team_prepare_by" : null,
        // data.team_required ? "team_prepare_by_remarks" : null,
        // data.team_required ? "team_requirements_details" : null,

        data.all_docs_done == null ? "all_docs_done" : null,
      ].filter(Boolean);
    }

    // 🟦 BID PREPARE IN PROGRESS (toggleState = 4)
    else if (toggleState === 4) {
      requiredFields = [
        // data.assigned_to?.length === 0 ? "assigned_to" : null,
      ].filter(Boolean);
    }

    // -------------------------
    // GENERAL VALIDATION
    // -------------------------
    const missingFieldsList = [];

    requiredFields.forEach((field) => {
      if (!data[field]) {
        newErrors[field] = `${field} is required`;
        missingFieldsList.push(field.replace(/_/g, " ").toUpperCase());
      }
    });

    // 🟧 Participant validation (Tech)
    if (data.tech_open != null) {
      const p = data.participant_name || { value: "", score: "" };
      if (!p.value?.trim() || !p.score?.toString().trim()) {
        newErrors["participant_name"] = "Participant name & score required";
        missingFieldsList.push("PARTICIPANT NAME");
      }
    }

    // 🟧 Financial Participant validation
    if (data.financial_status != null) {
      const p = data.financial_participant_name || { value: "", score: "" };
      if (!p.value?.trim() || !p.score?.toString().trim()) {
        newErrors["participant_name"] =
          "Financial participant name & score required";
        missingFieldsList.push("FINANCIAL PARTICIPANT NAME");
      }
    }

    setErrors(newErrors);
    setIsSubmitted(true);

    // ⛔ SHOW ONE TOAST FOR ALL MISSING FIELDS
    if (missingFieldsList.length > 0) {
      toast.error(`These fields are missing: ${missingFieldsList.join(", ")}`);
      return false;
    }

    return true;
  };

  // -------------------------
  // HANDLE FORM SUBMIT
  // -------------------------
  // const handleFormSubmit = async (e) => {
  //     e.preventDefault();
  //     const loadingToastId = toast.loading("Processing...");

  //     const updatedData = { ...i, document: null };

  //     if (toggleState === 1) {
  //         updatedData.is_in_bidlist = true;
  //         updatedData.date_aa = new Date().toISOString();
  //     }

  //     if (toggleState === 2) {
  //         updatedData.is_in_targetlist = true;
  //         updatedData.date_bb = new Date().toISOString();
  //     }

  //     if (toggleState === 3) {
  //         updatedData.is_finalize = true;
  //         updatedData.date_cc = new Date().toISOString();
  //         updatedData.tat_duration = getDaysLeftNumber(
  //             i.corrigendum_date ? i.corrigendum_date : i.submission_date
  //         );
  //     }

  //     if (toggleState === 9) {
  //         updatedData.is_submitted = true;
  //         updatedData.date_ee = new Date().toISOString();
  //     }

  //     if (toggleState === 4) {
  //         updatedData.is_bid_prepare_in_progress = true;
  //         updatedData.date_ff = new Date().toISOString();
  //         updatedData.assigned_to = JSON.stringify(toggleEmployeeCode);
  //         updatedData.assigned_by = sessionStorage.getItem("sitemanagement_emp_code");
  //     }

  //     // VALIDATE AFTER UPDATED DATA IS CREATED
  //     if (!validateUpdatedData(updatedData)) {
  //         toast.dismiss(loadingToastId);
  //         return;
  //     }

  //     // Build FormData
  //     const formData = new FormData();
  //     Object.keys(updatedData).forEach((key) => {
  //         const value = updatedData[key];

  //         if (value == null) return;

  //         if (Array.isArray(value)) {
  //             value.forEach((item, idx) => formData.append(`${key}[${idx}]`, JSON.stringify(item)));
  //         } else if (typeof value === "object") {
  //             formData.append(key, JSON.stringify(value));
  //         } else {
  //             formData.append(key, value);
  //         }
  //     });

  //     try {
  //         const res = await axios.put(
  //             `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
  //             formData,
  //             { headers: { "Content-Type": "multipart/form-data" } }
  //         );

  //         if (res.status === 200) {
  //             await getBid(filters);
  //             setShow(false);
  //             toast.dismiss(loadingToastId);

  //             toast.success(
  //                 toggleState === 1
  //                     ? "Added to WishList"
  //                     : toggleState === 2
  //                         ? "Added to Target List"
  //                         : toggleState === 3
  //                             ? "Marked as Final"
  //                             : toggleState === 9
  //                                 ? "Marked as Submitted"
  //                                 : "Moved to Bid Prepare In Progress"
  //             );
  //         }
  //     } catch (err) {
  //         handleErrorToast(err);
  //     } finally {
  //         toast.dismiss(loadingToastId);
  //     }
  // };
  // Normalize array: parse JSON strings, flatten, uppercase, remove duplicates
  const normalizeArray = (arr) => {
    if (!Array.isArray(arr)) return [];

    return Array.from(
      new Set(
        arr
          .flatMap((item) => {
            try {
              const parsed = JSON.parse(item);
              return Array.isArray(parsed) ? parsed : [parsed];
            } catch {
              return [item];
            }
          })
          .map((x) => x.toUpperCase()),
      ),
    );
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Processing...");

    const updatedData = { ...i, document: null };

    if (toggleState === 1) {
      updatedData.is_in_bidlist = true;
      updatedData.date_aa = new Date().toISOString();
    }

    if (toggleState === 2) {
      updatedData.is_in_targetlist = true;
      updatedData.date_bb = new Date().toISOString();
    }

    if (toggleState === 3) {
      updatedData.is_finalize = true;
      updatedData.date_cc = new Date().toISOString();
      updatedData.tat_duration = getDaysLeftNumber(
        i.corrigendum_date ? i.corrigendum_date : i.submission_date,
      );
    }

    if (toggleState === 9) {
      updatedData.is_submitted = true;
      updatedData.date_ee = new Date().toISOString();
    }

    // =====================================================
    // Bid Prepare In Progress
    // =====================================================
    if (toggleState === 4) {
      updatedData.is_bid_prepare_in_progress = true;
      updatedData.date_ff = new Date().toISOString();

      const emp = sessionStorage.getItem("sitemanagement_emp_code");

      // Merge assigned_to
      const existingAssignedTo = Array.isArray(i.assigned_to)
        ? i.assigned_to
        : [];
      const mergedAssignedTo = [...existingAssignedTo, ...toggleEmployeeCode];
      updatedData.assigned_to = normalizeArray(mergedAssignedTo);

      // assigned_at timestamp
      const assignedAt = {};
      toggleEmployeeCode?.forEach((code) => {
        assignedAt[code] = new Date().toISOString();
      });
      updatedData.assigned_at = assignedAt;

      // Merge assigned_by
      const existingAssignedBy = Array.isArray(i.assigned_by)
        ? i.assigned_by
        : [];
      const mergedAssignedBy = [...existingAssignedBy, emp];
      updatedData.assigned_by = normalizeArray(mergedAssignedBy);
    }

    // =====================================================
    // Validate
    // =====================================================
    if (!validateUpdatedData(updatedData)) {
      toast.dismiss(loadingToastId);
      return;
    }

    // =====================================================
    // Build FormData safely
    // =====================================================
    const formData = new FormData();
    Object.entries(updatedData).forEach(([key, value]) => {
      if (value == null) return;
      if (Array.isArray(value) || typeof value === "object") {
        formData.append(key, JSON.stringify(value));
      } else {
        formData.append(key, value);
      }
    });

    try {
      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (res.status === 200) {
        await getBid(filters);
        setShow(false);
        toast.success(
          toggleState === 1
            ? "Added to WishList"
            : toggleState === 2
              ? "Added to Target List"
              : toggleState === 3
                ? "Marked as Final"
                : toggleState === 9
                  ? "Marked as Submitted"
                  : "Moved to Bid Prepare In Progress",
        );
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  // -------------------------
  // LOAD EMPLOYEES (FOR TOGGLE 4)
  // -------------------------
  const getEmployeeData = async () => {
    try {
      const response = await axios.get(
        "https://csms.aimantra.info/siteproject/employeebyfilterss/null/null/null/134b633a-89b3-4173-a51e-d030c5b562f5/null/null/d11b2d36-9a36-47df-98c4-4e23923c0abb/",
      );
      setEmployeeList(response.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
    }
  };

  useEffect(() => {
    if (show && toggleState === 4) getEmployeeData();
  }, [show, toggleState]);

  useEffect(() => {
    console.log(i, "bid data");
  }, [toggleEmployeeCode]);

  return (
    <>
      <button
        title="Move To Next"
        onClick={handleShow}
        style={{
          cursor: "pointer",
          width: "2.7rem",
          height: "2.7rem",
          backgroundColor: "#2576bc",
          color: "white",
          borderRadius: "50%",
          fontSize: "1.5rem",
        }}
      >
        <ArrowBullet color={"white"} />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            Move Tender To{" "}
            {toggleState === 1
              ? "Wish List"
              : toggleState === 2
                ? "Target List"
                : toggleState === 3
                  ? "Final List"
                  : toggleState === 9
                    ? "Submitted List"
                    : toggleState === 4
                      ? "Bid Prepare In Progress"
                      : "Rejected"}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="parent-div">
            Are you sure you want to move this tender ({i.tender_name}
            )?
            {/* MULTI-EMPLOYEE SELECT FOR TOGGLE 4 */}
            {toggleState === 4 && (
              <div
                className="flex-column form-group-selectt"
                style={{ display: "block" }}
              >
                <label className="form-labels font-weight500 font-size-subheading">
                  Assign Tender To Team <span className="required">*</span>
                </label>
                <br />

                <Select
                  options={employeeList
                    .filter(
                      (emp) =>
                        emp.emp_role === "CertificationAccessDocumentTeam",
                    )
                    .map((emp) => ({
                      value: emp.emp_code,
                      label: `${emp.emp_code} - ${emp.name}`,
                    }))}
                  isMulti
                  placeholder="Select Employees"
                  value={toggleEmployeeCode.map((code) => ({
                    value: code,
                    label: employeeList.find((e) => e.emp_code === code)
                      ? `${code} - ${employeeList.find((e) => e.emp_code === code)?.name}`
                      : code,
                  }))}
                  onChange={(selected) => {
                    settoggleEmployeeCode(
                      selected ? selected.map((x) => x.value) : [],
                    );
                  }}
                />
              </div>
            )}
            <div className="button-models">
              <button
                className="model-button model-button-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmit}
                className="model-button model-button-delete"
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal.Body>

        <ToastContainer position="top-center" autoClose={1000} />
      </Modal>
    </>
  );
};

const AssignTeamOnly = ({ i, getBid, filters }) => {
  const [show, setShow] = useState(false);
  const [employeeList, setEmployeeList] = useState([]);
  const [assignedEmployees, setAssignedEmployees] = useState([]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // ✔ ONLY assign team — NO tab movement
  // const handleFormSubmit = async (e) => {
  //     e.preventDefault();
  //     const loadingToastId = toast.loading("Assigning team...");

  //     // Convert existing assigned_to into array safely
  //     const existingAssigned = Array.isArray(i.assigned_to)
  //         ? [...i.assigned_to]
  //         : i.assigned_to
  //             ? [i.assigned_to]
  //             : [];

  //     // Append new employees to next indexes
  //     const finalAssignedTo = [...existingAssigned, ...assignedEmployees];

  //     // Create update payload
  //     const updatedData = {
  //         ...i,
  //         document: null,
  //         assigned_to: finalAssignedTo, // <-- the important part
  //         assigned_by: sessionStorage.getItem("emp_code"),
  //         date_team_assigned: new Date().toISOString(),
  //     };

  //     console.log(updatedData, "updated_data");

  //     // Building FormData
  //     const formData = new FormData();

  //     for (let key in updatedData) {
  //         const value = updatedData[key];
  //         if (value === null || value === undefined) continue;

  //         if (Array.isArray(value)) {
  //             value.forEach((item, index) => {
  //                 formData.append(
  //                     `${key}[${index}]`,
  //                     typeof item === "object" ? JSON.stringify(item) : item
  //                 );
  //             });
  //         } else if (typeof value === "object") {
  //             formData.append(key, JSON.stringify(value));
  //         } else {
  //             formData.append(key, value);
  //         }
  //     }

  //     try {
  //         const res = await axios.put(
  //             `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
  //             formData,
  //             { headers: { "Content-Type": "multipart/form-data" } }
  //         );

  //         if (res.status === 200) {
  //             await getBid(filters);
  //             setShow(false);
  //             toast.success("Team Assigned Successfully");
  //         }
  //     } catch (err) {
  //         handleErrorToast(err);
  //     } finally {
  //         toast.dismiss(loadingToastId);
  //     }
  // };
  // Normalize array: parse JSON strings, flatten, uppercase, remove duplicates
  const normalizeArray = (arr) => {
    if (!Array.isArray(arr)) return [];

    return Array.from(
      new Set(
        arr
          .flatMap((item) => {
            try {
              const parsed = JSON.parse(item);
              return Array.isArray(parsed) ? parsed : [parsed];
            } catch {
              return [item];
            }
          })
          .map((x) => x.toUpperCase()),
      ),
    );
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Assigning team...");

    try {
      const emp = sessionStorage.getItem("sitemanagement_emp_code");

      // Merge assigned_to
      const existingAssignedTo = Array.isArray(i.assigned_to)
        ? i.assigned_to
        : [];
      const mergedAssignedTo = [...existingAssignedTo, ...assignedEmployees];
      const finalAssignedTo = normalizeArray(mergedAssignedTo);

      // Merge assigned_by
      const existingAssignedBy = Array.isArray(i.assigned_by)
        ? i.assigned_by
        : [];
      const mergedAssignedBy = [...existingAssignedBy, emp];
      const finalAssignedBy = normalizeArray(mergedAssignedBy);

      const updatedData = {
        ...i,
        document: null,
        assigned_to: finalAssignedTo,
        assigned_by: finalAssignedBy,
        date_team_assigned: new Date().toISOString(),
      };

      // Build FormData safely
      const formData = new FormData();
      Object.entries(updatedData).forEach(([key, value]) => {
        if (value == null) return;
        if (Array.isArray(value) || typeof value === "object") {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });

      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } },
      );

      if (res.status === 200) {
        await getBid(filters);
        setShow(false);
        toast.success("Team Assigned Successfully");
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  // Fetch Employees
  const getEmployeeData = async () => {
    try {
      const res = await axios.get(
        "https://cipl.aimantra.info/siteproject/employeebyfilterss/null/null/null/134b633a-89b3-4173-a51e-d030c5b562f5/null/null/d11b2d36-9a36-47df-98c4-4e23923c0abb/",
      );
      setEmployeeList(res.data);
    } catch (err) {
      console.error("Error fetching employees:", err);
    }
  };

  useEffect(() => {
    if (show) getEmployeeData();
  }, [show]);

  return (
    <>
      <button
        title="Assign Team"
        onClick={handleShow}
        style={{
          cursor: "pointer",
          width: "2.7rem",
          height: "2.7rem",
          backgroundColor: "#2576bc",
          color: "white",
          borderRadius: "50%",
          fontSize: "1.5rem",
        }}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="22"
          height="22"
          viewBox="0 0 24 24"
          fill="white"
        >
          <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5s-3 1.34-3 3 1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V20h14v-3.5C15 14.17 10.33 13 8 13zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V20h6v-3.5c0-2.33-4.67-3.5-7-3.5z" />
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Assign Tender to Team</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="parent-div">
            Assign team for tender: <b>{i.tender_name}</b>
            <div
              className="flex-column form-group-selectt"
              style={{ marginTop: "1rem" }}
            >
              <label className="form-labels font-weight500 font-size-subheading">
                Select Employees <span className="required">*</span>
              </label>

              <Select
                options={employeeList
                  .filter((emp) => emp.emp_role === "CertificationAccessCvTeam")
                  .map((emp) => ({
                    value: emp.emp_code,
                    label: `${emp.emp_code} - ${emp.name}`,
                  }))}
                isMulti
                value={assignedEmployees.map((code) => ({
                  value: code,
                  label: employeeList.find((e) => e.emp_code === code)
                    ? `${code} - ${employeeList.find((e) => e.emp_code === code)?.name}`
                    : code,
                }))}
                onChange={(selected) =>
                  setAssignedEmployees(
                    selected ? selected.map((opt) => opt.value) : [],
                  )
                }
                placeholder="Select Employees"
                isSearchable
                isClearable
                noOptionsMessage={() => "No employees available"}
              />
            </div>
            <div className="button-models">
              <button
                className="model-button model-button-cancel"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="model-button model-button-delete"
                onClick={handleFormSubmit}
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal.Body>

        <ToastContainer position="top-center" autoClose={1000} />
      </Modal>
    </>
  );
};

const TenderReject = ({ i, getBidData, filters }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [formData, setFormData] = useState({
    rejected_reason: "",
    rejected_reason_other: "",
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const validateForm = () => {
    const newErrors = {};
    const requiredFields = [
      "rejected_reason",
      formData.rejected_reason === "other" ? "rejected_reason_other" : null,
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (!formData[field]) {
        newErrors[field] = ` ${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required !`;
      }
    });

    setErrors(newErrors);

    return Object.keys(newErrors).length === 0;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setInputState({
      ...inputState,
      [name]: value.trim() ? "green" : "",
    });

    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
      const updatedData = {
        is_rejected: true,
        rejected_reason: formData.rejected_reason,
        rejected_reason_other: formData.rejected_reason_other,
      };
      try {
        let res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
          {
            ...updatedData,
          },
        );

        if (res.status === 200) {
          await getBidData(filters);
          // setShow(false);
        } else {
          // alert(res);
        }
      } catch (err) {
        //toast Logic
        if (err.response) {
          toast.dismiss(loadingToastId);
          const errorData = err.response.data;

          if (typeof errorData.error === "string") {
            // Single error message
            toast.error(`Error: ${errorData.error}`);
          } else if (typeof errorData === "object" && errorData !== null) {
            // Multiple error messages
            Object.entries(errorData).forEach(([field, messages]) => {
              messages.forEach((message) =>
                toast.error(`"${field}": ${message}`),
              );
            });
          } else {
            toast.error("Error:- Failed to Process!");
          }
        } else {
          toast.error("Error processing your request.");
        }
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  const handleDropdownChange = (e) => {
    const selectedValue = e.target.value;
    setFormData((prevData) => ({
      ...prevData,
      rejected_reason_dropdown: selectedValue,
      rejected_reason:
        selectedValue === "other" ? prevData.rejected_reason : "",
    }));
  };

  return (
    <>
      {/* <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover /> */}
      <button
        className="view_button"
        title="Reject Tender"
        onClick={handleShow}
      >
        <CrossRed />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Reject Tender</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            <div className="bdy-div">
              <div className="flex-column">
                <label
                  htmlFor="rejected_reason"
                  className="form-labels font-weight500 font-size-heading"
                >
                  Select Rejection Reason<span className="required">*</span>
                </label>
                <select
                  id="rejected_reason"
                  name="rejected_reason"
                  value={formData.rejected_reason}
                  onChange={handleInputChange}
                  className="form-input input-form form-group-selection font-weight400 font-size-subheading"
                >
                  <option value="">-- Select Reason --</option>
                  <option value="do_not_qualify">Do Not Qualify</option>
                  <option value="partner_not_found">Partner Not Found</option>
                  <option value="due_to_tendor_document">
                    Due To Tender Document
                  </option>
                  <option value="due_to_cv_not_found">
                    Due To CV Not Found
                  </option>
                  <option value="other">Other</option>
                </select>

                {errors.rejected_reason && (
                  <span className="error-message font-size-text ">
                    {errors.rejected_reason}
                  </span>
                )}
                {formData.rejected_reason === "other" && (
                  <>
                    <label
                      htmlFor="rejected_reason"
                      className="form-labels font-weight500 announce-date font-weight400 font-size-heading"
                    >
                      Tender Rejection Reason<span className="required">*</span>
                    </label>
                    <textarea
                      id="rejected_reason_other"
                      type="text"
                      name="rejected_reason_other"
                      placeholder=" Please write the Reject Reason Other"
                      onChange={handleInputChange}
                      maxLength={100}
                      value={formData.rejected_reason_other}
                      className={`form-input-textarea font-weight400 font-size-subheading ${
                        errors.rejected_reason_other
                          ? "error"
                          : inputState.rejected_reason_other
                            ? "success"
                            : ""
                      }`}
                    />
                    {errors.rejected_reason_other && (
                      <span className="error-message font-size-text ">
                        {errors.rejected_reason_other}
                      </span>
                    )}
                  </>
                )}
              </div>

              <div className="button-models">
                <button
                  className="model-button model-button-cancel   font-weight500"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="model-button   font-weight500    model-button-delete    font-size-heading"
                  onClick={handleFormSubmitPut}
                >
                  Reject
                </button>
              </div>
            </div>
            <p className="error-message font-size-text">
              {isSubmitted &&
                Object.keys(errors).length > 0 &&
                (Object.keys(errors).length > 5 ? (
                  <h5 className="text-center">
                    Please fill all mandatory fields!
                  </h5>
                ) : (
                  <h6 className="text-center">
                    {Object.keys(errors)
                      .map((field) =>
                        field
                          .replace(/_/g, " ")
                          .replace(/\b\w/g, (char) => char.toUpperCase()),
                      )
                      .join(", ") + " are required!"}
                  </h6>
                ))}
            </p>
          </div>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

const TenderCancel = ({ i, getBidData, filters }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  // const validateForm = () => {
  //     const newErrors = {};
  //     const requiredFields = [
  //         "rejected_reason",
  //         formData.rejected_reason === 'other' ? "rejected_reason_other" : null,
  //     ].filter(Boolean);

  //     requiredFields.forEach((field) => {
  //         if (!formData[field]) {
  //             newErrors[field] = ` ${field.charAt(0).toUpperCase() + field.slice(1)
  //                 } is required !`;
  //         }
  //     });

  //     setErrors(newErrors);

  //     return Object.keys(newErrors).length === 0;
  // };

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    const updatedData = {
      is_cancelled: true,
    };
    try {
      let res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        {
          ...updatedData,
        },
      );

      if (res.status === 200) {
        await getBidData(filters);
        // setShow(false);
      } else {
        // alert(res);
      }
    } catch (err) {
      //toast Logic
      if (err.response) {
        toast.dismiss(loadingToastId);
        const errorData = err.response.data;

        if (typeof errorData.error === "string") {
          // Single error message
          toast.error(`Error: ${errorData.error}`);
        } else if (typeof errorData === "object" && errorData !== null) {
          // Multiple error messages
          Object.entries(errorData).forEach(([field, messages]) => {
            messages.forEach((message) =>
              toast.error(`"${field}": ${message}`),
            );
          });
        } else {
          toast.error("Error:- Failed to Process!");
        }
      } else {
        toast.error("Error processing your request.");
      }
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      {/* <ToastContainer position="top-center" autoClose={1000} hideProgressBar={false} newestOnTop={true} closeOnClick rtl={false} pauseOnFocusLoss draggable pauseOnHover /> */}
      <button
        className="view_button"
        title="Cancel Tender"
        onClick={handleShow}
      >
        <CancelCircle />
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Cancel Tender</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You sure to cancel This tender {i?.tender_name}
            <div className="button-models">
              <button
                className="model-button   font-weight500   model-button-cancel "
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmitPut}
                className="model-button   font-weight500    model-button-delete"
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

const Tenderspecial = ({ i, getBidData, filters }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [errors, setErrors] = useState({});
  const [inputState, setInputState] = useState({});

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    const updatedData = {
      is_special_tender: true,
    };
    try {
      let res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        {
          ...updatedData,
        },
      );

      if (res.status === 200) {
        await getBidData(filters);
        // setShow(false);
      } else {
        // alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const handleFormSubmitRemovePut = async (e) => {
    e.preventDefault();

    const loadingToastId = toast.loading("Loading: Please wait..."); //toast Logic
    const updatedData = {
      is_special_tender: false,
    };
    try {
      let res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        {
          ...updatedData,
        },
      );

      if (res.status === 200) {
        await getBidData(filters);
        // setShow(false);
      } else {
        // alert(res);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      {!i?.is_special_tender ? (
        <button
          className="view_button"
          title="Mark as special"
          onClick={handleShow}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
        >
          <Star />
        </button>
      ) : (
        <button
          className="view_button"
          title="Remove From special"
          onClick={handleShow}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="24"
            height="24"
          >
            <circle cx="12" cy="12" r="12" fill="rgb(37,118,188)" />
            <path
              d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
              fill="#fff"
            />
          </svg>
        </button>
      )}

      {!i?.is_special_tender ? (
        <>
          {" "}
          <Modal
            show={show}
            onHide={handleClose}
            dialogClassName="request-leave width-40vw"
          >
            <Modal.Header closeButton>
              <Modal.Title>Mark Tender as Special</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="parent-div">
                <div className="bdy-div">
                  <div className="button-models">
                    <button
                      className="model-button model-button-cancel   font-weight500"
                      onClick={handleClose}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="model-button   font-weight500    model-button-delete    font-size-heading"
                      onClick={handleFormSubmitPut}
                    >
                      Mark special
                    </button>
                  </div>
                </div>
              </div>
            </Modal.Body>
          </Modal>
        </>
      ) : (
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="request-leave width-40vw"
        >
          <Modal.Header closeButton>
            <Modal.Title>Remove Tender From Special Tender</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="parent-div">
              <div className="bdy-div">
                <div className="button-models">
                  <button
                    className="model-button model-button-cancel   font-weight500"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="model-button   font-weight500    model-button-delete    font-size-heading"
                    onClick={handleFormSubmitRemovePut}
                  >
                    Remove Tender
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal>
      )}
    </>
  );
};

const Tenderdiscuss = ({ i, getBidData, filters }) => {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const handleFormSubmitPut = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Marking as discussed...");

    try {
      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        {
          is_discussed: true,
          is_discussed_by: sessionStorage.getItem("sitemanagement_emp_code"),
        },
      );
      if (res.status === 200) {
        await getBidData(filters);
        toast.success("Tender marked as discussed!");
        handleClose();
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const handleFormSubmitRemovePut = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Removing from discussed...");

    try {
      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${i.id}/`,
        {
          is_discussed: false,
        },
      );
      if (res.status === 200) {
        await getBidData(filters);
        toast.success("Tender removed from discussed!");
        handleClose();
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  return (
    <>
      {/* Discuss Button */}
      {!i?.is_discussed ? (
        <button
          className="view_button"
          title="Mark as To Be Discussed"
          onClick={handleShow}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
        >
          {/* Chat/Discuss SVG */}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#2576BC"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
        </button>
      ) : (
        <button
          className="view_button"
          title="Remove from Discussed"
          onClick={handleShow}
          style={{
            background: "transparent",
            border: "none",
            cursor: "pointer",
            padding: 0,
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="#2576BC"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>
          </svg>
        </button>
      )}

      {/* Modal for marking discussed */}
      {!i?.is_discussed ? (
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="request-leave width-40vw"
        >
          <Modal.Header closeButton>
            <Modal.Title>Mark Tender as Discussed</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="parent-div">
              <div className="bdy-div">
                <div className="button-models">
                  <button
                    className="model-button model-button-cancel font-weight500"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="model-button font-weight500 model-button-delete font-size-heading"
                    onClick={handleFormSubmitPut}
                  >
                    Mark Discussed
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      ) : (
        <Modal
          show={show}
          onHide={handleClose}
          dialogClassName="request-leave width-40vw"
        >
          <Modal.Header closeButton>
            <Modal.Title>Remove Tender from Discussed</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="parent-div">
              <div className="bdy-div">
                <div className="button-models">
                  <button
                    className="model-button model-button-cancel font-weight500"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="model-button font-weight500 model-button-delete font-size-heading"
                    onClick={handleFormSubmitRemovePut}
                  >
                    Remove Tender
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      )}

      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const UploadSiteProject = ({ getBidData, filters }) => {
  const [show, setShow] = useState(false);
  const [fileName, setFileName] = useState("");
  const [excelJson, setExcelJson] = useState(null); // State to store the converted JSON data
  const [docErrors, setDocErrors] = useState({});
  const [docInputState, setDocInputState] = useState({});

  const bulktableRef = useRef(null);
  const handleDownload = () => {
    const link = document.createElement("a");
    link.href =
      "https://cipl-aimantra.s3.ap-south-1.amazonaws.com/bid/tender/b4b6eb36-4b8b-495d-b18e-f3b40dc33a79/Aimantra_2025-10-13_13-37-51_SbL2Ba_bid_Tender+(4).xlsx";
    link.download = "Bid_Tender.xlsx"; // this will be the filename for the user
    link.target = "_blank"; // optional: open in a new tab if needed
    link.click();
  };

  const s2ab = (s) => {
    const buf = new ArrayBuffer(s.length);
    const view = new Uint8Array(buf);
    for (let i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xff;
    return buf;
  };

  const handleClose = () => {
    setFileName("");
    setExcelJson(null);
    setDocErrors({});
    setShow(false);
  };
  const handleShow = () => setShow(true);

  // Function to handle file change
  const handleFileChange = (e) => {
    const file = e.target.files[0];

    setDocErrors({});
    if (file) {
      // Check for valid file type
      const validFileTypes = [
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/vnd.ms-excel",
      ];
      if (!validFileTypes.includes(file.type)) {
        setDocErrors({
          document_file: "Please upload a valid Excel file (.xlsx or .xls).",
        });
        setFileName("");
        return;
      }

      setFileName(file.name);
      readExcel(file); // Convert the file to JSON
    } else {
      setFileName("");
    }
  };
  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const parts = dateStr.split("-");
    if (parts.length === 3) {
      return `${parts[2]}-${parts[1]}-${parts[0]}`; // dd-mm-yyyy
    }
    return dateStr; // if already formatted differently
  };

  const checkForDuplicates = (data) => {
    const sitecodes = new Map();
    const duplicates = [];

    // Track positions of each insurance number
    data.forEach((i, index) => {
      const projectcode = i.tender_id;
      if (sitecodes.has(projectcode)) {
        // If the insurance number already exists, add the current position to its list
        sitecodes.get(projectcode).push(index + 1); // index + 1 for 1-based position
      } else {
        // If it's the first time seeing this insurance number, initialize its position list
        sitecodes.set(projectcode, [index + 1]);
      }
    });

    // Now, filter out only the numbers that appear more than once
    sitecodes.forEach((positions, projectcode) => {
      if (positions.length > 1) {
        duplicates.push(
          `\Tender Id :${projectcode} is found in position(s) ${positions.join(", ")}`,
        );
      }
    });

    return duplicates;
  };

  const readExcel = (file) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const worksheet = workbook.Sheets[sheetName];

      // Convert entire sheet into 2D array
      const sheetData = XLSX.utils.sheet_to_json(worksheet, {
        header: 1,
        defval: null,
      });

      // 🔹 Define the allowed fields (your schema)
      const fields = [
        "sector",
        "tender_type",
        "tender_name",
        "client",
        "publish_date",
        "submission_date",
        "lane",
        "state",
        "length",
        "duration_construction",
        "duration_dlp",
        "duration_onm",
        "associate_with_version",
        "remarks",
        "km_cost",
        "tender_id",
        "special_structure_type",
        "is_special_tender",
        "consultancy_fees",
        "construction_fees",
        "GST_consultancy",
      ];

      // 🔹 Helper: Convert to yyyy-mm-dd regardless of Excel format
      const convertToYYYYMMDD = (input) => {
        try {
          if (!input) return null;
          let date;

          // Excel serial numbers
          if (typeof input === "number") {
            const excelEpoch = new Date(1899, 11, 30);
            date = new Date(excelEpoch.getTime() + input * 86400000);
          }
          // Text formats
          else if (typeof input === "string") {
            let normalized = input.trim().replace(/[\.\s/]+/g, "-");

            if (/^\d{1,2}-\d{1,2}-\d{4}$/.test(normalized)) {
              const [d, m, y] = normalized.split("-");
              date = new Date(
                `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`,
              );
            } else if (/^\d{4}-\d{1,2}-\d{1,2}$/.test(normalized)) {
              const [y, m, d] = normalized.split("-");
              date = new Date(
                `${y}-${m.padStart(2, "0")}-${d.padStart(2, "0")}`,
              );
            } else {
              date = new Date(normalized);
            }
          } else {
            date = new Date(input);
          }

          if (isNaN(date.getTime())) return null;
          return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, "0")}-${String(date.getDate()).padStart(2, "0")}`;
        } catch {
          return null;
        }
      };

      // 🔹 Identify header row (match by fields array)
      const headerRowIndex = sheetData.findIndex(
        (row) => Array.isArray(row) && fields.every((f) => row.includes(f)),
      );

      if (headerRowIndex === -1) {
        toast.error("❌ Correct header row not found in Excel sheet.");
        return;
      }

      const headers = sheetData[headerRowIndex];
      const dataRows = sheetData.slice(headerRowIndex + 1);

      // 🔹 Map rows → objects filtered by fields
      const formattedJson = dataRows.map((row) => {
        const obj = {};
        headers.forEach((header, idx) => {
          if (fields.includes(header)) {
            const val = row[idx];
            if (["publish_date", "submission_date"].includes(header)) {
              obj[header] = convertToYYYYMMDD(val);
            } else if (typeof val === "string") {
              obj[header] = val.trim();
            } else {
              obj[header] = val ?? null;
            }
          }
        });
        return obj;
      });

      // 🔹 Remove empty rows
      const nonEmptyRows = formattedJson.filter((row) =>
        Object.values(row).some((val) => val !== null && val !== ""),
      );

      // 🔹 Validate publish_date ≤ submission_date
      const invalidDates = nonEmptyRows.filter(
        (item) =>
          item.publish_date &&
          item.submission_date &&
          new Date(item.publish_date) > new Date(item.submission_date),
      );

      if (invalidDates.length > 0) {
        toast.error("❌ Error: Publish date cannot be after Submission date.", {
          autoClose: 5000,
        });
        return;
      }

      // ✅ Set parsed Excel JSON
      setExcelJson(nonEmptyRows);
    };

    reader.readAsArrayBuffer(file);
  };

  const [validationErrors, setValidationErrors] = useState([]);

  // Function to handle the upload button click
  const handleUpload = async () => {
    if (!excelJson) {
      setDocErrors({ document_file: "Please upload a valid Excel file." });
      return;
    }

    const allowedTenderTypes = [
      "Feasibility",
      "DPR",
      "FesibilityCumDPR",
      "Authority_Engineer",
      "Independent_Engineer",
      "PSSA",
      "PMC",
      "GC",
      "Other",
      "O&M",
      "Supervision",
    ];

    const allowedSectors = [
      "Highway",
      "Railway",
      "Metro",
      "Water",
      "Ropeway",
      "RF_planning",
      "Building",
      "Other",
    ];

    const states = [
      "Andaman and Nicobar Islands",
      "Andhra Pradesh",
      "Arunachal Pradesh",
      "Assam",
      "Bihar",
      "Chandigarh",
      "Chhattisgarh",
      "Dadra and Nagar Haveli and Daman and Diu",
      "Delhi",
      "Goa",
      "Gujarat",
      "Haryana",
      "Himachal Pradesh",
      "Jammu and Kashmir",
      "Jharkhand",
      "Karnataka",
      "Kerala",
      "Ladakh",
      "Lakshadweep",
      "Madhya Pradesh",
      "Maharashtra",
      "Manipur",
      "Meghalaya",
      "Mizoram",
      "Nagaland",
      "Odisha",
      "Puducherry",
      "Punjab",
      "Rajasthan",
      "Sikkim",
      "Tamil Nadu",
      "Telangana",
      "Tripura",
      "Uttar Pradesh",
      "Uttarakhand",
      "West Bengal",
    ];

    const errors = [];
    const seenTenderIds = new Map();

    excelJson.forEach((row, index) => {
      const rowNum = index + 2; // considering row 1 is header

      // Normalize ID (trim + lowercase for fair match)
      const tenderId = row.tender_id
        ? row.tender_id.trim().toLowerCase()
        : null;

      // 1️⃣ Missing or duplicate Tender ID check
      if (!tenderId) {
        errors.push(`Row ${rowNum}: Missing Tender ID`);
      } else {
        if (seenTenderIds.has(tenderId)) {
          const firstRow = seenTenderIds.get(tenderId);
          errors.push(
            `Row ${rowNum}: Duplicate Tender ID "${row.tender_id}" (also at Row ${firstRow})`,
          );
        } else {
          seenTenderIds.set(tenderId, rowNum);
        }
      }

      // 2️⃣ Tender Type validation
      if (
        row.tender_type &&
        !allowedTenderTypes.includes(row.tender_type.trim())
      ) {
        errors.push(`Row ${rowNum}: Invalid Tender Type "${row.tender_type}"`);
      }

      // 3️⃣ Sector validation
      if (row.sector && !allowedSectors.includes(row.sector.trim())) {
        errors.push(`Row ${rowNum}: Invalid Sector "${row.sector}"`);
      }

      // 4️⃣ State validation
      if (row.state && !states.includes(row.state.trim())) {
        errors.push(`Row ${rowNum}: Invalid State "${row.state}"`);
      }
    });

    // 🚫 Show validation errors inline below UI instead of toast
    if (errors.length > 0) {
      setValidationErrors(errors);
      return;
    }

    // ✅ No validation errors → clear UI & continue upload
    setValidationErrors([]);

    const enrichedExcelJson = excelJson.map(
      ({ duration_construction, duration_dlp, duration_onm, ...rest }) => ({
        ...rest,
        is_in_bidlist: false,
        is_in_targetlist: false,
        is_finalize: false,
        is_submitted: false,
        is_rejected: false,
        duration: { duration_construction, duration_dlp, duration_onm },
      }),
    );

    const loadingToastId = toast.loading("Uploading: Please wait...");

    try {
      const res = await axios.post(
        `${BASE_URL}/siteproject/bidtenderbulk/`,
        enrichedExcelJson,
      );
      if (res.status === 200) {
        await getBidData(filters);
        handleClose();
        toast.dismiss(loadingToastId);
        toast.success("Projects uploaded successfully.");
      } else {
        toast.dismiss(loadingToastId);
        toast.error("Failed to add data!");
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const fields = [
    "sector",
    "tender_type",
    "tender_name",
    "client",
    "publish_date",
    "submission_date",
    "lane",
    "state",
    "length",
    "duration_construction",
    "duration_dlp",
    "duration_onm",
    "associate_with_version",
    "remarks",
    "km_cost",
    "tender_id",
    "special_structure_type",
    "is_special_tender",
    "consultancy_fees",
    "construction_fees",
    "GST_consultancy",
  ];
  const dateFields = ["submission_date", "publish_date"];

  const toTitleCase = (str) =>
    str.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase());

  return (
    <>
      <button
        title="Upload"
        className="model-button   font-weight500   model-button-print"
        onClick={handleShow}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="22"
          id="upload"
        >
          <g
            fill="none"
            fill-rule="evenodd"
            stroke="#fff"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
          >
            <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
          </g>
        </svg>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Upload Bulk Tender Data in format :</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex-row align-center">
            <button
              onClick={handleDownload}
              className="model-button-download model-button font-weight500"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                id="download"
                fill="#fff"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M6 11l4 4 4-4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Format
            </button>
          </div>

          <div
            className="table-css-white-background"
            style={{ display: "none" }}
          >
            <table ref={bulktableRef} className="nested-table-lightblue">
              <thead>
                <tr className="custom-table-head-tr">
                  {fields.map((field, index) => (
                    <th key={index}>{field}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {excelJson?.map((project, rowIndex) => (
                  <tr key={rowIndex}>
                    {fields.map((field, colIndex) => (
                      <td key={colIndex}>
                        {typeof project[field] === "boolean"
                          ? project[field]
                            ? "Yes"
                            : "No"
                          : dateFields.includes(field) && project[field]
                            ? project[field]
                            : project[field]}
                      </td>
                    ))}
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          <div className="table-css-white-background scroll-container">
            <div
              className="table-container scrollbar"
              style={{ width: "100%" }}
            >
              <table
                className="nested-table-lightblue"
                style={{ margin: "0px" }}
              >
                <thead className="table-heading">
                  <tr className="custom-table-head-tr">
                    {fields.map((field, index) => (
                      <th key={index} className="table-heading-text">
                        {toTitleCase(field)}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {excelJson?.map((project, rowIndex) => (
                    <tr key={rowIndex} className="modal-padding-heading">
                      {fields.map((field, colIndex) => (
                        <td key={colIndex} className="table-heading-text">
                          {typeof project[field] === "boolean"
                            ? project[field]
                              ? "Yes"
                              : "No"
                            : dateFields.includes(field) && project[field]
                              ? formatDisplayDate(project[field])
                              : project[field]}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>

          <div className="flex-column field-cont-div">
            <label
              htmlFor="document_file"
              className="form-labels announce-date font-weight500 font-size-heading"
            >
              Upload File
            </label>
            <label
              htmlFor="document_file"
              className={`align-center form-inputss custom-file-upload ${
                docErrors.document_file
                  ? "error"
                  : docInputState.document_file
                    ? "success"
                    : ""
              }`}
            >
              <svg
                className="pdf-input"
                xmlns="http://www.w3.org/2000/svg"
                width="15"
                height="15"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M17.8666 9.2081L10.2082 16.8664C9.27005 17.8046 7.99757 18.3317 6.67075 18.3317C5.34393 18.3317 4.07145 17.8046 3.13325 16.8664C2.19505 15.9282 1.66797 14.6558 1.66797 13.3289C1.66797 12.0021 2.19505 10.7296 3.13325 9.79144L10.7916 2.1331C11.4171 1.50763 12.2654 1.15625 13.1499 1.15625C14.0345 1.15625 14.8828 1.50763 15.5082 2.1331C16.1337 2.75857 16.4851 3.60689 16.4851 4.49144C16.4851 5.37598 16.1337 6.2243 15.5082 6.84977L7.84158 14.5081C7.52885 14.8208 7.10469 14.9965 6.66242 14.9965C6.22014 14.9965 5.79598 14.8208 5.48325 14.5081C5.17051 14.1954 4.99482 13.7712 4.99482 13.3289C4.99482 12.8867 5.17051 12.4625 5.48325 12.1498L12.5582 5.0831"
                  stroke="#707070"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </label>
            <input
              id="document_file"
              name="document_file"
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileChange}
              className="file-inputs align-center"
              style={{ display: "none", position: "relative" }}
            />
            {fileName && <p className="file-name align-center">{fileName}</p>}
            <br />
            {docErrors.document_file && (
              <span className="file-name error-message font-size-text ">
                {docErrors.document_file}
              </span>
            )}
          </div>

          <div className="button-models">
            <button
              className="model-button-cancel model-button font-weight500"
              onClick={handleClose}
            >
              Cancel
            </button>
            <button
              className="model-button-download model-button font-weight500"
              onClick={handleUpload}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="22"
                id="upload"
              >
                <g
                  fill="none"
                  stroke="#fff"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                >
                  <path d="M1 16v3a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-3M14 5l-4-4-4 4M10 1v14"></path>
                </g>
              </svg>
              {"  "} Upload
            </button>
          </div>
          {validationErrors.length > 0 && (
            <div
              style={{
                background: "#ffecec",
                border: "1px solid #f5c2c7",
                color: "#842029",
                borderRadius: "6px",
                padding: "10px",
                marginTop: "15px",
                fontSize: "14px",
                maxHeight: "200px",
                overflowY: "auto",
              }}
            >
              <strong>Validation Errors:</strong>
              <ul style={{ marginTop: "5px", paddingLeft: "20px" }}>
                {validationErrors.map((err, i) => (
                  <li key={i}>{err}</li>
                ))}
              </ul>
            </div>
          )}

          <h4 style={{ marginBottom: "1rem" }}>References:</h4>
          <div
            style={{
              padding: "0.5rem",
              lineHeight: "1.4",
              borderRadius: "8px",
            }}
          >
            <div style={{ display: "flex", flexWrap: "wrap", gap: "1rem" }}>
              <div style={{ flex: "1 1 250px", fontSize: "14px" }}>
                <p style={{ fontWeight: "bold", margin: "0 0 0.3rem 0" }}>
                  General:
                </p>
                <ul
                  className="arrow-list"
                  style={{ paddingLeft: "1rem", margin: 0 }}
                >
                  <li>Tender ID must be unique</li>
                  <li>Dates: DD-MM-YYYY</li>
                  <li>Length in km</li>
                  <li>Lane: 1, 2, 4, 8</li>
                  <li>Duration: months</li>
                  <li>Publish &lt; Submission Date</li>
                  <li>
                    Amount Data should be in crores e.g. 1,46,00,000 should be
                    input as 1.46
                  </li>
                </ul>
              </div>

              <div style={{ flex: "1 1 200px", fontSize: "14px" }}>
                <p style={{ fontWeight: "bold", margin: "0 0 0.3rem 0" }}>
                  Sector Types:
                </p>
                <ul
                  className="arrow-list"
                  style={{ columnCount: 2, paddingLeft: "1rem", margin: 0 }}
                >
                  <li>Highway</li>
                  <li>Railway</li>
                  <li>Metro</li>
                  <li>Water</li>
                  <li>Ropeway</li>
                  <li>Building</li>
                  <li>Other</li>
                </ul>
              </div>

              <div style={{ flex: "1 1 200px", fontSize: "14px" }}>
                <p style={{ fontWeight: "bold", margin: "0 0 0.3rem 0" }}>
                  Tender Types:
                </p>
                <ul
                  className="arrow-list"
                  style={{ columnCount: 2, paddingLeft: "1rem", margin: 0 }}
                >
                  <li>Feasibility</li>
                  <li>DPR</li>
                  <li>FeasibilityCumDPR</li>
                  <li>Authority_Engineer</li>
                  <li>Independent_Engineer</li>
                  <li>PSSA</li>
                  <li>PMC</li>
                  <li>GC</li>
                  <li>Other</li>
                </ul>
              </div>

              <div style={{ flex: "1 1 150px", fontSize: "14px" }}>
                <p style={{ fontWeight: "bold", margin: "0 0 0.3rem 0" }}>
                  GST:
                </p>
                <ul
                  className="arrow-list"
                  style={{ paddingLeft: "1rem", margin: 0 }}
                >
                  <li>Including</li>
                  <li>Excluding</li>
                </ul>
              </div>

              <div style={{ flex: "1 1 400px", fontSize: "14px" }}>
                <p style={{ fontWeight: "bold", margin: "0 0 0.3rem 0" }}>
                  States:
                </p>
                <ul
                  className="arrow-list"
                  style={{ columnCount: 3, paddingLeft: "1rem", margin: 0 }}
                >
                  {[
                    "Andaman and Nicobar Islands",
                    "Andhra Pradesh",
                    "Arunachal Pradesh",
                    "Assam",
                    "Bihar",
                    "Chandigarh",
                    "Chhattisgarh",
                    "Dadra and Nagar Haveli and Daman and Diu",
                    "Delhi",
                    "Goa",
                    "Gujarat",
                    "Haryana",
                    "Himachal Pradesh",
                    "Jammu and Kashmir",
                    "Jharkhand",
                    "Karnataka",
                    "Kerala",
                    "Ladakh",
                    "Lakshadweep",
                    "Madhya Pradesh",
                    "Maharashtra",
                    "Manipur",
                    "Meghalaya",
                    "Mizoram",
                    "Nagaland",
                    "Odisha",
                    "Puducherry",
                    "Punjab",
                    "Rajasthan",
                    "Sikkim",
                    "Tamil Nadu",
                    "Telangana",
                    "Tripura",
                    "Uttar Pradesh",
                    "Uttarakhand",
                    "West Bengal",
                  ].map((state) => (
                    <li key={state}>{state}</li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};
const tooltipContainerStyle = {
  position: "absolute",
  bottom: "120%",
  left: "50%",
  transform: "translateX(-50%)",
  zIndex: 10,
  animation: "fadeInStausBadge 0.25s ease",
};

const tooltipArrowStyle = {
  position: "absolute",
  bottom: "-6px",
  left: "50%",
  transform: "translateX(-50%) rotate(45deg)",
  width: "12px",
  height: "12px",
  backgroundColor: "#fff",
  borderLeft: "1px solid #ccc",
  borderTop: "1px solid #ccc",
  boxShadow: "0 2px 3px rgba(0,0,0,0.08)",
  zIndex: 1,
};

const tooltipCardStyle = {
  position: "relative",
  backgroundColor: "#fff",
  borderRadius: "8px",
  boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
  border: "1px solid #ddd",
  padding: "10px 12px",
  minWidth: "200px",
};

const StatusBadge = ({ Tenderstatus }) => {
  const [showPopup, setShowPopup] = useState(false);
  const { status, missingFields = [] } = Tenderstatus || {};

  const getStatusColor = () => {
    switch (status) {
      case "Incomplete":
        return "#e74c3c"; // red
      case "Partially Filled":
        return "#f1c40f"; // yellow
      case "Complete":
      default:
        return "#27ae60"; // green
    }
  };

  const statusColor = getStatusColor();

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      {/* Status Pill */}
      <div
        onMouseEnter={() => setShowPopup(true)}
        onMouseLeave={() => setShowPopup(false)}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
          padding: "6px 12px",
          background: "#fff",
          borderRadius: "999px",
          boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
          border: `1px solid ${statusColor}`,
          cursor: "pointer",
          fontWeight: 500,
          color: statusColor,
          transition: "all 0.25s ease",
          fontSize: "0.8rem",
          minWidth: "100px",
          marginTop: "7px",
        }}
      >
        <div
          style={{
            width: "8px",
            height: "8px",
            borderRadius: "50%",
            backgroundColor: statusColor,
          }}
        />
        <span>{status || "Unknown"}</span>
      </div>

      {/* Tooltip Popup */}
      {showPopup && missingFields.length > 0 && (
        <div style={tooltipContainerStyle}>
          <div style={tooltipArrowStyle}></div>
          <div style={tooltipCardStyle}>
            <strong style={{ color: "#2576BC", fontSize: "0.8rem" }}>
              Missing Fields:
            </strong>
            <ul style={{ margin: "6px 0 0 0", paddingLeft: "18px" }}>
              {missingFields.map((field) => (
                <li
                  key={field}
                  style={{ lineHeight: "1.4em", fontSize: "0.75rem" }}
                >
                  {field}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

function getTenderStatus(toggleState, tender) {
  let requiredFields = [];
  let totalChecks = 0;
  let filledChecks = 0;
  let missingFields = [];

  if (toggleState === 2) {
    requiredFields = [
      tender.is_jv_allowed === null ? "is_jv_allowed" : null,
      "tech_score",
      "company_score",
      "company_name",
      "eligibity_criteria",
      tender.soil_quality === null ? "soil_quality" : null,
      tender.participating_as === null ? "participating_as" : null,
      tender.is_jv_consorium_association_allowed === null
        ? "jv_consorium_association_allowed"
        : null,
      tender.is_jv_consorium_association_allowed != null &&
      tender.is_jv_consorium_association_allowed
        ? "terms_of_jv"
        : null,
      tender.site_apprisate_required === null
        ? "site_apprisate_required"
        : null,
      tender.site_apprisate_required !== null ? "site_apprisate_marking" : null,
      tender.work_methodology_required === null
        ? "work_methodology_required"
        : null,
      tender.work_methodology_required != null
        ? "work_methodology_marking"
        : null,
      tender.presentation_required === null ? "presentation_required" : null,
      tender.presentation_required !== null && tender.presentation_required
        ? "presentation_required_marking"
        : null,
      tender.presentation_required !== null && tender.presentation_required
        ? "presentation_type"
        : null,
    ].filter(Boolean);

    totalChecks = requiredFields.length;

    requiredFields.forEach((field) => {
      if (
        tender[field] !== undefined &&
        tender[field] !== null &&
        tender[field] !== ""
      ) {
        filledChecks++;
      } else {
        missingFields.push(field);
      }
    });

    // if (tender.is_jv_consorium_association_allowed) {
    //     totalChecks++;
    //     if (tender.terms_of_jv) filledChecks++;
    //     else missingFields.push("terms_of_jv");
    // }

    // if (tender.site_apprisate_required) {
    //     totalChecks++;
    //     if (tender.site_apprisate_marking) filledChecks++;
    //     else missingFields.push("site_apprisate_marking");
    // }

    // if (tender.work_methodology_required) {
    //     totalChecks++;
    //     if (tender.work_methodology_marking) filledChecks++;
    //     else missingFields.push("work_methodology_marking");
    // }

    // if (tender.presentation_required) {
    //     totalChecks++;
    //     if (tender.presentation_required_marking) filledChecks++;
    //     else missingFields.push("presentation_required_marking");
    // }
  } else if (toggleState === 3) {
    requiredFields = [
      tender.tender_submission_type === null ? "tender_submission_type" : null,

      tender.bid_prepare_by === null ? "bid_prepare_by" : null,
      tender.bg_prepare_by === null ? "bg_prepare_by" : null,
      "lead_partner_share",
      tender.jv_partner_name != "Not Required" ? "jv_partner_share" : null,
      tender.assosiate_partner != "Not Required"
        ? "associate_partner_share"
        : null,
      "jv_partner_share",
    ].filter(Boolean);

    totalChecks = requiredFields.length;

    requiredFields.forEach((field) => {
      if (
        tender[field] !== undefined &&
        tender[field] !== null &&
        tender[field] !== ""
      ) {
        filledChecks++;
      } else {
        missingFields.push(field);
      }
    });
  } else if (toggleState === 9) {
    requiredFields = [
      tender.all_docs_done === null ? "all_docs_done" : null,
      tender.all_cvs_done === null ? "all_cvs_done" : null,
      tender.checklist === null ? "checklist" : null,
      "tech_score",
      "cv_score",
      tender.team_required === null ? "team_required" : null,
      tender.team_required !== null && tender.team_required
        ? "team_prepare_by"
        : null,
      tender.team_required !== null && tender.team_required
        ? "team_prepare_by_remarks"
        : null,
      tender.team_required !== null && tender.team_required
        ? "team_requirements_details"
        : null,
      tender.is_emd_required === null ? "is_emd_required" : null,
      tender.is_emd_required != null && tender.is_emd_required
        ? "emd_amount"
        : null,

      tender.is_emd_required != null && tender.is_emd_required
        ? "emd_unit"
        : null,
      // tender.is_emd_required != null && tender.is_emd_required ? "emd_review" : null,
      tender.is_emd_required != null && tender.is_emd_required
        ? "exmpted_emd"
        : null,

      tender.is_emd_required != null && tender.is_emd_required
        ? "emd_type"
        : null,
      tender.is_emd_required != null && tender.is_emd_required
        ? "emd_submission_type"
        : null,
    ].filter(Boolean);
    totalChecks = requiredFields.length;

    requiredFields.forEach((field) => {
      if (
        tender[field] !== undefined &&
        tender[field] !== null &&
        tender[field] !== ""
      ) {
        filledChecks++;
      } else missingFields.push(field);
    });
  } else {
    return { status: "Unknown", missingFields: [] };
  }

  let status =
    filledChecks === 0
      ? "Incomplete"
      : filledChecks < totalChecks
        ? "Partially Filled"
        : "Completed";

  return { status, missingFields };
}

const StatsCard = ({
  stat,
  index,
  handleStatClick,
  handleFilterTenderType,
  handleSpecialClick,
  handleTodayClick,
  handleDiscussClick,
}) => {
  console.log(stat);
  const [open, setOpen] = useState(false);

  const toggleOpen = () => {
    setOpen(!open);
    if (open) {
      handleStatClick("");
      handleFilterTenderType("");
    } else {
      handleFilterTenderType("");
      if (
        stat.sector !== "Special Tender" &&
        stat.sector !== "Today Tender" &&
        stat.sector !== "Discussion Tender"
      ) {
        handleStatClick(
          stat.sector.charAt(0).toUpperCase() +
            stat.sector.slice(1).toLowerCase(),
        );
      } else if (stat.sector == "Special Tender") {
        handleSpecialClick(true);
      } else if (stat.sector == "Discussion Tender") {
        handleDiscussClick(true);
      }
      if (stat.sector == "Today Tender") {
        handleTodayClick(true);
      }
    }
  };

  // 'Feasibility', 'DPR', 'FesibilityCumDPR', 'Authority_Engineer', 'Independent_Engineer', 'PSSA', 'PMC', 'GC', 'Other'

  const handleTenderTypeClick = (e, type) => {
    e.stopPropagation();

    const tenderType =
      type === "FEASIBILITY"
        ? "Feasibility"
        : type === "FESIBILITYCUMDPR"
          ? "FesibilityCumDPR"
          : type === "AUTHORITY_ENGINEER"
            ? "Authority_Engineer"
            : type === "INDEPENDENT_ENGINEER"
              ? "Independent_Engineer"
              : type === "OTHER"
                ? "Other"
                : type === "SUPERVISION"
                  ? "Supervision"
                  : type;
    handleFilterTenderType(tenderType);
  };

  return (
    <div
      onClick={toggleOpen}
      key={`${stat.sector}-${index}`}
      style={{
        width: "17%",

        gap: "3px",
        backgroundColor: "#fff",
        opacity: 1,
        borderRadius: "10px",
        padding: "16px",
      }}
    >
      <label
        style={{
          fontWeight: 500,
          fontSize: "17px",
          color: "#1E1E1E80",
          display: "block",
        }}
      >
        {stat.sector}
      </label>
      <label
        style={{
          color: " #1E1E1E",
          fontWeight: 600,
          fontSize: "22px",
        }}
      >
        {stat.count}
      </label>

      <div
        style={{
          maxHeight: open ? "500px" : "0px",
          overflow: "hidden",
          transition: "max-height 0.6s ease-in-out",
          display: "flex",
          flexDirection: "column",
          gap: "4px",
        }}
      >
        {Object.entries(stat.tender_type).map(([type, count]) => (
          <div
            key={type}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "10px",
              backgroundColor: "#fafafa",
              padding: "4px",
            }}
            onClick={(e) => handleTenderTypeClick(e, type)}
          >
            <label style={{ cursor: "pointer" }}>{type}</label>

            <label style={{ cursor: "pointer" }}>{count}</label>
          </div>
        ))}
      </div>
    </div>
  );
};
// console.log(sessionStorage.setItem('scrollTenderId'), 'sessionstorage item')
const CorrigendumModal = ({
  corriendumModal,
  setCorriendumModal,
  handleHideUpdateModal,
  tenderId,
  getBidData,
  toggleState,
  tenders,
  filters,
  onUpdateSuccess,
  setScrollToTender,
  scrollToTender,
}) => {
  const [selected, setSelected] = useState("date");
  const [corrigendumDate, setCorrigendumDate] = useState(null);
  const currTender = tenders?.find((t) => t.id === tenderId);

  const fieldMeta = {
    tender_id: {
      label: "Tender Id",
      type: "text",
      default: currTender?.tender_id,
    },
    tender_name: {
      label: "Tender Name",
      type: "text",
      default: currTender?.tender_name,
    },
    sector: {
      label: "Sector",
      type: "select",
      options: [
        "Highway",
        "Railway",
        "Metro",
        "Water",
        "Ropeway",
        "Building",
        "Other",
      ],
      default: currTender?.sector,
    },
    tender_type: {
      label: "Tender Type",
      type: "select",
      options: [
        "Feasibility",
        "DPR",
        "FesibilityCumDPR",
        "Authority_Engineer",
        "Independent_Engineer",
        "PSSA",
        "PMC",
        "GC",
        "Other",
      ],
      default: currTender?.tender_type,
    },
    client: { label: "Client", type: "text", default: currTender?.client },
    submission_date: {
      label: "Submission Date",
      type: "date",
      default: currTender?.submission_date,
    },
    publish_date: {
      label: "Publish Date",
      type: "date",
      default: currTender?.publish_date,
    },
    lane: { label: "Lane", type: "char", default: currTender?.lane },
    state: {
      label: "State",
      type: "select",
      options: [
        "Andaman and Nicobar Islands",
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chandigarh",
        "Chhattisgarh",
        "Dadra and Nagar Haveli and Daman and Diu",
        "Delhi",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Ladakh",
        "Lakshadweep",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Puducherry",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
      ],
      default: currTender?.state,
    },
    consultancy_fees: {
      label: "Consultancy Fees ",
      type: "number",
      default: currTender?.consultancy_fees,
    },
    construction_fees: {
      label: "Construction Fees",
      type: "number",
      default: currTender?.construction_fees,
    },
    GST_construction: {
      label: "GST on Construction",
      type: "select",
      options: ["Including", "Excluding"],
      default: currTender?.GST_construction,
    },
    length: {
      label: "Length (km)",
      type: "number",
      default: currTender?.length,
    },
    duration: {
      label: "Duration (days)",
      type: "char",
      default: currTender?.duration,
    },
    type_of_project: {
      label: "Type of Project",
      type: "text",
      default: currTender?.type_of_project,
    },
    km_cost: {
      label: "Cost per KM",
      type: "number",
      default: currTender?.km_cost,
    },
    remarks: { label: "Remarks", type: "text", default: currTender?.remarks },
  };

  const handleCheckboxChange = (value) => {
    setSelected((prev) => (prev === value ? null : value));
  };

  const [corrigendumFiles, setCorrigendumFiles] = useState([]);

  const handleCorrigendumFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setCorrigendumFiles((prev) => [...prev, ...newFiles]);
    }
  };

  const handleCorrigendumFileRemove = (index) => {
    setCorrigendumFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const [fieldEntries, setFieldEntries] = useState([]);

  const handleAddField = () => {
    const unusedFields = availableFields.filter((f) => !usedKeys.includes(f));
    if (unusedFields.length === 0) return;

    const newField = unusedFields[0];
    const defaultValue = fieldMeta[newField]?.default ?? "";

    setFieldEntries((prev) => [
      ...prev,
      { key: newField, value: defaultValue },
    ]);
  };

  const handleFieldKeyChange = (index, newKey) => {
    const defaultValue = fieldMeta[newKey]?.default ?? "";
    setFieldEntries((prev) => {
      const updated = [...prev];
      updated[index] = { key: newKey, value: defaultValue };
      return updated;
    });
  };

  const handleValueChange = (index, newValue) => {
    const updated = [...fieldEntries];
    updated[index].value = newValue;
    setFieldEntries(updated);
  };

  const handleRemoveField = (index) => {
    const updated = [...fieldEntries];
    updated.splice(index, 1);
    setFieldEntries(updated);
  };

  const usedKeys = fieldEntries.map((f) => f.key);

  const handleCloseModal = () => {
    setFieldEntries([]);
    setCorrigendumFiles([]);
    setCorrigendumDate(null);
    setSelected("date");
    handleHideUpdateModal();
  };

  const handleUpdateDate = async () => {
    if (!selected || (selected.includes("date") && !corrigendumDate)) return;

    try {
      const formData = new FormData();
      formData.append("corrigendum_tender", tenderId);

      corrigendumFiles.forEach((file) => {
        formData.append("document", file);
      });

      const fileNames = corrigendumFiles.map((f) => f.name);
      formData.append("document_name", JSON.stringify(fileNames));

      const otherDetails = [];

      if (selected === "date" || selected === "both") {
        otherDetails.push({
          corrigendum_type: selected,
          other_name: "corrigendum_date",
          other_value: formatISTWithOffset(corrigendumDate),
        });
      }

      if (selected === "other" || selected === "both") {
        fieldEntries.forEach((entry) => {
          otherDetails.push({
            corrigendum_type: selected,
            other_name: entry.key,
            other_value: entry.value,
          });
        });
      }

      formData.append("other_details", JSON.stringify(otherDetails));
      console.log(formData);
      const res = await axios.post(
        `${BASE_URL}/siteproject/bulkcorrengdum/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
      if (res.status === 200 || res.status === 201) {
        console.log(tenderId, "the tender id");
        sessionStorage.setItem("scrollTenderId", currTender?.tender_id);

        await getBidData(filters);
      } else {
      }
    } catch (err) {
    } finally {
      setCorrigendumDate(null);
      setCorrigendumFiles([]);
      setFieldEntries([]);
      setCorriendumModal(false);
      getBidData(filters);
    }
  };

  const availableFields = Object.keys(fieldMeta);
  const fieldLabels = Object.fromEntries(
    Object.entries(fieldMeta).map(([key, { label }]) => [key, label]),
  );

  return (
    <>
      <Modal
        show={corriendumModal}
        onHide={handleCloseModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Corrigendum</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex-column">
            <div style={{ display: "flex", gap: "20px", marginBottom: "2rem" }}>
              {["date", "other", "both"].map((type) => (
                <label
                  key={type}
                  style={{ display: "flex", alignItems: "center", gap: "4px" }}
                >
                  <input
                    type="checkbox"
                    checked={selected === type}
                    onChange={() => handleCheckboxChange(type)}
                  />
                  {type.charAt(0).toUpperCase() + type.slice(1)}
                </label>
              ))}
            </div>
            {(selected === "date" || selected === "both") && (
              <>
                <label className="form-labels">
                  Corrigendum Date <span className="required">*</span>
                </label>
                <input
                  type="datetime-local"
                  name="corrigendum_date"
                  value={corrigendumDate}
                  min={new Date().toISOString().slice(0, 16)}
                  onChange={(e) => setCorrigendumDate(e.target.value)}
                  className={`form-input input-form`}
                  style={{ width: "80%" }}
                />
              </>
            )}
            {(selected === "other" || selected === "both") && (
              <div
                style={{
                  padding: "16px",
                  maxWidth: "28rem",
                  margin: "0 auto",
                  fontFamily: "Arial, sans-serif",
                }}
              >
                <h2
                  style={{
                    fontSize: "1.25rem",
                    fontWeight: "600",
                    marginBottom: "1rem",
                  }}
                >
                  Add Other Fields
                </h2>

                {fieldEntries.map((entry, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      gap: "8px",
                      alignItems: "center",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <select
                      value={entry.key}
                      onChange={(e) =>
                        handleFieldKeyChange(index, e.target.value)
                      }
                      style={{
                        padding: "8px",
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                      }}
                    >
                      <option value="">Select Field</option>
                      {availableFields
                        .filter(
                          (field) =>
                            field === entry.key || !usedKeys.includes(field),
                        )
                        .map((field) => (
                          <option key={field} value={field}>
                            {fieldLabels[field] || field}
                          </option>
                        ))}
                    </select>

                    {(() => {
                      const meta = fieldMeta[entry.key];
                      if (!meta) return null;

                      if (meta.type === "select") {
                        return (
                          <select
                            value={entry.value}
                            onChange={(e) =>
                              handleValueChange(index, e.target.value)
                            }
                            style={{
                              padding: "8px",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              flex: 1,
                            }}
                          >
                            <option value="">Select {meta.label}</option>
                            {meta.options.map((opt) => (
                              <option key={opt} value={opt}>
                                {opt}
                              </option>
                            ))}
                          </select>
                        );
                      }

                      return (
                        <input
                          type={meta.type}
                          placeholder={`Enter ${meta.label}`}
                          value={entry.value}
                          onChange={(e) =>
                            handleValueChange(index, e.target.value)
                          }
                          style={{
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            flex: 1,
                          }}
                        />
                      );
                    })()}

                    <button
                      onClick={() => handleRemoveField(index)}
                      style={{
                        color: "red",
                        background: "none",
                        border: "none",
                        fontSize: "1.2rem",
                        cursor: "pointer",
                      }}
                    >
                      <CrossRed />
                    </button>
                  </div>
                ))}

                <button
                  onClick={handleAddField}
                  disabled={usedKeys.length >= availableFields.length}
                  style={{
                    backgroundColor: "#3B82F6",
                    color: "white",
                    padding: "8px 16px",
                    borderRadius: "4px",
                    border: "none",
                    cursor: "pointer",
                  }}
                >
                  <AddwithWhiteCircle /> Add Field
                </button>
              </div>
            )}
          </div>

          <div
            style={{
              width: "100%",
              maxWidth: 480,
              margin: "0",
              background: "#fff",
              borderRadius: 8,
              boxShadow: "0 2px 12px #eee",
              padding: 32,
            }}
          >
            <label
              className="form-labels font-weight500 font-size-subheading"
              style={{
                marginBottom: 12,
                display: "block",
                fontSize: 18,
                fontWeight: 600,
              }}
            >
              Upload Tender Document
            </label>
            <input
              type="file"
              multiple
              onChange={handleCorrigendumFileChange}
              style={{ marginBottom: 24, width: "100%" }}
              className="form-control"
            />

            <ul
              style={{
                listStyle: "none",
                padding: 0,
                margin: 0,
                width: "100%",
                maxHeight: 180,
                overflowY: "auto",
                border: corrigendumFiles.length ? "1px solid #ececec" : "none",
                borderRadius: 6,
                background: corrigendumFiles.length ? "#fafafd" : "none",
              }}
            >
              {corrigendumFiles.map((file, index) => (
                <li
                  key={file.name}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "10px 8px",
                    borderBottom:
                      index !== corrigendumFiles.length - 1
                        ? "1px solid #ececec"
                        : "none",
                  }}
                >
                  <span
                    style={{
                      flex: 1,
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    <svg
                      width="18"
                      height="18"
                      fill="#6c63ff"
                      style={{ marginRight: 8, verticalAlign: "middle" }}
                    >
                      <rect width="18" height="18" rx="3" />
                    </svg>
                    {file.name}
                  </span>
                  <button
                    onClick={() => handleCorrigendumFileRemove(index)}
                    style={{
                      marginLeft: 16,
                      padding: "4px 12px",
                      backgroundColor: "#ff4e4e",
                      color: "#fff",
                      border: "none",
                      borderRadius: 4,
                      fontWeight: 500,
                      cursor: "pointer",
                      fontSize: 14,
                    }}
                  >
                    Remove
                  </button>
                </li>
              ))}
              {!corrigendumFiles.length && (
                <li style={{ color: "#999", textAlign: "center", padding: 20 }}>
                  No files uploaded
                </li>
              )}
            </ul>
          </div>

          <button
            className="model-button-download model-button font-weight500"
            style={{ marginTop: "20px" }}
            onClick={handleUpdateDate}
            disabled={
              selected === null ||
              (selected.includes("date") && !corrigendumDate) ||
              (selected.includes("other") && fieldEntries.length === 0)
            }
          >
            Update
          </button>

          <div
            style={{
              marginTop: "2rem",
              display: "flex",
              gap: "1rem",
              flexDirection: "column",
            }}
          >
            <label>Logs</label>
            <table
              style={{
                width: "100%",
                borderCollapse: "collapse",
                fontFamily: "Arial, sans-serif",
              }}
            >
              <thead>
                <tr style={{ backgroundColor: "#f2f2f2", textAlign: "left" }}>
                  <th
                    style={{ padding: "12px", borderBottom: "2px solid #ccc" }}
                  >
                    Corrigendum Type
                  </th>
                  <th
                    style={{ padding: "12px", borderBottom: "2px solid #ccc" }}
                  >
                    Changed On
                  </th>
                  <th
                    style={{ padding: "12px", borderBottom: "2px solid #ccc" }}
                  >
                    Name
                  </th>
                  <th
                    style={{ padding: "12px", borderBottom: "2px solid #ccc" }}
                  >
                    Value
                  </th>
                </tr>
              </thead>
              <tbody>
                {currTender?.correigendum_types?.map((entry) => (
                  <tr key={entry.id} style={{ borderBottom: "1px solid #ddd" }}>
                    <td style={{ padding: "10px" }}>
                      {entry.corrigendum_type}
                    </td>
                    <td style={{ padding: "10px" }}>
                      {entry.created_at?.slice(0, 10)}
                    </td>
                    <td style={{ padding: "10px" }}>{entry.other_name}</td>
                    <td style={{ padding: "10px" }}>{entry.other_value}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

const CorrigendumModalScreening = ({
  corriendumModal,
  setCorriendumModal,
  handleHideUpdateModal,
  tenderId,
  getBidData,
  toggleState,
  tenders,
  filters,
  onUpdateSuccess,
  setScrollToTender,
  scrollToTender,
}) => {
  const [selected, setSelected] = useState("date");
  const [corrigendumDate, setCorrigendumDate] = useState(null);
  const currTender = tenders?.find((t) => t.id === tenderId);

  const fieldMeta = {
    tender_id: {
      label: "Tender Id",
      type: "text",
      default: currTender?.tender_id,
    },
    tender_name: {
      label: "Tender Name",
      type: "text",
      default: currTender?.tender_name,
    },
    sector: {
      label: "Sector",
      type: "select",
      options: [
        "Highway",
        "Railway",
        "Metro",
        "Water",
        "Ropeway",
        "Building",
        "Other",
      ],
      default: currTender?.sector,
    },
    tender_type: {
      label: "Tender Type",
      type: "select",
      options: [
        "Feasibility",
        "DPR",
        "FesibilityCumDPR",
        "Authority_Engineer",
        "Independent_Engineer",
        "PSSA",
        "PMC",
        "GC",
        "Other",
      ],
      default: currTender?.tender_type,
    },
    client: { label: "Client", type: "text", default: currTender?.client },
    submission_date: {
      label: "Submission Date",
      type: "date",
      default: currTender?.submission_date,
    },
    publish_date: {
      label: "Publish Date",
      type: "date",
      default: currTender?.publish_date,
    },
    lane: { label: "Lane", type: "char", default: currTender?.lane },
    state: {
      label: "State",
      type: "select",
      options: [
        "Andaman and Nicobar Islands",
        "Andhra Pradesh",
        "Arunachal Pradesh",
        "Assam",
        "Bihar",
        "Chandigarh",
        "Chhattisgarh",
        "Dadra and Nagar Haveli and Daman and Diu",
        "Delhi",
        "Goa",
        "Gujarat",
        "Haryana",
        "Himachal Pradesh",
        "Jammu and Kashmir",
        "Jharkhand",
        "Karnataka",
        "Kerala",
        "Ladakh",
        "Lakshadweep",
        "Madhya Pradesh",
        "Maharashtra",
        "Manipur",
        "Meghalaya",
        "Mizoram",
        "Nagaland",
        "Odisha",
        "Puducherry",
        "Punjab",
        "Rajasthan",
        "Sikkim",
        "Tamil Nadu",
        "Telangana",
        "Tripura",
        "Uttar Pradesh",
        "Uttarakhand",
        "West Bengal",
      ],
      default: currTender?.state,
    },
    consultancy_fees: {
      label: "Consultancy Fees ",
      type: "number",
      default: currTender?.consultancy_fees,
    },
    construction_fees: {
      label: "Construction Fees",
      type: "number",
      default: currTender?.construction_fees,
    },
    GST_construction: {
      label: "GST on Construction",
      type: "select",
      options: ["Including", "Excluding"],
      default: currTender?.GST_construction,
    },
    length: {
      label: "Length (km)",
      type: "number",
      default: currTender?.length,
    },
    duration: {
      label: "Duration (days)",
      type: "char",
      default: currTender?.duration,
    },
    type_of_project: {
      label: "Type of Project",
      type: "text",
      default: currTender?.type_of_project,
    },
    km_cost: {
      label: "Cost per KM",
      type: "number",
      default: currTender?.km_cost,
    },
    remarks: { label: "Remarks", type: "text", default: currTender?.remarks },
  };

  const handleCheckboxChange = (value) => {
    setSelected((prev) => (prev === value ? null : value));
  };

  const [corrigendumFiles, setCorrigendumFiles] = useState([]);

  const handleCorrigendumFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setCorrigendumFiles((prev) => [...prev, ...newFiles]);
    }
  };

  const handleCorrigendumFileRemove = (index) => {
    setCorrigendumFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const [fieldEntries, setFieldEntries] = useState([]);

  const handleAddField = () => {
    const unusedFields = availableFields.filter((f) => !usedKeys.includes(f));
    if (unusedFields.length === 0) return;

    const newField = unusedFields[0];
    const defaultValue = fieldMeta[newField]?.default ?? "";

    setFieldEntries((prev) => [
      ...prev,
      { key: newField, value: defaultValue },
    ]);
  };

  const handleFieldKeyChange = (index, newKey) => {
    const defaultValue = fieldMeta[newKey]?.default ?? "";
    setFieldEntries((prev) => {
      const updated = [...prev];
      updated[index] = { key: newKey, value: defaultValue };
      return updated;
    });
  };

  const handleValueChange = (index, newValue) => {
    const updated = [...fieldEntries];
    updated[index].value = newValue;
    setFieldEntries(updated);
  };

  const handleRemoveField = (index) => {
    const updated = [...fieldEntries];
    updated.splice(index, 1);
    setFieldEntries(updated);
  };

  const usedKeys = fieldEntries.map((f) => f.key);

  const handleCloseModal = () => {
    setCorrigendumDate(null);

    handleHideUpdateModal();
  };

  const handleUpdateDate = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Removing from discussed...");

    try {
      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
        {
          screening_date: corrigendumDate,
        },
      );
      if (res.status === 200) {
        await getBidData(filters);
        toast.success("Screening Date updated");
        handleHideUpdateModal();
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };
  const availableFields = Object.keys(fieldMeta);
  const fieldLabels = Object.fromEntries(
    Object.entries(fieldMeta).map(([key, { label }]) => [key, label]),
  );

  return (
    <>
      <Modal
        show={corriendumModal}
        onHide={handleCloseModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Screening Date</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="flex-column">
            <label className="form-labels">
              Screening Date <span className="required">*</span>
            </label>
            <input
              type="date"
              name="corrigendum_date"
              value={corrigendumDate}
              min={new Date().toISOString().slice(0, 16)}
              onChange={(e) => setCorrigendumDate(e.target.value)}
              className={`form-input input-form`}
              style={{ width: "80%" }}
            />
          </div>

          <button
            className="model-button-download model-button font-weight500"
            style={{ marginTop: "20px" }}
            onClick={handleUpdateDate}
            disabled={
              selected === null ||
              (selected.includes("date") && !corrigendumDate)
            }
          >
            Update
          </button>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

const TenderViewModal = ({
  rpfDocumentList,
  techDocumentList,
  cvDocumentList,
  BidDocumentList,
  financialDocumentList,
  toggleState,
  getBidData,
  filters,
}) => {
  const [show, SetShow] = useState(false);
  const [showfinancial, SetShowfinancial] = useState(false);
  const [showCV, SetShowCv] = useState(false);
  const [showRfp, SetShowRfp] = useState(false);
  const [showBid, SetShowBid] = useState(false);
  const handleShow = () => {
    SetShow(true);
  };

  const handleShowFinancial = () => {
    SetShowfinancial(true);
  };

  const handleShowCv = () => {
    SetShowCv(true);
  };

  const handleShowRfp = () => {
    SetShowRfp(true);
  };

  const handleShowBid = () => {
    SetShowBid(true);
  };

  const handleCloseModal = () => {
    SetShow(false);
  };

  const handleCloseFinancialModal = () => {
    SetShowfinancial(false);
  };

  const handleCloseCvModal = () => {
    SetShowCv(false);
  };

  const handleCloseRfpModal = () => {
    SetShowRfp(false);
  };

  const handleCloseBidModal = () => {
    SetShowBid(false);
  };

  const handleDeleterfp = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/siteproject/rfpdelete/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        SetShow(false);
        console.log("after console code");
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // toast.dismiss(loadingToastId);
    }
  };

  const handleDeleteTech = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/siteproject/techdelete/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        SetShow(false);
        // sessionStorage.setItem('scrollTenderId', tenderId);
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // toast.dismiss(loadingToastId);
    }
  };

  const handleDeleteFinancial = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/siteproject/financialdelete/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        SetShow(false);
        // sessionStorage.setItem('scrollTenderId', tenderId);
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // toast.dismiss(loadingToastId);
    }
  };

  const handleDeleteCv = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/siteproject/cvdelete/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        SetShow(false);
        // sessionStorage.setItem('scrollTenderId', tenderId);
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // toast.dismiss(loadingToastId);
    }
  };

  const handleDeleteBid = async (id) => {
    try {
      const res = await axios.delete(
        `${BASE_URL}/siteproject/biddelete/${id}/`,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );

      if (res.status === 200 || res.status === 201) {
        SetShow(false);
        // sessionStorage.setItem('scrollTenderId', tenderId);
        await getBidData(filters);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      // toast.dismiss(loadingToastId);
    }
  };

  const roleemp = sessionStorage.getItem("sitemanagement_role");

  return (
    <>
      <div class="tender-buttons">
        {toggleState === 5 &&
          (techDocumentList.length === 0 ? (
            ""
          ) : (
            <button onClick={handleShow} title="View Tech Tender Documents">
              <DOCIcon size={"27"} />
              <small className="tender-detail-doc-name">Tech</small>
            </button>
          ))}

        {toggleState === 5 &&
          (financialDocumentList.length === 0 ? (
            ""
          ) : (
            <button
              onClick={handleShowFinancial}
              title="View Financial Tender Documents"
            >
              <DOCIcon size={"27"} />
              <small className="tender-detail-doc-name">Financial</small>
            </button>
          ))}
        {console.log(
          toggleState,
          "togglestate",
          (toggleState === 5 || toggleState === 9) &&
            !["CertificationAccessCvTeam"].includes(roleemp),
        )}
        {(toggleState === 5 || toggleState === 9) &&
          !["CertificationAccessCvTeam"].includes(roleemp) &&
          (cvDocumentList.length === 0 ? (
            ""
          ) : (
            <button onClick={handleShowCv} title="View CV Tender Documents">
              <DOCIcon size={"27"} />
              <small className="tender-detail-doc-name">Cv</small>
            </button>
          ))}

        {rpfDocumentList.length === 0 ? (
          ""
        ) : (
          <OverlayTrigger
            placement="top"
            overlay={
              <Tooltip id="tooltip-rfp" className="rfp-tooltip">
                <div>
                  <b>RFP Documents:</b>
                  <br />
                  {rpfDocumentList.map((doc, index) => (
                    <div key={index}>
                      {index + 1}. {doc.document_name}
                    </div>
                  ))}
                </div>
              </Tooltip>
            }
          >
            <button
              onClick={handleShowRfp}
              className="align-center justify-center"
            >
              <DOCIcon size={"27"} />
              <small className="tender-detail-doc-name">Rfp</small>
            </button>
          </OverlayTrigger>
        )}

        {toggleState === 5 &&
          (BidDocumentList.length === 0 ? (
            ""
          ) : (
            <button onClick={handleShowBid} title="View Bid Tender Documents">
              <DOCIcon size={"27"} />
              <small className="tender-detail-doc-name">Bid</small>
            </button>
          ))}
      </div>

      <Modal
        show={show}
        onHide={handleCloseModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title> Technical Tender Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-overflow" style={{ marginTop: "2rem" }}>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr ">
                  <th className="table-heading-text">S.No.</th>
                  <th className="table-heading-text">Document Name</th>

                  <th className="table-heading-text text-center">Document</th>
                  <th className="table-heading-text text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {techDocumentList.map((doc, docIndex) => (
                  <tr className="custom-table-head-td" key={docIndex}>
                    <td className="table-body">{docIndex + 1}.</td>

                    <td className="table-body">{doc?.document_name}</td>
                    <td className="table-body">
                      {doc.document ? (
                        <a
                          href={doc.document}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="flex-row justify-center">
                            <AttachmentIcon source={doc.document} />
                          </div>
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>

                    <td className="table-body">
                      <button
                        onClick={() => {
                          handleDeleteTech(doc.id);
                        }}
                      >
                        <DeleteDustbinbUTTON />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showfinancial}
        onHide={handleCloseFinancialModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Financial Tender Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-overflow" style={{ marginTop: "2rem" }}>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr ">
                  <th className="table-heading-text">S.No.</th>
                  <th className="table-heading-text">Document Name</th>

                  <th className="table-heading-text text-center">Document</th>
                  <th className="table-heading-text text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {financialDocumentList.map((doc, docIndex) => (
                  <tr className="custom-table-head-td" key={docIndex}>
                    <td className="table-body">{docIndex + 1}.</td>

                    <td className="table-body">{doc?.document_name}</td>
                    <td className="table-body">
                      {doc.document ? (
                        <a
                          href={doc.document}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="flex-row justify-center">
                            <AttachmentIcon source={doc.document} />
                          </div>
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>
                    <td className="table-body">
                      <button
                        onClick={() => {
                          handleDeleteFinancial(doc.id);
                        }}
                      >
                        <DeleteDustbinbUTTON />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showCV}
        onHide={handleCloseCvModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Cv Tender Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-overflow" style={{ marginTop: "2rem" }}>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr ">
                  <th className="table-heading-text">S.No.</th>
                  <th className="table-heading-text">Document Name</th>

                  <th className="table-heading-text text-center">Document</th>

                  <th className="table-heading-text text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {cvDocumentList.map((doc, docIndex) => (
                  <tr className="custom-table-head-td" key={docIndex}>
                    <td className="table-body">{docIndex + 1}.</td>

                    <td className="table-body">{doc?.document_name}</td>
                    <td className="table-body">
                      {doc.document ? (
                        <a
                          href={doc.document}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="flex-row justify-center">
                            <AttachmentIcon source={doc.document} />
                          </div>
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>
                    <td className="table-body">
                      <button
                        onClick={() => {
                          handleDeleteCv(doc.id);
                        }}
                      >
                        <DeleteDustbinbUTTON />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showRfp}
        onHide={handleCloseRfpModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Rfp Tender Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-overflow" style={{ marginTop: "2rem" }}>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr ">
                  <th className="table-heading-text">S.No.</th>
                  <th className="table-heading-text">Document Name</th>

                  <th className="table-heading-text text-center">Document</th>

                  <th className="table-heading-text text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {rpfDocumentList.map((doc, docIndex) => (
                  <tr className="custom-table-head-td" key={docIndex}>
                    <td className="table-body">{docIndex + 1}.</td>

                    <td className="table-body">{doc?.document_name}</td>
                    <td className="table-body">
                      {doc.document ? (
                        <a
                          href={doc.document}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="flex-row justify-center">
                            <AttachmentIcon source={doc.document} />
                          </div>
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>
                    <td className="table-body text-center">
                      <button
                        onClick={() => {
                          handleDeleterfp(doc.id);
                        }}
                      >
                        <DeleteDustbinbUTTON />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showBid}
        onHide={handleCloseBidModal}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Bid Tender Document</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="table-overflow" style={{ marginTop: "2rem" }}>
            <table className="table-css">
              <thead>
                <tr className="custom-table-head-tr ">
                  <th className="table-heading-text">S.No.</th>
                  <th className="table-heading-text">Document Name</th>

                  <th className="table-heading-text text-center">Document</th>

                  <th className="table-heading-text text-center">Actions</th>
                </tr>
              </thead>
              <tbody>
                {BidDocumentList.map((doc, docIndex) => (
                  <tr className="custom-table-head-td" key={docIndex}>
                    <td className="table-body">{docIndex + 1}.</td>

                    <td className="table-body">{doc?.document_name}</td>
                    <td className="table-body">
                      {doc.document ? (
                        <a
                          href={doc.document}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          <div className="flex-row justify-center">
                            <AttachmentIcon source={doc.document} />
                          </div>
                        </a>
                      ) : (
                        "Document Not Attached"
                      )}
                    </td>
                    <td className="table-body">
                      <button
                        onClick={() => {
                          handleDeleteBid(doc.id);
                        }}
                      >
                        <DeleteDustbinbUTTON />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

const TenderViewAddDocumentModal = ({
  tenderID,
  getBidData,
  toogleState,
  filters,
  i,
}) => {
  const [tenderidscroll, SetTenderIdscroll] = useState("");
  const [rfpFiles, setRfpFiles] = useState([]);
  const [show, setShow] = useState(false);
  const handleRfpFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setRfpFiles((prev) => [...prev, ...newFiles]);
    }
  };

  const handleRemove = (index) => {
    setRfpFiles((prev) => prev.filter((_, i) => i !== index));
  };

  const handleClose = () => {
    setShow(false);
    setDocNames("");
    setRfpFiles([]);
  };

  const handleShow = () => {
    setShow(true);
    SetTenderIdscroll(i.tender_id);
  };

  const [docNames, setDocNames] = useState();

  const [loading, setLoading] = useState(false);
  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    const loadingToastId = toast.loading("Loading: Please wait...");

    try {
      if (rfpFiles.length) {
        try {
          const formData = new FormData();

          rfpFiles.forEach((file) => {
            formData.append("rfp_tender", tenderID);
            formData.append("document_name", file?.name);
            formData.append("document", file);
          });

          const uploadRes = await axios.post(
            `${BASE_URL}/siteproject/bulkrfp/`,
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            },
          );
        } catch (uploadErr) {
          setRfpFiles([]);
        } finally {
          setRfpFiles([]);
          getBidData(filters);
          sessionStorage.setItem("scrollTenderId", tenderidscroll);
        }
      }

      setShow(false);
      setLoading(false);
      toast.dismiss(loadingToastId);
      handleClose();
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const [cvsDocs, setCvsDocs] = useState([]);
  const [techDocs, setTechDocs] = useState([]);
  const [finacialDocs, setFinancialDocs] = useState([]);
  const [BidDocs, setBidDocs] = useState([]);
  const handleCvsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setCvsDocs(newFiles);
    }
  };

  const handleCvsRemove = (index) => {
    setCvsDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddCvDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      cvsDocs.forEach((file) => {
        formData.append("cv_tender", tenderID);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkcv/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setCvsDocs([]);
    } finally {
      setCvsDocs([]);
      getBidData(filters);
      sessionStorage.setItem("scrollTenderId", tenderidscroll);
    }
  };

  const handleTechFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setTechDocs(newFiles);
    }
  };

  const handleTechRemove = (index) => {
    setTechDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddTechDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      techDocs.forEach((file) => {
        formData.append("tech_tender", tenderID);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulktech/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setTechDocs([]);
    } finally {
      setTechDocs([]);
      getBidData(filters);
      sessionStorage.setItem("scrollTenderId", tenderidscroll);
    }
  };

  const handleFinancialFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setFinancialDocs(newFiles);
    }
  };

  const handleFinancialRemove = (index) => {
    setFinancialDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddFinancialDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      finacialDocs.forEach((file) => {
        formData.append("financial_tender", tenderID);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkfinancial/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setFinancialDocs([]);
    } finally {
      setFinancialDocs([]);
      getBidData(filters);
      sessionStorage.setItem("scrollTenderId", tenderidscroll);
    }
  };

  const handleBidsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setBidDocs(newFiles);
    }
  };

  const handleBidsRemove = (index) => {
    setBidDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddBidDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      BidDocs.forEach((file) => {
        formData.append("bid_tender", tenderID);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkbbid/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setBidDocs([]);
    } finally {
      setBidDocs([]);
      getBidData(filters);
      sessionStorage.setItem("scrollTenderId", tenderidscroll);
    }
  };

  return (
    <>
      <button
        title="Add Tender Documents"
        // className="jd-heading-bottom-bold "
        style={{ color: "#2576bc" }}
        onClick={handleShow}
      >
        <AddwithBlueCircle /> <u>Add Documents</u>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="ourcompany-model"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Add Tender Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Rfp Document
              </label>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleRfpFileChange}
                  style={{ marginBottom: 24, width: "100%" }}
                  className="form-control"
                />
                <button
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!rfpFiles.length}
                  onClick={handleSubmit}
                  className="model-button model-button-submit"
                >
                  Add
                </button>
              </div>
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: rfpFiles.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: rfpFiles.length ? "#fafafd" : "none",
                }}
              >
                {rfpFiles.map((file, index) => (
                  <li
                    key={file.name}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== rfpFiles.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#2576BC"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!rfpFiles.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            {toogleState === 4 && (
              <>
                <div
                  style={{
                    width: "100%",
                    maxWidth: 480,
                    margin: "0 auto",
                    background: "#fff",
                    borderRadius: 8,
                    boxShadow: "0 2px 12px #eee",
                    padding: 32,
                    marginTop: 24,
                  }}
                >
                  <label
                    className="form-labels font-weight500 font-size-subheading"
                    style={{
                      marginBottom: 12,
                      display: "block",
                      fontSize: 18,
                      fontWeight: 600,
                    }}
                  >
                    Upload Tech Proposal
                  </label>

                  {/* File Input and Add Button */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 24,
                    }}
                  >
                    <input
                      type="file"
                      multiple
                      onChange={handleTechFileChange}
                      style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                      className="form-control"
                    />
                    <button
                      onClick={handleAddTechDoc}
                      style={{
                        padding: "8px 20px",
                        backgroundColor: "#6c63ff",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: "pointer",
                      }}
                      disabled={!techDocs.length}
                    >
                      Add
                    </button>
                  </div>

                  {/* List of uploaded tech docs */}
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      width: "100%",
                      maxHeight: 180,
                      overflowY: "auto",
                      border: techDocs?.length ? "1px solid #ececec" : "none",
                      borderRadius: 6,
                      background: techDocs?.length ? "#fafafd" : "none",
                    }}
                  >
                    {techDocs?.map((file, index) => (
                      <li
                        key={file.name + index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 8px",
                          borderBottom:
                            index !== techDocs.length - 1
                              ? "1px solid #ececec"
                              : "none",
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            fill="#6c63ff"
                            style={{ marginRight: 8, verticalAlign: "middle" }}
                          >
                            <rect width="18" height="18" rx="3" />
                          </svg>
                          {file.name}
                        </span>
                        <button
                          onClick={() => handleTechRemove(index)}
                          style={{
                            marginLeft: 16,
                            padding: "4px 12px",
                            backgroundColor: "#ff4e4e",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            fontWeight: 500,
                            cursor: "pointer",
                            fontSize: 14,
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                    {!techDocs?.length && (
                      <li
                        style={{
                          color: "#999",
                          textAlign: "center",
                          padding: 20,
                        }}
                      >
                        No files uploaded
                      </li>
                    )}
                  </ul>
                </div>
                <div
                  style={{
                    width: "100%",
                    maxWidth: 480,
                    margin: "0 auto",
                    background: "#fff",
                    borderRadius: 8,
                    boxShadow: "0 2px 12px #eee",
                    padding: 32,
                    marginTop: 24,
                  }}
                >
                  <label
                    className="form-labels font-weight500 font-size-subheading"
                    style={{
                      marginBottom: 12,
                      display: "block",
                      fontSize: 18,
                      fontWeight: 600,
                    }}
                  >
                    Upload Financial Proposal
                  </label>

                  {/* File Input and Add Button */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 24,
                    }}
                  >
                    <input
                      type="file"
                      multiple
                      onChange={handleFinancialFileChange}
                      style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                      className="form-control"
                    />
                    <button
                      onClick={handleAddFinancialDoc}
                      style={{
                        padding: "8px 20px",
                        backgroundColor: "#6c63ff",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: "pointer",
                      }}
                      disabled={!finacialDocs.length}
                    >
                      Add
                    </button>
                  </div>

                  {/* List of uploaded tech docs */}
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      width: "100%",
                      maxHeight: 180,
                      overflowY: "auto",
                      border: finacialDocs?.length
                        ? "1px solid #ececec"
                        : "none",
                      borderRadius: 6,
                      background: finacialDocs?.length ? "#fafafd" : "none",
                    }}
                  >
                    {finacialDocs?.map((file, index) => (
                      <li
                        key={file.name + index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 8px",
                          borderBottom:
                            index !== finacialDocs.length - 1
                              ? "1px solid #ececec"
                              : "none",
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            fill="#6c63ff"
                            style={{ marginRight: 8, verticalAlign: "middle" }}
                          >
                            <rect width="18" height="18" rx="3" />
                          </svg>
                          {file.name}
                        </span>
                        <button
                          onClick={() => handleFinancialRemove(index)}
                          style={{
                            marginLeft: 16,
                            padding: "4px 12px",
                            backgroundColor: "#ff4e4e",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            fontWeight: 500,
                            cursor: "pointer",
                            fontSize: 14,
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                    {!finacialDocs?.length && (
                      <li
                        style={{
                          color: "#999",
                          textAlign: "center",
                          padding: 20,
                        }}
                      >
                        No files uploaded
                      </li>
                    )}
                  </ul>
                </div>
                <div
                  style={{
                    width: "100%",
                    maxWidth: 480,
                    margin: "0 auto",
                    background: "#fff",
                    borderRadius: 8,
                    boxShadow: "0 2px 12px #eee",
                    padding: 32,
                    marginTop: 24,
                  }}
                >
                  <label
                    className="form-labels font-weight500 font-size-subheading"
                    style={{
                      marginBottom: 12,
                      display: "block",
                      fontSize: 18,
                      fontWeight: 600,
                    }}
                  >
                    Upload CV's
                  </label>

                  {/* File Input and Add Button */}
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      marginBottom: 24,
                    }}
                  >
                    <input
                      type="file"
                      multiple
                      onChange={handleCvsFileChange}
                      style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                      className="form-control"
                    />
                    <button
                      onClick={handleAddCvDoc}
                      style={{
                        padding: "8px 20px",
                        backgroundColor: "#6c63ff",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 600,
                        fontSize: 15,
                        cursor: "pointer",
                      }}
                      disabled={!cvsDocs.length}
                    >
                      Add
                    </button>
                  </div>

                  {/* List of uploaded tech docs */}
                  <ul
                    style={{
                      listStyle: "none",
                      padding: 0,
                      margin: 0,
                      width: "100%",
                      maxHeight: 180,
                      overflowY: "auto",
                      border: cvsDocs?.length ? "1px solid #ececec" : "none",
                      borderRadius: 6,
                      background: cvsDocs?.length ? "#fafafd" : "none",
                    }}
                  >
                    {cvsDocs?.map((file, index) => (
                      <li
                        key={file.name + index}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          padding: "10px 8px",
                          borderBottom:
                            index !== cvsDocs.length - 1
                              ? "1px solid #ececec"
                              : "none",
                        }}
                      >
                        <span
                          style={{
                            flex: 1,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          <svg
                            width="18"
                            height="18"
                            fill="#6c63ff"
                            style={{ marginRight: 8, verticalAlign: "middle" }}
                          >
                            <rect width="18" height="18" rx="3" />
                          </svg>
                          {file.name}
                        </span>
                        <button
                          onClick={() => handleCvsRemove(index)}
                          style={{
                            marginLeft: 16,
                            padding: "4px 12px",
                            backgroundColor: "#ff4e4e",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            fontWeight: 500,
                            cursor: "pointer",
                            fontSize: 14,
                          }}
                        >
                          Remove
                        </button>
                      </li>
                    ))}
                    {!cvsDocs?.length && (
                      <li
                        style={{
                          color: "#999",
                          textAlign: "center",
                          padding: 20,
                        }}
                      >
                        No files uploaded
                      </li>
                    )}
                  </ul>
                </div>
              </>
            )}
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Bid Acknowledgemnet
              </label>

              {/* File Input and Add Button */}
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleBidsFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddBidDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!BidDocs.length}
                >
                  Add
                </button>
              </div>

              {/* List of uploaded tech docs */}
              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: BidDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: BidDocs?.length ? "#fafafd" : "none",
                }}
              >
                {BidDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== cvsDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleBidsRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!BidDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
          </div>

          <ToastContainer
            position="top-center"
            autoClose={1000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
          />
        </Modal.Body>
      </Modal>
    </>
  );
};

const TenderViewAddSingleNoteModal = ({ i, tenderID, getBidData, filters }) => {
  const [show, setShow] = useState(false);
  const [tenderidscroll, SetTenderIdscroll] = useState("");
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState({ title: "", detail: "" });
  const [buffering, setBuffering] = useState(false);

  const handleClose = () => {
    setShow(false);
    setNewNote({ title: "", detail: "" });
  };

  const handleShow = () => {
    setShow(true);
    SetTenderIdscroll(i?.tender_id);
  };

  const handleAddNote = async () => {
    if (!newNote.title.trim() || !newNote.detail.trim()) {
      toast.error("Please fill both Title and Detail!");
      return;
    }

    const payload = {
      tender_id: tenderID,
      employee_id: sessionStorage.getItem("sitemanagement_emp_id"),
      emp_code: sessionStorage.getItem("sitemanagement_emp_code"),
      description: newNote,
    };

    const loadingToastId = toast.loading("Saving note...");

    try {
      await axios.post(`${BASE_URL}/siteproject/notes/`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success("Note saved successfully!");
      setNewNote({ title: "", detail: "" });
      sessionStorage.setItem("scrollTenderId", tenderidscroll);
      getBidData(filters);
      handleClose();
    } catch (err) {
      toast.error("Failed to save note!");
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const getNotesData = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/notesfilterbytender/${tenderID}/`,
      );
      if (res?.data) {
        setNotes(res.data);
      } else {
        setNotes([]);
      }
    } catch (err) {
      console.error("Error fetching notes:", err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (show) {
      getNotesData();
    }
  }, [show]);

  return (
    <>
      <button
        title="Add Note"
        style={{ color: "#2576bc" }}
        onClick={handleShow}
      >
        <AddwithBlueCircle /> <u>Add Note</u>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>Add Note</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            {/* Note Title Input */}
            <div className="flex-column">
              <label className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                Title<span className="required">*</span>
              </label>
              <input
                type="text"
                value={newNote.title}
                onChange={(e) =>
                  setNewNote((prev) => ({ ...prev, title: e.target.value }))
                }
                placeholder="Enter note title"
                className="form-input"
              />
            </div>

            {/* Note Detail Input */}
            <div className="flex-column">
              <label className="form-labels  font-weight500    announce-date font-weight400  font-size-heading">
                Detail<span className="required">*</span>
              </label>
              <textarea
                rows="4"
                value={newNote.detail}
                onChange={(e) =>
                  setNewNote((prev) => ({ ...prev, detail: e.target.value }))
                }
                placeholder="Enter note details"
                className="form-input-textarea"
              />
            </div>

            {/* Add Button */}
            {/* <div style={{ display: "flex", justifyContent: "flex-end" }}> */}
            <div className="button-models">
              <button
                onClick={handleAddNote}
                disabled={!newNote.title.trim() || !newNote.detail.trim()}
                className="model-button   font-weight500    model-button-leave  font-weight500    font-size-heading"
                style={{
                  //     padding: '10px 24px',
                  backgroundColor:
                    !newNote.title.trim() || !newNote.detail.trim()
                      ? "#ccc"
                      : "#2576bc",
                  //     color: "#fff",
                  //     border: "none",
                  //     borderRadius: "6px",
                  //     fontWeight: 600,
                  //     fontSize: "15px",
                  cursor:
                    !newNote.title.trim() || !newNote.detail.trim()
                      ? "not-allowed"
                      : "pointer",
                  //     transition: "background-color 0.2s"
                }}
              >
                Add Note
              </button>
            </div>
          </div>

          {/* Existing Notes Section */}
          {notes.length > 0 && (
            <div
              style={{
                width: "100%",
                // maxWidth: 480,
                // margin: '32px auto 0',
                // background: '#fff',
                // borderRadius: 8,
                // boxShadow: '0 2px 12px #eee',
                // padding: 32
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 16,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Existing Notes ({notes.length})
              </label>

              <ol
                style={{
                  maxHeight: 300,
                  overflowY: "auto",
                  border: "1px solid #ececec",
                  borderRadius: 6,
                  background: "#fafafd",
                }}
              >
                {notes.map((note, index) => (
                  <li
                    key={index}
                    style={{
                      padding: "16px",
                      borderBottom:
                        index !== notes.length - 1
                          ? "1px solid #ececec"
                          : "none",
                      background: "#fff",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginBottom: 8,
                      }}
                    >
                      <strong
                        style={{
                          color: "#333",
                          fontSize: "15px",
                          flex: 1,
                        }}
                      >
                        {note?.description?.title}
                      </strong>
                    </div>
                    <p
                      style={{
                        margin: 0,
                        color: "#666",
                        fontSize: "14px",
                        lineHeight: "1.4",
                      }}
                    >
                      {note?.description?.detail}
                    </p>
                  </li>
                ))}
              </ol>
            </div>
          )}
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

const TenderViewSingleNote = ({
  noteIndex,
  noteData,
  tenderID,
  onNotesUpdated,
  getBidData,
  filters,
  notesId,
}) => {
  const [show, setShow] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [buffering, setBuffering] = useState(false);
  const [editedNote, setEditedNote] = useState({
    title: noteData?.title || "",
    detail: noteData?.detail || "",
  });

  const handleClose = () => {
    setShow(false);
    setEditMode(false);
  };
  const handleShow = () => setShow(true);

  const handleEdit = () => setEditMode(true);

  const handleDelete = async () => {
    try {
      setBuffering(true);
      const res = await axios.delete(
        `${BASE_URL}/siteproject/notesupdate/${notesId}/`,
      );
      if (res.status === 204 || res.status === 200) {
        toast.success("Note deleted successfully!");
        handleClose();
        await getBidData(filters);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setBuffering(false);
    }
  };

  const handleSaveEdit = async () => {
    try {
      setBuffering(true);
      const payload = {
        description: {
          title: editedNote.title,
          detail: editedNote.detail,
        },
      };
      const res = await axios.put(
        `${BASE_URL}/siteproject/notesupdate/${notesId}/`,
        payload,
      );
      if (res.status === 200) {
        toast.success("Note updated successfully!");
        setEditMode(false);
        setEditedNote({
          title: "",
          detail: "",
        });
        await getBidData(filters);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setBuffering(false);
    }
  };

  return (
    <>
      {/* ============================
                NOTE BUTTON WITH HOVER TOOLTIP
            ============================= */}
      <OverlayTrigger
        placement="top"
        overlay={
          <Tooltip id={`note-tooltip-${noteIndex}`} className="note-tooltip">
            <div style={{ textAlign: "left" }}>
              <b>Title:</b> {noteData?.title || "No Title"} <br />
              <b>Details:</b> {noteData?.detail || "No Details"}
            </div>
          </Tooltip>
        }
      >
        <button
          title="View Note"
          style={{ color: "#2576bc" }}
          onClick={handleShow}
          className="align-center justify-center"
        >
          <Notes />
          <small className="tender-detail-doc-name">Note {noteIndex}</small>
        </button>
      </OverlayTrigger>

      {/* ============================
                MODAL
            ============================= */}
      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title>{editMode ? "Edit Note" : "Note Details"}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {editMode ? (
            <form>
              <div className="mb-3">
                <label>
                  <b>Title</b>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="Enter note title"
                  value={editedNote.title}
                  onChange={(e) =>
                    setEditedNote({ ...editedNote, title: e.target.value })
                  }
                />
              </div>
              <div className="mb-3">
                <label>
                  <b>Details</b>
                </label>
                <textarea
                  rows="4"
                  className="form-control"
                  placeholder="Enter note details"
                  value={editedNote.detail}
                  onChange={(e) =>
                    setEditedNote({ ...editedNote, detail: e.target.value })
                  }
                />
              </div>
            </form>
          ) : (
            <div style={{ padding: "10px" }}>
              <p>
                <b>Title:</b> {noteData?.title}
              </p>
              <p>
                <b>Details:</b> {noteData?.detail}
              </p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer>
          {editMode ? (
            <>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={() => setEditMode(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleSaveEdit}
                disabled={buffering}
              >
                {buffering ? "Saving..." : "Save"}
              </button>
            </>
          ) : (
            <>
              <button
                type="button"
                className="btn btn-danger"
                onClick={handleDelete}
                disabled={buffering}
              >
                {buffering ? "Deleting..." : "Delete"}
              </button>
              <button
                type="button"
                className="btn btn-primary"
                onClick={handleEdit}
              >
                Edit
              </button>
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handleClose}
              >
                Close
              </button>
            </>
          )}
        </Modal.Footer>

        <ToastContainer
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

const TenderViewNotes = ({ tenderID, existingNotes }) => {
  const [show, setShow] = useState(false);
  const [notes, setNotes] = useState([]);
  const [buffering, setBuffering] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const getNotesData = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/notesfilterbytender/${tenderID}/`,
      );
      if (res?.data) {
        setNotes(res.data);
      } else {
        setNotes([]);
      }
    } catch (err) {
      console.error("Error fetching notes:", err);
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (show) {
      getNotesData();
    }
  }, [show]);

  return (
    <>
      <button
        title="View All Note"
        style={{ color: "#2576bc" }}
        onClick={handleShow}
        className="flex-row justify-between"
      >
        <div>
          <u>View All</u>
        </div>
      </button>

      <Modal show={show} onHide={handleClose} dialogClassName="request-leave">
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500 font-size-heading"
        >
          <Modal.Title className="flex-row">
            Tender Notes ({notes.length})
            {buffering ? (
              <div className="align-center justify-center">
                <div className="spinner-vsmall"></div>
              </div>
            ) : null}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            // notes.length > 0 && (
            <div>
              <ol
                style={{
                  maxHeight: 300,
                  overflowY: "auto",
                  border: "1px solid #ececec",
                  borderRadius: 6,
                  background: "#fafafd",
                }}
              >
                {notes.map((note, index) => (
                  <li
                    key={index}
                    style={{
                      padding: "16px",
                      borderBottom:
                        index !== notes.length - 1
                          ? "1px solid #ececec"
                          : "none",
                      background: "#fff",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "flex-start",
                        marginBottom: 8,
                      }}
                    >
                      <strong
                        style={{
                          color: "#333",
                          fontSize: "15px",
                          flex: 1,
                        }}
                      >
                        {note?.description?.title}
                      </strong>
                    </div>
                    <p
                      style={{
                        margin: 0,
                        color: "#666",
                        fontSize: "14px",
                        lineHeight: "1.4",
                      }}
                    >
                      {note?.description?.detail}
                    </p>
                  </li>
                ))}
              </ol>
            </div>
            // )
          }
        </Modal.Body>

        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

const TenderViewAddNotes = ({ tenderID }) => {
  const [show, setShow] = useState(false);
  const [notes, setNotes] = useState([]);
  const [newNote, setNewNote] = useState({ title: "", detail: "" });
  const [showInput, setShowInput] = useState(false);

  const handleClose = () => {
    setShow(false);
    setNotes([]);
    setNewNote({ title: "", detail: "" });
    setShowInput(false);
  };
  const [buffering, setBuffering] = useState(false);

  const handleShow = () => setShow(true);

  const handleAddNote = () => {
    if (newNote.title.trim() && newNote.detail.trim()) {
      setNotes((prev) => [...prev, newNote]);
      setNewNote({ title: "", detail: "" });
      setShowInput(false);
    } else {
      toast.error("Please fill both Title and Detail!");
    }
  };

  const handleRemoveNote = (index) => {
    setNotes((prev) => prev.filter((_, i) => i !== index));
  };

  const handleSubmit = async () => {
    if (!notes.length) {
      toast.error("Please add at least one note!");
      return;
    }

    const payload = {
      tender_id: tenderID,
      employee_id: sessionStorage.getItem("sitemanagement_emp_id"),
      description: notes,
    };

    const loadingToastId = toast.loading("Saving notes...");

    try {
      await axios.post(`${BASE_URL}/siteproject/notes/`, payload, {
        headers: { "Content-Type": "application/json" },
      });

      toast.success("Notes saved successfully!");

      handleClose();
    } catch (err) {
      toast.error("Failed to save notes!");
    } finally {
      toast.dismiss(loadingToastId);
    }
  };

  const getNotesdata = async () => {
    setBuffering(true);
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/notesfilterbytender/${tenderID}/`,
      );

      if (res?.data[0]?.description) {
        setNotes(res?.data[0].description);
      } else {
        setNotes([]);
      }
    } catch (err) {
    } finally {
      setBuffering(false);
    }
  };

  useEffect(() => {
    if (show) {
      getNotesdata();
    }
  }, [show]);

  return (
    <>
      {/* <button
                onClick={show ? handleClose : handleShow}

                title="Add Notes"
                style={{ fontSize: '38px' }}
            >
                📝
            </button> */}
      <button
        onClick={show ? handleClose : handleShow}
        title="Add Notes"
        className="flex-column "
      >
        <Notes />
        <small className="tender-detail-doc-name">Note</small>
      </button>

      {show && (
        <div
          style={{
            position: "fixed",
            bottom: "100px",
            right: "20px",
            width: "340px",
            background: "#fffbea",
            border: "1px solid #f1c40f",
            borderRadius: "10px",
            padding: "20px",
            boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
            zIndex: 999,
          }}
        >
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            {" "}
            <h4
              style={{ marginBottom: "12px", fontSize: "18px", color: "#444" }}
            >
              Add Notes
            </h4>
            <button onClick={handleClose} title="Add Notes">
              ✖
            </button>
          </div>

          {!showInput && (
            <button
              onClick={() => setShowInput(true)}
              style={{
                width: "100%",
                marginTop: "10px",
                background: "#f1c40f",
                border: "none",
                borderRadius: "6px",
                padding: "8px",
                fontWeight: "600",
                cursor: "pointer",
              }}
            >
              ➕ Add Note
            </button>
          )}

          {showInput && (
            <div style={{ marginTop: "10px" }}>
              <input
                type="text"
                value={newNote.title}
                onChange={(e) =>
                  setNewNote((prev) => ({ ...prev, title: e.target.value }))
                }
                placeholder="Note Title"
                style={{
                  width: "100%",
                  marginBottom: "8px",
                  padding: "6px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                }}
              />
              <textarea
                rows="2"
                value={newNote.detail}
                onChange={(e) =>
                  setNewNote((prev) => ({ ...prev, detail: e.target.value }))
                }
                placeholder="Note Detail"
                style={{
                  width: "100%",
                  marginBottom: "8px",
                  padding: "6px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  resize: "none",
                }}
              />
              <div style={{ display: "flex", gap: "8px" }}>
                <button
                  onClick={handleAddNote}
                  style={{
                    flex: 1,
                    background: "#2ecc71",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    padding: "6px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Save
                </button>
                <button
                  onClick={() => {
                    setNewNote({ title: "", detail: "" });
                    setShowInput(false);
                  }}
                  style={{
                    flex: 1,
                    background: "#e74c3c",
                    color: "#fff",
                    border: "none",
                    borderRadius: "6px",
                    padding: "6px",
                    fontWeight: "600",
                    cursor: "pointer",
                  }}
                >
                  Cancel
                </button>
              </div>
            </div>
          )}

          <ul style={{ listStyle: "none", padding: 0, margin: "10px 0" }}>
            {notes.map((note, index) => (
              <li
                key={index}
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "flex-start",
                  background: "#fff9c4",
                  padding: "8px",
                  marginBottom: "6px",
                  borderRadius: "6px",
                  fontSize: "13px",
                }}
              >
                <div>
                  <strong>{note.title}</strong>
                  <p style={{ margin: "4px 0 0", fontSize: "12px" }}>
                    {note.detail}
                  </p>
                </div>
                {/* <button
                                    onClick={() => handleRemoveNote(index)}
                                    style={{
                                        marginLeft: 8,
                                        padding: "2px 6px",
                                        background: "#ff4e4e",
                                        color: "#fff",
                                        border: "none",
                                        borderRadius: "4px",
                                        cursor: "pointer",
                                        fontSize: "12px",
                                    }}
                                >
                                    ✖
                                </button> */}
              </li>
            ))}
          </ul>

          <button
            onClick={handleSubmit}
            style={{
              marginTop: "12px",
              width: "100%",
              background: "#f39c12",
              border: "none",
              borderRadius: "6px",
              padding: "8px",
              fontWeight: "600",
              cursor: "pointer",
            }}
          >
            Submit
          </button>
        </div>
      )}
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar={false}
        newestOnTop={true}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
};

const TenderViewAddBidders = ({ bidders }) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
  };

  const handleShow = () => setShow(true);

  useEffect(() => {
    if (show) {
    }
  }, [show]);

  return (
    <>
      <button
        onClick={show ? handleClose : handleShow}
        title="View Bidders"
        className="flex-column "
      >
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          role="img"
          aria-label="Bidder"
        >
          <path
            fill="rgb(37,118,188)"
            d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zM4 20v-1c0-2.21 3.58-4 8-4s8 1.79 8 4v1H4z"
          />
        </svg>
        <small className="tender-detail-doc-name">Bidders</small>
      </button>

      <Modal
        show={show}
        onHide={handleClose}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Bidders List</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table
            className="modern-table"
            style={{ borderRadius: "15px", overflow: "hidden", width: "100%" }}
          >
            <thead>
              <tr>
                <th style={{ width: "80px" }}>S.No</th>
                <th>Bidder Name</th>
              </tr>
            </thead>
            <tbody>
              {bidders?.map((bidder, index) => (
                <tr key={index}>
                  <td className="text-center">{index + 1}</td>
                  <td>{bidder.bidder_name}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal.Body>
      </Modal>
    </>
  );
};

const AllTender = () => {
  const [corriendumModal, setCorriendumModal] = useState(false);
  const [corriendumModalScreening, setCorriendumModalScreening] =
    useState(false);

  const Partners = [
    {
      key: "Saptagon Asia Private Limited",
      value: "Saptagon Asia Private Limited",
    },
    {
      key: "Civilmantra Infracon Limited",
      value: "Civilmantra Infracon Limited",
    },
    {
      key: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED",
      value: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED",
    },
    { key: "ISAN CORPORATION", value: "ISAN CORPORATION" },
    { key: "MARC TECHNOCRATS LIMITED", value: "MARC TECHNOCRATS LIMITED" },
    {
      key: "ALOMNDS GLOBAL INFRASTRUCTURE",
      value: "ALOMNDS GLOBAL INFRASTRUCTURE",
    },
    { key: "VOYANTS SOLUTIONS PVT LTD", value: "VOYANTS SOLUTIONS PVT LTD" },
    {
      key: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED",
      value: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED",
    },
    { key: "MSV INTERNATIONAL", value: "MSV INTERNATIONAL" },
    { key: "YONGMA ENGINEERING CO LTD", value: "YONGMA ENGINEERING CO LTD" },
    { key: "TECH-4", value: "TECH-4" },
    {
      key: "AECOM INDIA PRIVATE LIMITED",
      value: "AECOM INDIA PRIVATE LIMITED",
    },
    { key: "SMEC INDIA PVT LTD", value: "SMEC INDIA PVT LTD" },
    { key: "SPECTRUM", value: "SPECTRUM" },
    { key: "INSTUTIUTE GIPROSTROYMOST", value: "INSTUTIUTE GIPROSTROYMOST" },
    {
      key: "RODIC CONSULTANT PRIVATE LIMITED",
      value: "RODIC CONSULTANT PRIVATE LIMITED",
    },
    {
      key: "CHAITANYA PROJECT CONSULTANCY LTD",
      value: "CHAITANYA PROJECT CONSULTANCY LTD",
    },
    {
      key: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)",
      value: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)",
    },
    {
      key: "TPF ENGINEERING PRIVATE LIMITED",
      value: "TPF ENGINEERING PRIVATE LIMITED",
    },
    {
      key: "INFRAPLUS CONSULTANCY PVT LTD",
      value: "INFRAPLUS CONSULTANCY PVT LTD",
    },
    { key: "RITES LIMITED", value: "RITES LIMITED" },
    { key: "TPF GETINSAEUROESTUDIOS SL", value: "TPF GETINSAEUROESTUDIOS SL" },
    {
      key: "SA INFRASTURCTURE CONSULTING PRIVATE",
      value: "SA INFRASTURCTURE CONSULTING PRIVATE",
    },
    { key: "CEG LIMITED", value: "CEG LIMITED" },
    {
      key: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD",
      value: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD",
    },
    { key: "Egis", value: "Egis" },
    { key: "OPEN SOLUTION", value: "OPEN SOLUTION" },
    { key: "SUMAD ENTERPRISE", value: "SUMAD ENTERPRISE" },
    {
      key: "Earl Techno Consultant Pvt. Ltd.",
      value: "Earl Techno Consultant Pvt. Ltd.",
    },
    { key: "Pentagon", value: "Pentagon" },
    { key: "Ropes", value: "Ropes" },
    { key: "WPKK", value: "WPKK" },
    { key: "sapl", value: "SAPL" },

    { key: "cipl", value: "CIPL" },
    { key: "joint", value: "Joint" },
    { key: "Other", value: "Other" },
    { key: "Not Required", value: "Not Required" },
  ];

  const EmdType = [
    { key: "Bank_Gurantee", value: "Bank Gurantee" },
    { key: "neft", value: "NEFT" },
    { key: "demand_draft", value: "Demand Draft" },
    { key: "other", value: "Other" },
  ];

  const handleHideUpdateModal = () => {
    setCorriendumModal(false);
  };

  const handleHideUpdateModalScreening = () => {
    setCorriendumModalScreening(false);
  };

  const [filters, setFilters] = useState({
    searchText: "",
    searchId: "",
    organizationID: "",
    category: "",
    state: "",
    city: "",
    ownership: "",
    department: "",
    closingDateFrom: "",
    closingDateTo: "",
    website: "",
    quantityType: ">=",
    quantityValue: "",
    tenderValueComparison: "=",
    valueFrom: "",
    valueTo: "",
    lakhFrom: "Lakh",
    lakhTo: "Lakh",
    gemType: "All",
    msmeExemption: false,
    aiSummary: false,
    startupExemption: false,
    boq: false,
    client: "",
    tenderType: "",
    is_special_tender: "",
    is_today: "",
    is_discussed: "",
    tenderStatus: "",
  });
  const [toggleCompany, setToggleCompany] = useState("null");
  const [siteSubCompanyList, setSiteSubCompanyList] = useState([]);
  const navigate = useNavigate();

  const [companySelected, setCompanySelected] = useState("");
  const [targetSector, setTargetSector] = useState("");
  const [targetTenderType, setTargetTenderType] = useState("");

  const handleCompanySelected = (val) => {
    setCompanySelected(val === companySelected ? "" : val);
  };

  const handleTargetSector = (val) => {
    setTargetSector(val === targetSector ? "" : val);
  };

  const handleTargetTenderType = (val) => {
    setTargetTenderType(val === targetTenderType ? "" : val);
  };

  const handleFilterTenderType = (val) => {
    setFilters((prev) => ({ ...prev, tenderType: val }));
  };

  const [structureList, setstructureList] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [error, setError] = useState(null);

  const [selectedNo, setNo] = useState("");
  const [selectedFromDate, setFromDate] = useState("null");
  const [selectedToDate, setToDate] = useState("null");
  const [structure, setStructure] = useState("null");
  const [sector, setSector] = useState("null");
  const [service, setService] = useState("null");
  const [selectedProject, setSelectedProject] = useState("null");
  const [searchQuery, setSearchQuery] = useState("");

  const [showModal, setShowMoadl] = useState(false);

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };
  const [trackRecordList, setTrackRecordList] = useState([]);

  const [buffer, setBuffering] = useState(true);

  const getcompany = async () => {
    setBuffering(true);
    try {
      const sub = await axios.get(`${BASE_URL}/siteproject/subcompany/`);
      setSiteSubCompanyList(sub.data);
    } catch (err) {
    } finally {
      setBuffering(false);
    }
  };

  // const getStructure = async () => {
  //     try {
  //         const getStr = await axios.get(`${BASE_URL}/siteproject/structuredetail/`);
  //         setstructureList(getStr.data);

  //     } catch (error) {

  //     }
  // }
  const [projectList, setProjectList] = useState([]);
  const [bidData, SetBidData] = useState([]);
  // console.log(bidData, 'biddata')
  // const getProject = async () => {
  //     setBuffering(true);
  //     try {
  //         const pro = await axios.get(`${BASE_URL}/siteproject/projectfilterbysubcompany/${toggleCompany}/`);

  //         setProjectList(pro.data);
  //     } catch (err) {
  //         handleErrorToast(err);
  //     } finally {
  //         setBuffering(false);
  //     }
  // };

  const roleemp = sessionStorage.getItem("sitemanagement_role");
  //     const getBidData = async (filters) => {
  //         setBuffering(true);
  //         try {
  //             console.log(roleemp, 'roleemp')
  //             if (roleemp === "certificaionadminaccess" || roleemp === "CertificationAccess" || roleemp === "CertificationAccessDocumentTeamHead" || roleemp === "CertificationAccessCvTeamHead") {
  //                 const empCode = sessionStorage.getItem('emp_code') || sessionStorage.getItem('sitemanagement_emp_code');

  //                 const res = await axios.get(`${BASE_URL}/siteproject/tenderforBDfilter/${filters?.client || "null"
  //                     }/${filters?.state || "null"
  //                     }/${filters?.searchText || "null"
  //                     }/${filters?.category || "null"
  //                     }/${selectedFromDate || "null"
  //                     }/${selectedToDate || "null"
  //                     }/${filters?.tenderType || "null"
  //                     }/${filters?.searchId || "null"
  //                     }/${filters?.is_special_tender || "null"
  //                     }/${filters?.is_today || "null"
  //                     }/${filters?.is_discussed || "null"
  //                     }/${empCode}/${empCode}/${filters?.tenderStatus ? filters.tenderStatus : 'null'}/
  // `);

  //                 SetBidData(res.data);
  //             } else if (roleemp === "CertificationAccessCvTeam" || roleemp === "CertificationAccessDocumentTeam") {
  //                 console.log(roleemp, 'roleempelse')
  //                 const empCode = sessionStorage.getItem('emp_code') || sessionStorage.getItem('sitemanagement_emp_code');
  //                 getEmployeeDatato(empCode, filters)
  //             }

  //         } catch (err) {

  //         } finally {
  //             setBuffering(false);
  //         }
  //     };

  // useEffect(() => {
  //     getcompany();
  //     getStructure();
  // }, []);

  // const getBidData = async (filters) => {
  //     setBuffering(true);
  //     try {
  //         const empCode =
  //             sessionStorage.getItem("sitemanagement_emp_code");
  //         let res;
  //         // Build base API URL with all filters — replace empty values with "null"
  //         const apiUrl = `${BASE_URL}/siteproject/tenderforBDfilter/${filters?.client || "null"
  //             }/${filters?.state || "null"}/${filters?.searchText || "null"}/${filters?.category || "null"
  //             }/${selectedFromDate || "null"}/${selectedToDate || "null"}/${filters?.tenderType || "null"
  //             }/${filters?.searchId || "null"}/${filters?.is_special_tender || "null"}/${filters?.is_today || "null"
  //             }/${filters?.is_discussed || "null"}/${empCode}/${empCode}/${filters?.tenderStatus ? filters.tenderStatus : "null"
  //             }/`;

  //         // Role-based API logic
  //         if (
  //             roleemp === "certificaionadminaccess" ||
  //             roleemp === "CertificationAccess" ||
  //             roleemp === "CertificationAccessDocumentTeamHead" ||
  //             roleemp === "CertificationAccessCvTeamHead"
  //         ) {
  //             res = await axios.get(apiUrl);
  //             const results = res?.data
  //             SetBidData(results);
  //             if (toggleState === 9) {
  //                 getEmployeeData()
  //             }
  //         } else if (
  //             roleemp === "CertificationAccessCvTeam" ||
  //             roleemp === "CertificationAccessDocumentTeam"
  //         ) {
  //             res = await getEmployeeDatato(empCode, filters);
  //         }

  //         // ✅ Handle API response

  //         // setTotalPages(Math.ceil(count / limit));
  //         // setCurrentPage(page);
  //     } catch (err) {
  //         console.error("Error fetching bid data:", err);
  //     } finally {
  //         setBuffering(false);
  //     }
  // };
  const latestRequestRef = useRef(0);

  const getBidData = async (filters) => {
    const requestId = ++latestRequestRef.current; // 👈 mark this request
    setBuffering(true);

    try {
      const empCode = sessionStorage.getItem("sitemanagement_emp_code");
      let res;

      const apiUrl = `${BASE_URL}/siteproject/tenderforBDfilter/${
        filters?.client || "null"
      }/${filters?.state || "null"}/${filters?.searchText || "null"}/${
        filters?.category || "null"
      }/${selectedFromDate || "null"}/${selectedToDate || "null"}/${
        filters?.tenderType || "null"
      }/${filters?.searchId || "null"}/${filters?.is_special_tender || "null"}/${
        filters?.is_today || "null"
      }/${filters?.is_discussed || "null"}/${empCode}/${empCode}/${
        filters?.tenderStatus || "null"
      }/`;

      if (
        roleemp === "certificaionadminaccess" ||
        roleemp === "CertificationAccess" ||
        roleemp === "CertificationAccessDocumentTeamHead" ||
        roleemp === "CertificationAccessCvTeamHead" ||
        roleemp === "CertificationAccessBd"
      ) {
        res = await axios.get(apiUrl);

        // ❌ Ignore OLD API response
        if (requestId !== latestRequestRef.current) return;

        const results = res?.data;
        SetBidData(results);

        if (toggleState === 9) {
          getEmployeeData();
        }
      } else if (
        roleemp === "CertificationAccessCvTeam" ||
        roleemp === "CertificationAccessDocumentTeam"
      ) {
        res = await getEmployeeDatato(empCode, filters);

        // ❌ Ignore OLD API response
        if (requestId !== latestRequestRef.current) return;

        // SetBidData(res?.data?.tenders);
      }
    } catch (err) {
      console.error("Error fetching bid data:", err);
    } finally {
      // ✅ Only latest request can stop loader
      if (requestId === latestRequestRef.current) {
        setBuffering(false);
      }
    }
  };

  useEffect(() => {
    getBidData(filters);
  }, [filters, selectedFromDate, selectedToDate]);

  useEffect(() => {
    applyFilters();
  }, [searchQuery, bidData]);

  const applyFilters = () => {
    let filteredData = bidData;

    if (searchQuery !== "") {
      const lowercaseSelectedName = searchQuery.toLowerCase();
      filteredData = filteredData.filter((data) => {
        const lid = data?.name_of_work
          ?.toString()
          .toLowerCase()
          .includes(lowercaseSelectedName);
        return lid;
      });
    }

    setFilteredData(filteredData);
  };

  const [toggleState, setToggleState] = useState(
    roleemp === "CertificationAccessCvTeamHead" ||
      roleemp === "CertificationAccessCvTeam" ||
      roleemp === "CertificationAccessDocumentTeam"
      ? 9
      : roleemp === "CertificationAccessDocumentTeamHead"
        ? 4
        : 0,
  );
  console.log(toggleState, "togglesatate");

  const ViewAllBidDetails = (project, data) => {
    navigate(
      `/${window.location?.pathname?.split("/")[1] || "certificaionadminaccess"}/tenderDetails/`,
      {
        state: { project, data },
      },
    );
  };

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
    setIsCollapsed(!isCollapsed);
  };

  const [isCollapsed, setIsCollapsed] = useState(true);

  const categories = [
    "Highway",
    "Railway",
    "Water",
    "Metro",
    "Urban Infrastructure Buildings",
  ];
  const states = [
    "Andaman and Nicobar Islands",
    "Andhra Pradesh",
    "Arunachal Pradesh",
    "Assam",
    "Bihar",
    "Chandigarh",
    "Chhattisgarh",
    "Dadra and Nagar Haveli and Daman and Diu",
    "Delhi",
    "Goa",
    "Gujarat",
    "Haryana",
    "Himachal Pradesh",
    "Jammu and Kashmir",
    "Jharkhand",
    "Karnataka",
    "Kerala",
    "Ladakh",
    "Lakshadweep",
    "Madhya Pradesh",
    "Maharashtra",
    "Manipur",
    "Meghalaya",
    "Mizoram",
    "Nagaland",
    "Odisha",
    "Puducherry",
    "Punjab",
    "Rajasthan",
    "Sikkim",
    "Tamil Nadu",
    "Telangana",
    "Tripura",
    "Uttar Pradesh",
    "Uttarakhand",
    "West Bengal",
  ];

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFilters({
      ...filters,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const [isclear, Setisclear] = useState(false);
  const handleSubmit = (e) => {
    e.preventDefault();
  };

  const handleClear = () => {
    setFilters({
      searchText: "",
      organizationID: "",
      category: "",
      state: "",
      city: "",
      ownership: "",
      department: "",
      closingDateFrom: "",
      closingDateTo: "",
      website: "",
      quantityType: ">=",
      quantityValue: "",
      tenderValueComparison: "=",
      valueFrom: "",
      valueTo: "",
      lakhFrom: "Lakh",
      lakhTo: "Lakh",
      gemType: "All",
      msmeExemption: false,
      aiSummary: false,
      startupExemption: false,
      boq: false,
      client: "",
      searchId: "",
      is_special_tender: "",
      is_today: "",
      tenderStatus: "",
      is_discussed: "",
    });
    Setisclear(true);
    setFromDate("null");
    setToDate("null");
  };

  useEffect(() => {
    if (isclear) {
    }
  }, [isclear]);

  const [isrequested, Setisrequested] = useState(false);
  const [isClosed, SetisClosed] = useState(false);
  const [submissionDateFilter, setSubmissionDateFilter] = useState("");

  const getDaysLeft = (dateString) => {
    if (!dateString) return "N/A";

    const today = new Date();
    const dueDate = new Date(dateString);
    const diffTime = dueDate - today;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

    const createdDate = new Date(dateString);
    const ageInDays = Math.floor((today - createdDate) / (1000 * 60 * 60 * 24));

    if (ageInDays <= 5) {
      return "New Tender";
    }

    return diffDays > 0 ? `${diffDays} Days Left` : "Closed";
  };
  const getDaysLeftNumber = (dateString) => {
    if (!dateString) return null;

    const today = new Date();
    today.setHours(0, 0, 0, 0); // normalize today

    const dueDate = new Date(dateString);
    dueDate.setHours(0, 0, 0, 0); // normalize due date

    const diffTime = dueDate.getTime() - today.getTime();
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    // today → 0 (valid), past → negative
    return diffDays >= 0 ? Math.floor(diffDays) : -1;
  };

  const [tenderId, setTenderId] = useState("");
  const [tenderIdscroll, SetTenderIdscroll] = useState("");
  const [wishListData, setWishListData] = useState({
    jv_partner_type: "null",
    soil_quality: "",
    participating_as: "",
    soil_type: "null",
    lead_partner: "",
    lead_partner_share: 0,
    jv_partner_name: "",
    jv_partner_share: 0,
    assosiate_partner: "",
    associate_partner_share: 0,
    bg_requried: "",
    is_emd_required: "",
    emd_review: "",
    exmpted_emd: "",

    bg_amount: "",
    emd_amount: "",
    bg_type: "",
    emd_type: "",
    tendersubmission: "",
    bg_submission: "",
    emd_submission_type: "",
    submission_date: "",
    company_score: "",
    company_type: "",
    tech_score: "",
    site_apprisate_required: "",
    work_methodology_required: "",
    work_methodology_marking: "",
    presentation_required: "",
    presentation_required_marking: "",
    presentation_type: "",
    client: "",
    technical_status: "",
    financial_status: "",
    responsive_status: "",
    are_we_l1: "",
    leading_parenter: "",
    bg_sharing: "",
    bidder_name: {
      value: "",
      loading: false,
    },
    bidders: [],
    bg_pending: false,

    tech_open: "",
    tech_responsive: "",
    participant_name: {
      value: "",
      score: "",
      loading: false,
    },
    participants: [],
    financial_participant_name: {
      value: "",
      score: "",
      loading: false,
    },
    financial_participants: [],
    checklist: "",
    all_docs_done: "",
    all_cvs_done: "",
    cvs_files: [],
    tech_doc: [],
    financial_doc: [],
    bid_doc: [],
    bidder_doc: [],
    is_jv_allowed: "",
    is_jv_consorium_association_allowed: "",
    terms_of_jv: "",
    partner_share_sum: 0,
    cv_score: 0,
    company_name: "",
    company_dist_lead: "",
    site_apprisate_marking: "",
    eligibity_criteria: "",
    eligibity_criteria_special: "",
    associate_qualify: false,
    tender_submission_type: "",
    custom_lead_partner: "",
    custom_emd_type: "",
    custom_jv_partner: "",
    custom_assosiate_partner: "",
    bid_prepare_by: "null",
    bg_prepare_by: "null",
    bid_prepare_by_remarks: "",
    team_prepare_by: "null",
    team_prepare_by_remarks: "",
    team_required: "",
    team_requirements_details: "",
    recipient_details: "",
    company_dist_jv: "",
  });

  const handleShow = (id, i) => {
    setShowMoadl(true);
    setTenderId(id);
    SetTenderIdscroll(i?.tender_id);
    setEditTenderData(i);
    const bid = bidData.find((bid) => bid.id === id);
    console.log(bid.soil_quality === true, "soil quality");
    setWishListData({
      jv_partner_type: bid.jv_partner_type,
      soil_quality: bid.soil_quality,
      participating_as: bid.participating_as,
      soil_type: bid.soil_type,
      lead_partner:
        bid.participating_as === "lead" ||
        wishListData.participating_as === "sole"
          ? bid.company_name
          : bid.lead_partner
            ? Partners.some((partner) => partner.key === bid.lead_partner)
              ? bid.lead_partner
              : "Other"
            : bid.lead_qualify
              ? bid.company_name
              : "null",

      lead_partner_share:
        wishListData.participating_as === "sole"
          ? "100"
          : bid.lead_partner_share,
      jv_partner_name:
        wishListData.participating_as === "sole"
          ? "Not Required"
          : bid.participating_as === "jv"
            ? bid.company_name
            : bid.jv_partner_name
              ? Partners.some((partner) => partner.key === bid.jv_partner_name)
                ? bid.jv_partner_name
                : "Other"
              : bid.jv_qualify
                ? bid.company_name
                : "null",

      jv_partner_share: bid.jv_partner_share,
      assosiate_partner:
        wishListData.participating_as === "sole"
          ? "Not Required"
          : bid.assosiate_partner
            ? Partners.some((partner) => partner.key === bid.assosiate_partner)
              ? bid.assosiate_partner
              : "Other"
            : bid.ass_qualify
              ? bid.company_name
              : "null",

      associate_partner_share: bid.associate_partner_share,
      bg_requried: bid.bg_requried,
      company_dist_lead: bid.company_dist_lead,
      company_dist_jv: bid.company_dist_jv,
      is_emd_required: bid.is_emd_required,
      emd_review: bid.emd_review,
      exmpted_emd: bid.exmpted_emd,

      team_required: bid.team_required,
      team_requirements_details: bid.team_requirements_details,
      recipient_details: bid.recipient_details,
      bg_amount: bid.bg_amount,
      emd_amount: bid.emd_amount,
      emd_unit: bid.emd_unit,
      bg_type: bid.bg_type,
      emd_type: bid.emd_type
        ? EmdType.some((emd) => emd.key === bid.emd_type)
          ? bid.emd_type
          : "Other"
        : "null",
      tendersubmission: bid.tendersubmission,
      bg_submission: bid.bg_submission,
      emd_submission_type: bid.emd_submission_type,
      submission_date: bid?.submission_date,
      company_score: bid.company_score,
      company_type: bid.company_type,
      tech_score: bid.tech_score,
      site_apprisate_required: bid.site_apprisate_required,
      site_apprisate_marking: bid.site_apprisate_marking,
      work_methodology_required: bid.work_methodology_required,
      work_methodology_marking: bid.work_methodology_marking,
      presentation_required: bid.presentation_required,
      presentation_required_marking: bid.presentation_required_marking,
      presentation_type: bid.presentation_type,
      client: bid.client,
      technical_status: bid.technical_status,
      financial_status: bid.financial_status,
      responsive_status: bid.responsive_status,
      are_we_l1: bid.are_we_l1,
      leading_parenter: bid?.leading_parenter,
      bg_sharing: bid.bg_sharing,
      bidder_name: { value: "", loading: false },
      bidders: bid.tender_bidders,
      bg_pending: bid.bg_pending,
      tech_open: bid.tech_open,
      tech_responsive: bid.tech_responsive,
      participant_name: {
        value: "",
        score: "",
        loading: false,
      },
      participants: bid.tender_participants,
      financial_participant_name: {
        value: "",
        score: "",
        loading: false,
      },
      financial_participants: bid.financial_participants,
      checklist: bid.checklist,
      all_docs_done: bid.all_docs_done,
      all_cvs_done: bid.all_cvs_done,
      cvs_files: bid?.cv_doc ? bid.cv_doc : [],
      tech_doc: bid?.tech_doc ? bid.tech_doc : [],
      financial_doc: bid?.financial_doc ? bid.financial_doc : [],
      bid_doc: bid?.bid_doc ? bid?.bid_doc : [],
      bidder_doc: bid?.bidder_doc ? bid.bidder_doc : [],
      is_jv_allowed: bid.is_jv_allowed,
      is_jv_consorium_association_allowed:
        bid.is_jv_consorium_association_allowed,
      terms_of_jv: bid.terms_of_jv,
      partner_share_sum: bid.partner_share_sum,
      cv_score: bid.cv_score,
      company_name: bid.company_name,
      company_dist_lead: bid.company_dist_lead,
      company_dist_jv: bid.company_dist_jv,
      eligibity_criteria: bid.eligibity_criteria,
      eligibity_criteria_special: bid.eligibity_criteria_special,
      associate_qualify: bid.associate_qualify,
      tender_submission_type: bid.tender_submission_type,
      custom_lead_partner: bid.lead_partner,
      custom_emd_type: bid.custom_emd_type,
      custom_jv_partner_name: bid.jv_partner_name,
      custom_assosiate_partner: bid.assosiate_partner,
      bid_prepare_by:
        wishListData.participating_as === "sole"
          ? bid.company_name
          : bid.bid_prepare_by,
      bg_prepare_by:
        wishListData.participating_as === "sole"
          ? bid.company_name
          : bid.bg_prepare_by,
      bid_prepare_by_remarks: bid.bid_prepare_by_remarks,
      team_prepare_by: bid.team_prepare_by,
      team_prepare_by_remarks: bid.team_prepare_by_remarks,
    });
  };

  const [errors, setErrors] = useState();
  const validateForm = () => {
    const newErrors = {};
    let requiredFields = [];
    if (toggleState === 2) {
      requiredFields = [
        wishListData.is_jv_allowed === null ? "is_jv_allowed" : null,
        "tech_score",
        "company_score",
        "company_name",
        "eligibity_criteria",
        wishListData.eligibity_criteria != "" &&
        wishListData.eligibity_criteria === "Special"
          ? "eligibity_criteria_special"
          : null,
        wishListData.soil_quality === null ? "soil_quality" : null,
        wishListData.participating_as === null ? "participating_as" : null,
        wishListData.is_jv_consorium_association_allowed === null
          ? "jv_consorium_association_allowed"
          : null,
        wishListData.site_apprisate_required === null
          ? "site_apprisate_required"
          : null,
        wishListData.site_apprisate_required !== null
          ? "site_apprisate_marking"
          : null,
        wishListData.work_methodology_required === null
          ? "work_methodology_required"
          : null,
        wishListData.work_methodology_required != null
          ? "work_methodology_marking"
          : null,
        wishListData.presentation_required === null
          ? "presentation_required"
          : null,
        wishListData.presentation_required !== null &&
        wishListData.presentation_required
          ? "presentation_required_marking"
          : null,
        wishListData.presentation_required !== null &&
        wishListData.presentation_required
          ? "presentation_type"
          : null,
      ].filter(Boolean);
    } else if (toggleState === 3) {
      console.log(
        wishListData.jv_partner_name,
        wishListData.soil_quality,
        wishListData.jv_partner_name != "Not Required",
        wishListData.soil_quality != true,
        wishListData.jv_partner_name != "Not Required" ||
          !wishListData.soil_quality != true,
        "reqwquired fileds conditions",
      );
      requiredFields = [
        wishListData.tender_submission_type === null
          ? "tender_submission_type"
          : null,
        wishListData.bid_prepare_by === null ? "bid_prepare_by" : null,
        wishListData.bg_prepare_by === null ? "bg_prepare_by" : null,
        "lead_partner_share",

        // Show ONLY when both conditions match
        wishListData.jv_partner_name !== "Not Required"
          ? "jv_partner_share"
          : null,

        wishListData.assosiate_partner !== "Not Required"
          ? "associate_partner_share"
          : null,
        wishListData.team_required === null ? "team_required" : null,
        wishListData.team_required !== null && wishListData.team_required
          ? "team_prepare_by"
          : null,
        wishListData.team_required !== null && wishListData.team_required
          ? "team_prepare_by_remarks"
          : null,
        wishListData.team_required !== null && wishListData.team_required
          ? "team_requirements_details"
          : null,
        wishListData.is_emd_required === null && wishListData.exmpted_emd
          ? "is_emd_required"
          : null,
        wishListData.is_emd_required != null &&
        wishListData.is_emd_required &&
        wishListData.exmpted_emd
          ? "emd_amount"
          : null,
        wishListData.is_emd_required != null &&
        wishListData.is_emd_required &&
        wishListData.exmpted_emd
          ? "emd_unit"
          : null,

        wishListData.is_emd_required != null &&
        wishListData.is_emd_required &&
        wishListData.exmpted_emd
          ? "exmpted_emd"
          : null,
        wishListData.is_emd_required != null &&
        wishListData.is_emd_required &&
        wishListData.exmpted_emd
          ? "emd_type"
          : null,
        wishListData.is_emd_required != null &&
        wishListData.is_emd_required &&
        wishListData.exmpted_emd
          ? "emd_submission_type"
          : null,
      ].filter(Boolean);
    } else if (toggleState === 9) {
      if (
        roleemp === "CertificationAccessCvTeamHead" ||
        roleemp === "CertificationAccessCvTeam"
      ) {
        requiredFields = [
          "tech_score",
          "cv_score",
          wishListData.all_cvs_done === null ? "all_cvs_done" : null,
        ].filter(Boolean);
      } else {
        requiredFields = [
          wishListData.checklist === null ? "checklist" : null,

          wishListData.all_docs_done === null ? "all_docs_done" : null,
        ].filter(Boolean);
      }
      // requiredFields = [

      //     wishListData.checklist === null ? "checklist" : null,
      //     wishListData.team_required === null ? "team_required" : null,
      //     wishListData.team_required !== null && wishListData.team_required ? "team_prepare_by" : null,
      //     wishListData.team_required !== null && wishListData.team_required ? "team_prepare_by_remarks" : null,
      //     wishListData.team_required !== null && wishListData.team_required ? "team_requirements_details" : null,
      //     wishListData.is_emd_required === null ? "is_emd_required" : null,
      //     wishListData.is_emd_required != null && wishListData.is_emd_required ? "emd_amount" : null,
      //     wishListData.is_emd_required != null && wishListData.is_emd_required ? "emd_unit" : null,
      //
      //     wishListData.is_emd_required != null && wishListData.is_emd_required ? "exmpted_emd" : null,

      //     wishListData.is_emd_required != null && wishListData.is_emd_required ? "emd_type" : null,
      //     wishListData.is_emd_required != null && wishListData.is_emd_required ? "emd_submission_type" : null,
      //     "tech_score",
      //     "cv_score",
      //     wishListData.all_docs_done === null ? "all_docs_done" : null,
      //     wishListData.all_cvs_done === null ? "all_cvs_done" : null,
      // ].filter(Boolean);
    } else if (toggleState === 5) {
      console.log(
        wishListData.participant_name,
        wishListData.tech_open != null,
        wishListData.participant_name?.value?.trim(),
        wishListData.participant_name?.score?.toString().trim(),
        "are we l1 ",
      );

      requiredFields = [
        wishListData.tech_open === null ? "tech_open" : null,
        wishListData.tech_responsive === null ? "tech_responsive" : null,
        wishListData.financial_status === null && wishListData.tech_responsive
          ? "financial_status"
          : null,
        wishListData.are_we_l1 === null ? "are_we_l1" : null,
      ].filter(Boolean);
    }

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          wishListData,
        );
    };

    requiredFields.forEach((field) => {
      if (!wishListData[field]) {
        newErrors[field] = ` ${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required !`;
      }
    });
    if (wishListData.tech_open != null) {
      const participant = wishListData.participant_name || {
        value: "",
        score: "",
      };
      if (!participant.value?.trim() || !participant.score?.toString().trim()) {
        newErrors["participant_name"] =
          "At least one participant (name & score) is required!";
      }
    }
    if (wishListData.financial_status != null) {
      const participant = wishListData.financial_participant_name || {
        value: "",
        score: "",
      };
      if (!participant.value?.trim() || !participant.score?.toString().trim()) {
        newErrors["participant_name"] =
          "At least one participant (name & score) is required!";
      }
    }
    console.log(requiredFields);
    setErrors(newErrors);
    setIsSubmitted(true);
    return Object.keys(newErrors).length === 0;
  };
  const [isSubmitted, setIsSubmitted] = useState(false);
  const handleSubmitEligibilityCretria = async (e, filters) => {
    e.preventDefault();
    console.log(wishListData.soil_quality, "soil qualify");
    if (validateForm()) {
      const loadingToastId = toast.loading("Loading: Please wait...");
      let data = {
        ...wishListData,
        submission_date: formatISTWithOffset(wishListData.submission_date),
      };
      if (
        !Partners.some(
          (partner) => partner.key === wishListData.lead_partner,
        ) ||
        wishListData.lead_partner === "Other"
      ) {
        data = { ...data, lead_partner: data.custom_lead_partner };
      }
      if (
        !EmdType.some((emd) => emd.key === wishListData.emd_type) ||
        wishListData.emd_type === "Other"
      ) {
        data = { ...data, emd_type: data.custom_emd_type };
      }
      if (
        !Partners.some(
          (partner) => partner.key === wishListData.jv_partner_name,
        ) ||
        wishListData.jv_partner_name === "Other"
      ) {
        data = { ...data, jv_partner_name: data.custom_jv_partner };
      }
      if (
        !Partners.some(
          (partner) => partner.key === wishListData.assosiate_partner,
        ) ||
        wishListData.assosiate_partner === "Other"
      ) {
        data = { ...data, assosiate_partner: data.custom_assosiate_partner };
      }

      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          data,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          setShowMoadl(false);
          sessionStorage.setItem("scrollTenderId", tenderIdscroll);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const handleClose = () => {
    setShowMoadl(false);
    setEditTenderData();
    setWishListData({
      jv_partner_type: "null",
      soil_quality: "",
      participating_as: "",
      soil_type: "",
      lead_partner: "",
      lead_partner_share: 0,
      jv_partner_name: "",
      jv_partner_share: 0,
      assosiate_partner: "",
      associate_partner_share: 0,
      bg_requried: "",
      is_emd_required: "",
      exmpted_emd: "",

      bg_amount: "",
      emd_amount: "",
      emd_unit: "",
      bg_type: "",
      emd_type: "",
      bg_submission: "",
      emd_submission_type: "",
      submission_date: "",
      company_score: "",
      company_type: "",
      tech_score: "",
      site_apprisate_required: "",
      site_apprisate_marking: "",
      work_methodology_required: "",
      work_methodology_marking: "",
      presentation_required: "",
      presentation_required_marking: "",
      presentation_type: "",
      client: "",
      technical_status: "",
      financial_status: "",
      responsive_status: "",
      are_we_l1: "",
      leading_parenter: "null",
      bg_sharing: "",
      bidder_name: { value: "", loading: false },
      bidders: [],
      bg_pending: false,
      tech_open: "",
      tech_responsive: "",
      participant_name: {
        value: "",
        score: "",
        loading: false,
      },
      participants: [],
      financial_participant_name: {
        value: "",
        score: "",
        loading: false,
      },
      financial_participants: [],
      checklist: "",
      all_docs_done: "",
      all_cvs_done: "",
      cvs_files: [],
      tech_doc: [],
      financial_doc: [],
      bid_doc: [],
      bidder_doc: [],
      is_jv_allowed: false,
      is_jv_consorium_association_allowed: "",
      terms_of_jv: "",
      partner_share_sum: 0,
      cv_score: 0,
      company_name: "",
      company_dist_lead: "",
      company_dist_jv: "",
      eligibity_criteria: "",
      eligibity_criteria_special: "",
      tender_submission_type: "",
      custom_lead_partner: "",
      custom_emd_type: "",
      custom_jv_partner: "",
      custom_assosiate_partner: "",
      bid_prepare_by: "null",
      bg_prepare_by: "null",
      bid_prepare_by_remarks: "",
      team_prepare_by: "null",
      team_prepare_by_remarks: "",
      team_required: "",
      team_requirements_details: "",
      recipient_details: "",
    });
    setTenderId("");
    setErrors("");
  };

  const handleBidderSubmit = async () => {
    const data = {
      bidder_name: wishListData.bidder_name.value,
      TenderforBD: tenderId,
      number_of_bidder: 1,
    };
    try {
      setWishListData((prev) => ({
        ...prev,
        bidder_name: { ...prev.bidder_name, loading: true },
      }));
      const res = await axios.post(`${BASE_URL}/siteproject/bidder/`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setWishListData((prev) => ({
        ...prev,
        bidders: [...prev.bidders, res.data],
        bidder_name: { ...prev.bidder_name, value: "" },
      }));
    } catch (err) {
    } finally {
      setWishListData((prev) => ({
        ...prev,
        bidder_name: { ...prev.bidder_name, loading: false },
      }));
    }
  };

  function isWithin10Days(obj) {
    const submissionDate = new Date(obj?.submission_date);
    const publishDate = new Date(obj?.publish_date);

    const diffInMs = Math.abs(publishDate - submissionDate);
    const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

    return diffInDays <= 10;
  }

  const handleParticipantSubmit = async () => {
    const data = {
      name: wishListData.participant_name.value,
      tender_participants: tenderId,
      score: wishListData.participant_name.score,
    };
    try {
      setWishListData((prev) => ({
        ...prev,
        participant_name: { ...prev.participant_name, loading: true },
      }));
      const res = await axios.post(
        `${BASE_URL}/siteproject/participant/`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      setWishListData((prev) => ({
        ...prev,
        participants: [...prev.participants, res.data],
        participant_name: { ...prev.participant_name, value: "", score: "" },
      }));
    } catch (err) {
    } finally {
      setWishListData((prev) => ({
        ...prev,
        participant_name: { ...prev.participant_name, loading: false },
      }));
    }
  };

  const handleFinancialParticipantSubmit = async () => {
    const data = {
      name: wishListData.financial_participant_name.value,
      tender_participants: tenderId,
      score: wishListData.financial_participant_name.score,
    };
    try {
      setWishListData((prev) => ({
        ...prev,
        financial_participant_name: {
          ...prev.financial_participant_name,
          loading: true,
        },
      }));
      const res = await axios.post(
        `${BASE_URL}/siteproject/financialparticipantsCreate/`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        },
      );
      setWishListData((prev) => ({
        ...prev,
        financial_participants: [...prev.financial_participants, res.data],
        financial_participant_name: {
          ...prev.financial_participant_name,
          value: "",
          score: "",
        },
      }));
    } catch (err) {
    } finally {
      setWishListData((prev) => ({
        ...prev,
        financial_participant_name: {
          ...prev.financial_participant_name,
          loading: false,
        },
      }));
    }
  };

  const [stats, setStats] = useState([]);

  const handleGetStats = async () => {
    try {
      const res = await axios.get(
        `${BASE_URL}/siteproject/tenderforBDStatsSpecial/`,
      );
      const sectorData = res.data;

      const result = Object.entries(sectorData.sector_counts).map(
        ([sector, data]) => ({
          sector,
          count: data.count,
          tender_type: data.tender_type,
        }),
      );

      setStats([
        ...result,
        {
          sector: "Special Tender",
          count: sectorData.special_tender,
          tender_type: {},
        },
        {
          sector: "Today Tender",
          count: sectorData.today_tender,
          tender_type: {},
        },
        {
          sector: "Discussion Tender",
          count: sectorData.is_discussed,
          tender_type: {},
        },
      ]);
    } catch (error) {}
  };

  useEffect(() => {
    handleGetStats();
  }, []);

  const handleStatClick = (category) => {
    setFilters((prev) => ({ ...prev, category: category }));
  };

  const handleSpecialClick = (category) => {
    setFilters((prev) => ({ ...prev, is_special_tender: true }));
  };

  const handleTodayClick = (category) => {
    setFilters((prev) => ({ ...prev, is_today: true }));
  };

  const handleDiscussClick = (category) => {
    setFilters((prev) => ({ ...prev, is_discussed: true }));
  };

  function formatToCrores(amountStr) {
    const cleaned = String(amountStr).replace(/,/g, "").trim();
    const amount = Number(cleaned);
    if (isNaN(amount)) {
      return 0;
    }
    return `${amount.toFixed(2)} cr`;
  }

  useEffect(() => {
    const updatedSum =
      parseInt(wishListData.lead_partner_share) +
      parseInt(wishListData.associate_partner_share) +
      parseInt(wishListData.jv_partner_share);
    setWishListData((prev) => ({ ...prev, partner_share_sum: updatedSum }));
  }, [
    wishListData.lead_partner_share,
    wishListData.associate_partner_share,
    wishListData.jv_partner_share,
  ]);
  const [tenderidscreening, setTenderIdScreening] = useState("");
  const openCorrigendumModal = (i) => {
    setCorriendumModal(true);
    setTenderId(i?.id);
  };

  const openCorrigendumModalScreening = (i) => {
    setCorriendumModalScreening(true);
    setTenderIdScreening(i?.id);
  };

  const [docsModal, setDocsModal] = useState(false);
  const [corrigendumDocs, setCorrigendumDocs] = useState([]);
  const [cvsDocs, setCvsDocs] = useState([]);
  const [techDocs, setTechDocs] = useState([]);
  const [finacialDocs, setFinancialDocs] = useState([]);
  const [BidDocs, setBidDocs] = useState([]);
  const [BidderDocs, setBidderDocs] = useState([]);
  const handleCvsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setCvsDocs(newFiles);
    }
  };

  const handleCvsRemove = (index) => {
    setCvsDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddCvDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      cvsDocs.forEach((file) => {
        formData.append("cv_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkcv/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setCvsDocs([]);
    } finally {
      setCvsDocs([]);
      getBidData();
    }
  };

  const handleTechFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setTechDocs(newFiles);
    }
  };

  const handleTechRemove = (index) => {
    setTechDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddTechDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      techDocs.forEach((file) => {
        formData.append("tech_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulktech/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setTechDocs([]);
    } finally {
      setTechDocs([]);
      getBidData();
    }
  };

  const handleFinancialFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setFinancialDocs(newFiles);
    }
  };

  const handleFinancialRemove = (index) => {
    setFinancialDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddFinancialDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      finacialDocs.forEach((file) => {
        formData.append("financial_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkfinancial/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setFinancialDocs([]);
    } finally {
      setFinancialDocs([]);
      getBidData();
    }
  };

  const handleBidsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setBidDocs(newFiles);
    }
  };

  const handleBidsRemove = (index) => {
    setBidDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddBidDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      BidDocs.forEach((file) => {
        formData.append("bid_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkbbid/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setBidDocs([]);
    } finally {
      setBidDocs([]);
      getBidData();
    }
  };
  const handleBidderDocsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setBidderDocs(newFiles);
    }
  };
  const handleBidderDocsRemove = (index) => {
    setBidderDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddBidderDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      BidderDocs.forEach((file) => {
        formData.append("bidder_tender", tenderId);
        formData.append("document_namebidder_tender", file?.name);
        formData.append("documents", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkbbidder/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setBidDocs([]);
    } finally {
      setBidDocs([]);
      getBidData();
    }
  };
  const [selectedDoc, setSelectedDoc] = useState(null);

  const handelOpenCorrigendumDocsModal = (docs) => {
    setCorrigendumDocs(docs);
    setDocsModal(true);
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  const handleCloseCorrigendumDocsModal = () => {
    setDocsModal(false);
    setCorrigendumDocs([]);
    setSelectedDoc(null);
  };

  const [tenderDocsModal, setTenderDocsModal] = useState(false);
  const [tenderDocuments, setTenderDocuments] = useState({
    tech: [],
    financial: [],
    cvs: [],
    rpf: [],
    bidDocs: [],
  });

  const handleOpenTenderDocsModal = (i) => {
    setTenderDocsModal(true);
    setTenderDocuments({
      tech: i?.tech_doc,
      financial: i?.financial_doc,
      cvs: i?.cv_doc,
      rpf: i?.rfp_doc,
      bidDocs: i?.bid_doc,
      bidder_doc: i?.bidder_doc,
    });
  };

  const handleCloseTenderDocsModal = () => {
    setTenderDocsModal(false);
    setTenderDocuments({
      tech: [],
      financial: [],
      cvs: [],
      rpf: [],
      bidDocs: [],
    });
    setSelectedDoc(null);
  };

  const [showEditModal, setShowEditModal] = useState(false);
  const [showEditModalTab, setShowEditModalTab] = useState(false);
  const [editTenderId, setEditTenderId] = useState(null);
  const [editTenderData, setEditTenderData] = useState([]);
  const handleOpenEditModal = (id, tender) => {
    setShowEditModal(true);
    setEditTenderId(id);

    setEditTenderData(tender);
  };

  const handleOpenEditModalTab = (id, tender) => {
    setShowEditModalTab(true);
    setEditTenderId(id);

    setEditTenderData(tender);
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditTenderId(null);
    setEditTenderData([]);
  };
  const handleCloseEditModalTab = () => {
    setShowEditModalTab(false);
    setEditTenderId(null);
    setEditTenderData([]);
  };

  const [showBackModal, setShowBackModal] = useState(false);
  const [backTenderId, setBackTenderId] = useState(null);

  const handleOpenBackModal = (id) => {
    setShowBackModal(true);
    setBackTenderId(id);
  };

  const handleCloseBackModal = () => {
    setShowBackModal(false);
    setBackTenderId(null);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const loadingToastId = toast.loading("Processing...");

    let data = {};

    if (toggleState === 2) {
      data = {
        is_in_bidlist: false,
        // date_aa: new Date().toISOString()
      };
    } else if (toggleState === 3) {
      data = {
        is_in_targetlist: false,
        date_aa: new Date().toISOString(),
      };
    } else if (toggleState === 4) {
      data = {
        is_finalize: false,
        date_bb: new Date().toISOString(),
        tat_duration: null,
      };
    } else if (toggleState === 9) {
      data = {
        is_bid_prepare_in_progress: false,
        date_cc: new Date().toISOString(),
        // assigned_to: [],
        // assigned_by: '',
      };
    } else if (toggleState === 5) {
      data = {
        is_submitted: false,
        date_ff: new Date().toISOString(),
      };
    }

    try {
      const res = await axios.put(
        `${BASE_URL}/siteproject/BidTenderUpdate/${backTenderId}/`,
        data,
      );

      if (res.status === 200) {
        getBidData(filters);
        setShowBackModal(false);
        toast.dismiss(loadingToastId);
        toast.success("Moved to previous stage");
        // setToggleState(prev => prev - 1);
      }
    } catch (err) {
      handleErrorToast(err);
    } finally {
      toast.dismiss(loadingToastId);
      setBackTenderId(null);
    }
  };

  // const downloadTenders = (dataArray, fileName = 'tenders-data.xlsx', toggleState) => {
  //     if (!Array.isArray(dataArray) || dataArray.length === 0) {
  //         return;
  //     }

  //     const allowedKeysMap = {
  //         1: [
  //             "tender_id", "tender_name", "sector", "tender_type", "client", "submission_date", "publish_date",
  //             "lane", "state", "consultancy_fees", "construction_fees", "GST_consultancy",
  //             "length", "duration_construction", "duration_onm", "duration_dlp", "km_cost", "remarks"
  //         ],
  //         2: [
  //             "tender_id", "tender_name", "sector", "tender_type", "client", "submission_date", "publish_date",
  //             "lane", "state", "consultancy_fees", "construction_fees", "GST_consultancy", "length",
  //             "duration_construction", "duration_onm", "duration_dlp", "km_cost", "remarks",
  //             "eligibity_criteria", "eligibity_criteria_special", "is_jv_allowed", "is_jv_consorium_association_allowed", "company_name", "company_dist_lead", "company_dist_jv",
  //             "soil_quality", "participating_as", "tech_score", "company_score",
  //             "site_apprisate_required", "site_apprisate_marking", "work_methodology_required",
  //             "work_methodology_marking", "presentation_required", "presentation_required_marking",
  //             "presentation_type", "terms_of_jv",
  //         ],
  //         3: [
  //             "tender_id", "tender_name", "sector", "tender_type", "client", "submission_date", "publish_date",
  //             "lane", "state", "consultancy_fees", "construction_fees", "GST_consultancy", "length",
  //             "duration_construction", "duration_onm", "duration_dlp", "km_cost", "remarks",
  //             "eligibity_criteria", "eligibity_criteria_special", "is_jv_allowed", "is_jv_consorium_association_allowed", "company_name", "company_dist_lead", "company_dist_jv",
  //             "soil_quality", 'participating_as', "tech_score", "company_score",
  //             "site_apprisate_required", "site_apprisate_marking", "work_methodology_required",
  //             "work_methodology_marking", "presentation_required", "presentation_required_marking",
  //             "presentation_type", "terms_of_jv", "lead_partner", "lead_partner_share", "jv_partner_name", "jv_partner_share",
  //             "associate_partner", "associate_partner_share", "bg_requried", "bg_amount", "is_emd_required", "emd_review", "exmpted_emd", "emd_amount", "emd_unit", "team_required",
  //             "bg_type", "emd_type", "tender_submission_type", "team_requirements_details", 'recipient_details'
  //         ],
  //         4: [
  //             "tender_id", "tender_name", "sector", "tender_type", "client", "submission_date", "publish_date",
  //             "lane", "state", "consultancy_fees", "construction_fees", "GST_consultancy", "length",
  //             "duration_construction", "duration_onm", "duration_dlp", "km_cost", "remarks",
  //             "eligibity_criteria", "eligibity_criteria_special", "is_jv_allowed", "is_jv_consorium_association_allowed", "company_name", "company_dist_jv",
  //             "soil_quality", "participating_as", "tech_score", "company_score",
  //             "site_apprisate_required", "site_apprisate_marking", "work_methodology_required",
  //             "work_methodology_marking", "presentation_required", "presentation_required_marking",
  //             "presentation_type", "terms_of_jv", "lead_partner", "lead_partner_share", "jv_partner_name", "jv_partner_share",
  //             "associate_partner", "associate_partner_share", "bg_requried", "bg_amount", "is_emd_required", "emd_review", "exmpted_emd", "team_required", "emd_amount", "emd_unit", "team_requirements_details",
  //             "bg_type", "emd_type", "tender_submission_type", "checklist", "all_docs_done", "tech_score", "cv_score", "all_cvs_done", 'recipient_details',
  //         ],
  //         5: [
  //             "tender_id", "tender_name", "sector", "tender_type", "client", "submission_date", "publish_date",
  //             "lane", "state", "consultancy_fees", "construction_fees", "GST_consultancy", "length",
  //             "duration_construction", "duration_onm", "duration_dlp", "km_cost", "remarks",
  //             "eligibity_criteria", "eligibity_criteria_special", "is_jv_allowed", "is_jv_consorium_association_allowed", "company_name", "company_dist_jv",
  //             "soil_quality", "participating_as", "tech_score", "company_score",
  //             "site_apprisate_required", "site_apprisate_marking", "work_methodology_required",
  //             "work_methodology_marking", "presentation_required", "presentation_required_marking",
  //             "presentation_type", "terms_of_jv", "lead_partner", "lead_partner_share", "jv_partner_name", "jv_partner_share",
  //             "associate_partner", "associate_partner_share", "bg_requried", "bg_amount", "is_emd_required", "exmpted_emd", "emd_review", "team_required", "emd_amount", "emd_unit", "team_requirements_details",
  //             "bg_type", "emd_type", "tender_submission_type", "checklist", "all_docs_done", "tech_score", "cv_score", "all_cvs_done", 'recipient_details',
  //             "tech_open", "tech_responsive", "financial_status", "are_we_l1"
  //         ],
  //         6: [
  //             "tender_id", "tender_name", "sector", "tender_type", "client", "submission_date", "publish_date",
  //             "lane", "state", "consultancy_fees", "construction_fees", "GST_consultancy", "length",
  //             "duration_construction", "duration_onm", "duration_dlp", "km_cost", "remarks",
  //             "eligibity_criteria", "eligibity_criteria_special", "is_jv_allowed", "is_jv_consorium_association_allowed", "company_name", "company_dist_jv",
  //             "soil_quality", "participating_as", "tech_score", "company_score",
  //             "site_apprisate_required", "site_apprisate_marking", "work_methodology_required",
  //             "work_methodology_marking", "presentation_required", "presentation_required_marking",
  //             "presentation_type", "terms_of_jv", "lead_partner", "lead_partner_share", "jv_partner_name", "jv_partner_share",
  //             "associate_partner", "associate_partner_share", "bg_requried", "bg_amount", "is_emd_required", "emd_review", "exmpted_emd", "team_required", "emd_amount", "emd_unit",
  //             "bg_type", "emd_type", "tender_submission_type", "checklist", "all_docs_done", "tech_score", "cv_score", "all_cvs_done",
  //             "tech_open", "tech_responsive", "financial_status", "are_we_l1", 'team_requirements_details', 'recipient_details'
  //         ]
  //     };

  //     let filteredData = dataArray;

  //     if (toggleState in allowedKeysMap) {
  //         const keys = allowedKeysMap[toggleState];

  //         filteredData = dataArray.map(item => {
  //             const flat = {
  //                 ...item,
  //                 duration_construction: item.duration?.duration_construction || '',
  //                 duration_dlp: item.duration?.duration_dlp || '',
  //                 duration_onm: item.duration?.duration_onm || ''
  //             };
  //             return Object.fromEntries(keys.map(key => [key, flat[key] ?? '']));
  //         });
  //     }

  //     const sheet = XLSX.utils.json_to_sheet(filteredData);
  //     const workbook = XLSX.utils.book_new();
  //     XLSX.utils.book_append_sheet(workbook, sheet, 'Sheet1');
  //     XLSX.writeFile(workbook, fileName);
  // };
  const downloadTenders = (dataArray, toggleState) => {
    if (!Array.isArray(dataArray) || dataArray.length === 0) return;

    // Map toggle → filename
    const fileNameMap = {
      1: "New Tenders.xlsx",
      2: "Wishlisted Tenders.xlsx",
      3: "Target Tenders.xlsx",
      4: "Finalized Tenders.xlsx",
      5: "Submitted Tenders.xlsx",
      6: "Rejected Tenders.xlsx",
      9: "Bid Preparation Pipeline.xlsx",
      7: "Expired Tenders.xlsx",
      8: "Cancelled Tenders.xlsx",
    };
    const fileName = fileNameMap[toggleState] || "Tenders.xlsx";

    // Apply same filtering logic used in table display
    const filteredData = dataArray.filter((i) => {
      switch (toggleState) {
        case 1:
          return (
            !i?.is_in_bidlist &&
            !i?.is_in_targetlist &&
            !i?.is_finalize &&
            !i?.is_submitted &&
            !i?.is_rejected &&
            (() => {
              const daysLeft = i?.corrigendum_date
                ? getDaysLeftNumber(i?.corrigendum_date)
                : getDaysLeftNumber(i?.submission_date);
              return daysLeft > 0;
            })()
          );
        case 2:
          return (
            i?.is_in_bidlist &&
            !i?.is_in_targetlist &&
            !i?.is_finalize &&
            !i?.is_submitted &&
            !i?.is_rejected &&
            (() => {
              const daysLeft = i?.corrigendum_date
                ? getDaysLeftNumber(i?.corrigendum_date)
                : getDaysLeftNumber(i?.submission_date);
              return daysLeft > 0;
            })()
          );
        case 3:
          return (
            i?.is_in_bidlist &&
            i?.is_in_targetlist &&
            !i?.is_finalize &&
            !i?.is_submitted &&
            !i?.is_rejected &&
            (() => {
              const daysLeft = i?.corrigendum_date
                ? getDaysLeftNumber(i?.corrigendum_date)
                : getDaysLeftNumber(i?.submission_date);
              return daysLeft > 0;
            })()
          );
        case 4:
          return (
            i?.is_in_bidlist &&
            i?.is_in_targetlist &&
            i?.is_finalize &&
            !i?.is_submitted &&
            !i?.is_rejected &&
            (() => {
              const daysLeft = i?.corrigendum_date
                ? getDaysLeftNumber(i?.corrigendum_date)
                : getDaysLeftNumber(i?.submission_date);
              return daysLeft > 0;
            })()
          );
        case 5:
          return (
            i?.is_in_bidlist &&
            i?.is_in_targetlist &&
            i?.is_finalize &&
            i?.is_submitted &&
            !i?.is_rejected &&
            (() => {
              const daysLeft = i?.corrigendum_date
                ? getDaysLeftNumber(i?.corrigendum_date)
                : getDaysLeftNumber(i?.submission_date);
              return daysLeft > 0;
            })()
          );
        case 6:
          return i?.is_rejected;
        case 7:
          const daysLeft = i?.corrigendum_date
            ? getDaysLeftNumber(i?.corrigendum_date)
            : getDaysLeftNumber(i?.submission_date);
          return daysLeft <= 0;
        case 8:
          return i?.is_cancelled;
        case 9:
          return (
            i?.is_in_bidlist &&
            i?.is_in_targetlist &&
            i?.is_finalize &&
            i?.is_bid_prepare_in_progress &&
            !i?.is_submitted &&
            !i?.is_rejected &&
            (() => {
              const daysLeft = i?.corrigendum_date
                ? getDaysLeftNumber(i?.corrigendum_date)
                : getDaysLeftNumber(i?.submission_date);
              return daysLeft > 0;
            })()
          );
        default:
          return true;
      }
    });

    if (filteredData.length === 0) {
      toast.info("No data available for this section");
      return;
    }

    // Select fields based on toggleState
    const allowedKeysMap = {
      1: [
        "tender_id",
        "tender_name",
        "sector",
        "tender_type",
        "client",
        "submission_date",
        "state",
        "consultancy_fees",
        "remarks",
      ],
      2: [
        "tender_id",
        "tender_name",
        "sector",
        "client",
        "submission_date",
        "state",
        "remarks",
      ],
      3: [
        "tender_id",
        "tender_name",
        "sector",
        "client",
        "submission_date",
        "state",
        "tech_score",
        "remarks",
      ],
      4: [
        "tender_id",
        "tender_name",
        "sector",
        "client",
        "submission_date",
        "state",
        "company_name",
        "remarks",
      ],
      5: [
        "tender_id",
        "tender_name",
        "sector",
        "client",
        "submission_date",
        "state",
        "are_we_l1",
        "remarks",
      ],
      6: [
        "tender_id",
        "tender_name",
        "sector",
        "client",
        "submission_date",
        "state",
        "remarks",
      ],
      7: [
        "tender_id",
        "tender_name",
        "sector",
        "client",
        "submission_date",
        "state",
        "remarks",
      ],
      8: [
        "tender_id",
        "tender_name",
        "sector",
        "client",
        "submission_date",
        "state",
        "remarks",
      ],
    };

    const keys = allowedKeysMap[toggleState] || Object.keys(filteredData[0]);
    const finalData = filteredData.map((item) =>
      Object.fromEntries(keys.map((key) => [key, item[key] ?? ""])),
    );

    // Generate and download Excel
    const sheet = XLSX.utils.json_to_sheet(finalData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, sheet, "Sheet1");
    XLSX.writeFile(workbook, fileName);
  };

  const [activeIndex, setActiveIndex] = useState(null);

  const handleOpen = (index) => setActiveIndex(index);
  const [toggle, SetShowToggle] = useState(4);
  const handleCloseDoc = () => setActiveIndex(null);
  const role = sessionStorage.getItem("sitemanagement_role");
  console.log(role, role != "CertificationAccessBd");
  const [scrollToTender, setScrollToTender] = useState(null);

  // Function to scroll to specific tender
  const handleScrollToTender = (tenderId) => {
    console.log(sessionStorage.getItem("scrollTenderId"), "storedtenderid");
    const element = document.querySelector(`[data-tender-id="${tenderId}"]`);
    console.log(element, "element");
    if (element) {
      setTimeout(() => {
        console.log(tenderId, "fucntion executed");
        element.scrollIntoView({ behavior: "smooth", block: "center" });
        sessionStorage.removeItem("scrollTenderId");
        SetTenderIdscroll("");
      }, 2000);
    }
  };

  useEffect(() => {
    const storedTenderId = sessionStorage.getItem("scrollTenderId");
    console.log(storedTenderId, "storedtenderid");
    if (storedTenderId) {
      handleScrollToTender(storedTenderId);

      // 🧹 Clean up after scrolling
    }
  }, [bidData]);

  const [employeelistassigned, SetEmployeelistassigned] = useState([]);
  const [employeelistbyhodassigned, SetEmployeelistbyhodassigned] = useState(
    [],
  );
  // const getEmployeeData = async () => {
  //     try {
  //         const empCode = sessionStorage.getItem('emp_code') || sessionStorage.getItem('sitemanagement_emp_code');
  //         const response = await axios.get(`${BASE_URL}/siteproject/tendersfilter/${empCode}/${filters?.client ? filters?.client : "null"}/${filters?.state ? filters?.state
  //             : "null"}/${filters?.searchText ? filters?.searchText : 'null'}/${filters?.category ? filters?.category : 'null'}/${selectedFromDate ? selectedFromDate : 'null'}/${selectedToDate ? selectedToDate : 'null'}/${filters?.tenderType ? filters.tenderType : 'null'}/${filters?.searchId ? filters.searchId : 'null'}/${filters?.is_special_tender ? filters.is_special_tender : 'null'}/${filters?.is_today ? filters.is_today : 'null'}/${filters?.is_discussed ? filters.is_discussed : 'null'}/null/${filters.tenderStatus ? filters.tenderStatus : "null"}/${currentPage}/${limit}/`);
  //         SetEmployeelistassigned(response.data);
  //     } catch (error) {
  //         console.error("Error fetching employee data:", error);

  //     }
  // }
  const getEmployeeData = async () => {
    try {
      const role = sessionStorage.getItem("sitemanagement_role");
      console.log(role);
      // If role is certificateadminaccess → empCode = "null"
      const empCode =
        role === "certificateadminaccess" || role === "CertificationAccess"
          ? "null"
          : sessionStorage.getItem("sitemanagement_emp_code");
      const newLocal = "";
      console.log(empCode, role, ">>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>");
      const response = await axios.get(
        `${BASE_URL}/siteproject/tendersfilter/${empCode}/${filters?.client ? filters?.client : "null"}/${
          filters?.state ? filters?.state : "null"
        }/${filters?.searchText ? filters?.searchText : "null"}/${filters?.category ? filters?.category : "null"}/${selectedFromDate ? selectedFromDate : "null"}/${selectedToDate ? selectedToDate : "null"}/${filters?.tenderType ? filters.tenderType : "null"}/${filters?.searchId ? filters.searchId : "null"}/${filters?.is_special_tender ? filters.is_special_tender : "null"}/${filters?.is_today ? filters.is_today : "null"}/${filters?.is_discussed ? filters.is_discussed : "null"}/null/${filters.tenderStatus ? filters.tenderStatus : "null"}/`,
      );

      SetEmployeelistassigned(response.data.assigned_to_detail);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };
  const getEmployeeDatabyhod = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/siteproject/assigneddata/`);

      SetEmployeelistbyhodassigned(response.data);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  const [employeelistassignedto, SetEmployeelistassignedto] = useState([]);
  const getEmployeeDatato = async (emp_code, filters) => {
    try {
      const empCode =
        sessionStorage.getItem("emp_code") ||
        sessionStorage.getItem("sitemanagement_emp_code");
      const response = await axios.get(
        `${BASE_URL}/siteproject/tendersassigned/${emp_code ? emp_code : empCode}/${filters?.client ? filters?.client : "null"}/${
          filters?.state ? filters?.state : "null"
        }/${filters?.searchText ? filters?.searchText : "null"}/${filters?.category ? filters?.category : "null"}/${selectedFromDate ? selectedFromDate : "null"}/${selectedToDate ? selectedToDate : "null"}/${filters?.tenderType ? filters.tenderType : "null"}/${filters?.searchId ? filters.searchId : "null"}/${filters?.is_special_tender ? filters.is_special_tender : "null"}/${filters?.is_today ? filters.is_today : "null"}/${filters?.is_discussed ? filters.is_discussed : "null"}/null/${filters.tenderStatus ? filters.tenderStatus : "null"}/`,
      );
      SetBidData(response.data.tenders);

      console.log(response.data.tenders, "response");
      // return (response.data.tenders)
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };
  console.log(bidData, "biddata");
  const [isemployeeSelected, SetisemployeeSelected] = useState(false);
  useEffect(() => {
    if (toggleState === 9 || toggleState === 5) {
      // console.log('useEffect if')
      const empCode =
        sessionStorage.getItem("emp_code") ||
        sessionStorage.getItem("sitemanagement_emp_code");
      getEmployeeData();
      getEmployeeDatabyhod();
    } else {
      // console.log('useEffect else')
      // getBidData(filters)
    }
  }, [toggleState, filters]);

  const [selectedEmployee, setSelectedEmployee] = useState(null);

  // 🧩 Handles clicking on an employee box
  const handleEmployeeSelected = (empCode) => {
    setSelectedEmployee((prev) => (prev === empCode ? null : empCode));
    SetisemployeeSelected(true);
  };

  useEffect(() => {
    // console.log(selectedEmployee != null)
    if (selectedEmployee != null) {
      getEmployeeDatato(selectedEmployee, filters);
    }
  }, [selectedEmployee, filters]);

  const toggleCvDone = async (id, mark) => {
    const newStatus = !mark;

    // setLoading(true);

    try {
      await axios.put(`${BASE_URL}/siteproject/BidTenderUpdate/${id}/`, {
        mark_as_cv: newStatus,
      });
      await getBidData(filters);
      toast.success("CV status updated:", newStatus);
    } catch (error) {
      console.error("Error updating CV status:", error);

      // alert("Failed to update CV status.");
    } finally {
      // setLoading(false);
    }
  };

  const toggleDocumentDone = async (id, mark) => {
    const newStatus = !mark;

    // setLoading(true);

    try {
      await axios.put(`${BASE_URL}/siteproject/BidTenderUpdate/${id}/`, {
        mark_as_document: newStatus,
      });
      await getBidData(filters);
      toast.success("Document status updated:", newStatus);
    } catch (error) {
      console.error("Error updating CV status:", error);

      // alert("Failed to update CV status.");
    } finally {
      // setLoading(false);
    }
  };
  const [gotoPage, setGotoPage] = useState("");
  const [scoreError, setScoreError] = useState("");
  const getCountByToggle = (data, toggle) => {
    if (!data) return 0;

    return data.filter((i) => {
      const daysLeft = i?.corrigendum_date
        ? getDaysLeftNumber(i?.corrigendum_date)
        : getDaysLeftNumber(i?.submission_date);

      switch (toggle) {
        case 0: // All
          return (
            (i?.is_in_bidlist ||
              i?.is_in_targetlist ||
              i?.is_finalize ||
              i?.is_bid_prepare_in_progress ||
              !i?.is_submitted ||
              !i?.is_rejected ||
              !i?.is_cancelled) &&
            (() => {
              const daysLeft = i?.corrigendum_date
                ? getDaysLeftNumber(i?.corrigendum_date)
                : getDaysLeftNumber(i?.submission_date);
              if (submissionDateFilter) {
                return daysLeft > 0 && daysLeft <= submissionDateFilter;
              } else {
                return daysLeft > 0;
              }
            })()
          );

        case 1: // New
          return (
            !i?.is_in_bidlist &&
            !i?.is_in_targetlist &&
            !i?.is_finalize &&
            !i?.is_submitted &&
            !i?.is_rejected &&
            !i?.is_cancelled &&
            daysLeft > 0
          );

        case 2: // Wishlist
          return (
            i?.is_in_bidlist &&
            !i?.is_in_targetlist &&
            !i?.is_finalize &&
            !i?.is_submitted &&
            !i?.is_rejected &&
            !i?.is_cancelled &&
            daysLeft > 0
          );

        case 3: // Target
          return (
            i?.is_in_bidlist &&
            i?.is_in_targetlist &&
            !i?.is_finalize &&
            !i?.is_submitted &&
            !i?.is_rejected &&
            !i?.is_cancelled &&
            daysLeft > 0
          );

        case 4: // Final
          return (
            i?.is_in_bidlist &&
            i?.is_in_targetlist &&
            i?.is_finalize &&
            !i?.is_bid_prepare_in_progress &&
            !i?.is_submitted &&
            !i?.is_rejected &&
            !i?.is_cancelled &&
            daysLeft > 0
          );

        case 9: // Bid Prepare
          return (
            i?.is_in_bidlist &&
            i?.is_in_targetlist &&
            i?.is_finalize &&
            i?.is_bid_prepare_in_progress &&
            !i?.is_submitted &&
            !i?.is_rejected &&
            !i?.is_cancelled &&
            daysLeft > 0
          );

        case 5: // Submitted
          return i?.is_submitted && !i?.is_rejected && !i?.is_cancelled;

        case 6: // Rejected
          return i?.is_rejected || i?.is_cancelled;

        case 7: // Expired
          return daysLeft < 0 && !i?.is_submitted;

        default:
          return true;
      }
    }).length;
  };

  // { console.log(employeelistassigned, 'employeelistassigned ') }
  // console.log((roleemp != "CertificationAccessBd", roleemp != "CertificationAccessCvTeamHead", roleemp != "CertificationAccessCvTeam", roleemp != "CertificationAccessDocumentTeam", roleemp != "CertificationAccessDocumentTeamHead", roleemp))
  return (
    <>
      <div className="attendance-history-conts">
        <div className="field-cont">
          <div
            className="attendance-subcontainer"
            style={{ width: "100%", padding: "0px 0px 0px 0px" }}
          >
            <div
              className="flex-row "
              style={{
                width: "100%",
                justifyContent: "end",
                padding: " 10px",
                gap: "5px",
              }}
            >
              {toggleState === 1 ? (
                <AddBidDetails
                  getBidData={getBidData}
                  handleGetStats={handleGetStats}
                  filters={filters}
                />
              ) : toggleState === 3 ? (
                ""
              ) : (
                ""
              )}
              <UploadSiteProject getBidData={getBidData} filters={filters} />
              <button
                onClick={() => downloadTenders(bidData, toggleState)}
                title="Download"
                className="model-button   font-weight500   model-button-print"
              >
                <DownloadIcon />
              </button>
            </div>
          </div>
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            flexWrap: "wrap",
            background: "#F4F7FE",
            borderRadius: "8px",
            gap: "12px",
          }}
        >
          {stats?.map((stat, index) => (
            <StatsCard
              stat={stat}
              index={index}
              handleStatClick={handleStatClick}
              handleFilterTenderType={handleFilterTenderType}
              handleSpecialClick={handleSpecialClick}
              handleTodayClick={handleTodayClick}
              handleDiscussClick={handleDiscussClick}
            />
          ))}
        </div>
        <div className="filters-card">
          <div
            className="filters-header"
            onClick={toggleCollapse}
            role="button"
          >
            <h3 className="filters-title">Filters</h3>
            <button className="collapse-btn" aria-label="toggle filters">
              {isCollapsed ? (
                <svg width="16" height="16" viewBox="0 0 24 24">
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="#0b85d8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              ) : (
                <svg width="16" height="16" viewBox="0 0 24 24">
                  <path
                    d="M18 15L12 9L6 15"
                    stroke="#0b85d8"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              )}
            </button>
          </div>

          {!isCollapsed && (
            <form onSubmit={handleSubmit} className="filters-form">
              <div className="filter-row full-width">
                <div className="field-wrapper search-wrapper">
                  <label htmlFor="searchText" className="filter-label">
                    Search By Tender Name
                  </label>
                  <div className="input-with-icon">
                    {/* search icon (SVG so no external lib needed) */}
                    <svg
                      className="icon search-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      aria-hidden
                    >
                      <path
                        fill="none"
                        stroke="#9fbfe8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
                      />
                    </svg>
                    <input
                      id="searchText"
                      name="searchText"
                      value={filters.searchText || ""}
                      onChange={handleChange}
                      placeholder="Search by Tender Name & Client Name"
                      className="filter-input search-input"
                      style={{ width: "90%" }}
                    />
                    {/* {errors.searchText && (
                                            <span className="error-message font-size-text ">
                                                {errors.searchText}
                                            </span>
                                        )} */}
                  </div>
                </div>
                <div className="field-wrapper search-wrapper">
                  <label htmlFor="searchId" className="filter-label">
                    Search By Tender Id
                  </label>
                  <div className="input-with-icon">
                    {/* search icon (SVG so no external lib needed) */}
                    <svg
                      className="icon search-icon"
                      width="16"
                      height="16"
                      viewBox="0 0 24 24"
                      aria-hidden
                    >
                      <path
                        fill="none"
                        stroke="#9fbfe8"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M21 21l-4.35-4.35M11 19a8 8 0 1 1 0-16 8 8 0 0 1 0 16z"
                      />
                    </svg>
                    <input
                      id="searchId"
                      name="searchId"
                      value={filters.searchId || ""}
                      onChange={handleChange}
                      placeholder="Search by Tender Id"
                      className="filter-input search-input"
                      style={{ width: "90%" }}
                    />
                  </div>
                </div>
                <div className="field-wrapper select-wrapper">
                  <label className="filter-label">Date</label>
                  <div className="input-with-icon date-input-wrapper">
                    <DateRangePicker
                      startDate={selectedFromDate}
                      endDate={selectedToDate}
                      placeHolder1="DD/MM/YYYY"
                      placeHolder2="DD/MM/YYYY"
                      onChange={(start, end) => {
                        setFromDate(start);
                        setToDate(end);
                      }}
                      className="custom-range-picker"
                    />
                  </div>
                </div>
              </div>

              {/* DROPDOWNS ROW */}
              <div className="filter-row">
                <div className="field-wrapper select-wrapper">
                  <label className="filter-label">Sectors</label>
                  <select
                    name="category"
                    value={filters.category || ""}
                    onChange={handleChange}
                    className="filter-input select-input"
                  >
                    <option value="">Select Sectors</option>
                    {categories.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="field-wrapper select-wrapper">
                  <label className="filter-label">State</label>
                  <select
                    name="state"
                    value={filters.state || ""}
                    onChange={handleChange}
                    className="filter-input select-input"
                  >
                    <option value="">Select State</option>
                    {states.map((s) => (
                      <option key={s} value={s}>
                        {s}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="field-wrapper select-wrapper">
                  <label className="filter-label">Tender Type</label>
                  <select
                    name="tenderType"
                    value={filters.tenderType || ""}
                    onChange={handleChange}
                    className="filter-input select-input"
                  >
                    <option value="">Select Tender Type</option>
                    <option value="Feasibility">Feasibility</option>
                    <option value="DPR">DPR</option>
                    <option value="FesibilityCumDPR">FesibilityCumDPR</option>
                    <option value="Authority_Engineer">
                      Authority Engineer
                    </option>
                    <option value="Independent_Engineer">
                      Independent Engineer
                    </option>
                    <option value="PSSA">PSSA</option>
                    <option value="PMC">PMC</option>
                    <option value="GC">GC</option>
                    <option value="O&M">O&M</option>
                    <option value="Supervision">Supervision</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
                <div className="field-wrapper select-wrapper">
                  <label className="filter-label">Tender Status</label>
                  <select
                    name="tenderStatus"
                    value={filters.tenderStatus || ""}
                    onChange={handleChange}
                    className="filter-input select-input"
                  >
                    <option value="">Select Tender Status</option>
                    <option value="Cancelled">Cancelled</option>
                    <option value="Rejected">Rejected</option>
                    <option value="Expired">Expired</option>
                  </select>
                </div>
              </div>

              <div className="filter-actions">
                <button
                  type="submit"
                  className="btn btn-primary btn-color"
                  style={{ background: "#2576bc" }}
                >
                  Search
                </button>
                <button
                  type="button"
                  className="btn btn-primary btn-color-white"
                  style={{
                    background: "#fff",
                    border: "1px solid #2576bc",
                    color: "#2576bc",
                  }}
                  onClick={handleClear}
                >
                  Clear
                </button>
              </div>
            </form>
          )}
        </div>

        <div className="header">
          <div className="tab-container">
            <button
              className={toggleState === 0 ? "tab-btn active" : "tab-btn"}
              onClick={() => {
                Setisrequested(false);
                SetShowToggle(4);
                SetisClosed(false);
                setToggleState(0);
                setCompanySelected("");
                setTargetSector("");
                setTargetTenderType("");
              }}
            >
              <i className="fas fa-bolt"></i> All Tenders (
              {bidData
                ? bidData.filter((tender) => {
                    const daysLeft = tender?.corrigendum_date
                      ? getDaysLeftNumber(tender?.corrigendum_date)
                      : getDaysLeftNumber(tender?.submission_date);

                    return (
                      (tender?.is_in_bidlist ||
                        tender?.is_in_targetlist ||
                        tender?.is_finalize ||
                        tender?.is_bid_prepare_in_progress ||
                        !tender?.is_submitted ||
                        !tender?.is_rejected ||
                        !tender?.is_cancelled) &&
                      daysLeft > 0 // ✅ exclude expired tenders
                    );
                  }).length
                : 0}
              )
            </button>
            <select
              value={toggleState}
              onChange={(e) => {
                setToggleState(Number(e.target.value));
                setCompanySelected("");
                setTargetSector("");
                setTargetTenderType("");
              }}
              className="tab-dropdown"
            >
              <option value={0}>
                All Tenders ({getCountByToggle(bidData, 0)})
              </option>

              <option value={1}>
                New Tenders ({getCountByToggle(bidData, 1)})
              </option>

              <option value={2}>
                Wishlist ({getCountByToggle(bidData, 2)})
              </option>

              <option value={3}>Target ({getCountByToggle(bidData, 3)})</option>

              <option value={4}>Final ({getCountByToggle(bidData, 4)})</option>

              <option value={9}>
                Bid Prepare ({getCountByToggle(bidData, 9)})
              </option>

              <option value={5}>
                Submitted ({getCountByToggle(bidData, 5)})
              </option>
            </select>
          </div>

          <div className="filter-section">
            <button className="print-btn">
              <i className="fas fa-print"></i>
            </button>
          </div>
        </div>

        <div
          className="table-css-white-background  table-box paddingTop-0px scroll-container-table"
          style={{ minHeight: "380px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "12px",
              marginTop: "10px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                onClick={() => handleCompanySelected("cipl")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: "8px",
                  backgroundColor:
                    companySelected === "cipl" ? "#2576bc" : "#fafafa",
                  color: companySelected === "cipl" ? "white" : "black",
                  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
                  borderRadius: "4px",
                }}
              >
                <label style={{ cursor: "pointer" }}>
                  CIPL:{" "}
                  {
                    filteredData
                      .filter(
                        (tender) =>
                          tender?.is_in_bidlist &&
                          tender?.is_in_targetlist &&
                          !tender?.is_finalize &&
                          !tender?.is_submitted &&
                          !tender?.is_rejected &&
                          getDaysLeftNumber(
                            tender?.corrigendum_date || tender?.submission_date,
                          ) > 0,
                      )
                      .filter((ten) => ten.company_name === "cipl").length
                  }
                </label>
              </div>
              <div
                onClick={() => handleCompanySelected("sapl")}
                style={{
                  display: "flex",
                  alignItems: "center",
                  cursor: "pointer",
                  padding: "8px",
                  backgroundColor:
                    companySelected === "sapl" ? "#2576bc" : "#fafafa",
                  color: companySelected === "sapl" ? "white" : "black",
                  boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
                  borderRadius: "4px",
                }}
              >
                <label style={{ cursor: "pointer" }}>
                  SAPL:{" "}
                  {
                    filteredData
                      .filter(
                        (tender) =>
                          tender?.is_in_bidlist &&
                          tender?.is_in_targetlist &&
                          !tender?.is_finalize &&
                          !tender?.is_submitted &&
                          !tender?.is_rejected &&
                          getDaysLeftNumber(
                            tender?.corrigendum_date || tender?.submission_date,
                          ) > 0,
                      )
                      .filter((ten) => ten.company_name === "sapl").length
                  }
                </label>
              </div>
              {/* <div onClick={() => handleCompanySelected('joint')} style={{ display: 'flex', alignItems: 'center', cursor: 'pointer', padding: '8px', backgroundColor: companySelected === 'joint' ? '#2576bc' : '#fafafa', color: companySelected === 'joint' ? 'white' : 'black', boxShadow: '0 0 5px 0 rgba(0, 0, 0, 0.3)', borderRadius: '4px' }}>
                                    <label style={{ cursor: 'pointer' }}>JOINT: {filteredData.filter(tender => tender?.is_in_bidlist && tender?.is_in_targetlist && !tender?.is_finalize && !tender?.is_submitted && !tender?.is_rejected).filter(ten => ten.company_name === 'joint').length}</label>
                                </div> */}
            </div>

            {companySelected !== "" && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginTop: "10px",
                }}
              >
                <div
                  onClick={() => handleTargetSector("Highway")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "8px",
                    backgroundColor:
                      targetSector === "Highway" ? "#2576bc" : "#fafafa",
                    color: targetSector === "Highway" ? "white" : "black",
                    boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
                    borderRadius: "4px",
                  }}
                >
                  <label style={{ cursor: "pointer" }}>
                    Highway:{" "}
                    {
                      filteredData
                        .filter(
                          (tender) =>
                            tender?.is_in_bidlist &&
                            tender?.is_in_targetlist &&
                            !tender?.is_finalize &&
                            !tender?.is_submitted &&
                            !tender?.is_rejected &&
                            getDaysLeftNumber(
                              tender?.corrigendum_date ||
                                tender?.submission_date,
                            ) > 0,
                        )
                        .filter((ten) => ten.company_name === companySelected)
                        .filter((ten) => ten.sector === "Highway").length
                    }
                  </label>
                </div>
                <div
                  onClick={() => handleTargetSector("Railway")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "8px",
                    backgroundColor:
                      targetSector === "Railway" ? "#2576bc" : "#fafafa",
                    color: targetSector === "Railway" ? "white" : "black",
                    boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
                    borderRadius: "4px",
                  }}
                >
                  <label style={{ cursor: "pointer" }}>
                    Railway:{" "}
                    {
                      filteredData
                        .filter(
                          (tender) =>
                            tender?.is_in_bidlist &&
                            tender?.is_in_targetlist &&
                            !tender?.is_finalize &&
                            !tender?.is_submitted &&
                            !tender?.is_rejected &&
                            getDaysLeftNumber(
                              tender?.corrigendum_date ||
                                tender?.submission_date,
                            ) > 0,
                        )
                        .filter((ten) => ten.company_name === companySelected)
                        .filter((ten) => ten.sector === "Railway").length
                    }
                  </label>
                </div>
                <div
                  onClick={() => handleTargetSector("Metro")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "8px",
                    backgroundColor:
                      targetSector === "Metro" ? "#2576bc" : "#fafafa",
                    color: targetSector === "Metro" ? "white" : "black",
                    boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
                    borderRadius: "4px",
                  }}
                >
                  <label style={{ cursor: "pointer" }}>
                    Metro:{" "}
                    {
                      filteredData
                        .filter(
                          (tender) =>
                            tender?.is_in_bidlist &&
                            tender?.is_in_targetlist &&
                            !tender?.is_finalize &&
                            !tender?.is_submitted &&
                            !tender?.is_rejected &&
                            getDaysLeftNumber(
                              tender?.corrigendum_date ||
                                tender?.submission_date,
                            ) > 0,
                        )
                        .filter((ten) => ten.company_name === companySelected)
                        .filter((ten) => ten.sector === "Metro").length
                    }
                  </label>
                </div>
                <div
                  onClick={() => handleTargetSector("Water")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "8px",
                    backgroundColor:
                      targetSector === "Water" ? "#2576bc" : "#fafafa",
                    color: targetSector === "Water" ? "white" : "black",
                    boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
                    borderRadius: "4px",
                  }}
                >
                  <label style={{ cursor: "pointer" }}>
                    Water:{" "}
                    {
                      filteredData
                        .filter(
                          (tender) =>
                            tender?.is_in_bidlist &&
                            tender?.is_in_targetlist &&
                            !tender?.is_finalize &&
                            !tender?.is_submitted &&
                            !tender?.is_rejected &&
                            getDaysLeftNumber(
                              tender?.corrigendum_date ||
                                tender?.submission_date,
                            ) > 0,
                        )
                        .filter((ten) => ten.company_name === companySelected)
                        .filter((ten) => ten.sector === "Water").length
                    }
                  </label>
                </div>
                <div
                  onClick={() => handleTargetSector("Ropeway")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "8px",
                    backgroundColor:
                      targetSector === "Ropeway" ? "#2576bc" : "#fafafa",
                    color: targetSector === "Ropeway" ? "white" : "black",
                    boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
                    borderRadius: "4px",
                  }}
                >
                  <label style={{ cursor: "pointer" }}>
                    Ropeway:{" "}
                    {
                      filteredData
                        .filter(
                          (tender) =>
                            tender?.is_in_bidlist &&
                            tender?.is_in_targetlist &&
                            !tender?.is_finalize &&
                            !tender?.is_submitted &&
                            !tender?.is_rejected &&
                            getDaysLeftNumber(
                              tender?.corrigendum_date ||
                                tender?.submission_date,
                            ) > 0,
                        )
                        .filter((ten) => ten.company_name === companySelected)
                        .filter((ten) => ten.sector === "Ropeway").length
                    }
                  </label>
                </div>
                <div
                  onClick={() => handleTargetSector("Building")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "8px",
                    backgroundColor:
                      targetSector === "Building" ? "#2576bc" : "#fafafa",
                    color: targetSector === "Building" ? "white" : "black",
                    boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
                    borderRadius: "4px",
                  }}
                >
                  <label style={{ cursor: "pointer" }}>
                    Building:{" "}
                    {
                      filteredData
                        .filter(
                          (tender) =>
                            tender?.is_in_bidlist &&
                            tender?.is_in_targetlist &&
                            !tender?.is_finalize &&
                            !tender?.is_submitted &&
                            !tender?.is_rejected &&
                            getDaysLeftNumber(
                              tender?.corrigendum_date ||
                                tender?.submission_date,
                            ) > 0,
                        )
                        .filter((ten) => ten.company_name === companySelected)
                        .filter((ten) => ten.sector === "Building").length
                    }
                  </label>
                </div>
                <div
                  onClick={() => handleTargetSector("Other")}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                    padding: "8px",
                    backgroundColor:
                      targetSector === "Other" ? "#2576bc" : "#fafafa",
                    color: targetSector === "Other" ? "white" : "black",
                    boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
                    borderRadius: "4px",
                  }}
                >
                  <label style={{ cursor: "pointer" }}>
                    Building:{" "}
                    {
                      filteredData
                        .filter(
                          (tender) =>
                            tender?.is_in_bidlist &&
                            tender?.is_in_targetlist &&
                            !tender?.is_finalize &&
                            !tender?.is_submitted &&
                            !tender?.is_rejected &&
                            getDaysLeftNumber(
                              tender?.corrigendum_date ||
                                tender?.submission_date,
                            ) > 0,
                        )
                        .filter((ten) => ten.company_name === companySelected)
                        .filter((ten) => ten.sector === "Other").length
                    }
                  </label>
                </div>
              </div>
            )}

            {targetSector !== "" && (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "12px",
                  marginTop: "10px",
                  flexWrap: "wrap",
                }}
              >
                {[
                  "Feasibility",
                  "DPR",
                  "FesibilityCumDPR",
                  "Authority_Engineer",
                  "Independent_Engineer",
                  "PSSA",
                  "PMC",
                  "GC",
                  "O&M",
                  "Supervision",
                  "Other",
                ].map((type) => (
                  <div
                    key={type}
                    onClick={() => handleTargetTenderType(type)}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      cursor: "pointer",
                      padding: "8px",
                      backgroundColor:
                        targetTenderType === type ? "#2576bc" : "#fafafa",
                      color: targetTenderType === type ? "white" : "black",
                      boxShadow: "0 0 5px 0 rgba(0, 0, 0, 0.3)",
                      borderRadius: "4px",
                    }}
                  >
                    <label style={{ cursor: "pointer" }}>
                      {type}:{" "}
                      {
                        filteredData
                          .filter(
                            (tender) =>
                              tender?.is_in_bidlist &&
                              tender?.is_in_targetlist &&
                              !tender?.is_finalize &&
                              !tender?.is_submitted &&
                              !tender?.is_rejected &&
                              getDaysLeftNumber(
                                tender?.corrigendum_date ||
                                  tender?.submission_date,
                              ) > 0,
                          )
                          .filter((ten) => ten.sector === targetSector)
                          .filter((ten) => ten.tender_type === type).length
                      }
                    </label>
                  </div>
                ))}
              </div>
            )}
          </div>

          {buffer ? (
            <div className="spinner-bgdatil"></div>
          ) : error ? (
            <p
              style={{ color: "#d32f2f", padding: "16px", textAlign: "center" }}
            >
              Error fetching data: {error?.message}
            </p>
          ) : filteredData?.length === 0 ? (
            <div
              className="tender-item"
              style={{ textAlign: "center", padding: "32px 16px" }}
            >
              <div
                className="tender-description"
                style={{ fontSize: "16px", color: "#666" }}
              >
                📭 No bids found. Add your first bid to get started.
              </div>
            </div>
          ) : (
            filteredData
              // ?.filter((i) => {
              //     switch (toggleState) {

              //         case 1:
              //             return (i?.is_in_bidlist ||
              //                 i?.is_in_targetlist ||
              //                 i?.is_finalize ||
              //                 i?.is_bid_prepare_in_progress ||
              //                 !i?.is_submitted ||
              //                 !i?.is_rejected || !i?.is_cancelled) &&
              //                 (() => {
              //                     const daysLeft = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date);
              //                     if (submissionDateFilter) {
              //                         return daysLeft > 0 && daysLeft <= submissionDateFilter;
              //                     } else {
              //                         return daysLeft > 0;
              //                     }
              //                 })();
              //         case 2:
              //             return i?.is_in_bidlist &&
              //                 !i?.is_in_targetlist &&
              //                 !i?.is_finalize &&
              //                 !i?.is_submitted &&
              //                 !i?.is_rejected && !i?.is_cancelled &&
              //                 (() => {
              //                     const daysLeft = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date);
              //                     return daysLeft >= 0;
              //                 })();
              //         case 3:
              //             return i?.is_in_bidlist &&
              //                 i?.is_in_targetlist &&
              //                 !i?.is_finalize &&
              //                 !i?.is_submitted &&
              //                 !i?.is_rejected && !i?.is_cancelled &&
              //                 (() => {
              //                     const daysLeft = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date);
              //                     return daysLeft >= 0;
              //                 })();
              //         case 4:
              //             return i?.is_in_bidlist &&
              //                 i?.is_in_targetlist &&
              //                 i?.is_finalize &&
              //                 !i.is_bid_prepare_in_progress &&
              //                 !i?.is_submitted &&
              //                 !i?.is_rejected && !i?.is_cancelled &&
              //                 (() => {
              //                     const daysLeft = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date);
              //                     return daysLeft >= 0;
              //                 })();
              //         case 5:
              //             return i?.is_in_bidlist &&
              //                 i?.is_in_targetlist &&
              //                 i?.is_finalize &&
              //                 i?.is_submitted &&
              //                 !i?.is_rejected && !i?.is_cancelled

              //         case 6:
              //             return i?.is_rejected || i?.is_cancelled

              //         case 7:
              //             const daysLeft = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date);
              //             return daysLeft < 0 && !i.is_submitted;
              //         case 9:
              //             return i?.is_in_bidlist &&
              //                 i?.is_in_targetlist &&
              //                 i?.is_finalize &&
              //                 i?.is_bid_prepare_in_progress &&
              //                 !i?.is_submitted &&
              //                 !i?.is_rejected && !i?.is_cancelled &&
              //                 (() => {
              //                     const daysLeft = i?.corrigendum_date ? getDaysLeftNumber(i?.corrigendum_date) : getDaysLeftNumber(i?.submission_date);
              //                     if (submissionDateFilter) {
              //                         return daysLeft >= 0 && daysLeft <= submissionDateFilter;
              //                     } else {
              //                         return daysLeft >= 0;
              //                     }
              //                 })();
              //         default:
              //             return true;
              //     }

              // })
              // filteredData
              ?.filter((i) => {
                const daysLeft = i?.corrigendum_date
                  ? getDaysLeftNumber(i?.corrigendum_date)
                  : getDaysLeftNumber(i?.submission_date);

                switch (toggleState) {
                  case 0: // ✅ ALL
                    return (
                      (i?.is_in_bidlist ||
                        i?.is_in_targetlist ||
                        i?.is_finalize ||
                        i?.is_bid_prepare_in_progress ||
                        !i?.is_submitted ||
                        !i?.is_rejected ||
                        !i?.is_cancelled) &&
                      (() => {
                        const daysLeft = i?.corrigendum_date
                          ? getDaysLeftNumber(i?.corrigendum_date)
                          : getDaysLeftNumber(i?.submission_date);
                        if (submissionDateFilter) {
                          return (
                            daysLeft > 0 && daysLeft <= submissionDateFilter
                          );
                        } else {
                          return daysLeft > 0;
                        }
                      })()
                    );

                  case 1: // 🆕 NEW
                    return (
                      !i?.is_in_bidlist &&
                      !i?.is_in_targetlist &&
                      !i?.is_finalize &&
                      !i?.is_submitted &&
                      !i?.is_rejected &&
                      !i?.is_cancelled &&
                      daysLeft > 0
                    );

                  case 2: // ⭐ Wishlist
                    return (
                      i?.is_in_bidlist &&
                      !i?.is_in_targetlist &&
                      !i?.is_finalize &&
                      !i?.is_submitted &&
                      !i?.is_rejected &&
                      !i?.is_cancelled &&
                      daysLeft > 0
                    );

                  case 3: // 🎯 Target
                    return (
                      i?.is_in_bidlist &&
                      i?.is_in_targetlist &&
                      !i?.is_finalize &&
                      !i?.is_submitted &&
                      !i?.is_rejected &&
                      !i?.is_cancelled &&
                      daysLeft > 0
                    );

                  case 4: // 📑 Final
                    return (
                      i?.is_in_bidlist &&
                      i?.is_in_targetlist &&
                      i?.is_finalize &&
                      !i?.is_bid_prepare_in_progress &&
                      !i?.is_submitted &&
                      !i?.is_rejected &&
                      !i?.is_cancelled &&
                      daysLeft > 0
                    );

                  case 9: // 🔄 Bid Prepare
                    return (
                      i?.is_in_bidlist &&
                      i?.is_in_targetlist &&
                      i?.is_finalize &&
                      i?.is_bid_prepare_in_progress &&
                      !i?.is_submitted &&
                      !i?.is_rejected &&
                      !i?.is_cancelled &&
                      daysLeft > 0
                    );

                  case 5: // ✅ Submitted
                    return (
                      i?.is_submitted && !i?.is_rejected && !i?.is_cancelled
                    );

                  case 6: // ❌ Rejected
                    return i?.is_rejected || i?.is_cancelled;

                  case 7: // ⏰ Expired
                    return daysLeft < 0 && !i?.is_submitted;

                  default:
                    return true;
                }
              })

              ?.filter((i) =>
                companySelected !== ""
                  ? i.company_name === companySelected
                  : true,
              )
              ?.filter((i) =>
                targetSector !== "" ? i.sector === targetSector : true,
              )
              ?.filter((i) =>
                targetTenderType !== ""
                  ? i.tender_type === targetTenderType
                  : true,
              )
              ?.sort((a, b) =>
                !submissionDateFilter
                  ? new Date(b.created_at) - new Date(a.created_at)
                  : (() => {
                      const dateA = a?.corrigendum_date
                        ? a.corrigendum_date
                        : a?.submission_date;

                      const dateB = b?.corrigendum_date
                        ? b.corrigendum_date
                        : b?.submission_date;

                      return (
                        getDaysLeftNumber(dateA) - getDaysLeftNumber(dateB)
                      );
                    })(),
              )
              .map((i, index) => (
                <>
                  <div
                    className="tender-item"
                    key={i.id}
                    data-tender-id={i.tender_id}
                    transition={{ duration: 0.3 }}
                    whileHover={{ boxShadow: "0 10px 20px rgba(0,0,0,0.1)" }}
                    style={{
                      background: i.is_discussed
                        ? "#FFF9C4"
                        : i.corrigendum_date
                          ? "#FAF9F6"
                          : "transparent",
                      borderWidth: i.corrigendum_date ? "2px" : "1px",
                    }}
                  >
                    <div className="tender-detail-header">
                      <div className="tender_basic_detail">
                        <span
                          className="tender_head_id"
                          style={{ fontWeight: "800", color: "black" }}
                        >
                          {index + 1}
                        </span>
                        <div
                          className="vertical-divider"
                          style={{
                            margin: "0px 20px",
                            background: "black",
                            height: "20px",
                          }}
                        ></div>
                        <span
                          className="tender_head_id"
                          style={{ fontWeight: "800", color: "black" }}
                        >
                          {i.tender_id || "N/A"}
                        </span>
                        <div
                          className="vertical-divider"
                          style={{
                            margin: "0px 20px",
                            background: "black",
                            height: "20px",
                          }}
                        ></div>
                        <span
                          className="tender_head_id"
                          style={{ fontWeight: "800", color: "black" }}
                        >
                          {i.is_special_tender && (
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 24 24"
                              width="24"
                              height="24"
                            >
                              <circle
                                cx="12"
                                cy="12"
                                r="12"
                                fill="rgb(37,118,188)"
                              />
                              <path
                                d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z"
                                fill="#fff"
                              />
                            </svg>
                          )}
                          {console.log(i.corrigendum_date, "coreegddidi")}{" "}
                          {i.corrigendum_date ? (
                            <>
                              {getDaysLeftNumber(i?.corrigendum_date) < 0 ? (
                                <span
                                  style={{
                                    width: "74px",
                                    height: "21px",
                                    padding: "2px 5px",
                                    gap: "10px",
                                    opacity: 1,
                                    borderRadius: "3px",
                                    background: "#fff",
                                    color: "red",
                                    marginRight: "2px",
                                  }}
                                >
                                  Expired
                                </span>
                              ) : (
                                <span
                                  style={{
                                    width: "74px",
                                    height: "21px",
                                    padding: "2px 5px",
                                    gap: "10px",
                                    opacity: 1,
                                    borderRadius: "3px",
                                    color: "red",
                                    marginRight: "2px",
                                  }}
                                >
                                  {" "}
                                  {`Days Left ${getDaysLeftNumber(i?.corrigendum_date)}`}
                                </span>
                              )}
                            </>
                          ) : (
                            <>
                              {getDaysLeftNumber(i?.submission_date) < 0 ? (
                                <span
                                  style={{
                                    width: "74px",
                                    height: "21px",
                                    padding: "2px 5px",
                                    gap: "10px",
                                    opacity: 1,
                                    borderRadius: "3px",
                                    background: "#fff",
                                    color: "red",
                                    marginRight: "2px",
                                  }}
                                >
                                  Expired
                                </span>
                              ) : (
                                <span
                                  style={{
                                    width: "74px",
                                    height: "21px",
                                    padding: "2px 5px",
                                    gap: "10px",
                                    opacity: 1,
                                    borderRadius: "3px",
                                    color: "red",
                                    marginRight: "2px",
                                  }}
                                >{`${getDaysLeftNumber(i?.submission_date)} ${getDaysLeftNumber(i?.submission_date) > 1 ? "Days" : "Day"} Left`}</span>
                              )}
                            </>
                          )}
                        </span>
                        <div
                          className="vertical-divider"
                          style={{
                            margin: "0px 20px",
                            background: "black",
                            height: "20px",
                          }}
                        ></div>
                        <span
                          className="tender_head_id"
                          style={{ fontWeight: "800", color: "black" }}
                        >
                          {i.client
                            ?.replace(/[-_]/g, " ")
                            ?.replace(/\s+/g, " ")
                            ?.trim()
                            ?.toUpperCase()}
                        </span>
                        <div
                          className="vertical-divider"
                          style={{
                            margin: "0px 20px",
                            background: "black",
                            height: "20px",
                          }}
                        ></div>
                        <span
                          className="tender_head_id"
                          style={{ fontWeight: "800", color: "black" }}
                        >
                          {i.tender_type
                            ?.replace(/[-_]/g, " ")
                            ?.replace(/\s+/g, " ")
                            ?.trim()
                            ?.toUpperCase()}
                        </span>
                        <div
                          className="vertical-divider"
                          style={{
                            margin: "0px 20px",
                            background: "black",
                            height: "20px",
                          }}
                        ></div>
                        <span
                          className="tender_head_id"
                          style={{ fontWeight: "800", color: "black" }}
                        >
                          {i?.lane
                            ? i.lane.toLowerCase() === "rfp_not_uploaded"
                              ? "Not Available"
                              : `${i.lane
                                  .replace(/[-_]/g, " ")
                                  .replace(/\s+/g, " ")
                                  .trim()
                                  .toUpperCase()} Lane`
                            : "N/A"}
                        </span>
                        <div
                          className="vertical-divider"
                          style={{
                            margin: "0px 20px",
                            background: "black",
                            height: "20px",
                          }}
                        ></div>
                        <span
                          className="tender_head_id"
                          style={{ fontWeight: "800", color: "black" }}
                        >
                          {i.length ? `${i.length} Km` : " N/A"}
                        </span>
                        <div
                          className="vertical-divider"
                          style={{
                            margin: "0px 20px",
                            background: "black",
                            height: "20px",
                          }}
                        ></div>
                        <span
                          className="tender_head_id"
                          style={{ fontWeight: "800", color: "black" }}
                        >
                          {i.tat_duration ? (
                            i?.tat_duration < 10 ? (
                              <span style={{ color: "red" }}>
                                {" "}
                                {`Bid Preparation Days ${i.tat_duration} Days`}
                              </span>
                            ) : (
                              <span>
                                {" "}
                                {`Bid Preparation Days ${i.tat_duration} Days`}
                              </span>
                            )
                          ) : (
                            " N/A"
                          )}
                        </span>

                        {i.assigned_to_detail?.length > 0 &&
                          i.assigned_to_detail?.map((assignee, idx) => {
                            return (
                              <span
                                className="tender_head_id"
                                style={{ fontWeight: "800", color: "black" }}
                              >
                                {assignee.name}
                              </span>
                            );
                          })}
                      </div>

                      <div
                        className="date-hover-wrapper"
                        style={{
                          height: "50px",
                          width: "15%",
                          position: "relative",
                        }}
                      >
                        {/* Date Icon */}
                        <span className="date-icon">📅</span>

                        {/* Hover Card */}
                        <div className="date-tooltip">
                          <p>
                            <strong>Screening Date:</strong>{" "}
                            {formatDateIndian(i.created_at)}
                          </p>

                          <p>
                            <strong>Final List Moved:</strong>{" "}
                            {formatDateIndian(i.date_cc)}
                          </p>

                          <p>
                            <strong>Submit List Moved:</strong>{" "}
                            {formatDateIndian(i.date_ee)}
                          </p>

                          <p>
                            <strong>Bid In Progress:</strong>{" "}
                            {formatDateIndian(i.date_ff)}
                          </p>
                        </div>
                      </div>

                      <div
                        className="tender_detail_button"
                        style={{
                          width: "10%",
                          display: "flex",
                          gap: "10px",
                          alignItems: "center",
                        }}
                      >
                        <button
                          title="Mark as Document"
                          style={{
                            borderRadius: "50%",
                            width: "42px",
                            height: "42px",
                            backgroundColor: i.mark_as_document
                              ? "#28a745"
                              : "#e0e0e0",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                            transition: "0.25s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.transform = "scale(1.1)")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.transform = "scale(1)")
                          }
                        >
                          {i.mark_as_document ? (
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="white"
                            >
                              <path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z" />
                            </svg>
                          ) : (
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="white"
                            >
                              <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                            </svg>
                          )}
                        </button>

                        <button
                          title="Mark as CV"
                          style={{
                            borderRadius: "50%",
                            width: "42px",
                            height: "42px",
                            backgroundColor: i.mark_as_cv
                              ? "#28a745"
                              : "#e0e0e0",
                            color: "white",
                            border: "none",
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                            transition: "0.25s ease",
                          }}
                          onMouseEnter={(e) =>
                            (e.target.style.transform = "scale(1.1)")
                          }
                          onMouseLeave={(e) =>
                            (e.target.style.transform = "scale(1)")
                          }
                        >
                          {i.mark_as_cv ? (
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="white"
                            >
                              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" />
                              <path
                                d="M10 14l2 2 4-4"
                                stroke="white"
                                strokeWidth="2"
                                fill="none"
                              />
                            </svg>
                          ) : (
                            <svg
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="white"
                            >
                              <path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8l-6-6z" />
                              <path
                                d="M14.5 13.5l-5 5M9.5 13.5l5 5"
                                stroke="white"
                                strokeWidth="2"
                              />
                            </svg>
                          )}
                        </button>
                        <button
                          className="view_button"
                          style={{ borderRadius: "50%" }}
                          onClick={() => ViewAllBidDetails(i.id, i)}
                        >
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M21.544 11.045C21.848 11.471 22 11.685 22 12C22 12.316 21.848 12.529 21.544 12.955C20.178 14.871 16.689 19 12 19C7.31 19 3.822 14.87 2.456 12.955C2.152 12.529 2 12.315 2 12C2 11.684 2.152 11.471 2.456 11.045C3.822 9.129 7.311 5 12 5C16.69 5 20.178 9.13 21.544 11.045Z"
                              stroke="#2576BC"
                              stroke-width="1.5"
                            />
                            <path
                              d="M15 12C15 11.2044 14.6839 10.4413 14.1213 9.87868C13.5587 9.31607 12.7956 9 12 9C11.2044 9 10.4413 9.31607 9.87868 9.87868C9.31607 10.4413 9 11.2044 9 12C9 12.7956 9.31607 13.5587 9.87868 14.1213C10.4413 14.6839 11.2044 15 12 15C12.7956 15 13.5587 14.6839 14.1213 14.1213C14.6839 13.5587 15 12.7956 15 12Z"
                              stroke="#2576BC"
                              stroke-width="1.5"
                            />
                          </svg>
                        </button>
                      </div>
                    </div>
                    <div
                      className="tender-detail-header"
                      style={{ padding: "0px 10px 10px 10px" }}
                    >
                      <span className="tender_head_name">{i.tender_name}</span>
                    </div>
                    <div className="expense-table-cont expense-bloc-tabs">
                      <div className="left-expense-bloc-tab wfm-margin">
                        <button
                          className={
                            "expense-tab " +
                            (toggle === 4
                              ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs dashboardcomponent-tabss expense-active-tab"
                              : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss expense-inactive-tab")
                          }
                          onClick={() => {
                            SetShowToggle(4);
                          }}
                        >
                          Basic Details
                        </button>
                        <button
                          className={
                            "expense-tab " +
                            (toggle === 1
                              ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs dashboardcomponent-tabss expense-active-tab"
                              : "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-tabss expense-inactive-tab")
                          }
                          onClick={() => {
                            SetShowToggle(1);
                          }}
                        >
                          Eligibility Critria
                        </button>
                        <button
                          className={
                            "expense-tab " +
                            (toggle === 2
                              ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs expense-active-tab"
                              : "dashboardcomponent-tabs  font-weight400  font-size-subheading   expense-inactive-tab")
                          }
                          onClick={() => {
                            SetShowToggle(2);
                          }}
                        >
                          Partner Details
                        </button>

                        <button
                          className={
                            "expense-tab " +
                            (toggle === 3
                              ? "dashboardcomponent-tabs  font-weight400  font-size-subheading   dashboardcomponent-active-tabs expense-active-tab"
                              : "dashboardcomponent-tabs  font-weight400  font-size-subheading   expense-inactive-tab")
                          }
                          onClick={() => {
                            SetShowToggle(3);
                          }}
                        >
                          Tender Documents
                        </button>
                      </div>
                    </div>
                    <div className="tender-detail-middle justify-evenly">
                      {toggle === 4 && (
                        <>
                          <div className="tender-detail-advanced-check">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                {i.special_tender && (
                                  <tr className="">
                                    <td
                                      className="tender-detail-box-text-lable"
                                      style={{ paddingBottom: "5px" }}
                                    >
                                      <svg
                                        width="16"
                                        height="17"
                                        viewBox="0 0 16 17"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <path
                                          d="M8.00133 9.5C7.50688 9.5 7.02353 9.35338 6.6124 9.07868C6.20128 8.80397 5.88085 8.41353 5.69163 7.95671C5.50241 7.49989 5.4529 6.99723 5.54937 6.51228C5.64583 6.02732 5.88393 5.58187 6.23356 5.23223C6.58319 4.8826 7.02865 4.6445 7.5136 4.54804C7.99856 4.45157 8.50122 4.50108 8.95804 4.6903C9.41485 4.87952 9.8053 5.19995 10.08 5.61108C10.3547 6.0222 10.5013 6.50555 10.5013 7C10.5005 7.6628 10.2369 8.29822 9.76822 8.76689C9.29955 9.23556 8.66413 9.49921 8.00133 9.5ZM8.00133 5.5C7.70466 5.5 7.41465 5.58797 7.16797 5.7528C6.9213 5.91762 6.72904 6.15189 6.61551 6.42598C6.50198 6.70007 6.47227 7.00167 6.53015 7.29264C6.58803 7.58361 6.73089 7.85088 6.94067 8.06066C7.15045 8.27044 7.41772 8.4133 7.70869 8.47118C7.99967 8.52906 8.30127 8.49935 8.57535 8.38582C8.84944 8.27229 9.08371 8.08003 9.24853 7.83336C9.41336 7.58668 9.50133 7.29667 9.50133 7C9.50093 6.6023 9.34277 6.221 9.06155 5.93978C8.78033 5.65856 8.39903 5.5004 8.00133 5.5Z"
                                          fill="#1E1E1E"
                                          fill-opacity="0.6"
                                        />
                                        <path
                                          d="M8.00133 15.5L3.78333 10.5255C3.72472 10.4508 3.66672 10.3756 3.60933 10.3C2.88918 9.3507 2.49999 8.19155 2.50133 7C2.50133 5.54131 3.08079 4.14236 4.11224 3.11091C5.14369 2.07946 6.54264 1.5 8.00133 1.5C9.46002 1.5 10.859 2.07946 11.8904 3.11091C12.9219 4.14236 13.5013 5.54131 13.5013 7C13.5025 8.19098 13.1135 9.34954 12.3938 10.2985L12.3933 10.3C12.3933 10.3 12.2433 10.497 12.2208 10.5235L8.00133 15.5ZM4.40783 9.6975C4.40783 9.6975 4.52433 9.8515 4.55083 9.8845L8.00133 13.954L11.4563 9.879C11.4783 9.8515 11.5953 9.6965 11.5958 9.696C12.1844 8.92057 12.5025 7.97352 12.5013 7C12.5013 5.80653 12.0272 4.66193 11.1833 3.81802C10.3394 2.97411 9.19481 2.5 8.00133 2.5C6.80786 2.5 5.66326 2.97411 4.81935 3.81802C3.97544 4.66193 3.50133 5.80653 3.50133 7C3.5001 7.97415 3.81855 8.92179 4.40783 9.6975Z"
                                          fill="#1E1E1E"
                                          fill-opacity="0.6"
                                        />
                                      </svg>{" "}
                                      Special Structure Type
                                    </td>
                                    <td style={{ padding: "0px 2px" }}>:</td>
                                    <td className="tender-detail-box-text-value word-wrap-10vw">
                                      {i?.special_structure_type}
                                    </td>
                                  </tr>
                                )}

                                <tr className="">
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <svg
                                      width="12"
                                      height="15"
                                      viewBox="0 0 12 15"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M6.39734 14.0053L6.38934 14.0066L6.342 14.03L6.32867 14.0326L6.31934 14.03L6.272 14.006C6.26489 14.0042 6.25956 14.0055 6.256 14.01L6.25334 14.0166L6.242 14.302L6.24534 14.3153L6.252 14.324L6.32133 14.3733L6.33134 14.376L6.33934 14.3733L6.40867 14.324L6.41667 14.3133L6.41934 14.302L6.408 14.0173C6.40622 14.0102 6.40267 14.0062 6.39734 14.0053ZM6.57334 13.93L6.564 13.9313L6.44134 13.9933L6.43467 14L6.43267 14.0073L6.44467 14.294L6.448 14.302L6.45334 14.3073L6.58733 14.3686C6.59578 14.3709 6.60222 14.3691 6.60667 14.3633L6.60933 14.354L6.58667 13.9446C6.58445 13.9362 6.58 13.9313 6.57334 13.93ZM6.09667 13.9313C6.09373 13.9295 6.09022 13.929 6.08687 13.9297C6.08351 13.9304 6.08058 13.9325 6.07867 13.9353L6.07467 13.9446L6.052 14.354C6.05245 14.362 6.05622 14.3673 6.06334 14.37L6.07334 14.3686L6.20734 14.3066L6.214 14.3013L6.216 14.294L6.228 14.0073L6.226 13.9993L6.21933 13.9926L6.09667 13.9313Z"
                                        fill="#1E1E1E"
                                        fill-opacity="0.6"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M0.00132751 1.83331C0.00132751 1.10864 0.596661 0.473306 1.37599 0.521973C4.13168 0.694427 6.72962 1.86693 8.682 3.8193C10.6344 5.77168 11.8069 8.36962 11.9793 11.1253C12.028 11.9046 11.3927 12.5 10.668 12.5H1.33466C0.981039 12.5 0.6419 12.3595 0.391852 12.1094C0.141803 11.8594 0.00132751 11.5203 0.00132751 11.1666V1.83331ZM1.33466 1.85531V11.1666H10.646C10.4846 8.75022 9.45177 6.47448 7.73929 4.76201C6.02682 3.04953 3.75108 2.0167 1.33466 1.85531Z"
                                        fill="#1E1E1E"
                                        fill-opacity="0.6"
                                      />
                                    </svg>{" "}
                                    Published date
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {formatDateDDMMYYYYmonthNew(
                                      i?.publish_date,
                                    )}
                                  </td>
                                </tr>
                                <tr className="">
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <svg
                                      width="12"
                                      height="15"
                                      viewBox="0 0 12 15"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M6.39734 14.0053L6.38934 14.0066L6.342 14.03L6.32867 14.0326L6.31934 14.03L6.272 14.006C6.26489 14.0042 6.25956 14.0055 6.256 14.01L6.25334 14.0166L6.242 14.302L6.24534 14.3153L6.252 14.324L6.32133 14.3733L6.33134 14.376L6.33934 14.3733L6.40867 14.324L6.41667 14.3133L6.41934 14.302L6.408 14.0173C6.40622 14.0102 6.40267 14.0062 6.39734 14.0053ZM6.57334 13.93L6.564 13.9313L6.44134 13.9933L6.43467 14L6.43267 14.0073L6.44467 14.294L6.448 14.302L6.45334 14.3073L6.58733 14.3686C6.59578 14.3709 6.60222 14.3691 6.60667 14.3633L6.60933 14.354L6.58667 13.9446C6.58445 13.9362 6.58 13.9313 6.57334 13.93ZM6.09667 13.9313C6.09373 13.9295 6.09022 13.929 6.08687 13.9297C6.08351 13.9304 6.08058 13.9325 6.07867 13.9353L6.07467 13.9446L6.052 14.354C6.05245 14.362 6.05622 14.3673 6.06334 14.37L6.07334 14.3686L6.20734 14.3066L6.214 14.3013L6.216 14.294L6.228 14.0073L6.226 13.9993L6.21933 13.9926L6.09667 13.9313Z"
                                        fill="#1E1E1E"
                                        fill-opacity="0.6"
                                      />
                                      <path
                                        fill-rule="evenodd"
                                        clip-rule="evenodd"
                                        d="M0.00132751 1.83331C0.00132751 1.10864 0.596661 0.473306 1.37599 0.521973C4.13168 0.694427 6.72962 1.86693 8.682 3.8193C10.6344 5.77168 11.8069 8.36962 11.9793 11.1253C12.028 11.9046 11.3927 12.5 10.668 12.5H1.33466C0.981039 12.5 0.6419 12.3595 0.391852 12.1094C0.141803 11.8594 0.00132751 11.5203 0.00132751 11.1666V1.83331ZM1.33466 1.85531V11.1666H10.646C10.4846 8.75022 9.45177 6.47448 7.73929 4.76201C6.02682 3.04953 3.75108 2.0167 1.33466 1.85531Z"
                                        fill="#1E1E1E"
                                        fill-opacity="0.6"
                                      />
                                    </svg>{" "}
                                    Sector
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.sector}
                                  </td>
                                </tr>

                                <tr className="">
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M5.42989 3.35712C5.09221 3.35712 4.75783 3.42363 4.44585 3.55286C4.13387 3.68208 3.8504 3.87149 3.61162 4.11027C3.37284 4.34905 3.18343 4.63252 3.0542 4.9445C2.92498 5.25648 2.85847 5.59086 2.85847 5.92854C2.85847 6.26623 2.92498 6.60061 3.0542 6.91259C3.18343 7.22457 3.37284 7.50804 3.61162 7.74682C3.8504 7.9856 4.13387 8.17501 4.44585 8.30424C4.75783 8.43346 5.09221 8.49997 5.42989 8.49997C6.11188 8.49997 6.76593 8.22906 7.24817 7.74682C7.73041 7.26458 8.00132 6.61053 8.00132 5.92854C8.00132 5.24656 7.73041 4.59251 7.24817 4.11027C6.76593 3.62803 6.11188 3.35712 5.42989 3.35712ZM3.71561 5.92854C3.71561 5.70342 3.75995 5.4805 3.8461 5.27252C3.93225 5.06453 4.05853 4.87555 4.21771 4.71636C4.3769 4.55718 4.56588 4.4309 4.77387 4.34475C4.98185 4.2586 5.20477 4.21426 5.42989 4.21426C5.65502 4.21426 5.87794 4.2586 6.08592 4.34475C6.29391 4.4309 6.48289 4.55718 6.64208 4.71636C6.80126 4.87555 6.92754 5.06453 7.01369 5.27252C7.09984 5.4805 7.14418 5.70342 7.14418 5.92854C7.14418 6.3832 6.96357 6.81924 6.64208 7.14073C6.32059 7.46222 5.88455 7.64283 5.42989 7.64283C4.97524 7.64283 4.5392 7.46222 4.21771 7.14073C3.89622 6.81924 3.71561 6.3832 3.71561 5.92854ZM11.4299 4.49997C10.8995 4.49997 10.3908 4.71069 10.0157 5.08576C9.64061 5.46083 9.4299 5.96954 9.4299 6.49997C9.4299 7.03041 9.64061 7.53911 10.0157 7.91419C10.3908 8.28926 10.8995 8.49997 11.4299 8.49997C11.9603 8.49997 12.469 8.28926 12.8441 7.91419C13.2192 7.53911 13.4299 7.03041 13.4299 6.49997C13.4299 5.96954 13.2192 5.46083 12.8441 5.08576C12.469 4.71069 11.9603 4.49997 11.4299 4.49997ZM10.287 6.49997C10.287 6.19687 10.4074 5.90618 10.6218 5.69185C10.8361 5.47752 11.1268 5.35712 11.4299 5.35712C11.733 5.35712 12.0237 5.47752 12.238 5.69185C12.4523 5.90618 12.5728 6.19687 12.5728 6.49997C12.5728 6.80308 12.4523 7.09377 12.238 7.3081C12.0237 7.52242 11.733 7.64283 11.4299 7.64283C11.1268 7.64283 10.8361 7.52242 10.6218 7.3081C10.4074 7.09377 10.287 6.80308 10.287 6.49997ZM1.14418 10.9285C1.14418 10.5876 1.27964 10.2605 1.52076 10.0194C1.76188 9.77829 2.0889 9.64283 2.42989 9.64283H8.42989C8.77089 9.64283 9.09791 9.77829 9.33903 10.0194C9.58015 10.2605 9.71561 10.5876 9.71561 10.9285V11.232C9.71517 11.2782 9.71193 11.3244 9.70589 11.3703C9.69303 11.4881 9.67203 11.605 9.64304 11.72C9.54838 12.0951 9.37997 12.4477 9.14761 12.7571C8.56818 13.5303 7.46304 14.2143 5.42989 14.2143C3.39675 14.2143 2.29161 13.5303 1.71218 12.7571C1.48003 12.4477 1.3118 12.0951 1.21732 11.72C1.17993 11.5706 1.15602 11.4182 1.14589 11.2645L1.14418 11.232V10.9285ZM2.00132 11.2114V11.2217L2.00647 11.2788C2.01218 11.3325 2.02361 11.4131 2.04875 11.512C2.11538 11.7763 2.23386 12.0247 2.39732 12.2428C2.78247 12.7554 3.60589 13.3571 5.42989 13.3571C7.25389 13.3571 8.07732 12.7554 8.46189 12.2428C8.66189 11.9765 8.76132 11.7103 8.81047 11.512C8.83456 11.4167 8.85043 11.3196 8.85789 11.2217L8.85847 11.2114V10.9285C8.85847 10.8149 8.81331 10.7059 8.73294 10.6255C8.65257 10.5451 8.54356 10.5 8.42989 10.5H2.42989C2.31623 10.5 2.20722 10.5451 2.12685 10.6255C2.04648 10.7059 2.00132 10.8149 2.00132 10.9285V11.2114ZM9.77275 12.8543C10.2145 12.9897 10.7596 13.0714 11.4288 13.0714C13.0116 13.0714 13.8962 12.6165 14.3768 12.068C14.5686 11.8507 14.7109 11.5943 14.7939 11.3165C14.8263 11.2043 14.8472 11.089 14.8562 10.9725L14.8573 10.9457V10.9285C14.8573 10.5876 14.7219 10.2605 14.4807 10.0194C14.2396 9.77829 13.9126 9.64283 13.5716 9.64283H9.76932C9.99447 9.87769 10.159 10.172 10.2368 10.5H13.5722C13.6849 10.5 13.793 10.5443 13.8732 10.6235C13.9534 10.7026 13.9993 10.8102 14.0008 10.9228L13.9979 10.9491C13.9922 10.9922 13.9832 11.0348 13.971 11.0765C13.9228 11.2345 13.8409 11.3801 13.731 11.5034C13.4619 11.812 12.847 12.2143 11.4288 12.2143C10.891 12.2143 10.4688 12.1565 10.1368 12.0674C10.0492 12.344 9.92689 12.6084 9.77275 12.8543Z"
                                        fill="#1E1E1E"
                                        fill-opacity="0.6"
                                      />
                                    </svg>{" "}
                                    Rfp Uploaded{" "}
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {" "}
                                    {i?.rfp_doc?.length === 0 ? (
                                      <span style={{ color: "red" }}>No</span>
                                    ) : (
                                      <span>Yes</span>
                                    )}
                                  </td>
                                </tr>

                                <tr className="">
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g clip-path="url(#clip0_20_625)">
                                        <path
                                          d="M4.00133 3.63996C4.52133 4.11396 5.59333 5.40863 5.71799 6.79796C5.80133 7.72796 6.26466 8.53329 7.00133 8.92063C7.29399 9.07396 7.62933 9.16263 8.00133 9.16663C8.50466 9.17196 9.01333 8.80863 9.01199 8.30529C9.01199 8.14996 8.98599 7.99063 8.94599 7.84396C8.87866 7.61925 8.89842 7.37743 9.00133 7.16663C9.40799 6.32863 10.208 6.10329 10.8413 5.64796C11.122 5.44596 11.3787 5.23263 11.4913 5.06129C11.804 4.58796 12.116 3.64063 11.96 3.16663"
                                          stroke="#1E1E1E"
                                          stroke-opacity="0.6"
                                          stroke-width="1.5"
                                        />
                                        <path
                                          d="M14.668 9.16663C14.448 9.78729 14.2933 11.4166 11.8133 11.4426C11.8133 11.4426 11.2847 11.4426 10.668 11.5893M8.95933 12.684C8.43199 13.6773 8.73933 14.7526 8.95933 15.1666"
                                          stroke="#1E1E1E"
                                          stroke-opacity="0.6"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                        />
                                        <path
                                          d="M4.66799 14.2746C5.68108 14.8605 6.83102 15.1683 8.00132 15.1666C11.6833 15.1666 14.668 12.182 14.668 8.49998C14.668 4.81798 11.6833 1.83331 8.00132 1.83331C4.31932 1.83331 1.33466 4.81798 1.33466 8.49998C1.33466 9.71398 1.65932 10.8533 2.22666 11.8333"
                                          stroke="#1E1E1E"
                                          stroke-opacity="0.6"
                                          stroke-width="1.5"
                                          stroke-linecap="round"
                                        />
                                      </g>
                                      <defs>
                                        <clipPath id="clip0_20_625">
                                          <rect
                                            width="16"
                                            height="16"
                                            fill="white"
                                            transform="translate(0.00132751 0.5)"
                                          />
                                        </clipPath>
                                      </defs>
                                    </svg>{" "}
                                    Regional Office
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.ro}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div className="vertical-divider"></div>
                          <div className="tender-detail-advanced-check">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr className="">
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M8.00133 9.5C7.50688 9.5 7.02353 9.35338 6.6124 9.07868C6.20128 8.80397 5.88085 8.41353 5.69163 7.95671C5.50241 7.49989 5.4529 6.99723 5.54937 6.51228C5.64583 6.02732 5.88393 5.58187 6.23356 5.23223C6.58319 4.8826 7.02865 4.6445 7.5136 4.54804C7.99856 4.45157 8.50122 4.50108 8.95804 4.6903C9.41485 4.87952 9.8053 5.19995 10.08 5.61108C10.3547 6.0222 10.5013 6.50555 10.5013 7C10.5005 7.6628 10.2369 8.29822 9.76822 8.76689C9.29955 9.23556 8.66413 9.49921 8.00133 9.5ZM8.00133 5.5C7.70466 5.5 7.41465 5.58797 7.16797 5.7528C6.9213 5.91762 6.72904 6.15189 6.61551 6.42598C6.50198 6.70007 6.47227 7.00167 6.53015 7.29264C6.58803 7.58361 6.73089 7.85088 6.94067 8.06066C7.15045 8.27044 7.41772 8.4133 7.70869 8.47118C7.99967 8.52906 8.30127 8.49935 8.57535 8.38582C8.84944 8.27229 9.08371 8.08003 9.24853 7.83336C9.41336 7.58668 9.50133 7.29667 9.50133 7C9.50093 6.6023 9.34277 6.221 9.06155 5.93978C8.78033 5.65856 8.39903 5.5004 8.00133 5.5Z"
                                        fill="#1E1E1E"
                                        fill-opacity="0.6"
                                      />
                                      <path
                                        d="M8.00133 15.5L3.78333 10.5255C3.72472 10.4508 3.66672 10.3756 3.60933 10.3C2.88918 9.3507 2.49999 8.19155 2.50133 7C2.50133 5.54131 3.08079 4.14236 4.11224 3.11091C5.14369 2.07946 6.54264 1.5 8.00133 1.5C9.46002 1.5 10.859 2.07946 11.8904 3.11091C12.9219 4.14236 13.5013 5.54131 13.5013 7C13.5025 8.19098 13.1135 9.34954 12.3938 10.2985L12.3933 10.3C12.3933 10.3 12.2433 10.497 12.2208 10.5235L8.00133 15.5ZM4.40783 9.6975C4.40783 9.6975 4.52433 9.8515 4.55083 9.8845L8.00133 13.954L11.4563 9.879C11.4783 9.8515 11.5953 9.6965 11.5958 9.696C12.1844 8.92057 12.5025 7.97352 12.5013 7C12.5013 5.80653 12.0272 4.66193 11.1833 3.81802C10.3394 2.97411 9.19481 2.5 8.00133 2.5C6.80786 2.5 5.66326 2.97411 4.81935 3.81802C3.97544 4.66193 3.50133 5.80653 3.50133 7C3.5001 7.97415 3.81855 8.92179 4.40783 9.6975Z"
                                        fill="#1E1E1E"
                                        fill-opacity="0.6"
                                      />
                                    </svg>{" "}
                                    State
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.state}
                                  </td>
                                </tr>

                                <tr className="">
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M13.6673 11.0334V5.9667C13.667 5.74492 13.6088 5.52708 13.4984 5.33473C13.388 5.14238 13.2293 4.98219 13.038 4.87003L8.62999 2.3367C8.43882 2.2257 8.2217 2.16724 8.00065 2.16724C7.7796 2.16724 7.56248 2.2257 7.37132 2.3367L2.96332 4.87003C2.77155 4.98168 2.61248 5.14175 2.50203 5.33422C2.39158 5.52669 2.33363 5.74479 2.33399 5.9667V11.0347C2.33442 11.2564 2.3927 11.4741 2.50308 11.6663C2.61346 11.8585 2.7721 12.0186 2.96332 12.1307L7.37132 14.664C7.56248 14.775 7.7796 14.8335 8.00065 14.8335C8.2217 14.8335 8.43882 14.775 8.62999 14.664L13.038 12.1307C13.2299 12.019 13.389 11.8588 13.4994 11.6662C13.6099 11.4736 13.6678 11.2554 13.6673 11.0334Z"
                                        stroke="#1E1E1E"
                                        strokeOpacity="0.6"
                                        strokeWidth="0.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M6.00067 5.5H10.0007M6.00067 7.352H10.0007M8.834 12.1667L6.00067 9.204H7.00067C9.22334 9.204 9.22334 5.5 7.00067 5.5"
                                        stroke="#1E1E1E"
                                        strokeOpacity="0.6"
                                        strokeWidth="0.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>{" "}
                                    Construction Cost
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value">
                                    {i?.construction_fees
                                      ? `${Math.round(i.construction_fees)} cr`
                                      : "-"}
                                  </td>
                                </tr>

                                <tr className="">
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    <svg
                                      width="16"
                                      height="17"
                                      viewBox="0 0 16 17"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M13.6673 11.0334V5.9667C13.667 5.74492 13.6088 5.52708 13.4984 5.33473C13.388 5.14238 13.2293 4.98219 13.038 4.87003L8.62999 2.3367C8.43882 2.2257 8.2217 2.16724 8.00065 2.16724C7.7796 2.16724 7.56248 2.2257 7.37132 2.3367L2.96332 4.87003C2.77155 4.98168 2.61248 5.14175 2.50203 5.33422C2.39158 5.52669 2.33363 5.74479 2.33399 5.9667V11.0347C2.33442 11.2564 2.3927 11.4741 2.50308 11.6663C2.61346 11.8585 2.7721 12.0186 2.96332 12.1307L7.37132 14.664C7.56248 14.775 7.7796 14.8335 8.00065 14.8335C8.2217 14.8335 8.43882 14.775 8.62999 14.664L13.038 12.1307C13.2299 12.019 13.389 11.8588 13.4994 11.6662C13.6099 11.4736 13.6678 11.2554 13.6673 11.0334Z"
                                        stroke="#1E1E1E"
                                        strokeOpacity="0.6"
                                        strokeWidth="0.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                      <path
                                        d="M6.00067 5.5H10.0007M6.00067 7.352H10.0007M8.834 12.1667L6.00067 9.204H7.00067C9.22334 9.204 9.22334 5.5 7.00067 5.5"
                                        stroke="#1E1E1E"
                                        strokeOpacity="0.6"
                                        strokeWidth="0.8"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                      />
                                    </svg>{" "}
                                    Consultancy Cost
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value">
                                    {i?.consultancy_fees
                                      ? `${Number(i.consultancy_fees).toFixed(2)} cr`
                                      : "-"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="vertical-divider"></div>
                        </>
                      )}
                      {toggle === 1 && (
                        <>
                          <div className="tender-detail-advanced-check">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Company Name
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.company_name
                                      ? i?.company_name?.toUpperCase()
                                      : ""}
                                  </td>
                                </tr>

                                {i.company_name === "joint" && (
                                  <>
                                    {" "}
                                    <tr>
                                      <td
                                        className="tender-detail-box-text-lable"
                                        style={{ paddingBottom: "5px" }}
                                      >
                                        Company Dist Jv
                                      </td>
                                      <td style={{ padding: "0px 2px" }}>:</td>
                                      <td className="tender-detail-box-text-value word-wrap-10vw">
                                        {i?.company_dist_jv
                                          ? i?.company_dist_jv?.toUpperCase()
                                          : ""}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        className="tender-detail-box-text-lable"
                                        style={{ paddingBottom: "5px" }}
                                      >
                                        Company Dist Lead
                                      </td>
                                      <td style={{ padding: "0px 2px" }}>:</td>
                                      <td className="tender-detail-box-text-value word-wrap-10vw">
                                        {i?.company_dist_lead
                                          ? i?.company_dist_lead?.toUpperCase()
                                          : ""}
                                      </td>
                                    </tr>
                                  </>
                                )}

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Total Tech Score
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.tech_score ? i?.tech_score : ""}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Company Score
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.company_score ? i?.company_score : ""}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Sole Qualify
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i.soil_quality ? "Yes" : "NO"}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Partcipating as
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i.participating_as
                                      ? i.participating_as
                                      : ""}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>

                          <div className="vertical-divider"></div>

                          <div className="tender-detail-advanced-check">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Is JV Allowed
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i.is_jv_allowed ? "Yes" : "NO"}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Is Consorium/Association Allowed
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i.is_jv_consorium_association_allowed
                                      ? "Yes"
                                      : "NO"}
                                  </td>
                                </tr>
                                {i.is_jv_consorium_association_allowed && (
                                  <tr>
                                    <td
                                      className="tender-detail-box-text-lable"
                                      style={{ paddingBottom: "5px" }}
                                    >
                                      Terms Of Jv
                                    </td>
                                    <td style={{ padding: "0px 2px" }}>:</td>
                                    <td className="tender-detail-box-text-value word-wrap-10vw">
                                      {i.terms_of_jv ? i.terms_of_jv : "-"}
                                    </td>
                                  </tr>
                                )}

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Site Appreciate Marking
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.site_apprisate_marking
                                      ? i.site_apprisate_marking
                                      : "No"}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Work Methodology Marking
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.work_methodology_marking
                                      ? i?.work_methodology_marking
                                      : "No"}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Presentation Required Marking
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.presentation_required_marking
                                      ? i?.presentation_required_marking
                                      : "No"}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Presentation Type
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.presentation_type
                                      ? i?.presentation_type
                                      : "No"}
                                  </td>
                                </tr>

                                <tr>
                                  <td className="tender-detail-box-text-lable">
                                    Eligibility Criteria
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i.eligibity_criteria
                                      ? i.eligibity_criteria === "Special"
                                        ? i.eligibity_criteria_special
                                        : i.eligibity_criteria
                                      : ""}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="vertical-divider"></div>
                        </>
                      )}

                      {toggle === 2 && (
                        <>
                          <div className="tender-detail-advanced-check">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Lead Partner
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value  ">
                                    {i.lead_partner ? i.lead_partner : ""}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Lead Partner Share
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.lead_partner_share
                                      ? ` ${i?.lead_partner_share}  %`
                                      : ""}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Jv Partner
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.jv_partner_name
                                      ? i?.jv_partner_name
                                      : ""}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Jv Partner Share
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.jv_partner_share
                                      ? `${i?.jv_partner_share} %`
                                      : ""}{" "}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Assosiate Partner
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.assosiate_partner
                                      ? i?.assosiate_partner === "Other"
                                        ? i.custom_assosiate_partner
                                        : i.assosiate_partner
                                      : ""}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Associate Partner Share
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.associate_partner_share
                                      ? `${i?.associate_partner_share} %`
                                      : ""}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="vertical-divider"></div>
                          <div className="tender-detail-advanced-check">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Recipeint Details
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.recipient_details
                                      ? i?.recipient_details
                                      : ""}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Tender Submission Type
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.tender_submission_type
                                      ? i?.tender_submission_type
                                      : ""}
                                  </td>
                                </tr>
                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Emd Required
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.is_emd_required === null ||
                                    i?.is_emd_required === undefined
                                      ? "-"
                                      : i.is_emd_required
                                        ? "Yes"
                                        : "No"}
                                  </td>
                                </tr>
                                {i.is_emd_required && (
                                  <>
                                    {" "}
                                    <tr>
                                      <td
                                        className="tender-detail-box-text-lable"
                                        style={{ paddingBottom: "5px" }}
                                      >
                                        Emd Amount
                                      </td>
                                      <td style={{ padding: "0px 2px" }}>:</td>
                                      <td className="tender-detail-box-text-value word-wrap-10vw">
                                        {i?.emd_amount ? i?.emd_amount : ""}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        className="tender-detail-box-text-lable"
                                        style={{ paddingBottom: "5px" }}
                                      >
                                        Emd Unit
                                      </td>
                                      <td style={{ padding: "0px 2px" }}>:</td>
                                      <td className="tender-detail-box-text-value word-wrap-10vw">
                                        {i?.emd_unit ? i?.emd_unit : ""}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        className="tender-detail-box-text-lable"
                                        style={{ paddingBottom: "5px" }}
                                      >
                                        Emd type
                                      </td>
                                      <td style={{ padding: "0px 2px" }}>:</td>
                                      <td className="tender-detail-box-text-value word-wrap-10vw">
                                        {i.emd_type ? i.emd_type : ""}
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="vertical-divider"></div>
                        </>
                      )}

                      {toggle === 3 && (
                        <>
                          <div className="tender-detail-advanced-check">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    CV Score
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.cv_score ? i?.cv_score : "-"}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Checklist
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.checklist ? "YES" : "NO"}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    All Docs Done
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.all_docs_done ? "YES" : "NO"}
                                  </td>
                                </tr>

                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    All CVS Done
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i?.all_cvs_done ? "YES" : "NO"}
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <div className="vertical-divider"></div>
                          <div className="tender-detail-advanced-check">
                            <table
                              style={{
                                borderCollapse: "collapse",
                                width: "100%",
                              }}
                            >
                              <tbody>
                                <tr>
                                  <td
                                    className="tender-detail-box-text-lable"
                                    style={{ paddingBottom: "5px" }}
                                  >
                                    Team Required
                                  </td>
                                  <td style={{ padding: "0px 2px" }}>:</td>
                                  <td className="tender-detail-box-text-value word-wrap-10vw">
                                    {i.team_required ? "Yes" : "No"}
                                  </td>
                                </tr>
                                {i.team_required && (
                                  <>
                                    <tr>
                                      <td
                                        className="tender-detail-box-text-lable"
                                        style={{ paddingBottom: "5px" }}
                                      >
                                        Team Requirement Details
                                      </td>
                                      <td style={{ padding: "0px 2px" }}>:</td>
                                      <td className="tender-detail-box-text-value word-wrap-10vw">
                                        {i?.team_requirements_details
                                          ? i?.team_requirements_details
                                          : ""}
                                      </td>
                                    </tr>
                                    <tr>
                                      <td
                                        className="tender-detail-box-text-lable"
                                        style={{ paddingBottom: "5px" }}
                                      >
                                        Team Prepare By Remarks
                                      </td>
                                      <td style={{ padding: "0px 2px" }}>:</td>
                                      <td className="tender-detail-box-text-value word-wrap-10vw">
                                        {i?.team_prepare_by_remarks
                                          ? i?.team_prepare_by_remarks
                                          : ""}
                                      </td>
                                    </tr>
                                  </>
                                )}
                              </tbody>
                            </table>
                          </div>
                          <div className="vertical-divider"></div>
                        </>
                      )}

                      <div className="flex-column " style={{ width: "32%" }}>
                        <div className="tender-detail-doc-section">
                          <TenderViewModal
                            rpfDocumentList={i?.rfp_doc}
                            techDocumentList={i?.tech_doc}
                            cvDocumentList={i?.cv_doc}
                            BidDocumentList={i?.bid_doc}
                            financialDocumentList={i?.financial_doc}
                            BidderDocs={i?.bidder_doc}
                            isOpen={activeIndex === index}
                            onOpen={() => handleOpen(index)}
                            toggleState={toggleState}
                            getBidData={getBidData}
                            filters={filters}
                            i={i}
                          />
                        </div>

                        <div className="flex-row justify-between">
                          <div className="flex-row">
                            {i?.notes_tender?.length === 0 ? (
                              <div className="flex-row"></div>
                            ) : (
                              i?.notes_tender
                                ?.slice(0, 3)
                                .map((note, index) => (
                                  <>
                                    <TenderViewSingleNote
                                      noteIndex={index + 1}
                                      noteData={note?.description}
                                      getBidData={getBidData}
                                      filters={filters}
                                      notesId={note?.id}
                                    />
                                  </>
                                ))
                            )}
                          </div>
                          {i?.notes_tender?.length > 3 && (
                            <TenderViewNotes tenderID={i?.id} />
                          )}
                        </div>

                        {toggleState === 5 && i?.tender_bidders.length > 0 && (
                          <>
                            {" "}
                            <div className="tender-detail-header-doc  align-center">
                              <p className="tender-detail-box-text-value word-wrap-10vw"></p>
                            </div>
                            <div className="tender-detail-notes-section">
                              <TenderViewAddBidders
                                bidders={i?.tender_bidders}
                                getBidData={getBidData}
                              />
                            </div>{" "}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="action-button">
                      <div
                        className="salaryslip-header"
                        style={{ padding: "10px 5px 0 5px", alignItems: "end" }}
                      >
                        <div style={{ display: "flex", width: "30%" }}>
                          {" "}
                          <span style={{ fontWeight: "bold" }}>
                            Sub. Date{" "}
                          </span>{" "}
                          :{" "}
                          {i.corrigendum_date ? (
                            <>
                              <span
                                style={{ fontWeight: 500, color: "#2576bc" }}
                              >
                                New Submission Date (
                                {(() => {
                                  const dateCorrigendum = i?.correigendum_types
                                    ?.filter(
                                      (ct) =>
                                        ct.corrigendum_type === "date" ||
                                        (ct.corrigendum_type === "both" &&
                                          ct.other_name === "corrigendum_date"),
                                    )
                                    ?.sort(
                                      (a, b) =>
                                        new Date(b.created_at) -
                                        new Date(a.created_at),
                                    )[0];

                                  return dateCorrigendum ? (
                                    <span
                                      style={{
                                        fontWeight: 500,
                                        color: "#2576bc",
                                      }}
                                    >
                                      {formatDateDDMMYYYYmonth(
                                        dateCorrigendum.other_value,
                                      )}
                                    </span>
                                  ) : null;
                                })()}
                                )
                              </span>
                            </>
                          ) : (
                            <>{formatDateDDMMYYYYmonth(i?.submission_date)} </>
                          )}
                          {i.correigendum_doc?.length ? (
                            <button
                              onClick={() =>
                                handelOpenCorrigendumDocsModal(
                                  i.correigendum_doc,
                                )
                              }
                              title="View Doc"
                              className="add-button"
                              style={{
                                width: "1rem",
                                height: "1rem",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                marginLeft: "0.5rem",
                              }}
                            >
                              <Eye />
                            </button>
                          ) : null}
                        </div>

                        <div
                          className="flex-row"
                          style={{ width: "65%", justifyContent: "end" }}
                        ></div>
                      </div>

                      {i?.is_rejected && (
                        <label>
                          Rejection Reason:{" "}
                          {i?.rejected_reason === "other"
                            ? i?.rejected_reason_other
                            : i?.rejected_reason}
                        </label>
                      )}
                    </div>
                  </div>
                </>
              ))
          )}
        </div>
      </div>

      <CorrigendumModal
        corriendumModal={corriendumModal}
        setCorriendumModal={setCorriendumModal}
        handleHideUpdateModal={handleHideUpdateModal}
        tenderId={tenderId}
        getBidData={getBidData}
        toggleState={toggleState}
        tenders={filteredData}
        filters={filters}
        onUpdateSuccess={handleScrollToTender}
        setScrollToTender={setScrollToTender}
        scrollToTender={scrollToTender}
      />
      <CorrigendumModalScreening
        corriendumModal={corriendumModalScreening}
        setCorriendumModal={setCorriendumModalScreening}
        handleHideUpdateModal={handleHideUpdateModalScreening}
        tenderId={tenderidscreening}
        getBidData={getBidData}
        toggleState={toggleState}
        tenders={filteredData}
        filters={filters}
        onUpdateSuccess={handleScrollToTender}
        setScrollToTender={setScrollToTender}
        scrollToTender={scrollToTender}
      />

      <EditTenderInfo
        showEditModal={showEditModal}
        handleCloseEditModal={handleCloseEditModal}
        toggleState={toggleState}
        tenders={filteredData}
        tenderId={editTenderId}
        getBidData={getBidData}
        editTenderData={editTenderData}
        showModal={showModal}
        filters={filters}
        roleemp={roleemp}
      />
      <EditTenderInfoTab
        showEditModal={showEditModalTab}
        handleCloseEditModal={handleCloseEditModalTab}
        toggleState={toggleState}
        tenders={filteredData}
        tenderId={editTenderId}
        getBidData={getBidData}
        editTenderData={editTenderData}
        showModal={showModal}
        filters={filters}
        roleemp={roleemp}
      />

      <Modal
        show={showBackModal}
        onHide={handleCloseBackModal}
        dialogClassName="request-leave width-40vw"
      >
        <Modal.Header closeButton>
          <Modal.Title>Move back tender to previous stage</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="parent-div">
            Are You Sure You Want To Move This Tender Back ?
            <div className="button-models">
              <button
                className="model-button   font-weight500   model-button-cancel "
                onClick={handleCloseBackModal}
              >
                Cancel
              </button>
              <button
                onClick={handleFormSubmit}
                className="model-button   font-weight500    model-button-delete"
              >
                Confirm
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={tenderDocsModal}
        onHide={handleCloseTenderDocsModal}
        dialogClassName="request-leave"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Tender Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label style={{ fontSize: "1.5rem", marginBottom: "1rem" }}>
            Technical Documents
          </label>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>
                <th>Name</th>
                <th>Added On</th>
                <th></th> {/* Blank for View button/label */}
              </tr>
            </thead>
            <tbody>
              {tenderDocuments.tech.map((docs, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                  <td>{docs.document_name}</td>
                  <td>{formatDate(docs.created_at)}</td>
                  <td>
                    <a href={docs?.document} style={{ padding: "4px 8px" }}>
                      View
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <label style={{ fontSize: "1.5rem", margin: "1rem 0" }}>
            Financial Documents
          </label>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>
                <th>Name</th>
                <th>Added On</th>
                <th></th> {/* Blank for View button/label */}
              </tr>
            </thead>
            <tbody>
              {tenderDocuments.financial.map((docs, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                  <td>{docs.document_name}</td>
                  <td>{formatDate(docs.created_at)}</td>
                  <td>
                    <a href={docs?.document} style={{ padding: "4px 8px" }}>
                      View
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <label style={{ fontSize: "1.5rem", margin: "1rem 0" }}>
            CV Documents
          </label>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>
                <th>Name</th>
                <th>Added On</th>
                <th></th> {/* Blank for View button/label */}
              </tr>
            </thead>
            <tbody>
              {tenderDocuments.cvs.map((docs, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                  <td>{docs.document_name}</td>
                  <td>{formatDate(docs.created_at)}</td>
                  <td>
                    <a href={docs?.document} style={{ padding: "4px 8px" }}>
                      View
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <label style={{ fontSize: "1.5rem", margin: "1rem 0" }}>
            RPF Documents
          </label>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>
                <th>Name</th>
                <th>Added On</th>
                <th></th> {/* Blank for View button/label */}
              </tr>
            </thead>
            <tbody>
              {tenderDocuments.rpf.map((docs, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                  <td>{docs.document_name}</td>
                  <td>{formatDate(docs.created_at)}</td>
                  <td>
                    <a href={docs?.document} style={{ padding: "4px 8px" }}>
                      View
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          <label style={{ fontSize: "1.5rem", margin: "1rem 0" }}>
            Bid Acknowledgement Documents
          </label>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>
                <th>Name</th>
                <th>Added On</th>
                <th></th> {/* Blank for View button/label */}
              </tr>
            </thead>
            <tbody>
              {tenderDocuments.bidDocs.map((docs, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                  <td>{docs.document_name}</td>
                  <td>{formatDate(docs.created_at)}</td>
                  <td>
                    <a href={docs?.document} style={{ padding: "4px 8px" }}>
                      View
                    </a>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {selectedDoc && (
            <div style={{ marginTop: "1rem", height: "500px" }}>
              <iframe
                src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDoc)}&embedded=true`}
                style={{ width: "100%", height: "100%", border: "none" }}
                title="Document Preview"
              />
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        show={docsModal}
        onHide={handleCloseCorrigendumDocsModal}
        dialogClassName="request-leave"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>Corrigendum Documents</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ borderBottom: "1px solid #ccc", textAlign: "left" }}>
                <th>Name</th>
                <th>Added On</th>
                <th></th> {/* Blank for View button/label */}
              </tr>
            </thead>
            <tbody>
              {corrigendumDocs.map((docs, index) => (
                <tr key={index} style={{ borderBottom: "1px solid #eee" }}>
                  <td>{docs.document_name}</td>
                  <td>{formatDate(docs.created_at)}</td>
                  <td>
                    <button
                      onClick={() => setSelectedDoc(docs.document)}
                      style={{ padding: "4px 8px" }}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {selectedDoc && (
            <div style={{ marginTop: "1rem", height: "500px" }}>
              <iframe
                src={`https://docs.google.com/gview?url=${encodeURIComponent(selectedDoc)}&embedded=true`}
                style={{ width: "100%", height: "100%", border: "none" }}
                title="Document Preview"
              />
            </div>
          )}
        </Modal.Body>
      </Modal>

      <Modal
        Modal
        show={showModal}
        onHide={handleClose}
        dialogClassName="request-leave"
      >
        <Modal.Header
          closeButton
          className="justify-center task-Tab-heading font-weight500    font-size-heading "
        >
          <Modal.Title>
            {toggleState === 2
              ? "Eligibility Cretria"
              : toggleState === 3
                ? "Finalize Partners"
                : toggleState === 9
                  ? "Tender Documents"
                  : "Tender Result"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form className="register-form">
            <div style={{ display: "flex", flexDirection: "column" }}>
              {toggleState === 2 && (
                <>
                  <div className="dropdown-wrapper flex-column justify-center  ">
                    <label
                      htmlFor="eligibity_criteria"
                      className="form-label font-weight500 font-size-subheading"
                    >
                      Eligibilty Criteria<span className="required">*</span>
                    </label>
                    <select
                      name="eligibity_criteria"
                      placeholder="Please write a eligibility creteria. "
                      value={wishListData.eligibity_criteria}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          eligibity_criteria: e.target.value,
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Eligibilty Criteria</option>
                      <option value="Normal">Normal</option>
                      <option value="Special">Special</option>
                    </select>
                  </div>
                  {wishListData.eligibity_criteria === "Special" && (
                    <div className="dropdown-wrapper flex-column justify-center ">
                      <label className="form-labels">
                        Eligibility Criteria Special
                        <span className="required">*</span>
                      </label>
                      <textarea
                        name="eligibity_criteria_special Eligibity Criteria"
                        placeholder="Please write Special Eligibilty Criteria "
                        value={wishListData.eligibity_criteria_special}
                        className={`form-input input-form`}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            eligibity_criteria_special: e.target.value,
                          }))
                        }
                      />
                    </div>
                  )}
                </>
              )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center  ">
                  <label
                    htmlFor="is_jv_allowed"
                    className="form-label font-weight500 font-size-subheading"
                  >
                    Is JV allowed<span className="required">*</span>
                  </label>
                  <select
                    id="is_jv_allowed"
                    name="is_jv_allowed"
                    value={wishListData.is_jv_allowed}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        is_jv_allowed:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Is Jv Allowed</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}
              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center ">
                  <label
                    htmlFor="is_jv_consorium_association_allowed"
                    className="form-label font-weight500 font-size-subheading"
                  >
                    Is Consorium/Association allowed
                    <span className="required">*</span>
                  </label>
                  <select
                    id="is_jv_consorium_association_allowed"
                    name="is_jv_consorium_association_allowed"
                    value={wishListData.is_jv_consorium_association_allowed}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        is_jv_consorium_association_allowed:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Is Consorium/Association allowed</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}
              {toggleState === 2 &&
                wishListData.is_jv_consorium_association_allowed && (
                  <div className="flex-column">
                    <label className="form-labels">Terms of JV </label>
                    <textarea
                      name="terms_of_jv"
                      placeholder="terms"
                      value={wishListData.terms_of_jv}
                      className={`form-input input-form`}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          terms_of_jv: e.target.value,
                        }))
                      }
                    />
                  </div>
                )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center ">
                  <label
                    htmlFor="company_name"
                    className="  font-weight500    font-size-subheading"
                  >
                    Company Name<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="company_name"
                    name="company_name"
                    value={wishListData.company_name}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        company_name: e.target.value,
                      }))
                    }
                    className={`form-input font-size-subheading  `}
                    //style={{ width: '80% !important' }}
                  >
                    <option value="">Select Company Name</option>
                    <option value="sapl">SAPL</option>
                    <option value="cipl">CIPL</option>
                  </select>
                </div>
              )}
              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center ">
                  <label
                    htmlFor="soil_quality"
                    className="font-weight500 font-size-subheading"
                  >
                    Sole Qualify<span className="required">*</span>
                  </label>
                  <select
                    id="soil_quality"
                    name="soil_quality"
                    value={wishListData.soil_quality}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        soil_quality:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Sole Qualify</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center ">
                  <label
                    htmlFor="participating_as "
                    className="  font-weight500    font-size-subheading"
                  >
                    Participating As<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="participating_as"
                    name="participating_as"
                    value={wishListData.participating_as}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        participating_as: e.target.value,
                      }))
                    }
                    className={`form-input font-size-subheading`}
                    //style={{ width: '80% !important' }}
                  >
                    <option value="">Select Participating As</option>
                    <option value="lead">Lead</option>
                    <option value="jv">JV</option>
                    <option value="associate">Associate</option>

                    {wishListData.soil_quality ? (
                      <option value="sole">Sole</option>
                    ) : (
                      ""
                    )}
                  </select>
                </div>
              )}

              <div
                className="joint-columns"
                style={{ display: "flex", gap: "20px", marginTop: "10px" }}
              >
                {toggleState === 2 && (
                  <div className="flex-column form-group-selectt widths50">
                    <label
                      htmlFor="tech_score"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Total Tech Score<span className="required">*</span>
                    </label>
                    <br />
                    <input
                      type="text"
                      name="tech_score"
                      placeholder="tech Score"
                      value={wishListData.tech_score}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          tech_score: e.target.value,
                        }))
                      }
                      className={`form-input input-form`}
                      style={{ width: "80%" }}
                    />
                  </div>
                )}

                {toggleState === 2 && (
                  <div className="flex-column form-group-selectt widths50">
                    <label
                      htmlFor="company_score"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      {wishListData.company_name === null ||
                      wishListData.company_name === ""
                        ? "Our Company"
                        : wishListData.company_name?.toUpperCase()}{" "}
                      Technical Score<span className="required">*</span>
                    </label>
                    <br />
                    <input
                      type="text"
                      name="company_score"
                      placeholder="Technical  Score"
                      value={wishListData.company_score}
                      onChange={(e) => {
                        const value = e.target.value;

                        if (Number(value) > Number(wishListData.tech_score)) {
                          setScoreError(
                            "Company score should not be greater than Total Tech Score",
                          );
                        } else {
                          setScoreError("");
                          setWishListData((prev) => ({
                            ...prev,
                            company_score: value,
                          }));
                        }
                      }}
                      className={`form-input input-form`}
                      style={{ width: "80%" }}
                    />
                    {scoreError && (
                      <p
                        style={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {scoreError}
                      </p>
                    )}
                  </div>
                )}
              </div>

              {toggleState === 3 && (
                <div className="dropdown-wrapper flex justify-center ">
                  <label
                    htmlFor="lead_partner"
                    className="form-labels font-weight500 font-size-subheading"
                  >
                    {console.log(wishListData, "wishlistdata")}
                    {wishListData.participating_as === "sole"
                      ? "Sole Partner "
                      : "Lead Partner"}{" "}
                    <span className="required">*</span>
                  </label>
                  <br />
                  {wishListData.lead_qualify ? (
                    // If lead_qualify is true, show a disabled text input with the lead_partner value
                    <input
                      type="text"
                      name="lead_partner"
                      placeholder="lead partner"
                      value={wishListData.lead_partner}
                      disabled={true}
                      className="form-input input-form"
                    />
                  ) : (
                    <>
                      {/* Dropdown for lead partner selection */}
                      <select
                        id="lead_partner"
                        name="lead_partner"
                        value={
                          wishListData.lead_partner === ""
                            ? "null"
                            : wishListData.lead_partner
                        }
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            lead_partner: e.target.value,
                          }))
                        }
                        className="form-input font-size-subheading"
                      >
                        <option value="">Select lead partner</option>
                        {Partners.map((partner) => (
                          <option value={partner.key}>{partner.value}</option>
                        ))}
                      </select>

                      {/* Show custom input box only if "Other" is selected */}
                      {(!Partners.some(
                        (partner) => partner.key === wishListData.lead_partner,
                      ) ||
                        wishListData.lead_partner === "Other") &&
                        wishListData.lead_partner !== "null" && (
                          <input
                            type="text"
                            name="lead_partner"
                            placeholder="Enter custom lead partner"
                            value={wishListData.custom_lead_partner}
                            onChange={(e) =>
                              setWishListData((prev) => ({
                                ...prev,
                                custom_lead_partner: e.target.value,
                              }))
                            }
                            className="form-input font-size-subheading"
                          />
                        )}
                    </>
                  )}
                </div>
              )}

              {toggleState === 3 && (
                <div className="dropdown-wrapper flex justify-center ">
                  <label
                    htmlFor="lead_partner_share"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    {wishListData.participating_as === "sole"
                      ? "Sole Partner "
                      : "Lead Partner"}{" "}
                    %<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="number"
                    name="lead_partner_share"
                    placeholder="lead partner share"
                    value={wishListData.lead_partner_share}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        lead_partner_share: e.target.value,
                      }))
                    }
                    className={`form-input font-size-subheading`}
                    onWheel={(e) => e.target.blur()}
                  />
                  {wishListData.partner_share_sum > 100 && (
                    <label style={{ color: "red" }}>
                      Sum of all partner should not be more than 100
                    </label>
                  )}
                  {wishListData.partner_share_sum < 100 && (
                    <label style={{ color: "red" }}>
                      Sum of all lead partner should not be less than 100
                    </label>
                  )}
                </div>
              )}
              {toggleState === 3 && wishListData.participating_as != "sole" && (
                <div className="dropdown-wrapper flex justify-center ">
                  <label
                    htmlFor="jv_partner_name"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Jv Partner<span className="required">*</span>
                  </label>
                  <br />
                  {wishListData.jv_qualify ? (
                    <input
                      type="text"
                      name="jv_partner_name"
                      placeholder="Jv Partner"
                      value={wishListData.jv_partner_name}
                      disabled={wishListData.jv_qualify}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          jv_partner_name: e.target.value,
                        }))
                      }
                      className={`form-input font-size-subheading`}
                    />
                  ) : (
                    <>
                      <select
                        id="jv_partner_name"
                        name="jv_partner_name"
                        value={wishListData.jv_partner_name}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            jv_partner_name: e.target.value,
                          }))
                        }
                        className={`form-input font-size-subheading`}
                      >
                        <option value="">Select JV partner</option>
                        {Partners.map((partner) => (
                          <option value={partner.key}>{partner.value}</option>
                        ))}
                      </select>
                      {(!Partners.some(
                        (partner) =>
                          partner.key === wishListData.jv_partner_name,
                      ) ||
                        wishListData.jv_partner_name === "Other") &&
                        wishListData.jv_partner_name !== "null" && (
                          <input
                            type="text"
                            name="jv_partner_name"
                            placeholder="Enter custom jv partner"
                            value={wishListData.custom_jv_partner}
                            onChange={(e) =>
                              setWishListData((prev) => ({
                                ...prev,
                                custom_jv_partner: e.target.value,
                              }))
                            }
                            className="form-input input-form"
                          />
                        )}
                    </>
                  )}
                </div>
              )}

              {toggleState === 3 &&
                wishListData.jv_partner_name != "Not Required" && (
                  <>
                    {" "}
                    <div className="dropdown-wrapper flex justify-center ">
                      <label
                        htmlFor="jv_partner_share"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Jv Partner Share %<span className="required">*</span>
                      </label>
                      <br />
                      <input
                        type="number"
                        name="jv_partner_share"
                        placeholder="Jv Partner Share"
                        value={wishListData.jv_partner_share}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            jv_partner_share: e.target.value,
                          }))
                        }
                        className={`form-input font-size-subheading`}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    {wishListData.partner_share_sum > 100 && (
                      <label style={{ color: "red" }}>
                        Sum of all partner should not be more than 100
                      </label>
                    )}
                    {wishListData.partner_share_sum < 100 && (
                      <label style={{ color: "red" }}>
                        Sum of all lead partner should not be less than 100
                      </label>
                    )}{" "}
                  </>
                )}

              {toggleState === 3 && wishListData.participating_as != "sole" && (
                <div className="dropdown-wrapper flex justify-center ">
                  <label
                    htmlFor="assosiate_partner"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Assosiate Partner<span className="required">*</span>
                  </label>
                  <br />
                  {wishListData.associate_qualify ? (
                    <>
                      <select
                        id="assosiate_partner"
                        name="assosiate_partner"
                        value={wishListData.assosiate_partner}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            assosiate_partner: e.target.value,
                          }))
                        }
                        className={`form-input font-size-subheading`}
                      >
                        <option value="">Select associate partner</option>
                        {Partners.map((partner) => (
                          <option value={partner.key}>{partner.value}</option>
                        ))}
                      </select>
                      {(!Partners.some(
                        (partner) =>
                          partner.key === wishListData.assosiate_partner,
                      ) ||
                        wishListData.assosiate_partner === "Other") &&
                        wishListData.assosiate_partner !== "null" && (
                          <input
                            type="text"
                            name="assosiate_partner"
                            placeholder="Enter custom assosiate partner"
                            value={wishListData.custom_assosiate_partner}
                            onChange={(e) =>
                              setWishListData((prev) => ({
                                ...prev,
                                custom_assosiate_partner: e.target.value,
                              }))
                            }
                            className="form-input font-size-subheading"
                          />
                        )}
                    </>
                  ) : (
                    <>
                      <select
                        id="assosiate_partner"
                        name="assosiate_partner"
                        value={wishListData.assosiate_partner}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            assosiate_partner: e.target.value,
                          }))
                        }
                        className={`form-input font-size-subheading`}
                      >
                        <option value="">Select associate partner</option>
                        {Partners.map((partner) => (
                          <option value={partner.key}>{partner.value}</option>
                        ))}
                      </select>
                      {(!Partners.some(
                        (partner) =>
                          partner.key === wishListData.assosiate_partner,
                      ) ||
                        wishListData.assosiate_partner === "Other") &&
                        wishListData.assosiate_partner !== "null" && (
                          <input
                            type="text"
                            name="assosiate_partner"
                            placeholder="Enter custom assosiate partner"
                            value={wishListData.custom_assosiate_partner}
                            onChange={(e) =>
                              setWishListData((prev) => ({
                                ...prev,
                                custom_assosiate_partner: e.target.value,
                              }))
                            }
                            className="form-input font-size-subheading"
                          />
                        )}
                    </>
                  )}
                </div>
              )}
              {toggleState === 3 &&
                wishListData.assosiate_partner != "Not Required" && (
                  <>
                    <div className="dropdown-wrapper flex justify-center ">
                      <label
                        htmlFor="associate_partner_share"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Associate Partner Share %
                        <span className="required">*</span>
                      </label>
                      <br />
                      <input
                        type="number"
                        name="associate_partner_share"
                        placeholder="Associate Partner Share"
                        value={wishListData.associate_partner_share}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            associate_partner_share: e.target.value,
                          }))
                        }
                        className={`form-input font-size-subheading`}
                        onWheel={(e) => e.target.blur()}
                      />
                    </div>
                    {wishListData.partner_share_sum > 100 && (
                      <label style={{ color: "red" }}>
                        Sum of all partner should not be more than 100
                      </label>
                    )}
                    {wishListData.partner_share_sum < 100 && (
                      <label style={{ color: "red" }}>
                        Sum of all lead partner should not be less than 100
                      </label>
                    )}
                  </>
                )}

              {/* {toggleState === 3 && <div className="checkbox-wrapper flex-column justify-center">
                                        <label className="custom-checkbox  font-weight500 font-size-subheading">
                                            <input
                                                type="checkbox"
                                                name="bg_requried"
                                                checked={wishListData.bg_requried}
                                                onChange={(e) => setWishListData((prev) => ({ ...prev, bg_requried: e.target.checked }))}
                                            />
                                            <span className="checkmark"></span>
                                            Bg Requried
                                        </label>
                                    </div>} */}
              {/* {toggleState === 3 && wishListData.bg_requried && <div title="bg_amount" className="flex-column form-group-selectt" >
                                        <label htmlFor="bg_amount" className="form-labels  font-weight500    font-size-subheading">
                                            Bg Amount<span className="required">*</span>
                                        </label>
                                        <br />
                                        <input
                                            type="text"
                                            name="bg_amount"
                                            placeholder="bg Amount"
                                            value={wishListData.bg_amount}
                                            onChange={(e) => setWishListData((prev) => ({ ...prev, bg_amount: e.target.value }))}
                                            className={`form-input `}
                                        />
                                    </div>} */}
              {toggleState === 3 && (
                <>
                  <div className="dropdown-wrapper flex justify-center ">
                    <label
                      htmlFor="bid_prepare_by"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Bid Prepare By<span className="required">*</span>
                    </label>
                    <br />
                    <select
                      id="bid_prepare_by"
                      name="bid_prepare_by"
                      value={wishListData.bid_prepare_by}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          bid_prepare_by: e.target.value,
                        }))
                      }
                      className={`form-input font-size-subheading`}
                    >
                      <option value="">Select</option>
                      <option value="lead_partner">
                        {" "}
                        {wishListData.lead_partner ||
                        wishListData.lead_partner != "null"
                          ? wishListData.lead_partner
                          : ""}
                      </option>
                      <option value="jv_partner">
                        {" "}
                        {wishListData.jv_partner_name ||
                        wishListData.jv_partner_name != "null"
                          ? wishListData.jv_partner_name
                          : ""}
                      </option>
                      <option value="associate_partner">
                        {" "}
                        {wishListData.assosiate_partner ||
                        wishListData.assosiate_partner != "null"
                          ? wishListData.assosiate_partner
                          : ""}
                      </option>
                    </select>
                  </div>
                  <div className="dropdown-wrapper flex justify-center ">
                    <label className="form-labels font-weight500 font-size-subheading">
                      Bid Prepare By Remarks
                    </label>
                    <textarea
                      name="bid_prepare_by_remarks"
                      placeholder="Remarks for bid prepared by"
                      value={wishListData.bid_prepare_by_remarks}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          bid_prepare_by_remarks: e.target.value,
                        }))
                      }
                      className={`form-input font-size-subheading`}
                    />
                  </div>

                  <div className="dropdown-wrapper flex justify-center ">
                    <label
                      htmlFor="bg_prepare_by"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      BG Prepare By<span className="required">*</span>
                    </label>
                    <br />
                    <select
                      id="bg_prepare_by"
                      name="bg_prepare_by"
                      value={wishListData.bg_prepare_by}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          bg_prepare_by: e.target.value,
                        }))
                      }
                      className={`form-input font-size-subheading`}
                    >
                      <option value="">Select</option>
                      <option value="lead_partner">
                        {" "}
                        {wishListData.lead_partner ||
                        wishListData.lead_partner != "null"
                          ? wishListData.lead_partner
                          : ""}
                      </option>
                      <option value="jv_partner">
                        {" "}
                        {wishListData.jv_partner_name ||
                        wishListData.jv_partner_name != "null"
                          ? wishListData.jv_partner_name
                          : ""}
                      </option>
                      <option value="associate_partner">
                        {" "}
                        {wishListData.assosiate_partner ||
                        wishListData.assosiate_partner != "null"
                          ? wishListData.assosiate_partner
                          : ""}
                      </option>
                    </select>
                  </div>
                </>
              )}

              {console.log(
                roleemp != "CertificationAccessCvTeamHead" ||
                  roleemp != "CertificationAccessCvTeam",
                roleemp,
              )}

              {toggleState === 3 && (
                <>
                  <div className="dropdown-wrapper flex justify-center ">
                    <label
                      htmlFor="team_required"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Team Required<span className="required">*</span>
                    </label>
                    <br />
                    <select
                      id="team_required"
                      name="team_required"
                      value={wishListData.team_required}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          team_required:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null, // handles "Select Team Required"
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Select Team Required</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                  {wishListData.team_required && (
                    <>
                      <div className="flex-column form-group-selectt">
                        <label
                          htmlFor="team_prepare_by"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Team Prepare By<span className="required">*</span>
                        </label>
                        <br />
                        <select
                          id="team_prepare_by"
                          name="team_prepare_by"
                          value={wishListData.team_prepare_by}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              team_prepare_by: e.target.value,
                            }))
                          }
                          className={`form-input input-form  form-group-selection`}
                        >
                          <option value="">Select</option>
                          <option value="lead_partner">
                            {wishListData.lead_partner}
                          </option>
                          <option value="jv_partner">
                            {" "}
                            {wishListData.jv_partner_name}
                          </option>
                          <option value="associate_partner">
                            {" "}
                            {wishListData.assosiate_partner}
                          </option>
                        </select>
                      </div>
                      <div className="flex-column">
                        <label className="form-labels">
                          Team Prepare By Remarks{" "}
                          <span className="required">*</span>
                        </label>
                        <textarea
                          name="team_prepare_by_remarks"
                          placeholder="Remarks for Team prepared by"
                          value={wishListData.team_prepare_by_remarks}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              team_prepare_by_remarks: e.target.value,
                            }))
                          }
                          className={`form-input input-form`}
                        />
                      </div>

                      <div className="flex-column">
                        <label className="form-labels">
                          Team Requirements Details
                          <span className="required">*</span>
                        </label>
                        <textarea
                          name="team_requirements_details"
                          placeholder="Team Requirements Details"
                          value={wishListData.team_requirements_details}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              team_requirements_details: e.target.value,
                            }))
                          }
                          className={`form-input input-form`}
                        />
                      </div>
                    </>
                  )}

                  <div className="dropdown-wrapper flex justify-center ">
                    <label
                      htmlFor="is_emd_required"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Emd Required<span className="required">*</span>
                    </label>
                    <br />

                    <select
                      id="is_emd_required"
                      name="is_emd_required"
                      value={wishListData.is_emd_required}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          is_emd_required:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null, // handles "Select Team Required"
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Select Emd Required</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                  {wishListData.is_emd_required && (
                    <div className="dropdown-wrapper flex justify-center ">
                      <label
                        htmlFor="exmpted_emd"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Exmpted Emd<span className="required">*</span>
                      </label>
                      <br />

                      <select
                        id="exmpted_emd"
                        name="exmpted_emd"
                        value={wishListData.exmpted_emd}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            exmpted_emd:
                              e.target.value === "true"
                                ? true
                                : e.target.value === "false"
                                  ? false
                                  : null, // handles "Select Team Required"
                          }))
                        }
                        className="form-input font-size-subheading"
                      >
                        <option value="">Exmpted Emd</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  )}
                  {wishListData.is_emd_required && (
                    <>
                      {" "}
                      <div className="dropdown-wrapper flex justify-center ">
                        <label
                          htmlFor="emd_amount"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Emd Amount<span className="required">*</span>
                        </label>
                        <br />
                        <input
                          type="text"
                          name="emd_amount"
                          placeholder="Enter full amount (e.g. 1 crore = 10000000)"
                          value={wishListData.emd_amount}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              emd_amount: e.target.value,
                            }))
                          }
                          className={`form-input font-size-subheading`}
                        />
                      </div>
                      <div className="dropdown-wrapper flex justify-center ">
                        <label
                          htmlFor="emd_unit"
                          className="form-labels font-weight500 font-size-subheading"
                        >
                          EMD Unit<span className="required">*</span>
                        </label>
                        <br />
                        <select
                          id="emd_unit"
                          name="emd_unit"
                          value={wishListData.emd_unit}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              emd_unit: e.target.value,
                            }))
                          }
                          className="form-input font-size-subheading"
                        >
                          <option value="">Select EMD Unit</option>
                          <option value="crore">Crore</option>
                          <option value="lakhs">Lakhs</option>
                          <option value="thousand">thousand</option>
                          <option value="hundreds">hundreds</option>
                        </select>
                      </div>
                      {/* <div className="dropdown-wrapper flex justify-center " >
                                            <label htmlFor="emd_review" className="form-labels  font-weight500    font-size-subheading">
                                                Emd Review<span className="required">*</span>
                                            </label>
                                            <br />


                                            <select
                                                id="emd_review"
                                                name="emd_review"
                                                value={wishListData.emd_review}
                                                onChange={(e) =>
                                                    setWishListData((prev) => ({
                                                        ...prev,
                                                        emd_review:
                                                            e.target.value === "true"
                                                                ? true
                                                                : e.target.value === "false"
                                                                    ? false
                                                                    : null, // handles "Select Team Required"
                                                    }))
                                                }
                                                className="form-input font-size-subheading"
                                            >
                                                <option value="">Select Emd Review</option>
                                                <option value="true">Yes</option>
                                                <option value="false">No</option>
                                            </select>

                                        </div> */}
                    </>
                  )}
                  {wishListData.is_emd_required && (
                    <div className="dropdown-wrapper flex justify-center ">
                      <label
                        htmlFor="emd_type"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Emd Type<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="emd_type"
                        name="emd_type"
                        value={wishListData.emd_type}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            emd_type: e.target.value,
                          }))
                        }
                        className={`form-input font-size-subheading`}
                        // style={{ width: '80% !important' }}
                      >
                        <option value="">EMD Type</option>
                        {EmdType.map((emd) => (
                          <option value={emd.key}>{emd.value}</option>
                        ))}
                      </select>
                      {(!EmdType.some(
                        (emd) => emd.key === wishListData.emd_type,
                      ) ||
                        wishListData.emd_type === "other") &&
                        wishListData.emd_type !== "null" && (
                          <input
                            type="text"
                            name="emd_type"
                            placeholder="Enter custom emd type"
                            value={wishListData.custom_emd_type}
                            onChange={(e) =>
                              setWishListData((prev) => ({
                                ...prev,
                                custom_emd_type: e.target.value,
                              }))
                            }
                            className="form-input font-size-subheading"
                          />
                        )}
                    </div>
                  )}

                  {wishListData.is_emd_required && (
                    <div className="dropdown-wrapper flex justify-center ">
                      <label
                        htmlFor="emd_submission_type"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Emd Submission Type<span className="required">*</span>
                      </label>
                      <br />
                      <select
                        id="emd_submission_type"
                        name="emd_submission_type"
                        value={wishListData.emd_submission_type}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            emd_submission_type: e.target.value,
                          }))
                        }
                        className={`form-input font-size-subheading`}
                        // style={{ width: '80% !important' }}
                      >
                        <option value="">EMD Submission Type</option>
                        <option value="online">Online</option>
                        <option value="physical">Physical</option>
                        <option value="both">Both</option>
                      </select>
                    </div>
                  )}
                </>
              )}

              {toggleState === 3 &&
                wishListData.tendersubmission === "HardCopy" && (
                  <div className="flex-column">
                    <label className="form-labels">
                      Submission Date <span className="required">*</span>
                    </label>
                    <input
                      type="datetime-local"
                      name="submission_date"
                      min={new Date().toISOString().slice(0, 16)}
                      value={wishListData?.submission_date}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          submission_date: e.target.value,
                        }))
                      }
                      className={`form-input input-form`}
                    />
                  </div>
                )}

              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center ">
                  <label
                    htmlFor="site_apprisate_required"
                    className="font-weight500 font-size-subheading"
                  >
                    Site Appriciate Required <span className="required">*</span>
                  </label>
                  <select
                    id="site_apprisate_required"
                    name="site_apprisate_required"
                    value={wishListData.site_apprisate_required}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        site_apprisate_required:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null,
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Site Appriciate Required</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}

              {toggleState === 2 && wishListData.site_apprisate_required && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="site_apprisate_marking"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Site Appreciate Marking<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="site_apprisate_marking"
                    placeholder="site_apprisate_marking"
                    value={wishListData.site_apprisate_marking}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        site_apprisate_marking: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
              )}
              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center ">
                  <label
                    htmlFor="work_methodology_required"
                    className="font-weight500 font-size-subheading"
                  >
                    Work methodology required{" "}
                    <span className="required">*</span>
                  </label>
                  <select
                    id="work_methodology_required"
                    name="work_methodology_required"
                    value={wishListData.work_methodology_required}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        work_methodology_required:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null, // handles "Select Team Required"
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Work Methodology Marking</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}
              {toggleState === 2 && wishListData.work_methodology_required && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="work_methodology_marking"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Work Methodology Marking<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="work_methodology_marking"
                    placeholder="work_methodology_marking"
                    value={wishListData.work_methodology_marking}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        work_methodology_marking: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
              )}
              {toggleState === 2 && (
                <div className="dropdown-wrapper flex-column justify-center ">
                  <label
                    htmlFor="presentation_required"
                    className="font-weight500 font-size-subheading"
                  >
                    Presentation Required<span className="required">*</span>
                  </label>
                  <select
                    id="presentation_required"
                    name="presentation_required"
                    value={wishListData.presentation_required}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        presentation_required:
                          e.target.value === "true"
                            ? true
                            : e.target.value === "false"
                              ? false
                              : null, // handles "Select Team Required"
                      }))
                    }
                    className="form-input font-size-subheading"
                  >
                    <option value="">Presentation Required</option>
                    <option value="true">Yes</option>
                    <option value="false">No</option>
                  </select>
                </div>
              )}
              {toggleState === 2 && wishListData.presentation_required && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="presentation_required_marking"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Presentation Required Marking
                    <span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="presentation_required_marking"
                    placeholder="presentation_required_marking"
                    value={wishListData.presentation_required_marking}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        presentation_required_marking: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
              )}

              {toggleState === 2 && wishListData.presentation_required && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="presentation_type"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Presentation Type<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="presentation_type"
                    name="presentation_type"
                    value={wishListData.presentation_type}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        presentation_type: e.target.value,
                      }))
                    }
                    className={`form-input input-form  form-group-selection `}
                    // style={{ width: '80% !important' }}
                  >
                    <option value="">Select Presentation Type</option>
                    <option value="Online">Online</option>
                    <option value="physical">Physical</option>
                    <option value="both">Both</option>
                  </select>
                </div>
              )}
              {toggleState === 3 && (
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="tender_submission_type"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Tender Submission Type<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="tender_submission_type"
                    name="tender_submission_type"
                    value={wishListData.tender_submission_type}
                    className={`form-input input-form  form-group-selection`}
                    onChange={(e) =>
                      setWishListData((prev) => ({
                        ...prev,
                        tender_submission_type: e.target.value,
                      }))
                    }
                  >
                    <option value="null">Select Tender Submission Type</option>
                    <option value="Online">Online</option>
                    <option value="physical">Physical</option>
                    <option value="both">Both</option>
                  </select>
                </div>
              )}
              {toggleState === 9 && (
                <>
                  {roleemp != "CertificationAccessCvTeamHead" &&
                    roleemp != "CertificationAccessCvTeam" && (
                      <div className="dropdown-wrapper flex justify-center ">
                        <label
                          htmlFor="checklist"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Checklist<span className="required">*</span>
                        </label>
                        <br />

                        <select
                          id="checklist"
                          name="checklist"
                          value={wishListData.checklist}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              checklist:
                                e.target.value === "true"
                                  ? true
                                  : e.target.value === "false"
                                    ? false
                                    : null, // handles "Select Team Required"
                            }))
                          }
                          className="form-input font-size-subheading"
                        >
                          <option value="">All Checklist done</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                    )}
                  {roleemp != "CertificationAccessCvTeamHead" &&
                    roleemp != "CertificationAccessCvTeam" && (
                      <div className="dropdown-wrapper flex justify-center ">
                        <label
                          htmlFor="all_docs_done"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          All Docs done<span className="required">*</span>
                        </label>
                        <br />

                        <select
                          id="all_docs_done"
                          name="all_docs_done"
                          value={wishListData.all_docs_done}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              all_docs_done:
                                e.target.value === "true"
                                  ? true
                                  : e.target.value === "false"
                                    ? false
                                    : null, // handles "Select Team Required"
                            }))
                          }
                          className="form-input font-size-subheading"
                        >
                          <option value="">All Docs done</option>
                          <option value="true">Yes</option>
                          <option value="false">No</option>
                        </select>
                      </div>
                    )}
                  {roleemp != "CertificationAccessCvTeamHead" &&
                    roleemp != "CertificationAccessCvTeam" && (
                      <div className="flex-column form-group-selectt ">
                        <label
                          htmlFor="tech_score"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Total Technical Score
                          <span className="required">*</span>
                        </label>
                        <br />
                        <input
                          type="text"
                          name="tech_score"
                          placeholder="tech Score"
                          value={wishListData.tech_score}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              tech_score: e.target.value,
                            }))
                          }
                          className={`form-input input-form`}
                        />
                      </div>
                    )}

                  {(roleemp === "CertificationAccessCvTeamHead" ||
                    roleemp === "CertificationAccessCvTeam" ||
                    roleemp === "CertificationAccess" ||
                    roleemp === "CertificateAccessBd" ||
                    roleemp === "certificaionadminaccess") && (
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="cv_score"
                        className="form-labels font-weight500 font-size-subheading"
                      >
                        CV Score<span className="required">*</span>
                      </label>
                      <br />
                      <input
                        type="text"
                        name="cv_score"
                        placeholder="CV Score"
                        value={wishListData.cv_score}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            cv_score: e.target.value,
                          }))
                        }
                        className="form-input input-form"
                      />
                    </div>
                  )}

                  {roleemp != "CertificationAccessCvTeamHead" &&
                    roleemp != "CertificationAccessCvTeam" && (
                      <div
                        style={{
                          width: "100%",
                          maxWidth: 480,
                          margin: "0 auto",
                          background: "#fff",
                          borderRadius: 8,
                          boxShadow: "0 2px 12px #eee",
                          padding: 32,
                          marginTop: 24,
                        }}
                      >
                        <label
                          className="form-labels font-weight500 font-size-subheading"
                          style={{
                            marginBottom: 12,
                            display: "block",
                            fontSize: 18,
                            fontWeight: 600,
                          }}
                        >
                          Upload Tech Proposal
                        </label>

                        {/* If there are any required/previous docs from wishListData */}
                        {wishListData?.tech_doc?.length > 0 && (
                          <div style={{ marginBottom: 18 }}>
                            {wishListData.tech_doc.map((cv) => (
                              <div
                                key={cv.document_name}
                                style={{ marginBottom: 6 }}
                              >
                                <label
                                  style={{ color: "#6c63ff", fontWeight: 500 }}
                                >
                                  {cv.document_name}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* File Input and Add Button */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: 24,
                          }}
                        >
                          <input
                            type="file"
                            multiple
                            onChange={handleTechFileChange}
                            style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                            className="form-control"
                          />
                          <button
                            onClick={handleAddTechDoc}
                            style={{
                              padding: "8px 20px",
                              backgroundColor: "#6c63ff",
                              color: "#fff",
                              border: "none",
                              borderRadius: 4,
                              fontWeight: 600,
                              fontSize: 15,
                              cursor: "pointer",
                            }}
                            disabled={!techDocs.length}
                          >
                            Add
                          </button>
                        </div>

                        {/* List of uploaded tech docs */}
                        <ul
                          style={{
                            listStyle: "none",
                            padding: 0,
                            margin: 0,
                            width: "100%",
                            maxHeight: 180,
                            overflowY: "auto",
                            border: techDocs?.length
                              ? "1px solid #ececec"
                              : "none",
                            borderRadius: 6,
                            background: techDocs?.length ? "#fafafd" : "none",
                          }}
                        >
                          {techDocs?.map((file, index) => (
                            <li
                              key={file.name + index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "10px 8px",
                                borderBottom:
                                  index !== techDocs.length - 1
                                    ? "1px solid #ececec"
                                    : "none",
                              }}
                            >
                              <span
                                style={{
                                  flex: 1,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  fill="#6c63ff"
                                  style={{
                                    marginRight: 8,
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <rect width="18" height="18" rx="3" />
                                </svg>
                                {file.name}
                              </span>
                              <button
                                onClick={() => handleTechRemove(index)}
                                style={{
                                  marginLeft: 16,
                                  padding: "4px 12px",
                                  backgroundColor: "#ff4e4e",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: 4,
                                  fontWeight: 500,
                                  cursor: "pointer",
                                  fontSize: 14,
                                }}
                              >
                                Remove
                              </button>
                            </li>
                          ))}
                          {!techDocs?.length && (
                            <li
                              style={{
                                color: "#999",
                                textAlign: "center",
                                padding: 20,
                              }}
                            >
                              No files uploaded
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                  {((roleemp != "CertificationAccessCvTeamHead" &&
                    roleemp != "CertificationAccessCvTeam") ||
                    roleemp === "CertificationAccess" ||
                    roleemp === "CertificateAccessBd" ||
                    roleemp === "certificaionadminaccess") && (
                    <div
                      style={{
                        width: "100%",
                        maxWidth: 480,
                        margin: "0 auto",
                        background: "#fff",
                        borderRadius: 8,
                        boxShadow: "0 2px 12px #eee",
                        padding: 32,
                        marginTop: 24,
                      }}
                    >
                      <label
                        className="form-labels font-weight500 font-size-subheading"
                        style={{
                          marginBottom: 12,
                          display: "block",
                          fontSize: 18,
                          fontWeight: 600,
                        }}
                      >
                        Upload Financial Proposal
                      </label>

                      {/* If there are any required/previous docs from wishListData */}
                      {wishListData?.financial_doc?.length > 0 && (
                        <div style={{ marginBottom: 18 }}>
                          {wishListData.financial_doc.map((cv) => (
                            <div
                              key={cv.document_name}
                              style={{ marginBottom: 6 }}
                            >
                              <label
                                style={{ color: "#6c63ff", fontWeight: 500 }}
                              >
                                {cv.document_name}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* File Input and Add Button */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: 24,
                        }}
                      >
                        <input
                          type="file"
                          multiple
                          onChange={handleFinancialFileChange}
                          style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                          className="form-control"
                        />
                        <button
                          onClick={handleAddFinancialDoc}
                          style={{
                            padding: "8px 20px",
                            backgroundColor: "#6c63ff",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            fontWeight: 600,
                            fontSize: 15,
                            cursor: "pointer",
                          }}
                          disabled={!finacialDocs.length}
                        >
                          Add
                        </button>
                      </div>

                      {/* List of uploaded tech docs */}
                      <ul
                        style={{
                          listStyle: "none",
                          padding: 0,
                          margin: 0,
                          width: "100%",
                          maxHeight: 180,
                          overflowY: "auto",
                          border: finacialDocs?.length
                            ? "1px solid #ececec"
                            : "none",
                          borderRadius: 6,
                          background: finacialDocs?.length ? "#fafafd" : "none",
                        }}
                      >
                        {finacialDocs?.map((file, index) => (
                          <li
                            key={file.name + index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "10px 8px",
                              borderBottom:
                                index !== finacialDocs.length - 1
                                  ? "1px solid #ececec"
                                  : "none",
                            }}
                          >
                            <span
                              style={{
                                flex: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <svg
                                width="18"
                                height="18"
                                fill="#6c63ff"
                                style={{
                                  marginRight: 8,
                                  verticalAlign: "middle",
                                }}
                              >
                                <rect width="18" height="18" rx="3" />
                              </svg>
                              {file.name}
                            </span>
                            <button
                              onClick={() => handleFinancialRemove(index)}
                              style={{
                                marginLeft: 16,
                                padding: "4px 12px",
                                backgroundColor: "#ff4e4e",
                                color: "#fff",
                                border: "none",
                                borderRadius: 4,
                                fontWeight: 500,
                                cursor: "pointer",
                                fontSize: 14,
                              }}
                            >
                              Remove
                            </button>
                          </li>
                        ))}
                        {!finacialDocs?.length && (
                          <li
                            style={{
                              color: "#999",
                              textAlign: "center",
                              padding: 20,
                            }}
                          >
                            No files uploaded
                          </li>
                        )}
                      </ul>
                    </div>
                  )}
                  {(roleemp === "CertificationAccessCvTeamHead" ||
                    roleemp === "CertificationAccessCvTeam" ||
                    roleemp === "CertificationAccess" ||
                    roleemp === "CertificateAccessBd" ||
                    roleemp === "certificaionadminaccess") && (
                    <div
                      style={{
                        width: "100%",
                        maxWidth: 480,
                        margin: "0 auto",
                        background: "#fff",
                        borderRadius: 8,
                        boxShadow: "0 2px 12px #eee",
                        padding: 32,
                        marginTop: 24,
                      }}
                    >
                      <label
                        className="form-labels font-weight500 font-size-subheading"
                        style={{
                          marginBottom: 12,
                          display: "block",
                          fontSize: 18,
                          fontWeight: 600,
                        }}
                      >
                        Upload CV's
                      </label>

                      {/* If there are any required/previous docs from wishListData */}
                      {wishListData?.cvs_files?.length > 0 && (
                        <div style={{ marginBottom: 18 }}>
                          {wishListData.cvs_files.map((cv) => (
                            <div
                              key={cv.document_name}
                              style={{ marginBottom: 6 }}
                            >
                              <label
                                style={{ color: "#6c63ff", fontWeight: 500 }}
                              >
                                {cv.document_name}
                              </label>
                            </div>
                          ))}
                        </div>
                      )}

                      {/* File Input and Add Button */}
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "space-between",
                          marginBottom: 24,
                        }}
                      >
                        <input
                          type="file"
                          multiple
                          onChange={handleCvsFileChange}
                          style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                          className="form-control"
                        />
                        <button
                          onClick={handleAddCvDoc}
                          style={{
                            padding: "8px 20px",
                            backgroundColor: "#6c63ff",
                            color: "#fff",
                            border: "none",
                            borderRadius: 4,
                            fontWeight: 600,
                            fontSize: 15,
                            cursor: "pointer",
                          }}
                          disabled={!cvsDocs.length}
                        >
                          Add
                        </button>
                      </div>

                      {/* List of uploaded tech docs */}
                      <ul
                        style={{
                          listStyle: "none",
                          padding: 0,
                          margin: 0,
                          width: "100%",
                          maxHeight: 180,
                          overflowY: "auto",
                          border: cvsDocs?.length
                            ? "1px solid #ececec"
                            : "none",
                          borderRadius: 6,
                          background: cvsDocs?.length ? "#fafafd" : "none",
                        }}
                      >
                        {cvsDocs?.map((file, index) => (
                          <li
                            key={file.name + index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "space-between",
                              padding: "10px 8px",
                              borderBottom:
                                index !== cvsDocs.length - 1
                                  ? "1px solid #ececec"
                                  : "none",
                            }}
                          >
                            <span
                              style={{
                                flex: 1,
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              <svg
                                width="18"
                                height="18"
                                fill="#6c63ff"
                                style={{
                                  marginRight: 8,
                                  verticalAlign: "middle",
                                }}
                              >
                                <rect width="18" height="18" rx="3" />
                              </svg>
                              {file.name}
                            </span>
                            <button
                              onClick={() => handleCvsRemove(index)}
                              style={{
                                marginLeft: 16,
                                padding: "4px 12px",
                                backgroundColor: "#ff4e4e",
                                color: "#fff",
                                border: "none",
                                borderRadius: 4,
                                fontWeight: 500,
                                cursor: "pointer",
                                fontSize: 14,
                              }}
                            >
                              Remove
                            </button>
                          </li>
                        ))}
                        {!cvsDocs?.length && (
                          <li
                            style={{
                              color: "#999",
                              textAlign: "center",
                              padding: 20,
                            }}
                          >
                            No files uploaded
                          </li>
                        )}
                      </ul>
                    </div>
                  )}
                  {/*  */}

                  {(roleemp === "CertificationAccessCvTeamHead" ||
                    roleemp === "CertificationAccessCvTeam" ||
                    roleemp === "CertificationAccess" ||
                    roleemp === "CertificateAccessBd" ||
                    roleemp === "certificaionadminaccess") && (
                    <div className="flex-column form-group-selectt">
                      <label
                        htmlFor="all_cvs_done"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        All CV's Done<span className="required">*</span>
                      </label>
                      <br />

                      <select
                        id="all_cvs_done"
                        name="all_cvs_done"
                        value={wishListData.all_cvs_done}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            all_cvs_done:
                              e.target.value === "true"
                                ? true
                                : e.target.value === "false"
                                  ? false
                                  : null, // handles "Select Team Required"
                          }))
                        }
                        className="form-input input-form form-group-selection"
                      >
                        <option value="">All Cv's done</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  )}
                  {roleemp != "CertificationAccessCvTeamHead" &&
                    roleemp != "CertificationAccessCvTeam" && (
                      <div
                        style={{
                          width: "100%",
                          maxWidth: 480,
                          margin: "0 auto",
                          background: "#fff",
                          borderRadius: 8,
                          boxShadow: "0 2px 12px #eee",
                          padding: 32,
                          marginTop: 24,
                        }}
                      >
                        <label
                          className="form-labels font-weight500 font-size-subheading"
                          style={{
                            marginBottom: 12,
                            display: "block",
                            fontSize: 18,
                            fontWeight: 600,
                          }}
                        >
                          Upload Bid Acknowledgemnet
                        </label>

                        {/* If there are any required/previous docs from wishListData */}
                        {wishListData?.bid_doc?.length > 0 && (
                          <div style={{ marginBottom: 18 }}>
                            {wishListData.bid_doc.map((cv) => (
                              <div
                                key={cv.document_name}
                                style={{ marginBottom: 6 }}
                              >
                                <label
                                  style={{ color: "#6c63ff", fontWeight: 500 }}
                                >
                                  {cv.document_name}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* File Input and Add Button */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: 24,
                          }}
                        >
                          <input
                            type="file"
                            multiple
                            onChange={handleBidsFileChange}
                            style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                            className="form-control"
                          />
                          <button
                            onClick={handleAddBidDoc}
                            style={{
                              padding: "8px 20px",
                              backgroundColor: "#6c63ff",
                              color: "#fff",
                              border: "none",
                              borderRadius: 4,
                              fontWeight: 600,
                              fontSize: 15,
                              cursor: "pointer",
                            }}
                            disabled={!BidDocs.length}
                          >
                            Add
                          </button>
                        </div>

                        {/* List of uploaded tech docs */}
                        <ul
                          style={{
                            listStyle: "none",
                            padding: 0,
                            margin: 0,
                            width: "100%",
                            maxHeight: 180,
                            overflowY: "auto",
                            border: BidDocs?.length
                              ? "1px solid #ececec"
                              : "none",
                            borderRadius: 6,
                            background: BidDocs?.length ? "#fafafd" : "none",
                          }}
                        >
                          {BidDocs?.map((file, index) => (
                            <li
                              key={file.name + index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "10px 8px",
                                borderBottom:
                                  index !== cvsDocs.length - 1
                                    ? "1px solid #ececec"
                                    : "none",
                              }}
                            >
                              <span
                                style={{
                                  flex: 1,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  fill="#6c63ff"
                                  style={{
                                    marginRight: 8,
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <rect width="18" height="18" rx="3" />
                                </svg>
                                {file.name}
                              </span>
                              <button
                                onClick={() => handleBidsRemove(index)}
                                style={{
                                  marginLeft: 16,
                                  padding: "4px 12px",
                                  backgroundColor: "#ff4e4e",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: 4,
                                  fontWeight: 500,
                                  cursor: "pointer",
                                  fontSize: 14,
                                }}
                              >
                                Remove
                              </button>
                            </li>
                          ))}
                          {!BidDocs?.length && (
                            <li
                              style={{
                                color: "#999",
                                textAlign: "center",
                                padding: 20,
                              }}
                            >
                              No files uploaded
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                </>
              )}

              {toggleState === 5 && (
                <>
                  {/* <div className="checkbox-wrapper">
                                        <label className="custom-checkbox  font-weight500 font-size-subheading">
                                            <input
                                                type="checkbox"
                                                name="tech_open"
                                                checked={wishListData.tech_open}
                                                onChange={(e) => setWishListData((prev) => ({ ...prev, tech_open: e.target.checked }))}
                                            />
                                            <span className="checkmark"></span>
                                            Tech Open
                                        </label>
                                    </div> */}

                  <div className="dropdown-wrapper flex justify-center ">
                    <label
                      htmlFor="tech_open"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Tech Open<span className="required">*</span>
                    </label>
                    <br />

                    <select
                      id="tech_open"
                      name="tech_open"
                      value={wishListData.tech_open}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          tech_open:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null, // handles "Select Team Required"
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Tech Open</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>

                  {wishListData.tech_open && (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <div className="flex-column form-group-selectt">
                        <table
                          className="table-css table-border"
                          style={{ borderRadius: "15px" }}
                        >
                          <thead className="table-heading">
                            <tr className="custom-table-head-tr">
                              <th
                                className="table-heading-text text-center table-border"
                                style={{ padding: "8px 10px" }}
                              >
                                S.No
                              </th>
                              <th
                                className="table-heading-text text-center table-border"
                                style={{ padding: "8px 10px" }}
                              >
                                Name
                              </th>
                              <th
                                className="table-heading-text text-center table-border"
                                style={{ padding: "8px 10px" }}
                              >
                                Score
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {wishListData?.participants?.map(
                              (bidder, index) => (
                                <tr>
                                  <td
                                    className="text-center table-border"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    className="text-center table-border"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {bidder.name}
                                  </td>
                                  <td
                                    className="text-center table-border"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {bidder.score}
                                  </td>
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                        <label
                          htmlFor="participant_name"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Add Participant
                        </label>
                        <br />
                        <br />
                        <label
                          htmlFor="participant_name"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Participant Name<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="participant_name"
                          placeholder="participant_name"
                          value={wishListData.participant_name.value}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              participant_name: {
                                ...prev.participant_name,
                                value: e.target.value,
                              },
                            }))
                          }
                          className={`form-input input-form`}
                        />

                        <label
                          htmlFor="participant_name"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Participant Score<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="participant_score"
                          placeholder="participant_score"
                          value={wishListData.participant_name.score}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              participant_name: {
                                ...prev.participant_name,
                                score: e.target.value,
                              },
                            }))
                          }
                          className={`form-input input-form`}
                        />
                      </div>

                      <button
                        className="upload-svg"
                        style={{
                          display: "flex",
                          gap: "10px",
                          width: "fit-content",
                          marginLeft: "auto",
                        }}
                        disabled={
                          wishListData.participant_name.loading ||
                          wishListData.participant_name.value === ""
                        }
                        onClick={handleParticipantSubmit}
                      >
                        <AddwithWhiteCircle />
                        Add
                      </button>
                    </div>
                  )}
                  {wishListData.tech_open && (
                    <div className="dropdown-wrapper flex justify-center ">
                      <label
                        htmlFor="tech_responsive"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Tech Responsive<span className="required">*</span>
                      </label>
                      <br />

                      <select
                        id="tech_responsive"
                        name="tech_responsive"
                        value={wishListData.tech_responsive}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            tech_responsive:
                              e.target.value === "true"
                                ? true
                                : e.target.value === "false"
                                  ? false
                                  : null, // handles "Select Team Required"
                          }))
                        }
                        className="form-input font-size-subheading"
                      >
                        <option value="">Tech Responsive</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  )}
                  {wishListData.tech_responsive && (
                    <div className="dropdown-wrapper flex justify-center ">
                      <label
                        htmlFor="financial_status"
                        className="form-labels  font-weight500    font-size-subheading"
                      >
                        Financial Status<span className="required">*</span>
                      </label>
                      <br />

                      <select
                        id="financial_status"
                        name="financial_status"
                        value={wishListData.financial_status}
                        onChange={(e) =>
                          setWishListData((prev) => ({
                            ...prev,
                            financial_status:
                              e.target.value === "true"
                                ? true
                                : e.target.value === "false"
                                  ? false
                                  : null, // handles "Select Team Required"
                          }))
                        }
                        className="form-input font-size-subheading"
                      >
                        <option value="">Financial Status</option>
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                      </select>
                    </div>
                  )}
                  {wishListData.financial_status && (
                    <div
                      style={{
                        width: "100%",
                        display: "flex",
                        flexDirection: "column",
                        gap: "8px",
                      }}
                    >
                      <div className="flex-column form-group-selectt">
                        <table
                          className="table-css table-border"
                          style={{ borderRadius: "15px" }}
                        >
                          <thead className="table-heading">
                            <tr className="custom-table-head-tr">
                              <th
                                className="table-heading-text text-center table-border"
                                style={{ padding: "8px 10px" }}
                              >
                                S.No
                              </th>
                              <th
                                className="table-heading-text text-center table-border"
                                style={{ padding: "8px 10px" }}
                              >
                                Name
                              </th>
                              <th
                                className="table-heading-text text-center table-border"
                                style={{ padding: "8px 10px" }}
                              >
                                Score
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {wishListData?.financial_participants?.map(
                              (bidder, index) => (
                                <tr>
                                  <td
                                    className="text-center table-border"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {index + 1}
                                  </td>
                                  <td
                                    className="text-center table-border"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {bidder.name}
                                  </td>
                                  <td
                                    className="text-center table-border"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {bidder.score}
                                  </td>
                                </tr>
                              ),
                            )}
                          </tbody>
                        </table>
                        <label
                          htmlFor="participant_name"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Add Participant
                        </label>
                        <br />
                        <br />
                        <label
                          htmlFor="participant_name"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Participant Name<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="financial_participants"
                          placeholder="financial_participants"
                          value={wishListData.financial_participant_name.value}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              financial_participant_name: {
                                ...prev.financial_participant_name,
                                value: e.target.value,
                              },
                            }))
                          }
                          className={`form-input input-form`}
                        />

                        <label
                          htmlFor="financial_participants"
                          className="form-labels  font-weight500    font-size-subheading"
                        >
                          Participant Score<span className="required">*</span>
                        </label>
                        <input
                          type="text"
                          name="participant_score"
                          placeholder="participant_score"
                          value={wishListData.financial_participant_name.score}
                          onChange={(e) =>
                            setWishListData((prev) => ({
                              ...prev,
                              financial_participant_name: {
                                ...prev.financial_participant_name,
                                score: e.target.value,
                              },
                            }))
                          }
                          className={`form-input input-form`}
                        />
                      </div>

                      <button
                        className="upload-svg"
                        style={{
                          display: "flex",
                          gap: "10px",
                          width: "fit-content",
                          marginLeft: "auto",
                        }}
                        disabled={
                          wishListData.financial_participant_name.loading ||
                          wishListData.financial_participant_name.value === ""
                        }
                        onClick={handleFinancialParticipantSubmit}
                      >
                        <AddwithWhiteCircle />
                        Add
                      </button>
                    </div>
                  )}

                  <div className="dropdown-wrapper flex justify-center ">
                    <label
                      htmlFor="are_we_l1"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Are We L1<span className="required">*</span>
                    </label>
                    <br />

                    <select
                      id="are_we_l1"
                      name="are_we_l1"
                      value={wishListData.are_we_l1}
                      onChange={(e) =>
                        setWishListData((prev) => ({
                          ...prev,
                          are_we_l1:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null, // handles "Select Team Required"
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Are We L1</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                  {roleemp != "CertificationAccessCvTeamHead" &&
                    roleemp != "CertificationAccessCvTeam" && (
                      <div
                        style={{
                          width: "100%",
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                        }}
                      >
                        <label style={{ fontSize: "16px", fontWeight: 500 }}>
                          Bidder
                        </label>
                        {/* <table className="table-css " border="1" cellspacing="0" cellpadding="8"> */}
                        <table
                          className="table-css table-border"
                          style={{ borderRadius: "15px" }}
                        >
                          <thead className="table-heading">
                            <tr className="custom-table-head-tr">
                              <th
                                className="table-heading-text text-center table-border"
                                style={{ padding: "8px 10px" }}
                              >
                                S.No
                              </th>
                              <th
                                className="table-heading-text text-center table-border"
                                style={{ padding: "8px 10px" }}
                              >
                                Bidder Name
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {wishListData?.bidders?.map((bidder, index) => (
                              <tr>
                                <td
                                  className="text-center table-border"
                                  style={{ fontSize: "14px" }}
                                >
                                  {index + 1}
                                </td>
                                <td
                                  className="text-center table-border"
                                  style={{ fontSize: "14px" }}
                                >
                                  {bidder.bidder_name}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                        <div className="flex-column form-group-selectt">
                          <label
                            htmlFor="bidder_name"
                            className="form-labels  font-weight500    font-size-subheading"
                          >
                            Bidder Name<span className="required">*</span>
                          </label>
                          <br />
                          <input
                            type="text"
                            name="bidder_name"
                            placeholder="bidder_name"
                            value={wishListData.bidder_name.value}
                            onChange={(e) =>
                              setWishListData((prev) => ({
                                ...prev,
                                bidder_name: {
                                  ...prev.bidder_name,
                                  value: e.target.value,
                                },
                              }))
                            }
                            className={`form-input input-form`}
                          />
                        </div>

                        <button
                          className="upload-svg"
                          style={{
                            display: "flex",
                            gap: "10px",
                            width: "fit-content",
                            marginLeft: "auto",
                          }}
                          disabled={
                            wishListData.bidder_name.loading ||
                            wishListData.bidder_name.value === ""
                          }
                          onClick={handleBidderSubmit}
                        >
                          <AddwithWhiteCircle />
                          Add
                        </button>
                      </div>
                    )}
                  {roleemp != "CertificationAccessCvTeamHead" &&
                    roleemp != "CertificationAccessCvTeam" && (
                      <div
                        style={{
                          width: "100%",
                          maxWidth: 480,
                          margin: "0 auto",
                          background: "#fff",
                          borderRadius: 8,
                          boxShadow: "0 2px 12px #eee",
                          padding: 32,
                          marginTop: 24,
                        }}
                      >
                        <label
                          className="form-labels font-weight500 font-size-subheading"
                          style={{
                            marginBottom: 12,
                            display: "block",
                            fontSize: 18,
                            fontWeight: 600,
                          }}
                        >
                          Upload Bidder Attachment Document
                        </label>

                        {/* If there are any required/previous docs from wishListData */}
                        {wishListData?.bidder_doc?.length > 0 && (
                          <div style={{ marginBottom: 18 }}>
                            {wishListData.bidder_doc.map((cv) => (
                              <div
                                key={cv.document_name}
                                style={{ marginBottom: 6 }}
                              >
                                <label
                                  style={{ color: "#6c63ff", fontWeight: 500 }}
                                >
                                  {cv.document_name}
                                </label>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* File Input and Add Button */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            marginBottom: 24,
                          }}
                        >
                          <input
                            type="file"
                            multiple
                            onChange={handleBidderDocsFileChange}
                            style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                            className="form-control"
                          />
                          <button
                            onClick={handleAddBidderDoc}
                            style={{
                              padding: "8px 20px",
                              backgroundColor: "#6c63ff",
                              color: "#fff",
                              border: "none",
                              borderRadius: 4,
                              fontWeight: 600,
                              fontSize: 15,
                              cursor: "pointer",
                            }}
                            disabled={!BidDocs.length}
                          >
                            Add
                          </button>
                        </div>

                        {/* List of uploaded tech docs */}
                        <ul
                          style={{
                            listStyle: "none",
                            padding: 0,
                            margin: 0,
                            width: "100%",
                            maxHeight: 180,
                            overflowY: "auto",
                            border: BidderDocs?.length
                              ? "1px solid #ececec"
                              : "none",
                            borderRadius: 6,
                            background: BidderDocs?.length ? "#fafafd" : "none",
                          }}
                        >
                          {BidderDocs?.map((file, index) => (
                            <li
                              key={file.name + index}
                              style={{
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "space-between",
                                padding: "10px 8px",
                                borderBottom:
                                  index !== BidderDocs.length - 1
                                    ? "1px solid #ececec"
                                    : "none",
                              }}
                            >
                              <span
                                style={{
                                  flex: 1,
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  whiteSpace: "nowrap",
                                }}
                              >
                                <svg
                                  width="18"
                                  height="18"
                                  fill="#6c63ff"
                                  style={{
                                    marginRight: 8,
                                    verticalAlign: "middle",
                                  }}
                                >
                                  <rect width="18" height="18" rx="3" />
                                </svg>
                                {file.name}
                              </span>
                              <button
                                onClick={() => handleBidderDocsRemove(index)}
                                style={{
                                  marginLeft: 16,
                                  padding: "4px 12px",
                                  backgroundColor: "#ff4e4e",
                                  color: "#fff",
                                  border: "none",
                                  borderRadius: 4,
                                  fontWeight: 500,
                                  cursor: "pointer",
                                  fontSize: 14,
                                }}
                              >
                                Remove
                              </button>
                            </li>
                          ))}
                          {!BidderDocs?.length && (
                            <li
                              style={{
                                color: "#999",
                                textAlign: "center",
                                padding: 20,
                              }}
                            >
                              No files uploaded
                            </li>
                          )}
                        </ul>
                      </div>
                    )}
                </>
              )}
            </div>
            <p className="error-message font-size-text">
              {isSubmitted && Object.keys(errors).length > 0 && (
                <h6 className="text-center">
                  {"Error in: " +
                    Object.keys(errors)
                      .map((field) => {
                        // Convert field names to readable format
                        const formatted = field
                          .replace(/_/g, " ") // replace underscores with spaces
                          .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letters
                        return `${formatted}`; // include the actual error message
                      })
                      .join(", ")}
                </h6>
              )}
            </p>

            <div className="button-models">
              <button
                type="submit"
                onClick={(e) => handleSubmitEligibilityCretria(e, filters)}
                className="model-button model-button-submit"
              >
                {toggleState === 1 ? "Update" : "Submit"}
              </button>
            </div>
          </form>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};
const EditTenderInfo = ({
  showEditModal,
  handleCloseEditModal,
  toggleState,
  tenders,
  tenderId,
  getBidData,
  editTenderData,
  showModal,
  filters,
  roleemp,
}) => {
  const TABS = [
    { key: "eligibility", label: "Eligibility Criteria", minToggle: 3 },
    { key: "partners", label: "Finalize Partners", minToggle: 4 },
    { key: "documents", label: "Attach Tender Documents", minToggle: 5 },
  ];

  const tender = useMemo(() => {
    return tenders?.find((t) => t.id === tenderId) ?? {};
  }, [tenders, tenderId]);

  const filteredTabs = useMemo(() => {
    return TABS?.filter((tab) => toggleState >= tab.minToggle);
  }, [toggleState]);

  const getInitialTab = () => {
    return filteredTabs.length > 0 ? filteredTabs[0].key : null;
  };

  const [activeTab, setActiveTab] = useState(getInitialTab());

  useEffect(() => {
    const tabExists = filteredTabs.find((tab) => tab.key === activeTab);
    if (!tabExists) {
      const newActive = filteredTabs.length > 0 ? filteredTabs[0].key : null;
      if (newActive !== activeTab) {
        setActiveTab(newActive);
      }
    }
  }, [toggleState, activeTab, filteredTabs]);

  const [tenderDocumentsData, setTenderDocumentsData] = useState({
    checklist: tender.checklist ?? false,
    all_docs_done: tender.all_docs_done ?? false,
    tech_score: tender.tech_score ?? "",
    cv_score: tender.cv_score ?? "",
    tech_doc: tender.tech_doc ?? [],
    financial_doc: tender.financial_doc ?? [],
    cvs_files: tender.cvs_files ?? [],
    bid_doc: tender.bid_doc ?? [],
    bidder_doc: tender.bidder_doc ?? [],
    all_cvs_done: tender.all_cvs_done ?? false,
    bidders: tender.tender_bidders ?? [],
    bidder_name: {
      value: "",
      laoding: false,
    },
  });

  const [finalizePartnersData, setFinalizePartnersData] = useState({
    lead_partner: tender.lead_partner
      ? tender.lead_partner
      : tender.lead_qualify
        ? tender.company_name
        : "",
    lead_partner_share: tender.lead_partner_share ?? "",
    partner_share_sum: 0,
    jv_partner_share: tender.jv_partner_share ?? "",
    jv_partner_name:
      tender.soil_quality === true
        ? "Not Required"
        : tender.jv_partner_name
          ? tender.jv_partner_name
          : tender.jv_qualify
            ? tender.company_name
            : "",
    assosiate_partner:
      tender.soil_quality === true
        ? "Not Required"
        : tender.assosiate_partner
          ? tender.assosiate_partner
          : tender.associate_qualify
            ? tender.company_name
            : "",
    associate_partner_share: tender.associate_partner_share ?? "",
    bg_requried: tender.bg_requried,
    bg_amount: tender.bg_amount ?? 0,
    bg_prepare_by: tender.bg_prepare_by ?? "",
    bid_prepare_by: tender.bid_prepare_by ?? "",
    bid_prepare_by_remarks: tender.bid_prepare_by_remarks ?? "",
    // emd_assumpter: tender.emd_assumpter,

    bg_type: tender.bg_type ?? "",

    tender_submission_type: tender.tender_submission_type ?? "",

    emd_submission_type: tender.emd_submission_type ?? "",
    team_required: tender.team_required,
    team_requirements_details: tender.team_requirements_details ?? "",
    team_prepare_by: tender.team_prepare_by,
    team_prepare_by_remarks: tender.team_prepare_by_remarks,
    emd_type: tender.emd_type ?? "",
    emd_review: tender.emd_review,

    emd_amount: tender.emd_amount ?? 0,
    emd_unit: tender.emd_unit,
    is_emd_required: tender.is_emd_required,
    exmpted_emd: tender.exmpted_emd,
  });

  const [eligibilityCriteriaData, setEligibilityCriteriaData] = useState({
    eligibity_criteria: tender?.eligibity_criteria ?? "",
    eligibity_criteria_special: tender?.eligibity_criteria_special ?? "",
    is_jv_allowed: tender?.is_jv_allowed ?? false,
    is_jv_consorium_association_allowed:
      tender?.is_jv_consorium_association_allowed ?? false,
    company_name: tender?.company_name ?? "",
    company_dist_lead: tender?.company_dist_lead,
    company_dist_jv: tender?.company_dist_jv,
    soil_quality: tender?.soil_quality ?? false,
    participating_as: tender?.participating_as ?? "",
    terms_of_jv: tender?.terms_of_jv ?? "",
    tech_score: tender?.tech_score ?? "",
    company_score: tender?.company_score ?? "",
    site_apprisate_required: tender?.site_apprisate_required ?? false,
    site_apprisate_marking: tender?.site_apprisate_marking ?? "",
    work_methodology_required: tender?.work_methodology_required ?? false,
    work_methodology_marking: tender?.work_methodology_marking ?? "",
    presentation_required: tender?.presentation_required ?? false,
    presentation_type: tender?.presentation_type ?? "",
    presentation_required_marking: tender?.presentation_required_marking ?? "",
  });

  useEffect(() => {
    if (tender) {
      setEligibilityCriteriaData({
        eligibity_criteria: tender?.eligibity_criteria ?? "",
        eligibity_criteria_special: tender?.eligibity_criteria_special ?? "",
        is_jv_allowed: tender?.is_jv_allowed ?? false,
        is_jv_consorium_association_allowed:
          tender?.is_jv_consorium_association_allowed ?? false,
        company_name: tender?.company_name ?? "",
        company_dist_lead: tender?.company_dist_lead,
        company_dist_jv: tender?.company_dist_jv,
        soil_quality: tender?.soil_quality ?? false,
        participating_as: tender?.participating_as ?? "",
        terms_of_jv: tender?.terms_of_jv ?? "",
        tech_score: tender?.tech_score ?? "",
        company_score: tender?.company_score ?? "",
        site_apprisate_required: tender?.site_apprisate_required ?? false,
        site_apprisate_marking: tender?.site_apprisate_marking ?? "",
        work_methodology_required: tender?.work_methodology_required ?? false,
        work_methodology_marking: tender?.work_methodology_marking ?? "",
        presentation_required: tender?.presentation_required ?? false,
        presentation_type: tender?.presentation_type ?? "",
        presentation_required_marking:
          tender?.presentation_required_marking ?? "",
      });
      setFinalizePartnersData({
        lead_partner: tender.lead_partner
          ? tender.lead_partner
          : tender.lead_qualify
            ? tender.company_name
            : "",
        lead_partner_share: tender.lead_partner_share ?? "",
        partner_share_sum: 0,
        jv_partner_share: tender.jv_partner_share ?? "",
        jv_partner_name: tender.jv_partner_name
          ? tender.jv_partner_name
          : tender.jv_qualify
            ? tender.company_name
            : "",
        assosiate_partner: tender.assosiate_partner
          ? tender.assosiate_partner
          : tender.associate_qualify
            ? tender.company_name
            : "",
        associate_partner_share: tender.associate_partner_share ?? "",
        bg_requried: tender.bg_requried,
        bg_amount: tender.bg_amount ?? 0,
        bg_prepare_by: tender.bg_prepare_by ?? "",
        bid_prepare_by: tender.bid_prepare_by ?? "",
        bid_prepare_by_remarks: tender.bid_prepare_by_remarks ?? "",
        // emd_assumpter: tender.emd_assumpter,

        bg_type: tender.bg_type ?? "",

        tender_submission_type: tender.tender_submission_type ?? "",

        emd_submission_type: tender.emd_submission_type ?? "",
        team_required: tender.team_required,
        team_requirements_details: tender.team_requirements_details ?? "",
        team_prepare_by: tender.team_prepare_by,
        team_prepare_by_remarks: tender.team_prepare_by_remarks,
        emd_type: tender.emd_type ?? "",
        emd_review: tender.emd_review,

        emd_amount: tender.emd_amount ?? 0,
        emd_unit: tender.emd_unit,
        is_emd_required: tender.is_emd_required,
        exmpted_emd: tender.exmpted_emd,
      });
      setTenderDocumentsData({
        checklist: tender.checklist ?? false,
        all_docs_done: tender.all_docs_done ?? false,
        tech_score: tender.tech_score ?? "",
        cv_score: tender.cv_score ?? "",
        tech_doc: tender.tech_doc ?? [],
        financial_doc: tender.financial_doc ?? [],
        cvs_files: tender.cvs_files ?? [],
        bid_doc: tender.bid_doc ?? [],
        bidder_doc: tender.bidder_doc ?? [],
        all_cvs_done: tender.all_cvs_done ?? false,
        bidders: tender.tender_bidders ?? [],
        bidder_name: {
          value: "",
          laoding: false,
        },
      });
    }
    const updatedSum =
      parseInt(tender.lead_partner_share) +
      parseInt(tender.associate_partner_share) +
      parseInt(tender.jv_partner_share);
    setFinalizePartnersData((prev) => ({
      ...prev,
      partner_share_sum: updatedSum,
    }));
  }, [tender]);

  useEffect(() => {
    const updatedSum =
      (parseInt(finalizePartnersData.lead_partner_share) || 0) +
      (parseInt(finalizePartnersData.associate_partner_share) || 0) +
      (parseInt(finalizePartnersData.jv_partner_share) || 0);

    if (finalizePartnersData.partner_share_sum !== updatedSum) {
      setFinalizePartnersData((prev) => ({
        ...prev,
        partner_share_sum: updatedSum,
      }));
    }
  }, [
    finalizePartnersData.lead_partner_share,
    finalizePartnersData.associate_partner_share,
    finalizePartnersData.jv_partner_share,
  ]);
  const [errorsdoc, setErrorsDoc] = useState({});
  const [isSubmitteddoc, setIsSubmittedDoc] = useState(false);
  const validateFormTenderdocument = () => {
    const newErrors = {};
    let requiredFields = [];

    requiredFields = [
      tenderDocumentsData.all_docs_done === null ? "all_docs_done" : null,
      tenderDocumentsData.all_cvs_done === null ? "all_cvs_done" : null,
      tenderDocumentsData.checklist === null ? "checklist" : null,

      "tech_score",
      "cv_score",
    ].filter(Boolean);

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          tenderDocumentsData,
        );
    };

    requiredFields.forEach((field) => {
      if (!tenderDocumentsData[field]) {
        newErrors[field] = ` ${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required !`;
      }
    });

    setErrorsDoc(newErrors);
    setIsSubmittedDoc(true);
    return Object.keys(newErrors).length === 0;
  };
  const handleTenderDocumentUpdate = async (e) => {
    if (validateFormTenderdocument()) {
      e.preventDefault();
      const loadingToastId = toast.loading("Loading: Please wait...");
      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          tenderDocumentsData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };
  const [errorseligiblity, setErrorsEligibilty] = useState({});
  const [isSubmittedeligiblity, setIsSubmittedEligibility] = useState(false);
  const validateFormEligibility = () => {
    const newErrors = {};
    let requiredFields = [];

    console.log(
      eligibilityCriteriaData.participating_as === null,
      eligibilityCriteriaData.participating_as,
    );
    requiredFields = [
      eligibilityCriteriaData.is_jv_allowed === null ? "is_jv_allowed" : null,
      "tech_score",
      "company_score",
      "company_name",
      "eligibity_criteria",
      eligibilityCriteriaData.eligibity_criteria != "" &&
      eligibilityCriteriaData.eligibity_criteria === "Special"
        ? "eligibity_criteria_special"
        : null,
      eligibilityCriteriaData.soil_quality === null ? "soil_quality" : null,
      eligibilityCriteriaData.participating_as === null
        ? "participating_as"
        : null,
      eligibilityCriteriaData.is_jv_consorium_association_allowed === null
        ? "jv_consorium_association_allowed"
        : null,

      eligibilityCriteriaData.site_apprisate_required === null
        ? "site_apprisate_required"
        : null,
      eligibilityCriteriaData.site_apprisate_required !== null
        ? "site_apprisate_marking"
        : null,
      eligibilityCriteriaData.work_methodology_required === null
        ? "work_methodology_required"
        : null,
      eligibilityCriteriaData.work_methodology_required != null
        ? "work_methodology_marking"
        : null,
      eligibilityCriteriaData.presentation_required === null
        ? "presentation_required"
        : null,
      eligibilityCriteriaData.presentation_required !== null &&
      eligibilityCriteriaData.presentation_required
        ? "presentation_required_marking"
        : null,
      eligibilityCriteriaData.presentation_required !== null &&
      eligibilityCriteriaData.presentation_required
        ? "presentation_type"
        : null,
    ].filter(Boolean);

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          eligibilityCriteriaData,
        );
    };

    requiredFields.forEach((field) => {
      if (!eligibilityCriteriaData[field]) {
        newErrors[field] = ` ${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required !`;
      }
    });

    setErrorsEligibilty(newErrors);
    setIsSubmittedEligibility(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleEligibilityCriteriaUpdate = async (e) => {
    if (validateFormEligibility()) {
      e.preventDefault();
      const loadingToastId = toast.loading("Loading: Please wait...");
      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          eligibilityCriteriaData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [errorspartner, setErrorsPartner] = useState({});
  const [isSubmittedpartner, setIsSubmittedPartner] = useState(false);
  const validateFormPartner = () => {
    const newErrors = {};
    let requiredFields = [];

    requiredFields = [
      finalizePartnersData.tender_submission_type === null
        ? "tender_submission_type"
        : null,

      finalizePartnersData.bid_prepare_by === null ? "bid_prepare_by" : null,
      finalizePartnersData.bg_prepare_by === null ? "bg_prepare_by" : null,
      "lead_partner_share",
      finalizePartnersData.jv_partner_name != "Not Required"
        ? "jv_partner_share"
        : null,
      finalizePartnersData.assosiate_partner != "Not Required"
        ? "associate_partner_share"
        : null,
      "jv_partner_share",
      finalizePartnersData.team_required === null ? "team_required" : null,
      finalizePartnersData.team_required !== null &&
      finalizePartnersData.team_required
        ? "team_prepare_by"
        : null,
      finalizePartnersData.team_required !== null &&
      finalizePartnersData.team_required
        ? "team_prepare_by_remarks"
        : null,
      finalizePartnersData.team_required !== null &&
      finalizePartnersData.team_required
        ? "team_requirements_details"
        : null,
      finalizePartnersData.is_emd_required === null ? "is_emd_required" : null,
      finalizePartnersData.is_emd_required != null &&
      finalizePartnersData.is_emd_required
        ? "emd_amount"
        : null,

      finalizePartnersData.is_emd_required != null &&
      finalizePartnersData.is_emd_required
        ? "emd_unit"
        : null,
      // finalizePartnersData.is_emd_required != null && finalizePartnersData.is_emd_required ? "emd_review" : null,
      finalizePartnersData.is_emd_required != null &&
      finalizePartnersData.is_emd_required
        ? "exmpted_emd"
        : null,
      // finalizePartnersData.is_emd_required != null && finalizePartnersData.is_emd_required ? "emd_assumpter" : null,
      finalizePartnersData.is_emd_required != null &&
      finalizePartnersData.is_emd_required
        ? "emd_type"
        : null,
      finalizePartnersData.is_emd_required != null &&
      finalizePartnersData.is_emd_required
        ? "emd_submission_type"
        : null,
    ].filter(Boolean);

    const getValue = (path) => {
      return path
        .split(".")
        .reduce(
          (obj, key) => (obj && obj[key] !== undefined ? obj[key] : ""),
          finalizePartnersData,
        );
    };

    requiredFields.forEach((field) => {
      if (!finalizePartnersData[field]) {
        newErrors[field] = ` ${
          field.charAt(0).toUpperCase() + field.slice(1)
        } is required !`;
      }
    });

    setErrorsPartner(newErrors);
    setIsSubmittedPartner(true);
    return Object.keys(newErrors).length === 0;
  };

  const handleFinalizePartnerUpdate = async (e) => {
    if (validateFormPartner()) {
      e.preventDefault();
      const loadingToastId = toast.loading("Loading: Please wait...");
      try {
        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          finalizePartnersData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const [cvsDocs, setCvsDocs] = useState([]);
  const [techDocs, setTechDocs] = useState([]);
  const [finacialDocs, setFinancialDocs] = useState([]);
  const [BidDocs, setBidDocs] = useState([]);
  const handleCvsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setCvsDocs(newFiles);
    }
  };

  const handleCvsRemove = (index) => {
    setCvsDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddCvDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      cvsDocs.forEach((file) => {
        formData.append("cv_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkcv/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setCvsDocs([]);
    } finally {
      setCvsDocs([]);
      getBidData();
    }
  };

  const handleTechFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setTechDocs(newFiles);
    }
  };

  const handleTechRemove = (index) => {
    setTechDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddTechDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      techDocs.forEach((file) => {
        formData.append("tech_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulktech/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setTechDocs([]);
    } finally {
      setTechDocs([]);
      getBidData();
    }
  };

  const handleFinancialFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setFinancialDocs(newFiles);
    }
  };

  const handleFinancialRemove = (index) => {
    setFinancialDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddFinancialDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      finacialDocs.forEach((file) => {
        formData.append("financial_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkfinancial/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setFinancialDocs([]);
    } finally {
      setFinancialDocs([]);
      getBidData();
    }
  };

  const handleBidsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setBidDocs(newFiles);
    }
  };

  const handleBidsRemove = (index) => {
    setBidDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddBidDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();

      BidDocs.forEach((file) => {
        formData.append("bid_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkbbid/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setBidDocs([]);
    } finally {
      setBidDocs([]);
      getBidData();
    }
  };
  const [stop, SetStop] = useState(false);
  const handleBidderSubmit = async (name, id) => {
    const data = {
      bidder_name: name ? name : tenderDocumentsData.bidder_name.value,
      TenderforBD: tenderId ? tenderId : id,
      number_of_bidder: 1,
    };
    try {
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidder_name: { ...prev.bidder_name, loading: true },
      }));
      const res = await axios.post(`${BASE_URL}/siteproject/bidder/`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidders: [...prev.bidders, res.data],
        bidder_name: { ...prev.bidder_name, value: "" },
      }));
      SetStop(true);
    } catch (err) {
    } finally {
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidder_name: { ...prev.bidder_name, loading: false },
      }));
    }
  };
  useEffect(() => {
    if (
      showModal &&
      editTenderData != undefined &&
      editTenderData?.lead_partner != null &&
      !stop &&
      editTenderData?.tender_bidders?.length == 0
    ) {
      SetStop(true);
    }
  }, [editTenderData, showModal, tenderDocumentsData, stop]);

  const EmdType = [
    { key: "Bank_Gurantee", value: "Bank Gurantee" },
    { key: "neft", value: "NEFT" },
    { key: "demand_draft", value: "Demand Draft" },
    { key: "other", value: "Other" },
  ];
  const Partners = [
    {
      key: "Saptagon Asia Private Limited",
      value: "Saptagon Asia Private Limited",
    },
    {
      key: "Civilmantra Infracon Limited",
      value: "Civilmantra Infracon Limited",
    },
    {
      key: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED",
      value: "HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED",
    },
    { key: "ISAN CORPORATION", value: "ISAN CORPORATION" },
    { key: "MARC TECHNOCRATS LIMITED", value: "MARC TECHNOCRATS LIMITED" },
    {
      key: "ALOMNDS GLOBAL INFRASTRUCTURE",
      value: "ALOMNDS GLOBAL INFRASTRUCTURE",
    },
    { key: "VOYANTS SOLUTIONS PVT LTD", value: "VOYANTS SOLUTIONS PVT LTD" },
    {
      key: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED",
      value: "SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED",
    },
    { key: "MSV INTERNATIONAL", value: "MSV INTERNATIONAL" },
    { key: "YONGMA ENGINEERING CO LTD", value: "YONGMA ENGINEERING CO LTD" },
    { key: "TECH-4", value: "TECH-4" },
    {
      key: "AECOM INDIA PRIVATE LIMITED",
      value: "AECOM INDIA PRIVATE LIMITED",
    },
    { key: "SMEC INDIA PVT LTD", value: "SMEC INDIA PVT LTD" },
    { key: "SPECTRUM", value: "SPECTRUM" },
    { key: "INSTUTIUTE GIPROSTROYMOST", value: "INSTUTIUTE GIPROSTROYMOST" },
    {
      key: "RODIC CONSULTANT PRIVATE LIMITED",
      value: "RODIC CONSULTANT PRIVATE LIMITED",
    },
    {
      key: "CHAITANYA PROJECT CONSULTANCY LTD",
      value: "CHAITANYA PROJECT CONSULTANCY LTD",
    },
    {
      key: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)",
      value: "CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)",
    },
    {
      key: "TPF ENGINEERING PRIVATE LIMITED",
      value: "TPF ENGINEERING PRIVATE LIMITED",
    },
    {
      key: "INFRAPLUS CONSULTANCY PVT LTD",
      value: "INFRAPLUS CONSULTANCY PVT LTD",
    },
    { key: "RITES LIMITED", value: "RITES LIMITED" },
    { key: "TPF GETINSAEUROESTUDIOS SL", value: "TPF GETINSAEUROESTUDIOS SL" },
    {
      key: "SA INFRASTURCTURE CONSULTING PRIVATE",
      value: "SA INFRASTURCTURE CONSULTING PRIVATE",
    },
    { key: "CEG LIMITED", value: "CEG LIMITED" },
    {
      key: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD",
      value: "AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD",
    },
    { key: "Egis", value: "Egis" },
    { key: "OPEN SOLUTION", value: "OPEN SOLUTION" },
    { key: "SUMAD ENTERPRISE", value: "SUMAD ENTERPRISE" },
    {
      key: "Earl Techno Consultant Pvt. Ltd.",
      value: "Earl Techno Consultant Pvt. Ltd.",
    },
    { key: "Pentagon", value: "Pentagon" },
    { key: "Ropes", value: "Ropes" },
    { key: "WPKK", value: "WPKK" },
    { key: "sapl", value: "SAPL" },
    { key: "cipl", value: "CIPL" },
    { key: "joint", value: "Joint" },
    { key: "Other", value: "Other" },
    { key: "Not Required", value: "Not Required" },
  ];

  const [scoreError, setScoreError] = useState("");

  const renderTabContent = () => {
    switch (activeTab) {
      case "eligibility":
        return (
          <section
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div className="dropdown-wrapper flex-column justify-center  ">
              <label
                htmlFor="eligibity_criteria"
                className="form-label font-weight500 font-size-subheading"
              >
                Eligibilty Criteria<span className="required">*</span>
              </label>
              <select
                name="eligibity_criteria"
                placeholder="Please write a eligibility creteria. "
                value={eligibilityCriteriaData.eligibity_criteria}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    eligibity_criteria: e.target.value,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Eligibilty Criteria</option>
                <option value="Normal">Normal</option>
                <option value="Special">Special</option>
              </select>
            </div>
            {eligibilityCriteriaData.eligibity_criteria === "Special" && (
              <div className="dropdown-wrapper flex-column justify-center ">
                <label className="form-labels">
                  Eligibility Criteria Special
                  <span className="required">*</span>
                </label>
                <textarea
                  name="eligibity_criteria_special Eligibity Criteria"
                  placeholder="Please write Special Eligibilty Criteria "
                  value={eligibilityCriteriaData.eligibity_criteria_special}
                  className={`form-input input-form`}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      eligibity_criteria_special: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="is_jv_allowed"
                className="font-weight500 font-size-subheading"
              >
                Is Jv allowed<span className="required">*</span>
              </label>
              <select
                id="is_jv_allowed"
                name="is_jv_allowed"
                value={eligibilityCriteriaData.is_jv_allowed}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    is_jv_allowed:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Is Jv Allowed</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="is_jv_consorium_association_allowed"
                className="font-weight500 font-size-subheading"
              >
                Is Consorium/Association allowed
                <span className="required">*</span>
              </label>
              <select
                id="is_jv_consorium_association_allowed"
                name="is_jv_consorium_association_allowed"
                value={
                  eligibilityCriteriaData.is_jv_consorium_association_allowed
                }
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    is_jv_consorium_association_allowed:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Checklist</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {eligibilityCriteriaData.is_jv_consorium_association_allowed && (
              <div className="flex-column">
                <label className="form-labels">Terms of JV </label>
                <textarea
                  name="terms_of_jv"
                  placeholder="terms"
                  value={eligibilityCriteriaData.terms_of_jv}
                  className={`form-input input-form`}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      terms_of_jv: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            <div className="flex-column form-group-selectt">
              <label
                htmlFor="company_name"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Company Name<span className="required">*</span>
              </label>
              <br />
              <select
                id="company_name"
                name="company_name"
                value={eligibilityCriteriaData.company_name}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    company_name: e.target.value,
                  }))
                }
                className={`form-input input-form  form-group-selection`}
              >
                <option value="null">Select Company Name</option>
                <option value="sapl">SAPL</option>
                <option value="cipl">CIPL</option>
              </select>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="soil_quality"
                className="font-weight500 font-size-subheading"
              >
                Sole Qualify<span className="required">*</span>
              </label>
              <select
                id="soil_quality"
                name="soil_quality"
                value={eligibilityCriteriaData.soil_quality}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    soil_quality:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Sole Qualify</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="participating_as "
                className="  font-weight500    font-size-subheading"
              >
                Participating As<span className="required">*</span>
              </label>
              <br />
              <select
                id="participating_as"
                name="participating_as"
                value={eligibilityCriteriaData.participating_as}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    participating_as: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
                //style={{ width: '80% !important' }}
              >
                <option value="">Select Participating As</option>

                <option value="lead">Lead</option>
                <option value="jv">JV</option>
                <option value="associate">Associate</option>
                {eligibilityCriteriaData?.soil_quality ? (
                  <option value="sole">Sole</option>
                ) : (
                  ""
                )}
              </select>
            </div>

            <div
              className="joint-columns"
              style={{ display: "flex", gap: "20px", marginTop: "10px" }}
            >
              <div className="flex-column form-group-selectt widths50">
                <label
                  htmlFor="tech_score"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Total Tech Score<span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="tech_score"
                  placeholder="tech Score"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.tech_score}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      tech_score: e.target.value,
                    }))
                  }
                  style={{ width: "80%" }}
                />
              </div>

              <div className="flex-column form-group-selectt widths50">
                <label
                  htmlFor="company_score"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  {eligibilityCriteriaData.company_name === null ||
                  eligibilityCriteriaData.company_name === "null"
                    ? "Our Company"
                    : eligibilityCriteriaData.company_name?.toUpperCase()}{" "}
                  Technical Score<span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="company_score"
                  placeholder="Company Score"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.company_score}
                  onChange={(e) => {
                    const value = e.target.value;

                    if (
                      Number(value) > Number(eligibilityCriteriaData.tech_score)
                    ) {
                      setScoreError(
                        "Company score cannot be greater than Total Tech Score",
                      );
                    } else {
                      setScoreError("");
                      setEligibilityCriteriaData((prev) => ({
                        ...prev,
                        company_score: value,
                      }));
                    }
                  }}
                  style={{ width: "80%" }}
                />
                <br />
                {scoreError && (
                  <p
                    style={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                  >
                    {scoreError}
                  </p>
                )}
              </div>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="site_apprisate_required"
                className="font-weight500 font-size-subheading"
              >
                Site Appreciate Required <span className="required">*</span>
              </label>
              <select
                id="site_apprisate_required"
                name="site_apprisate_required"
                value={eligibilityCriteriaData.site_apprisate_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    site_apprisate_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Site Appreciate Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            {eligibilityCriteriaData.site_apprisate_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="site_apprisate_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Site Appreciate Marking <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="site_apprisate_marking"
                  placeholder="site_apprisate_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.site_apprisate_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      site_apprisate_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="work_methodology_required"
                className="font-weight500 font-size-subheading"
              >
                Work Methodology Required <span className="required">*</span>
              </label>
              <select
                id="work_methodology_required"
                name="work_methodology_required"
                value={eligibilityCriteriaData.work_methodology_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    work_methodology_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Work Methodology Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            {eligibilityCriteriaData.work_methodology_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="work_methodology_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Work Methodology Marking <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="work_methodology_marking"
                  placeholder="work_methodology_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.work_methodology_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      work_methodology_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="presentation_required"
                className="font-weight500 font-size-subheading"
              >
                Presentation Required <span className="required">*</span>
              </label>
              <select
                id="presentation_required"
                name="presentation_required"
                value={eligibilityCriteriaData.presentation_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    presentation_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Presentation Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {eligibilityCriteriaData.presentation_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="presentation_required_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Presentation Required Marking{" "}
                  <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="presentation_required_marking"
                  placeholder="presentation_required_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.presentation_required_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      presentation_required_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            {eligibilityCriteriaData.presentation_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="presentation_type"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Presentation Type <span className="required">*</span>
                </label>
                <br />
                <select
                  id="presentation_type"
                  name="presentation_type"
                  className={`form-input input-form  form-group-selection `}
                  value={eligibilityCriteriaData.presentation_type}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      presentation_type: e.target.value,
                    }))
                  }
                >
                  <option value="null">Select Presentation Type</option>
                  <option value="Online">Online</option>
                  <option value="physical">Physical</option>
                  <option value="both">Both</option>
                </select>
              </div>
            )}
            <p className="error-message font-size-text">
              {" "}
              {isSubmittedeligiblity &&
                Object.keys(errorseligiblity).length > 0 && (
                  <h6 className="text-center">
                    {"Error in: " +
                      Object.keys(errorseligiblity)
                        .map((field) => {
                          // Convert field names to readable format
                          const formatted = field
                            .replace(/_/g, " ") // replace underscores with spaces
                            .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letters
                          return `${formatted}`; // include the actual error message
                        })
                        .join(", ")}
                  </h6>
                )}
            </p>

            <button
              onClick={handleEligibilityCriteriaUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      case "partners":
        return (
          <section
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div className="flex-column form-group-selectt ">
              <label
                htmlFor="lead_partner"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Lead Partner<span className="required">*</span>
              </label>
              <br />
              {finalizePartnersData.lead_qualify ? (
                <input
                  type="text"
                  name="lead_partner"
                  placeholder="lead partner"
                  value={finalizePartnersData.lead_partner}
                  disabled={finalizePartnersData.lead_qualify}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      lead_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              ) : (
                <select
                  id="lead_partner"
                  name="lead_partner"
                  value={finalizePartnersData.lead_partner}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      lead_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form  form-group-selection`}
                >
                  {Partners.map((partner) => (
                    <option value={partner.key}>{partner.value}</option>
                  ))}
                </select>
              )}
            </div>
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="lead_partner_share"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Lead Partner Share %<span className="required">*</span>
              </label>
              <br />
              <input
                type="number"
                name="lead_partner_share"
                placeholder="lead partner share"
                value={finalizePartnersData.lead_partner_share}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    lead_partner_share: e.target.value,
                  }))
                }
                className={`form-input input-form`}
              />
              {finalizePartnersData.partner_share_sum > 100 && (
                <label style={{ color: "red" }}>
                  Sum of all partner should not be more than 100
                </label>
              )}
              {finalizePartnersData.partner_share_sum < 100 && (
                <label style={{ color: "red" }}>
                  Sum of all lead partner should not be less than 100
                </label>
              )}
            </div>
            {eligibilityCriteriaData.soil_quality != true && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="jv_partner_name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Jv Partner<span className="required">*</span>
                </label>
                <br />
                {finalizePartnersData.jv_qualify ? (
                  <input
                    type="text"
                    name="jv_partner_name"
                    placeholder="Jv Partner"
                    value={finalizePartnersData.jv_partner_name}
                    disabled={finalizePartnersData.jv_qualify}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        jv_partner_name: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                ) : (
                  <select
                    id="jv_partner_name"
                    name="jv_partner_name"
                    value={finalizePartnersData.jv_partner_name}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        jv_partner_name: e.target.value,
                      }))
                    }
                    className={`form-input input-form  form-group-selection`}
                  >
                    {Partners.map((partner) => (
                      <option value={partner.key}>{partner.value}</option>
                    ))}
                  </select>
                )}
              </div>
            )}

            {finalizePartnersData.jv_partner_name != "Not Required" && (
              <>
                {" "}
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="jv_partner_share"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Jv Partner Share %<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="number"
                    name="jv_partner_share"
                    placeholder="Jv Partner Share"
                    value={finalizePartnersData.jv_partner_share}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        jv_partner_share: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
                {finalizePartnersData.partner_share_sum > 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all partner should not be more than 100
                  </label>
                )}
                {finalizePartnersData.partner_share_sum < 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all lead partner should not be less than 100
                  </label>
                )}
              </>
            )}
            {eligibilityCriteriaData.soil_quality != true && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="assosiate_partner"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Assosiate Partner<span className="required">*</span>
                </label>
                <br />
                {finalizePartnersData.associate_qualify ? (
                  <input
                    type="text"
                    name="assosiate_partner"
                    placeholder="Assosiate Partner"
                    value={finalizePartnersData.assosiate_partner}
                    disabled={finalizePartnersData.associate_qualify}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        assosiate_partner: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                ) : (
                  <select
                    id="assosiate_partner"
                    name="assosiate_partner"
                    value={finalizePartnersData.assosiate_partner}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        assosiate_partner: e.target.value,
                      }))
                    }
                    className={`form-input input-form  form-group-selection`}
                  >
                    {Partners.map((partner) => (
                      <option value={partner.key}>{partner.value}</option>
                    ))}
                  </select>
                )}
              </div>
            )}
            {/* {finalizePartnersData.assosiate_partner != "Not Required" && <>         <div className="flex-column form-group-selectt" >
                            <label htmlFor="associate_partner_share" className="form-labels  font-weight500    font-size-subheading">
                                Associate Partner Share %<span className="required">*</span>
                            </label>
                            <br />
                            <input
                                type="number"
                                name="associate_partner_share"
                                placeholder="Associate Partner Share"
                                value={finalizePartnersData.associate_partner_share}
                                onChange={(e) => setFinalizePartnersData((prev) => ({ ...prev, associate_partner_share: e.target.value }))}
                                className={`form-input input-form`}
                            />
                        </div>
                            {finalizePartnersData.partner_share_sum > 100 && <label style={{ color: 'red' }}>Sum of all partner should not be more than 100</label>}
                            {finalizePartnersData.partner_share_sum < 100 && <label style={{ color: 'red' }}>Sum of all lead partner should not be less than 100</label>}
                        </>} */}

            <div className="dropdown-wrapper flex justify-center ">
              <label
                htmlFor="bid_prepare_by"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Bid Prepare By<span className="required">*</span>
              </label>
              <br />
              <select
                id="bid_prepare_by"
                name="bid_prepare_by"
                value={finalizePartnersData.bid_prepare_by}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    bid_prepare_by: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
              >
                <option value="">Select</option>
                <option value="lead_partner">
                  {" "}
                  {finalizePartnersData.lead_partner ||
                  finalizePartnersData.lead_partner != "null"
                    ? finalizePartnersData.lead_partner
                    : ""}
                </option>
                <option value="jv_partner">
                  {" "}
                  {finalizePartnersData.jv_partner_name ||
                  finalizePartnersData.jv_partner_name != "null"
                    ? finalizePartnersData.jv_partner_name
                    : ""}
                </option>
                <option value="associate_partner">
                  {" "}
                  {finalizePartnersData.assosiate_partner ||
                  finalizePartnersData.assosiate_partner != "null"
                    ? finalizePartnersData.assosiate_partner
                    : ""}
                </option>
              </select>
            </div>
            <div className="dropdown-wrapper flex justify-center ">
              <label className="form-labels font-weight500 font-size-subheading">
                Bid Prepare By Remarks
              </label>
              <br />
              <textarea
                name="bid_prepare_by_remarks"
                placeholder="Remarks for bid prepared by"
                value={finalizePartnersData.bid_prepare_by_remarks}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    bid_prepare_by_remarks: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
              />
            </div>

            <div className="dropdown-wrapper flex justify-center ">
              <label
                htmlFor="bg_prepare_by"
                className="form-labels  font-weight500    font-size-subheading"
              >
                BG Prepare By<span className="required">*</span>
              </label>
              <br />
              <select
                id="bg_prepare_by"
                name="bg_prepare_by"
                value={finalizePartnersData.bg_prepare_by}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    bg_prepare_by: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
              >
                <option value="">Select</option>
                <option value="lead_partner">
                  {" "}
                  {finalizePartnersData.lead_partner ||
                  finalizePartnersData.lead_partner != "null"
                    ? finalizePartnersData.lead_partner
                    : ""}
                </option>
                <option value="jv_partner">
                  {" "}
                  {finalizePartnersData.jv_partner_name ||
                  finalizePartnersData.jv_partner_name != "null"
                    ? finalizePartnersData.jv_partner_name
                    : ""}
                </option>
                <option value="associate_partner">
                  {" "}
                  {finalizePartnersData.assosiate_partner ||
                  finalizePartnersData.assosiate_partner != "null"
                    ? finalizePartnersData.assosiate_partner
                    : ""}
                </option>
              </select>
            </div>

            <div className="flex-column form-group-selectt">
              <label
                htmlFor="tender_submission_type"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Tender Submission Type<span className="required">*</span>
              </label>
              <br />
              <select
                id="tender_submission_type"
                name="tender_submission_type"
                value={finalizePartnersData.tender_submission_type}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    tender_submission_type: e.target.value,
                  }))
                }
                className={`form-input input-form  form-group-selection`}
              >
                <option value="null">Select Tender Submission Type</option>
                <option value="Online">Online</option>
                <option value="physical">Physical</option>
                <option value="both">Both</option>
              </select>
            </div>
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="team_required"
                className="font-weight500 font-size-subheading"
              >
                Team Required <span className="required">*</span>
              </label>
              <select
                id="team_required"
                name="team_required"
                value={finalizePartnersData.team_required}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    team_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Team Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {finalizePartnersData.team_required && (
              <>
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="team_prepare_by"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Team Prepare By<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="team_prepare_by"
                    name="team_prepare_by"
                    value={finalizePartnersData.team_prepare_by}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        team_prepare_by: e.target.value,
                      }))
                    }
                    className={`form-input input-form  form-group-selection`}
                  >
                    <option value="">Select</option>
                    <option value="lead_partner">
                      {finalizePartnersData.lead_partner}
                    </option>
                    <option value="jv_partner">
                      {" "}
                      {finalizePartnersData.jv_partner_name}
                    </option>
                    <option value="associate_partner">
                      {" "}
                      {finalizePartnersData.assosiate_partner}
                    </option>
                  </select>
                </div>
                <div className="flex-column">
                  <label className="form-labels">
                    Team Prepare By Remarks <span className="required">*</span>
                  </label>
                  <textarea
                    name="team_prepare_by_remarks"
                    placeholder="Remarks for Team prepared by"
                    value={finalizePartnersData.team_prepare_by_remarks}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        team_prepare_by_remarks: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>{" "}
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="team_requirements_details"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Team Requirements Details<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="team_requirements_details"
                    placeholder="Team Requirements Deatils"
                    value={finalizePartnersData.team_requirements_details}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        team_requirements_details: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
              </>
            )}
            <div className="dropdown-wrapper flex justify-center ">
              <label
                htmlFor="exmpted_emd"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Exmpted Emd<span className="required">*</span>
              </label>
              <br />

              <select
                id="exmpted_emd"
                name="exmpted_emd"
                value={finalizePartnersData.exmpted_emd}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    exmpted_emd:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null, // handles "Select Team Required"
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Exmpted Emd</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="is_emd_required"
                className="font-weight500 font-size-subheading"
              >
                Emd Required <span className="required">*</span>
              </label>
              <select
                id="is_emd_required"
                name="is_emd_required"
                value={finalizePartnersData.is_emd_required}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    is_emd_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Emd Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            {finalizePartnersData.is_emd_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="emd_amount"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Emd Amount<span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="emd_amount"
                  placeholder="Enter full amount (e.g. 1 crore = 10000000)"
                  value={finalizePartnersData.emd_amount}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      emd_amount: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              </div>
            )}

            {finalizePartnersData.is_emd_required && (
              <>
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="emd_type"
                    className="form-labels  font-weight500 font-size-subheading"
                  >
                    Emd type<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="emd_type"
                    name="emd_type"
                    value={finalizePartnersData.emd_type}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        emd_type: e.target.value,
                      }))
                    }
                    className={`form-input input-form  form-group-selection`}
                  >
                    {EmdType.map((emd) => (
                      <option value={emd.key}>{emd.value}</option>
                    ))}
                  </select>
                </div>
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="emd_submission_type"
                    className="form-labels  font-weight500 font-size-subheading"
                  >
                    Emd Submission type<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="emd_submission_type"
                    name="emd_submission_type"
                    value={finalizePartnersData.emd_submission_type}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        emd_submission_type: e.target.value,
                      }))
                    }
                    className={`form-input input-form  form-group-selection`}
                  >
                    <option value="null">EMD Submission Type</option>
                    <option value="online">Online</option>
                    <option value="physical">Physical</option>
                    <option value="both">Both</option>
                  </select>
                </div>
              </>
            )}
            <br />
            <p className="error-message font-size-text">
              {isSubmittedpartner && Object.keys(errorspartner).length > 0 && (
                <h6 className="text-center">
                  {"Error in: " +
                    Object.keys(errorspartner)
                      .map((field) => {
                        // Convert field names to readable format
                        const formatted = field
                          .replace(/_/g, " ") // replace underscores with spaces
                          .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letters
                        return `${formatted}`; // include the actual error message
                      })
                      .join(", ")}
                </h6>
              )}
            </p>
            <button
              onClick={handleFinalizePartnerUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      case "documents":
        return (
          <section>
            {roleemp != "CertificationAccessCvTeamHead" &&
              roleemp != "CertificationAccessCvTeam" && (
                <>
                  <div className="dropdown-wrapper flex-column justify-center ">
                    <label
                      htmlFor="checklist"
                      className="font-weight500 font-size-subheading"
                    >
                      Checklist <span className="required">*</span>
                    </label>
                    <select
                      id="checklist"
                      name="checklist"
                      value={tenderDocumentsData.checklist}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          checklist:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null,
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">Checklist</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>
                  <div className="dropdown-wrapper flex-column justify-center ">
                    <label
                      htmlFor="all_docs_done"
                      className="font-weight500 font-size-subheading"
                    >
                      All Docs Done <span className="required">*</span>
                    </label>
                    <select
                      id="all_docs_done"
                      name="all_docs_done"
                      value={tenderDocumentsData.all_docs_done}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          all_docs_done:
                            e.target.value === "true"
                              ? true
                              : e.target.value === "false"
                                ? false
                                : null,
                        }))
                      }
                      className="form-input font-size-subheading"
                    >
                      <option value="">All Docs Done</option>
                      <option value="true">Yes</option>
                      <option value="false">No</option>
                    </select>
                  </div>

                  <div className="flex-column form-group-selectt">
                    <label
                      htmlFor="tech_score"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Total Technical Score <span className="required">*</span>
                    </label>
                    <br />
                    <input
                      type="text"
                      name="tech_score"
                      placeholder="tech Score"
                      value={tenderDocumentsData.tech_score}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          tech_score: e.target.value,
                        }))
                      }
                      className={`form-input input-form`}
                    />
                  </div>
                </>
              )}
            {(roleemp === "CertificationAccessCvTeamHead" ||
              roleemp === "CertificationAccessCvTeam" ||
              roleemp === "CertificationAccess" ||
              roleemp === "CertificateAccessBd" ||
              roleemp === "certificaionadminaccess") && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="cv_score"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  CV Score <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="cv_score"
                  placeholder="CV Score"
                  value={tenderDocumentsData.cv_score}
                  onChange={(e) =>
                    setTenderDocumentsData((prev) => ({
                      ...prev,
                      cv_score: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              </div>
            )}
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Tech Proposal
              </label>

              {tenderDocumentsData?.tech_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.tech_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleTechFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddTechDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!techDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: techDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: techDocs?.length ? "#fafafd" : "none",
                }}
              >
                {techDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== techDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleTechRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!techDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Financial Proposal
              </label>

              {tenderDocumentsData?.financial_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.financial_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleFinancialFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddFinancialDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!finacialDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: finacialDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: finacialDocs?.length ? "#fafafd" : "none",
                }}
              >
                {finacialDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== finacialDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleFinancialRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!finacialDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload CV's
              </label>

              {tenderDocumentsData?.cvs_files?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.cvs_files.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleCvsFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddCvDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!cvsDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: cvsDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: cvsDocs?.length ? "#fafafd" : "none",
                }}
              >
                {cvsDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== cvsDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleCvsRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!cvsDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="all_cvs_done"
                className="font-weight500 font-size-subheading"
              >
                All Cvs Done
              </label>
              <select
                id="all_cvs_done"
                name="all_cvs_done"
                value={tenderDocumentsData.all_cvs_done}
                onChange={(e) =>
                  setTenderDocumentsData((prev) => ({
                    ...prev,
                    all_cvs_done:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">All Cvs Done</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Bid Acknowledgemnet
              </label>

              {tenderDocumentsData?.bid_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.bid_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleBidsFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddBidDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!BidDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: BidDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: BidDocs?.length ? "#fafafd" : "none",
                }}
              >
                {BidDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== BidDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleBidsRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!BidDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            {roleemp != "CertificationAccessCvTeamHead" &&
              roleemp != "CertificationAccessCvTeam" && (
                <div
                  style={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "8px",
                  }}
                >
                  <label style={{ fontSize: "16px", fontWeight: 500 }}>
                    Bidder
                  </label>

                  <table
                    className="table-css table-border"
                    style={{ borderRadius: "15px" }}
                  >
                    <thead className="table-heading">
                      <tr className="custom-table-head-tr">
                        <th
                          className="table-heading-text text-center table-border"
                          style={{ padding: "8px 10px" }}
                        >
                          S.No
                        </th>
                        <th
                          className="table-heading-text text-center table-border"
                          style={{ padding: "8px 10px" }}
                        >
                          Bidder Name
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {tenderDocumentsData?.bidders?.map((bidder, index) => (
                        <tr>
                          <td
                            className="text-center table-border"
                            style={{ fontSize: "14px" }}
                          >
                            {index + 1}
                          </td>
                          <td
                            className="text-center table-border"
                            style={{ fontSize: "14px" }}
                          >
                            {bidder.bidder_name}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <div className="flex-column form-group-selectt">
                    <label
                      htmlFor="bidder_name"
                      className="form-labels  font-weight500    font-size-subheading"
                    >
                      Bidder Name<span className="required">*</span>
                    </label>
                    <br />
                    <input
                      type="text"
                      name="bidder_name"
                      placeholder="bidder_name"
                      value={tenderDocumentsData.bidder_name.value}
                      onChange={(e) =>
                        setTenderDocumentsData((prev) => ({
                          ...prev,
                          bidder_name: {
                            ...prev.bidder_name,
                            value: e.target.value,
                          },
                        }))
                      }
                      className={`form-input input-form`}
                    />
                  </div>

                  <button
                    className="upload-svg"
                    style={{
                      display: "flex",
                      gap: "10px",
                      width: "fit-content",
                      marginLeft: "auto",
                    }}
                    disabled={
                      tenderDocumentsData.bidder_name.loading ||
                      tenderDocumentsData.bidder_name.value === ""
                    }
                    onClick={handleBidderSubmit}
                  >
                    <AddwithWhiteCircle />
                    Add
                  </button>
                </div>
              )}

            <p className="error-message font-size-text">
              {isSubmitteddoc && Object.keys(errorsdoc).length > 0 && (
                <h6 className="text-center">
                  {"Error in: " +
                    Object.keys(errorsdoc)
                      .map((field) => {
                        // Convert field names to readable format
                        const formatted = field
                          .replace(/_/g, " ") // replace underscores with spaces
                          .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letters
                        return `${formatted}`; // include the actual error message
                      })
                      .join(", ")}
                </h6>
              )}
            </p>

            <button
              onClick={handleTenderDocumentUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        dialogClassName="edit-tender-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Tender Information</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              display: "flex",
              borderBottom: "1px solid #e0e0e0",
              marginBottom: 20,
              gap: 16,
            }}
            role="tablist"
          >
            {filteredTabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                type="button"
                style={{
                  padding: "10px 20px",
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: 16,
                  color: "#495057",
                  background: "none",
                  border: "none",
                  borderBottom: "2px solid transparent",
                  outline: "none",
                  transition: "color 0.18s, border-bottom 0.18s",
                  ...(activeTab === tab.key
                    ? {
                        color: "#0d6efd",
                        borderBottom: "2px solid #0d6efd",
                        fontWeight: 700,
                      }
                    : {}),
                }}
                tabIndex={0}
                aria-selected={activeTab === tab.key}
                role="tab"
                aria-controls={`tab-panel-${tab.key}`}
                id={`tab-${tab.key}`}
              >
                {tab.label}
              </button>
            ))}
          </div>
          <div
            id={`tab-panel-${activeTab}`}
            role="tabpanel"
            aria-labelledby={`tab-${activeTab}`}
            style={{
              background: "#fafbfc",
              borderRadius: 8,
              padding: 20,
              minHeight: 180,
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            }}
          >
            {renderTabContent()}
          </div>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

const EditTenderInfoTab = ({
  showEditModal,
  handleCloseEditModal,
  toggleState,
  tenders,
  tenderId,
  getBidData,
  editTenderData,
  showModal,
  filters,
  roleemp,
}) => {
  const TABS = [
    { key: "eligibility", label: "Eligibility Criteria" },
    { key: "partners", label: "Finalize Partners" },
    { key: "documents", label: "Attach Tender Documents" },
  ];

  const tender = useMemo(() => {
    return tenders?.find((t) => t.id === tenderId) ?? {};
  }, [tenders, tenderId]);

  // State for selected stage
  const [selectedStage, setSelectedStage] = useState("wishlist");

  // Filter tabs based on selected stage
  const filteredTabs = useMemo(() => {
    switch (selectedStage) {
      case "wishlist":
        return TABS.filter((tab) => tab.key === "eligibility");
      case "target":
        return TABS.filter(
          (tab) => tab.key === "eligibility" || tab.key === "partners",
        );
      case "final":
        return TABS; // Show all tabs
      default:
        return TABS.filter((tab) => tab.key === "eligibility");
    }
  }, [selectedStage]);

  const getInitialTab = () => {
    return filteredTabs.length > 0 ? filteredTabs[0].key : null;
  };

  const [activeTab, setActiveTab] = useState(getInitialTab());

  useEffect(() => {
    const tabExists = filteredTabs.find((tab) => tab.key === activeTab);
    if (!tabExists) {
      const newActive = filteredTabs.length > 0 ? filteredTabs[0].key : null;
      if (newActive !== activeTab) {
        setActiveTab(newActive);
      }
    }
  }, [selectedStage, activeTab, filteredTabs]);

  // Handle stage change
  const handleStageChange = (e) => {
    const stage = e.target.value;
    setSelectedStage(stage);

    // Reset to first available tab when stage changes
    switch (stage) {
      case "wishlist":
        setActiveTab("eligibility");
        break;
      case "target":
        setActiveTab("eligibility");
        break;
      case "final":
        setActiveTab("eligibility");
        break;
      default:
        setActiveTab("eligibility");
    }
  };

  // Get toggle state based on selected stage
  const getToggleState = () => {
    switch (selectedStage) {
      case "wishlist":
        return 1; // is_in_bidlist
      case "target":
        return 2; // is_in_targetlist
      case "final":
        return 3; // is_finalize
      default:
        return 1;
    }
  };

  // Form data states
  const [tenderDocumentsData, setTenderDocumentsData] = useState({
    checklist: tender.checklist ?? false,
    all_docs_done: tender.all_docs_done ?? false,
    tech_score: tender.tech_score ?? "",
    cv_score: tender.cv_score ?? "",
    tech_doc: tender.tech_doc ?? [],
    financial_doc: tender.financial_doc ?? [],
    cvs_files: tender.cvs_files ?? [],
    bid_doc: tender.bid_doc ?? [],
    bidder_doc: tender.bidder_doc ?? [],
    all_cvs_done: tender.all_cvs_done ?? false,
    bidders: tender.tender_bidders ?? [],
    bidder_name: { value: "", loading: false },
    team_required: tender.team_required,
    team_requirements_details: tender.team_requirements_details ?? "",
    team_prepare_by: tender.team_prepare_by,
    team_prepare_by_remarks: tender.team_prepare_by_remarks,
    emd_type: tender.emd_type ?? "",
    emd_review: tender.emd_review,
    emd_amount: tender.emd_amount ?? 0,
    emd_unit: tender.emd_unit,
    is_emd_required: tender.is_emd_required,
    exmpted_emd: tender.exmpted_emd,
  });

  const [finalizePartnersData, setFinalizePartnersData] = useState({
    lead_partner: tender.lead_partner
      ? tender.lead_partner
      : tender.lead_qualify
        ? tender.company_name
        : "",
    lead_partner_share: tender.lead_partner_share ?? "",
    partner_share_sum: 0,
    jv_partner_share: tender.jv_partner_share ?? "",
    jv_partner_name: tender.jv_partner_name
      ? tender.jv_partner_name
      : tender.jv_qualify
        ? tender.company_name
        : "",
    assosiate_partner: tender.assosiate_partner
      ? tender.assosiate_partner
      : tender.associate_qualify
        ? tender.company_name
        : "",
    associate_partner_share: tender.associate_partner_share ?? "",
    bg_requried: tender.bg_requried,
    bg_amount: tender.bg_amount ?? 0,
    bg_type: tender.bg_type ?? "",
    tender_submission_type: tender.tender_submission_type ?? "",
    emd_submission_type: tender.emd_submission_type ?? "",
  });

  const [eligibilityCriteriaData, setEligibilityCriteriaData] = useState({
    eligibity_criteria: tender?.eligibity_criteria ?? "",
    eligibity_criteria_special: tender?.eligibity_criteria_special ?? "",
    is_jv_allowed: tender?.is_jv_allowed ?? false,
    is_jv_consorium_association_allowed:
      tender?.is_jv_consorium_association_allowed ?? false,
    company_name: tender?.company_name ?? "",
    company_dist_lead: tender?.company_dist_lead,
    company_dist_jv: tender?.company_dist_jv,
    soil_quality: tender?.soil_quality ?? false,
    participating_as: tender?.participating_as ?? "",
    terms_of_jv: tender?.terms_of_jv ?? "",
    tech_score: tender?.tech_score ?? "",
    company_score: tender?.company_score ?? "",
    site_apprisate_required: tender?.site_apprisate_required ?? false,
    site_apprisate_marking: tender?.site_apprisate_marking ?? "",
    work_methodology_required: tender?.work_methodology_required ?? false,
    work_methodology_marking: tender?.work_methodology_marking ?? "",
    presentation_required: tender?.presentation_required ?? false,
    presentation_type: tender?.presentation_type ?? "",
    presentation_required_marking: tender?.presentation_required_marking ?? "",
  });

  // Update form data when tender changes
  useEffect(() => {
    if (tender) {
      setEligibilityCriteriaData({
        eligibity_criteria: tender?.eligibity_criteria ?? "",
        eligibity_criteria_special: tender?.eligibity_criteria_special ?? "",
        is_jv_allowed: tender?.is_jv_allowed ?? false,
        is_jv_consorium_association_allowed:
          tender?.is_jv_consorium_association_allowed ?? false,
        company_name: tender?.company_name ?? "",
        company_dist_lead: tender?.company_dist_lead,
        company_dist_jv: tender?.company_dist_jv,
        soil_quality: tender?.soil_quality ?? false,
        participating_as: tender?.participating_as ?? "",
        terms_of_jv: tender?.terms_of_jv ?? "",
        tech_score: tender?.tech_score ?? "",
        company_score: tender?.company_score ?? "",
        site_apprisate_required: tender?.site_apprisate_required ?? false,
        site_apprisate_marking: tender?.site_apprisate_marking ?? "",
        work_methodology_required: tender?.work_methodology_required ?? false,
        work_methodology_marking: tender?.work_methodology_marking ?? "",
        presentation_required: tender?.presentation_required ?? false,
        presentation_type: tender?.presentation_type ?? "",
        presentation_required_marking:
          tender?.presentation_required_marking ?? "",
      });
      setFinalizePartnersData({
        lead_partner: tender.lead_partner
          ? tender.lead_partner
          : tender.lead_qualify
            ? tender.company_name
            : "",
        lead_partner_share: tender.lead_partner_share ?? "",
        partner_share_sum: 0,
        jv_partner_share: tender.jv_partner_share ?? "",
        jv_partner_name: tender.jv_partner_name
          ? tender.jv_partner_name
          : tender.jv_qualify
            ? tender.company_name
            : "",
        assosiate_partner: tender.assosiate_partner
          ? tender.assosiate_partner
          : tender.associate_qualify
            ? tender.company_name
            : "",
        associate_partner_share: tender.associate_partner_share ?? "",
        bg_requried: tender.bg_requried,
        bg_amount: tender.bg_amount ?? 0,
        bg_type: tender.bg_type ?? "",
        tender_submission_type: tender.tender_submission_type ?? "",
        emd_submission_type: tender.emd_submission_type ?? "",
      });
      setTenderDocumentsData({
        checklist: tender.checklist ?? false,
        all_docs_done: tender.all_docs_done ?? false,
        tech_score: tender.tech_score ?? "",
        cv_score: tender.cv_score ?? "",
        tech_doc: tender.tech_doc ?? [],
        financial_doc: tender.financial_doc ?? [],
        cvs_files: tender.cvs_files ?? [],
        bid_doc: tender.bid_doc ?? [],
        bidder_doc: tender?.bidder_doc ?? [],
        all_cvs_done: tender.all_cvs_done ?? false,
        bidders: tender.tender_bidders ?? [],
        bidder_name: { value: "", loading: false },
        team_required: tender.team_required,
        team_requirements_details: tender.team_requirements_details ?? "",
        team_prepare_by: tender.team_prepare_by,
        team_prepare_by_remarks: tender.team_prepare_by_remarks,
        emd_type: tender.emd_type ?? "",
        emd_review: tender.emd_review,
        emd_amount: tender.emd_amount ?? 0,
        emd_unit: tender.emd_unit,
        is_emd_required: tender.is_emd_required,
        exmpted_emd: tender.exmpted_emd,
      });
    }
    const updatedSum =
      parseInt(tender.lead_partner_share) +
      parseInt(tender.associate_partner_share) +
      parseInt(tender.jv_partner_share);
    setFinalizePartnersData((prev) => ({
      ...prev,
      partner_share_sum: updatedSum,
    }));
  }, [tender]);

  // Update partner share sum
  useEffect(() => {
    const updatedSum =
      (parseInt(finalizePartnersData.lead_partner_share) || 0) +
      (parseInt(finalizePartnersData.associate_partner_share) || 0) +
      (parseInt(finalizePartnersData.jv_partner_share) || 0);

    if (finalizePartnersData.partner_share_sum !== updatedSum) {
      setFinalizePartnersData((prev) => ({
        ...prev,
        partner_share_sum: updatedSum,
      }));
    }
  }, [
    finalizePartnersData.lead_partner_share,
    finalizePartnersData.associate_partner_share,
    finalizePartnersData.jv_partner_share,
  ]);

  // Validation states
  const [errorsdoc, setErrorsDoc] = useState({});
  const [isSubmitteddoc, setIsSubmittedDoc] = useState(false);
  const [errorseligiblity, setErrorsEligibilty] = useState({});
  const [isSubmittedeligiblity, setIsSubmittedEligibility] = useState(false);
  const [errorspartner, setErrorsPartner] = useState({});
  const [isSubmittedpartner, setIsSubmittedPartner] = useState(false);

  // File upload states
  const [cvsDocs, setCvsDocs] = useState([]);
  const [techDocs, setTechDocs] = useState([]);
  const [finacialDocs, setFinancialDocs] = useState([]);
  const [BidDocs, setBidDocs] = useState([]);
  const [stop, SetStop] = useState(false);

  // EMD Type options
  const EmdType = [
    { key: "Bank_Gurantee", value: "Bank Gurantee" },
    { key: "neft", value: "NEFT" },
    { key: "demand_draft", value: "Demand Draft" },
    { key: "other", value: "Other" },
  ];

  // Add toggle state flags to data
  const addToggleStateFlags = (data) => {
    const toggleState = getToggleState();
    const updatedData = { ...data };

    if (toggleState === 1) {
      updatedData.is_in_bidlist = true;
      updatedData.is_in_targetlist = false;
      updatedData.is_finalize = false;
      updatedData.is_bid_prepare_in_progress = false;
      updatedData.is_submitted = false;
      updatedData.is_cancelled = false;
      updatedData.is_rejected = false;
      updatedData.date_aa = new Date().toISOString();
    } else if (toggleState === 2) {
      updatedData.is_in_targetlist = true;
      updatedData.is_in_bidlist = true;
      updatedData.is_finalize = false;
      updatedData.is_bid_prepare_in_progress = false;
      updatedData.is_submitted = false;
      updatedData.is_cancelled = false;
      updatedData.is_rejected = false;
      updatedData.date_bb = new Date().toISOString();
    } else if (toggleState === 3) {
      updatedData.is_in_bidlist = true;
      updatedData.is_in_targetlist = true;
      updatedData.is_bid_prepare_in_progress = false;
      updatedData.is_submitted = false;
      updatedData.is_finalize = true;
      updatedData.is_cancelled = false;
      updatedData.is_rejected = false;
      updatedData.date_cc = new Date().toISOString();
    } else if (toggleState === 9) {
      updatedData.is_in_bidlist = true;
      updatedData.is_in_targetlist = true;
      updatedData.is_bid_prepare_in_progress = true;

      updatedData.is_finalize = true;
      updatedData.is_submitted = false;
      updatedData.is_cancelled = false;
      updatedData.is_rejected = false;
      updatedData.date_ee = new Date().toISOString();
    } else if (toggleState === 4) {
      updatedData.is_in_bidlist = true;
      updatedData.is_in_targetlist = true;

      updatedData.is_submitted = false;
      updatedData.is_finalize = true;

      updatedData.is_bid_prepare_in_progress = true;
      updatedData.is_cancelled = false;
      updatedData.is_rejected = false;
      updatedData.date_ff = new Date().toISOString();
    }

    return updatedData;
  };

  // Validation functions
  const validateFormTenderdocument = () => {
    const newErrors = {};
    let requiredFields = [
      tenderDocumentsData.all_docs_done === null ? "all_docs_done" : null,
      tenderDocumentsData.all_cvs_done === null ? "all_cvs_done" : null,
      tenderDocumentsData.checklist === null ? "checklist" : null,
      tenderDocumentsData.team_required === null ? "team_required" : null,
      tenderDocumentsData.team_required !== null &&
      tenderDocumentsData.team_required
        ? "team_prepare_by"
        : null,
      tenderDocumentsData.team_required !== null &&
      tenderDocumentsData.team_required
        ? "team_prepare_by_remarks"
        : null,
      tenderDocumentsData.team_required !== null &&
      tenderDocumentsData.team_required
        ? "team_requirements_details"
        : null,
      tenderDocumentsData.is_emd_required === null &&
      tenderDocumentsData.exmpted_emd
        ? "is_emd_required"
        : null,
      tenderDocumentsData.is_emd_required != null &&
      tenderDocumentsData.is_emd_required &&
      tenderDocumentsData.exmpted_emd
        ? "emd_amount"
        : null,
      tenderDocumentsData.is_emd_required != null &&
      tenderDocumentsData.is_emd_required &&
      tenderDocumentsData.exmpted_emd
        ? "emd_unit"
        : null,
      // tenderDocumentsData.is_emd_required != null && tenderDocumentsData.is_emd_required && tenderDocumentsData.exmpted_emd ? "emd_review" : null,
      tenderDocumentsData.is_emd_required != null &&
      tenderDocumentsData.is_emd_required &&
      tenderDocumentsData.exmpted_emd
        ? "exmpted_emd"
        : null,
      tenderDocumentsData.is_emd_required != null &&
      tenderDocumentsData.is_emd_required &&
      tenderDocumentsData.exmpted_emd
        ? "emd_type"
        : null,
      tenderDocumentsData.is_emd_required != null &&
      tenderDocumentsData.is_emd_required &&
      tenderDocumentsData.exmpted_emd
        ? "emd_submission_type"
        : null,
      "tech_score",
      "cv_score",
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (!tenderDocumentsData[field]) {
        newErrors[field] =
          ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrorsDoc(newErrors);
    setIsSubmittedDoc(true);
    return Object.keys(newErrors).length === 0;
  };

  const validateFormEligibility = () => {
    const newErrors = {};
    let requiredFields = [
      eligibilityCriteriaData.is_jv_allowed === null ? "is_jv_allowed" : null,
      "tech_score",
      "company_score",
      "company_name",
      "eligibity_criteria",
      eligibilityCriteriaData.eligibity_criteria != "" &&
      eligibilityCriteriaData.eligibity_criteria === "Special"
        ? "eligibity_criteria_special"
        : null,
      eligibilityCriteriaData.soil_quality === null ? "soil_quality" : null,
      eligibilityCriteriaData.participating_as === null
        ? "participating_as"
        : null,
      eligibilityCriteriaData.is_jv_consorium_association_allowed === null
        ? "jv_consorium_association_allowed"
        : null,
      eligibilityCriteriaData.site_apprisate_required === null
        ? "site_apprisate_required"
        : null,
      eligibilityCriteriaData.site_apprisate_required !== null
        ? "site_apprisate_marking"
        : null,
      eligibilityCriteriaData.work_methodology_required === null
        ? "work_methodology_required"
        : null,
      eligibilityCriteriaData.work_methodology_required != null
        ? "work_methodology_marking"
        : null,
      eligibilityCriteriaData.presentation_required === null
        ? "presentation_required"
        : null,
      eligibilityCriteriaData.presentation_required !== null &&
      eligibilityCriteriaData.presentation_required
        ? "presentation_required_marking"
        : null,
      eligibilityCriteriaData.presentation_required !== null &&
      eligibilityCriteriaData.presentation_required
        ? "presentation_type"
        : null,
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (!eligibilityCriteriaData[field]) {
        newErrors[field] =
          ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrorsEligibilty(newErrors);
    setIsSubmittedEligibility(true);
    return Object.keys(newErrors).length === 0;
  };

  const validateFormPartner = () => {
    const newErrors = {};
    let requiredFields = [
      finalizePartnersData.tender_submission_type === null
        ? "tender_submission_type"
        : null,
      "lead_partner_share",
      finalizePartnersData.jv_partner_name != "Not Required"
        ? "jv_partner_share"
        : null,
      finalizePartnersData.assosiate_partner != "Not Required"
        ? "associate_partner_share"
        : null,
    ].filter(Boolean);

    requiredFields.forEach((field) => {
      if (!finalizePartnersData[field]) {
        newErrors[field] =
          ` ${field.charAt(0).toUpperCase() + field.slice(1)} is required !`;
      }
    });

    setErrorsPartner(newErrors);
    setIsSubmittedPartner(true);
    return Object.keys(newErrors).length === 0;
  };

  // Submit handlers with toggle state logic
  const handleTenderDocumentUpdate = async (e) => {
    if (validateFormTenderdocument()) {
      e.preventDefault();
      const loadingToastId = toast.loading("Loading: Please wait...");
      try {
        // Add toggle state flags to the data
        const dataWithToggleState = addToggleStateFlags(tenderDocumentsData);

        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          dataWithToggleState,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const handleEligibilityCriteriaUpdate = async (e) => {
    if (validateFormEligibility()) {
      e.preventDefault();
      const loadingToastId = toast.loading("Loading: Please wait...");
      try {
        // Add toggle state flags to the data
        const dataWithToggleState = addToggleStateFlags(
          eligibilityCriteriaData,
        );

        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          dataWithToggleState,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  const handleFinalizePartnerUpdate = async (e) => {
    if (validateFormPartner()) {
      e.preventDefault();
      const loadingToastId = toast.loading("Loading: Please wait...");
      try {
        // Add toggle state flags to the data
        const dataWithToggleState = addToggleStateFlags(finalizePartnersData);

        const res = await axios.put(
          `${BASE_URL}/siteproject/BidTenderUpdate/${tenderId}/`,
          dataWithToggleState,
          {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          },
        );

        if (res.status === 200 || res.status === 201) {
          handleCloseEditModal();
          sessionStorage.setItem("scrollTenderId", tenderId);
          await getBidData(filters);
        }
      } catch (err) {
        handleErrorToast(err);
      } finally {
        toast.dismiss(loadingToastId);
      }
    }
  };

  // File upload handlers (keep your existing file upload handlers)
  const handleCvsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setCvsDocs(newFiles);
    }
  };

  const handleCvsRemove = (index) => {
    setCvsDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddCvDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      cvsDocs.forEach((file) => {
        formData.append("cv_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkcv/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setCvsDocs([]);
    } finally {
      setCvsDocs([]);
      getBidData();
    }
  };

  const handleTechFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setTechDocs(newFiles);
    }
  };

  const handleTechRemove = (index) => {
    setTechDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddTechDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      techDocs.forEach((file) => {
        formData.append("tech_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulktech/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setTechDocs([]);
    } finally {
      setTechDocs([]);
      getBidData();
    }
  };

  const handleFinancialFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setFinancialDocs(newFiles);
    }
  };

  const handleFinancialRemove = (index) => {
    setFinancialDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddFinancialDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      finacialDocs.forEach((file) => {
        formData.append("financial_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkfinancial/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setFinancialDocs([]);
    } finally {
      setFinancialDocs([]);
      getBidData();
    }
  };

  const handleBidsFileChange = (e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      setBidDocs(newFiles);
    }
  };

  const handleBidsRemove = (index) => {
    setBidDocs((prev) => prev.filter((_, i) => i !== index));
  };

  const handleAddBidDoc = async (e) => {
    e.preventDefault();
    try {
      const formData = new FormData();
      BidDocs.forEach((file) => {
        formData.append("bid_tender", tenderId);
        formData.append("document_name", file?.name);
        formData.append("document", file);
      });

      const uploadRes = await axios.post(
        `${BASE_URL}/siteproject/bulkbbid/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        },
      );
    } catch (uploadErr) {
      setBidDocs([]);
    } finally {
      setBidDocs([]);
      getBidData();
    }
  };

  const handleBidderSubmit = async (name, id) => {
    const data = {
      bidder_name: name ? name : tenderDocumentsData.bidder_name.value,
      TenderforBD: tenderId ? tenderId : id,
      number_of_bidder: 1,
    };
    try {
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidder_name: { ...prev.bidder_name, loading: true },
      }));
      const res = await axios.post(`${BASE_URL}/siteproject/bidder/`, data, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidders: [...prev.bidders, res.data],
        bidder_name: { ...prev.bidder_name, value: "" },
      }));
      SetStop(true);
    } catch (err) {
    } finally {
      setTenderDocumentsData((prev) => ({
        ...prev,
        bidder_name: { ...prev.bidder_name, loading: false },
      }));
    }
  };

  useEffect(() => {
    if (
      showModal &&
      editTenderData != undefined &&
      editTenderData?.lead_partner != null &&
      !stop &&
      editTenderData?.tender_bidders?.length == 0
    ) {
      SetStop(true);
    }
  }, [editTenderData, showModal, tenderDocumentsData, stop]);

  // Render tab content function (keep your existing renderTabContent function)
  const renderTabContent = (activeTab) => {
    switch (activeTab) {
      case "eligibility":
        return (
          <section
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div className="dropdown-wrapper flex-column justify-center  ">
              <label
                htmlFor="eligibity_criteria"
                className="form-label font-weight500 font-size-subheading"
              >
                Eligibilty Criteria<span className="required">*</span>
              </label>
              <select
                name="eligibity_criteria"
                placeholder="Please write a eligibility creteria. "
                value={eligibilityCriteriaData.eligibity_criteria}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    eligibity_criteria: e.target.value,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Eligibilty Criteria</option>
                <option value="Normal">Normal</option>
                <option value="Special">Special</option>
              </select>
            </div>
            {eligibilityCriteriaData.eligibity_criteria === "Special" && (
              <div className="dropdown-wrapper flex-column justify-center ">
                <label className="form-labels">
                  Eligibility Criteria Special
                  <span className="required">*</span>
                </label>
                <textarea
                  name="eligibity_criteria_special Eligibity Criteria"
                  placeholder="Please write Special Eligibilty Criteria "
                  value={eligibilityCriteriaData.eligibity_criteria_special}
                  className={`form-input input-form`}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      eligibity_criteria_special: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="is_jv_allowed"
                className="font-weight500 font-size-subheading"
              >
                Is Jv allowed<span className="required">*</span>
              </label>
              <select
                id="is_jv_allowed"
                name="is_jv_allowed"
                value={eligibilityCriteriaData.is_jv_allowed}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    is_jv_allowed:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Is Jv Allowed</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="is_jv_consorium_association_allowed"
                className="font-weight500 font-size-subheading"
              >
                Is Consorium/Association allowed
                <span className="required">*</span>
              </label>
              <select
                id="is_jv_consorium_association_allowed"
                name="is_jv_consorium_association_allowed"
                value={
                  eligibilityCriteriaData.is_jv_consorium_association_allowed
                }
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    is_jv_consorium_association_allowed:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Checklist</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {eligibilityCriteriaData.is_jv_consorium_association_allowed && (
              <div className="flex-column">
                <label className="form-labels">Terms of JV </label>
                <textarea
                  name="terms_of_jv"
                  placeholder="terms"
                  value={eligibilityCriteriaData.terms_of_jv}
                  className={`form-input input-form`}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      terms_of_jv: e.target.value,
                    }))
                  }
                />
              </div>
            )}

            <div className="flex-column form-group-selectt">
              <label
                htmlFor="company_name"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Company Name<span className="required">*</span>
              </label>
              <br />
              <select
                id="company_name"
                name="company_name"
                value={eligibilityCriteriaData.company_name}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    company_name: e.target.value,
                  }))
                }
                className={`form-input input-form  form-group-selection`}
              >
                <option value="null">Select Company Name</option>
                <option value="sapl">SAPL</option>
                <option value="cipl">CIPL</option>
              </select>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="soil_quality"
                className="font-weight500 font-size-subheading"
              >
                Sole Qualify<span className="required">*</span>
              </label>
              <select
                id="soil_quality"
                name="soil_quality"
                value={eligibilityCriteriaData.soil_quality}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    soil_quality:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Sole Qualify</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="participating_as "
                className="  font-weight500    font-size-subheading"
              >
                Participating As<span className="required">*</span>
              </label>
              <br />
              <select
                id="participating_as"
                name="participating_as"
                value={eligibilityCriteriaData.participating_as}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    participating_as: e.target.value,
                  }))
                }
                className={`form-input font-size-subheading`}
                //style={{ width: '80% !important' }}
              >
                <option value="">Select Participating As</option>

                <option value="lead">Lead</option>
                <option value="jv">JV</option>
                <option value="associate">Associate</option>
                {eligibilityCriteriaData?.soil_quality ? (
                  <option value="sole">Sole</option>
                ) : (
                  ""
                )}
              </select>
            </div>

            <div
              className="joint-columns"
              style={{ display: "flex", gap: "20px", marginTop: "10px" }}
            >
              <div className="flex-column form-group-selectt widths50">
                <label
                  htmlFor="tech_score"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Total Tech Score<span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="tech_score"
                  placeholder="tech Score"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.tech_score}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      tech_score: e.target.value,
                    }))
                  }
                  style={{ width: "80%" }}
                />
              </div>

              <div className="flex-column form-group-selectt widths50">
                <label
                  htmlFor="company_score"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  {eligibilityCriteriaData.company_name === null ||
                  eligibilityCriteriaData.company_name === "null"
                    ? "Our Company"
                    : eligibilityCriteriaData.company_name?.toUpperCase()}{" "}
                  Technical Score<span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="company_score"
                  placeholder="Company Score"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.company_score}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      company_score: e.target.value,
                    }))
                  }
                  style={{ width: "80%" }}
                />
              </div>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="site_apprisate_required"
                className="font-weight500 font-size-subheading"
              >
                Site Appreciate Required <span className="required">*</span>
              </label>
              <select
                id="site_apprisate_required"
                name="site_apprisate_required"
                value={eligibilityCriteriaData.site_apprisate_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    site_apprisate_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Site Appreciate Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            {eligibilityCriteriaData.site_apprisate_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="site_apprisate_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Site Appreciate Marking <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="site_apprisate_marking"
                  placeholder="site_apprisate_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.site_apprisate_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      site_apprisate_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="work_methodology_required"
                className="font-weight500 font-size-subheading"
              >
                Work Methodology Required <span className="required">*</span>
              </label>
              <select
                id="work_methodology_required"
                name="work_methodology_required"
                value={eligibilityCriteriaData.work_methodology_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    work_methodology_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Work Methodology Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            {eligibilityCriteriaData.work_methodology_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="work_methodology_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Work Methodology Marking <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="work_methodology_marking"
                  placeholder="work_methodology_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.work_methodology_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      work_methodology_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="presentation_required"
                className="font-weight500 font-size-subheading"
              >
                Presentation Required <span className="required">*</span>
              </label>
              <select
                id="presentation_required"
                name="presentation_required"
                value={eligibilityCriteriaData.presentation_required}
                onChange={(e) =>
                  setEligibilityCriteriaData((prev) => ({
                    ...prev,
                    presentation_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Presentation Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {eligibilityCriteriaData.presentation_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="presentation_required_marking"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Presentation Required Marking{" "}
                  <span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="presentation_required_marking"
                  placeholder="presentation_required_marking"
                  className={`form-input input-form`}
                  value={eligibilityCriteriaData.presentation_required_marking}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      presentation_required_marking: e.target.value,
                    }))
                  }
                />
              </div>
            )}
            {eligibilityCriteriaData.presentation_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="presentation_type"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Presentation Type <span className="required">*</span>
                </label>
                <br />
                <select
                  id="presentation_type"
                  name="presentation_type"
                  className={`form-input input-form  form-group-selection `}
                  value={eligibilityCriteriaData.presentation_type}
                  onChange={(e) =>
                    setEligibilityCriteriaData((prev) => ({
                      ...prev,
                      presentation_type: e.target.value,
                    }))
                  }
                >
                  <option value="null">Select Presentation Type</option>
                  <option value="Online">Online</option>
                  <option value="physical">Physical</option>
                  <option value="both">Both</option>
                </select>
              </div>
            )}
            <p className="error-message font-size-text">
              {" "}
              {isSubmittedeligiblity &&
                Object.keys(errorseligiblity).length > 0 && (
                  <h6 className="text-center">
                    {"Error in: " +
                      Object.keys(errorseligiblity)
                        .map((field) => {
                          // Convert field names to readable format
                          const formatted = field
                            .replace(/_/g, " ") // replace underscores with spaces
                            .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letters
                          return `${formatted}`; // include the actual error message
                        })
                        .join(", ")}
                  </h6>
                )}
            </p>

            <button
              onClick={handleEligibilityCriteriaUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      case "partners":
        return (
          <section
            style={{ display: "flex", flexDirection: "column", gap: "20px" }}
          >
            <div className="flex-column form-group-selectt ">
              <label
                htmlFor="lead_partner"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Lead Partner<span className="required">*</span>
              </label>
              <br />
              {finalizePartnersData.lead_qualify ? (
                <input
                  type="text"
                  name="lead_partner"
                  placeholder="lead partner"
                  value={finalizePartnersData.lead_partner}
                  disabled={finalizePartnersData.lead_qualify}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      lead_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              ) : (
                <select
                  id="lead_partner"
                  name="lead_partner"
                  value={finalizePartnersData.lead_partner}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      lead_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form  form-group-selection`}
                >
                  <option value="null">Select lead partner</option>
                  <option value="Saptagon Asia Private Limited">
                    Saptagon Asia Private Limited
                  </option>
                  <option value="Civilmantra Infracon Limited">
                    Civilmantra Infracon Limited
                  </option>
                  <option value="HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED">
                    HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED
                  </option>
                  <option value="ISAN CORPORATION">ISAN CORPORATION</option>
                  <option value="MARC TECHNOCRATS LIMITED">
                    MARC TECHNOCRATS LIMITED{" "}
                  </option>
                  <option value="ALOMNDS GLOBAL INFRASTRUCTURE">
                    ALOMNDS GLOBAL INFRASTRUCTURE
                  </option>
                  <option value="VOYANTS SOLUTIONS PVT LTD">
                    VOYANTS SOLUTIONS PVT LTD
                  </option>
                  <option value="SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED">
                    SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED
                  </option>
                  <option value="MSV INTERNATIONAL">MSV INTERNATIONAL</option>
                  <option value="YONGMA ENGINEERING CO LTD">
                    YONGMA ENGINEERING CO LTD
                  </option>
                  <option value="TECH-4">TECH-4</option>
                  <option value="AECOM INDIA PRIVATE LIMITED">
                    AECOM INDIA PRIVATE LIMITED
                  </option>
                  <option value="SMEC INDIA PVT LTD">SMEC INDIA PVT LTD</option>
                  <option value="SPECTRUM">SPECTRUM</option>
                  <option value="INSTUTIUTE GIPROSTROYMOST">
                    INSTUTIUTE GIPROSTROYMOST
                  </option>
                  <option value="RODIC CONSULTANT PRIVATE LIMITED">
                    RODIC CONSULTANT PRIVATE LIMITED
                  </option>
                  <option value="CHAITANYA PROJECT CONSULTANCY LTD">
                    CHAITANYA PROJECT CONSULTANCY LTD
                  </option>
                  <option value="CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)">
                    CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA
                    S.A.)
                  </option>
                  <option value="TPF ENGINEERING PRIVATE LIMITED">
                    TPF ENGINEERING PRIVATE LIMITED
                  </option>
                  <option value="INFRAPLUS CONSULTANCY PVT LTD">
                    INFRAPLUS CONSULTANCY PVT LTD
                  </option>
                  <option value="RITES LIMITED">RITES LIMITED</option>
                  <option value="TPF GETINSAEUROESTUDIOS SL">
                    TPF GETINSAEUROESTUDIOS SL
                  </option>
                  <option value="SA INFRASTURCTURE CONSULTING PRIVATE">
                    SA INFRASTURCTURE CONSULTING PRIVATE
                  </option>
                  <option value="CEG LIMITED">CEG LIMITED</option>
                  <option value="AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD">
                    AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD
                  </option>
                  <option value="Egis">Egis</option>
                </select>
              )}
            </div>
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="lead_partner_share"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Lead Partner Share %<span className="required">*</span>
              </label>
              <br />
              <input
                type="number"
                name="lead_partner_share"
                placeholder="lead partner share"
                value={finalizePartnersData.lead_partner_share}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    lead_partner_share: e.target.value,
                  }))
                }
                className={`form-input input-form`}
              />
              {finalizePartnersData.partner_share_sum > 100 && (
                <label style={{ color: "red" }}>
                  Sum of all partner should not be more than 100
                </label>
              )}
              {finalizePartnersData.partner_share_sum < 100 && (
                <label style={{ color: "red" }}>
                  Sum of all lead partner should not be less than 100
                </label>
              )}
            </div>
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="jv_partner_name"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Jv Partner<span className="required">*</span>
              </label>
              <br />
              {finalizePartnersData.jv_qualify ? (
                <input
                  type="text"
                  name="jv_partner_name"
                  placeholder="Jv Partner"
                  value={finalizePartnersData.jv_partner_name}
                  disabled={finalizePartnersData.jv_qualify}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      jv_partner_name: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              ) : (
                <select
                  id="jv_partner_name"
                  name="jv_partner_name"
                  value={finalizePartnersData.jv_partner_name}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      jv_partner_name: e.target.value,
                    }))
                  }
                  className={`form-input input-form  form-group-selection`}
                >
                  <option value="null">Select JV partner</option>
                  <option value="Saptagon Asia Private Limited">
                    Saptagon Asia Private Limited
                  </option>
                  <option value="Civilmantra Infracon Limited">
                    Civilmantra Infracon Limited
                  </option>
                  <option value="HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED">
                    HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED
                  </option>
                  <option value="ISAN CORPORATION">ISAN CORPORATION</option>
                  <option value="MARC TECHNOCRATS LIMITED">
                    MARC TECHNOCRATS LIMITED{" "}
                  </option>
                  <option value="ALOMNDS GLOBAL INFRASTRUCTURE">
                    ALOMNDS GLOBAL INFRASTRUCTURE
                  </option>
                  <option value="VOYANTS SOLUTIONS PVT LTD">
                    VOYANTS SOLUTIONS PVT LTD
                  </option>
                  <option value="SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED">
                    SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED
                  </option>
                  <option value="MSV INTERNATIONAL">MSV INTERNATIONAL</option>
                  <option value="YONGMA ENGINEERING CO LTD">
                    YONGMA ENGINEERING CO LTD
                  </option>
                  <option value="TECH-4">TECH-4</option>
                  <option value="AECOM INDIA PRIVATE LIMITED">
                    AECOM INDIA PRIVATE LIMITED
                  </option>
                  <option value="SMEC INDIA PVT LTD">SMEC INDIA PVT LTD</option>
                  <option value="SPECTRUM">SPECTRUM</option>
                  <option value="INSTUTIUTE GIPROSTROYMOST">
                    INSTUTIUTE GIPROSTROYMOST
                  </option>
                  <option value="RODIC CONSULTANT PRIVATE LIMITED">
                    RODIC CONSULTANT PRIVATE LIMITED
                  </option>
                  <option value="CHAITANYA PROJECT CONSULTANCY LTD">
                    CHAITANYA PROJECT CONSULTANCY LTD
                  </option>
                  <option value="CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)">
                    CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA
                    S.A.)
                  </option>
                  <option value="TPF ENGINEERING PRIVATE LIMITED">
                    TPF ENGINEERING PRIVATE LIMITED
                  </option>
                  <option value="INFRAPLUS CONSULTANCY PVT LTD">
                    INFRAPLUS CONSULTANCY PVT LTD
                  </option>
                  <option value="RITES LIMITED">RITES LIMITED</option>
                  <option value="TPF GETINSAEUROESTUDIOS SL">
                    TPF GETINSAEUROESTUDIOS SL
                  </option>
                  <option value="SA INFRASTURCTURE CONSULTING PRIVATE">
                    SA INFRASTURCTURE CONSULTING PRIVATE
                  </option>
                  <option value="CEG LIMITED">CEG LIMITED</option>
                  <option value="AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD">
                    AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD
                  </option>
                  <option value="Egis">Egis</option>

                  <option value="Not Required">Not Required </option>
                </select>
              )}
            </div>

            {finalizePartnersData.jv_partner_name != "Not Required" && (
              <>
                {" "}
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="jv_partner_share"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Jv Partner Share %<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="number"
                    name="jv_partner_share"
                    placeholder="Jv Partner Share"
                    value={finalizePartnersData.jv_partner_share}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        jv_partner_share: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
                {finalizePartnersData.partner_share_sum > 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all partner should not be more than 100
                  </label>
                )}
                {finalizePartnersData.partner_share_sum < 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all lead partner should not be less than 100
                  </label>
                )}
              </>
            )}
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="assosiate_partner"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Assosiate Partner<span className="required">*</span>
              </label>
              <br />
              {finalizePartnersData.associate_qualify ? (
                <input
                  type="text"
                  name="assosiate_partner"
                  placeholder="Assosiate Partner"
                  value={finalizePartnersData.assosiate_partner}
                  disabled={finalizePartnersData.associate_qualify}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      assosiate_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              ) : (
                <select
                  id="assosiate_partner"
                  name="assosiate_partner"
                  value={finalizePartnersData.assosiate_partner}
                  onChange={(e) =>
                    setFinalizePartnersData((prev) => ({
                      ...prev,
                      assosiate_partner: e.target.value,
                    }))
                  }
                  className={`form-input input-form  form-group-selection`}
                >
                  <option value="null">Select associate partner</option>
                  <option value="Saptagon Asia Private Limited">
                    Saptagon Asia Private Limited
                  </option>
                  <option value="Civilmantra Infracon Limited">
                    Civilmantra Infracon Limited
                  </option>
                  <option value="HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED">
                    HIGHRAISE CONSTRUCTION AND CONSULTANT PRIVATE LIMITED
                  </option>
                  <option value="ISAN CORPORATION">ISAN CORPORATION</option>
                  <option value="MARC TECHNOCRATS LIMITED">
                    MARC TECHNOCRATS LIMITED{" "}
                  </option>
                  <option value="ALOMNDS GLOBAL INFRASTRUCTURE">
                    ALOMNDS GLOBAL INFRASTRUCTURE
                  </option>
                  <option value="VOYANTS SOLUTIONS PVT LTD">
                    VOYANTS SOLUTIONS PVT LTD
                  </option>
                  <option value="SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED">
                    SEGMENTAL INFRASTRUCTURE DEVLOPMENT PRIVATE LIMITED
                  </option>
                  <option value="MSV INTERNATIONAL">MSV INTERNATIONAL</option>
                  <option value="YONGMA ENGINEERING CO LTD">
                    YONGMA ENGINEERING CO LTD
                  </option>
                  <option value="TECH-4">TECH-4</option>
                  <option value="AECOM INDIA PRIVATE LIMITED">
                    AECOM INDIA PRIVATE LIMITED
                  </option>
                  <option value="SMEC INDIA PVT LTD">SMEC INDIA PVT LTD</option>
                  <option value="SPECTRUM">SPECTRUM</option>
                  <option value="INSTUTIUTE GIPROSTROYMOST">
                    INSTUTIUTE GIPROSTROYMOST
                  </option>
                  <option value="RODIC CONSULTANT PRIVATE LIMITED">
                    RODIC CONSULTANT PRIVATE LIMITED
                  </option>
                  <option value="CHAITANYA PROJECT CONSULTANCY LTD">
                    CHAITANYA PROJECT CONSULTANCY LTD
                  </option>
                  <option value="CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA S.A.)">
                    CEMOSA ( CENTRO DE ESTUDIOS MATERAILS Y CONTROL DE OBRA
                    S.A.)
                  </option>
                  <option value="TPF ENGINEERING PRIVATE LIMITED">
                    TPF ENGINEERING PRIVATE LIMITED
                  </option>
                  <option value="INFRAPLUS CONSULTANCY PVT LTD">
                    INFRAPLUS CONSULTANCY PVT LTD
                  </option>
                  <option value="RITES LIMITED">RITES LIMITED</option>
                  <option value="TPF GETINSAEUROESTUDIOS SL">
                    TPF GETINSAEUROESTUDIOS SL
                  </option>
                  <option value="SA INFRASTURCTURE CONSULTING PRIVATE">
                    SA INFRASTURCTURE CONSULTING PRIVATE
                  </option>
                  <option value="CEG LIMITED">CEG LIMITED</option>
                  <option value="AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD">
                    AARVEE ASSOCIATES ARCHITECTS ENGG PVT LTD
                  </option>
                  <option value="Egis">Egis</option>
                  <option value="Not Required">Not Required </option>
                </select>
              )}
            </div>
            {finalizePartnersData.assosiate_partner != "Not Required" && (
              <>
                {" "}
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="associate_partner_share"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Associate Partner Share %<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="number"
                    name="associate_partner_share"
                    placeholder="Associate Partner Share"
                    value={finalizePartnersData.associate_partner_share}
                    onChange={(e) =>
                      setFinalizePartnersData((prev) => ({
                        ...prev,
                        associate_partner_share: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
                {finalizePartnersData.partner_share_sum > 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all partner should not be more than 100
                  </label>
                )}
                {finalizePartnersData.partner_share_sum < 100 && (
                  <label style={{ color: "red" }}>
                    Sum of all lead partner should not be less than 100
                  </label>
                )}
              </>
            )}

            <div className="flex-column form-group-selectt">
              <label
                htmlFor="tender_submission_type"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Tender Submission Type<span className="required">*</span>
              </label>
              <br />
              <select
                id="tender_submission_type"
                name="tender_submission_type"
                value={finalizePartnersData.tender_submission_type}
                onChange={(e) =>
                  setFinalizePartnersData((prev) => ({
                    ...prev,
                    tender_submission_type: e.target.value,
                  }))
                }
                className={`form-input input-form  form-group-selection`}
              >
                <option value="null">Select Tender Submission Type</option>
                <option value="Online">Online</option>
                <option value="physical">Physical</option>
                <option value="both">Both</option>
              </select>
            </div>
            <br />
            <p className="error-message font-size-text">
              {isSubmittedpartner && Object.keys(errorspartner).length > 0 && (
                <h6 className="text-center">
                  {"Error in: " +
                    Object.keys(errorspartner)
                      .map((field) => {
                        // Convert field names to readable format
                        const formatted = field
                          .replace(/_/g, " ") // replace underscores with spaces
                          .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letters
                        return `${formatted}`; // include the actual error message
                      })
                      .join(", ")}
                </h6>
              )}
            </p>
            <button
              onClick={handleFinalizePartnerUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      case "documents":
        return (
          <section>
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="team_required"
                className="font-weight500 font-size-subheading"
              >
                Team Required <span className="required">*</span>
              </label>
              <select
                id="team_required"
                name="team_required"
                value={tenderDocumentsData.team_required}
                onChange={(e) =>
                  setTenderDocumentsData((prev) => ({
                    ...prev,
                    team_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Team Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            {tenderDocumentsData.team_required && (
              <>
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="team_prepare_by"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Team Prepare By<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="team_prepare_by"
                    name="team_prepare_by"
                    value={tenderDocumentsData.team_prepare_by}
                    onChange={(e) =>
                      setTenderDocumentsData((prev) => ({
                        ...prev,
                        team_prepare_by: e.target.value,
                      }))
                    }
                    className={`form-input input-form  form-group-selection`}
                  >
                    <option value="">Select</option>
                    <option value="lead_partner">
                      {tenderDocumentsData.lead_partner}
                    </option>
                    <option value="jv_partner">
                      {" "}
                      {tenderDocumentsData.jv_partner_name}
                    </option>
                    <option value="associate_partner">
                      {" "}
                      {tenderDocumentsData.assosiate_partner}
                    </option>
                  </select>
                </div>
                <div className="flex-column">
                  <label className="form-labels">
                    Team Prepare By Remarks <span className="required">*</span>
                  </label>
                  <textarea
                    name="team_prepare_by_remarks"
                    placeholder="Remarks for Team prepared by"
                    value={tenderDocumentsData.team_prepare_by_remarks}
                    onChange={(e) =>
                      setTenderDocumentsData((prev) => ({
                        ...prev,
                        team_prepare_by_remarks: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>{" "}
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="team_requirements_details"
                    className="form-labels  font-weight500    font-size-subheading"
                  >
                    Team Requirements Details<span className="required">*</span>
                  </label>
                  <br />
                  <input
                    type="text"
                    name="team_requirements_details"
                    placeholder="Team Requirements Deatils"
                    value={tenderDocumentsData.team_requirements_details}
                    onChange={(e) =>
                      setTenderDocumentsData((prev) => ({
                        ...prev,
                        team_requirements_details: e.target.value,
                      }))
                    }
                    className={`form-input input-form`}
                  />
                </div>
              </>
            )}

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="is_emd_required"
                className="font-weight500 font-size-subheading"
              >
                Emd Required <span className="required">*</span>
              </label>
              <select
                id="is_emd_required"
                name="is_emd_required"
                value={tenderDocumentsData.is_emd_required}
                onChange={(e) =>
                  setTenderDocumentsData((prev) => ({
                    ...prev,
                    is_emd_required:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Emd Required</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            {tenderDocumentsData.is_emd_required && (
              <div className="dropdown-wrapper flex justify-center ">
                <label
                  htmlFor="exmpted_emd"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Exmpted Emd<span className="required">*</span>
                </label>
                <br />

                <select
                  id="exmpted_emd"
                  name="exmpted_emd"
                  value={tenderDocumentsData.exmpted_emd}
                  onChange={(e) =>
                    setTenderDocumentsData((prev) => ({
                      ...prev,
                      exmpted_emd:
                        e.target.value === "true"
                          ? true
                          : e.target.value === "false"
                            ? false
                            : null, // handles "Select Team Required"
                    }))
                  }
                  className="form-input font-size-subheading"
                >
                  <option value="">Exmpted Emd</option>
                  <option value="true">Yes</option>
                  <option value="false">No</option>
                </select>
              </div>
            )}
            {tenderDocumentsData.is_emd_required && (
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="emd_amount"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Emd Amount<span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="emd_amount"
                  placeholder="Enter full amount (e.g. 1 crore = 10000000)"
                  value={tenderDocumentsData.emd_amount}
                  onChange={(e) =>
                    setTenderDocumentsData((prev) => ({
                      ...prev,
                      emd_amount: e.target.value,
                    }))
                  }
                  className={`form-input input-form`}
                />
              </div>
            )}

            {tenderDocumentsData.is_emd_required && (
              <>
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="emd_type"
                    className="form-labels  font-weight500 font-size-subheading"
                  >
                    Emd type<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="emd_type"
                    name="emd_type"
                    value={tenderDocumentsData.emd_type}
                    onChange={(e) =>
                      setTenderDocumentsData((prev) => ({
                        ...prev,
                        emd_type: e.target.value,
                      }))
                    }
                    className={`form-input input-form  form-group-selection`}
                  >
                    {EmdType.map((emd) => (
                      <option value={emd.key}>{emd.value}</option>
                    ))}
                  </select>
                </div>
                <div className="flex-column form-group-selectt">
                  <label
                    htmlFor="emd_submission_type"
                    className="form-labels  font-weight500 font-size-subheading"
                  >
                    Emd Submission type<span className="required">*</span>
                  </label>
                  <br />
                  <select
                    id="emd_submission_type"
                    name="emd_submission_type"
                    value={tenderDocumentsData.emd_submission_type}
                    onChange={(e) =>
                      setTenderDocumentsData((prev) => ({
                        ...prev,
                        emd_submission_type: e.target.value,
                      }))
                    }
                    className={`form-input input-form  form-group-selection`}
                  >
                    <option value="null">EMD Submission Type</option>
                    <option value="online">Online</option>
                    <option value="physical">Physical</option>
                    <option value="both">Both</option>
                  </select>
                </div>
              </>
            )}
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="checklist"
                className="font-weight500 font-size-subheading"
              >
                Checklist <span className="required">*</span>
              </label>
              <select
                id="checklist"
                name="checklist"
                value={tenderDocumentsData.checklist}
                onChange={(e) =>
                  setTenderDocumentsData((prev) => ({
                    ...prev,
                    checklist:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">Checklist</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="all_docs_done"
                className="font-weight500 font-size-subheading"
              >
                All Docs Done <span className="required">*</span>
              </label>
              <select
                id="all_docs_done"
                name="all_docs_done"
                value={tenderDocumentsData.all_docs_done}
                onChange={(e) =>
                  setTenderDocumentsData((prev) => ({
                    ...prev,
                    all_docs_done:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">All Docs Done</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>

            <div className="flex-column form-group-selectt">
              <label
                htmlFor="tech_score"
                className="form-labels  font-weight500    font-size-subheading"
              >
                Total Technical Score <span className="required">*</span>
              </label>
              <br />
              <input
                type="text"
                name="tech_score"
                placeholder="tech Score"
                value={tenderDocumentsData.tech_score}
                onChange={(e) =>
                  setTenderDocumentsData((prev) => ({
                    ...prev,
                    tech_score: e.target.value,
                  }))
                }
                className={`form-input input-form`}
              />
            </div>
            <div className="flex-column form-group-selectt">
              <label
                htmlFor="cv_score"
                className="form-labels  font-weight500    font-size-subheading"
              >
                CV Score <span className="required">*</span>
              </label>
              <br />
              <input
                type="text"
                name="cv_score"
                placeholder="CV Score"
                value={tenderDocumentsData.cv_score}
                onChange={(e) =>
                  setTenderDocumentsData((prev) => ({
                    ...prev,
                    cv_score: e.target.value,
                  }))
                }
                className={`form-input input-form`}
              />
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Tech Proposal
              </label>

              {tenderDocumentsData?.tech_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.tech_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleTechFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddTechDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!techDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: techDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: techDocs?.length ? "#fafafd" : "none",
                }}
              >
                {techDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== techDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleTechRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!techDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Financial Proposal
              </label>

              {tenderDocumentsData?.financial_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.financial_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleFinancialFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddFinancialDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!finacialDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: finacialDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: finacialDocs?.length ? "#fafafd" : "none",
                }}
              >
                {finacialDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== finacialDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleFinancialRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!finacialDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload CV's
              </label>

              {tenderDocumentsData?.cvs_files?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.cvs_files.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleCvsFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddCvDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!cvsDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: cvsDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: cvsDocs?.length ? "#fafafd" : "none",
                }}
              >
                {cvsDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== cvsDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleCvsRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!cvsDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>

            <div className="dropdown-wrapper flex-column justify-center ">
              <label
                htmlFor="all_cvs_done"
                className="font-weight500 font-size-subheading"
              >
                All Cvs Done
              </label>
              <select
                id="all_cvs_done"
                name="all_cvs_done"
                value={tenderDocumentsData.all_cvs_done}
                onChange={(e) =>
                  setTenderDocumentsData((prev) => ({
                    ...prev,
                    all_cvs_done:
                      e.target.value === "true"
                        ? true
                        : e.target.value === "false"
                          ? false
                          : null,
                  }))
                }
                className="form-input font-size-subheading"
              >
                <option value="">All Cvs Done</option>
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </div>
            <div
              style={{
                width: "100%",
                maxWidth: 480,
                margin: "0 auto",
                background: "#fff",
                borderRadius: 8,
                boxShadow: "0 2px 12px #eee",
                padding: 32,
                marginTop: 24,
              }}
            >
              <label
                className="form-labels font-weight500 font-size-subheading"
                style={{
                  marginBottom: 12,
                  display: "block",
                  fontSize: 18,
                  fontWeight: 600,
                }}
              >
                Upload Bid Acknowledgemnet
              </label>

              {tenderDocumentsData?.bid_doc?.length > 0 && (
                <div style={{ marginBottom: 18 }}>
                  {tenderDocumentsData.bid_doc.map((cv) => (
                    <div key={cv.document_name} style={{ marginBottom: 6 }}>
                      <label style={{ color: "#6c63ff", fontWeight: 500 }}>
                        {cv.document_name}
                      </label>
                    </div>
                  ))}
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  marginBottom: 24,
                }}
              >
                <input
                  type="file"
                  multiple
                  onChange={handleBidsFileChange}
                  style={{ flex: 1, marginRight: 12, minWidth: 0 }}
                  className="form-control"
                />
                <button
                  onClick={handleAddBidDoc}
                  style={{
                    padding: "8px 20px",
                    backgroundColor: "#6c63ff",
                    color: "#fff",
                    border: "none",
                    borderRadius: 4,
                    fontWeight: 600,
                    fontSize: 15,
                    cursor: "pointer",
                  }}
                  disabled={!BidDocs.length}
                >
                  Add
                </button>
              </div>

              <ul
                style={{
                  listStyle: "none",
                  padding: 0,
                  margin: 0,
                  width: "100%",
                  maxHeight: 180,
                  overflowY: "auto",
                  border: BidDocs?.length ? "1px solid #ececec" : "none",
                  borderRadius: 6,
                  background: BidDocs?.length ? "#fafafd" : "none",
                }}
              >
                {BidDocs?.map((file, index) => (
                  <li
                    key={file.name + index}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "10px 8px",
                      borderBottom:
                        index !== BidDocs.length - 1
                          ? "1px solid #ececec"
                          : "none",
                    }}
                  >
                    <span
                      style={{
                        flex: 1,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      <svg
                        width="18"
                        height="18"
                        fill="#6c63ff"
                        style={{ marginRight: 8, verticalAlign: "middle" }}
                      >
                        <rect width="18" height="18" rx="3" />
                      </svg>
                      {file.name}
                    </span>
                    <button
                      onClick={() => handleBidsRemove(index)}
                      style={{
                        marginLeft: 16,
                        padding: "4px 12px",
                        backgroundColor: "#ff4e4e",
                        color: "#fff",
                        border: "none",
                        borderRadius: 4,
                        fontWeight: 500,
                        cursor: "pointer",
                        fontSize: 14,
                      }}
                    >
                      Remove
                    </button>
                  </li>
                ))}
                {!BidDocs?.length && (
                  <li
                    style={{ color: "#999", textAlign: "center", padding: 20 }}
                  >
                    No files uploaded
                  </li>
                )}
              </ul>
            </div>
            <div
              style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "8px",
              }}
            >
              <label style={{ fontSize: "16px", fontWeight: 500 }}>
                Bidder
              </label>

              <table
                className="table-css table-border"
                style={{ borderRadius: "15px" }}
              >
                <thead className="table-heading">
                  <tr className="custom-table-head-tr">
                    <th
                      className="table-heading-text text-center table-border"
                      style={{ padding: "8px 10px" }}
                    >
                      S.No
                    </th>
                    <th
                      className="table-heading-text text-center table-border"
                      style={{ padding: "8px 10px" }}
                    >
                      Bidder Name
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {tenderDocumentsData?.bidders?.map((bidder, index) => (
                    <tr>
                      <td
                        className="text-center table-border"
                        style={{ fontSize: "14px" }}
                      >
                        {index + 1}
                      </td>
                      <td
                        className="text-center table-border"
                        style={{ fontSize: "14px" }}
                      >
                        {bidder.bidder_name}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <div className="flex-column form-group-selectt">
                <label
                  htmlFor="bidder_name"
                  className="form-labels  font-weight500    font-size-subheading"
                >
                  Bidder Name<span className="required">*</span>
                </label>
                <br />
                <input
                  type="text"
                  name="bidder_name"
                  placeholder="bidder_name"
                  value={tenderDocumentsData.bidder_name.value}
                  onChange={(e) =>
                    setTenderDocumentsData((prev) => ({
                      ...prev,
                      bidder_name: {
                        ...prev.bidder_name,
                        value: e.target.value,
                      },
                    }))
                  }
                  className={`form-input input-form`}
                />
              </div>

              <button
                className="upload-svg"
                style={{
                  display: "flex",
                  gap: "10px",
                  width: "fit-content",
                  marginLeft: "auto",
                }}
                disabled={
                  tenderDocumentsData.bidder_name.loading ||
                  tenderDocumentsData.bidder_name.value === ""
                }
                onClick={handleBidderSubmit}
              >
                <AddwithWhiteCircle />
                Add
              </button>
            </div>

            <p className="error-message font-size-text">
              {isSubmitteddoc && Object.keys(errorsdoc).length > 0 && (
                <h6 className="text-center">
                  {"Error in: " +
                    Object.keys(errorsdoc)
                      .map((field) => {
                        // Convert field names to readable format
                        const formatted = field
                          .replace(/_/g, " ") // replace underscores with spaces
                          .replace(/\b\w/g, (c) => c.toUpperCase()); // capitalize first letters
                        return `${formatted}`; // include the actual error message
                      })
                      .join(", ")}
                </h6>
              )}
            </p>

            <button
              onClick={handleTenderDocumentUpdate}
              type="submit"
              className="model-button model-button-submit"
              style={{ width: "fit-content" }}
            >
              Submit
            </button>
          </section>
        );
      default:
        return null;
    }
  };

  return (
    <>
      <Modal
        show={showEditModal}
        onHide={handleCloseEditModal}
        dialogClassName="edit-tender-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Move Tender To Tab</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Move To Stage Dropdown */}
          <div
            className="dropdown-wrapper flex-column justify-center"
            style={{ marginBottom: "20px" }}
          >
            <label
              htmlFor="move_to_stage"
              className="form-label font-weight500 font-size-subheading"
            >
              Move To Stage<span className="required">*</span>
            </label>
            <select
              id="move_to_stage"
              name="move_to_stage"
              value={selectedStage}
              onChange={handleStageChange}
              className="form-input font-size-subheading"
            >
              <option value="">Select Stage to Move</option>
              <option value="wishlist">WishList</option>
              <option value="target">Target Tender</option>
              <option value="final">Final Tender</option>
            </select>
          </div>

          {/* Dynamic Tabs */}
          <div
            style={{
              display: "flex",
              borderBottom: "1px solid #e0e0e0",
              marginBottom: 20,
              gap: 16,
            }}
            role="tablist"
          >
            {filteredTabs.map((tab) => (
              <button
                key={tab.key}
                onClick={() => setActiveTab(tab.key)}
                type="button"
                style={{
                  padding: "10px 20px",
                  cursor: "pointer",
                  fontWeight: 500,
                  fontSize: 16,
                  color: "#495057",
                  background: "none",
                  border: "none",
                  borderBottom: "2px solid transparent",
                  outline: "none",
                  transition: "color 0.18s, border-bottom 0.18s",
                  ...(activeTab === tab.key
                    ? {
                        color: "#0d6efd",
                        borderBottom: "2px solid #0d6efd",
                        fontWeight: 700,
                      }
                    : {}),
                }}
                tabIndex={0}
                aria-selected={activeTab === tab.key}
                role="tab"
                aria-controls={`tab-panel-${tab.key}`}
                id={`tab-${tab.key}`}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Tab Content */}
          <div
            id={`tab-panel-${activeTab}`}
            role="tabpanel"
            aria-labelledby={`tab-${activeTab}`}
            style={{
              background: "#fafbfc",
              borderRadius: 8,
              padding: 20,
              minHeight: 180,
              boxShadow: "0 1px 3px rgba(0,0,0,0.04)",
            }}
          >
            {renderTabContent(activeTab)}
          </div>
        </Modal.Body>
        <ToastContainer
          position="top-center"
          autoClose={1000}
          hideProgressBar={false}
          newestOnTop={true}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
        />
      </Modal>
    </>
  );
};

export default AllTender;
